import React from 'react';

const FutureCityStaticElements: React.FC = () => {
  return (
    <g className="future-city-static-elements" transform="translate(-7 -30)">
      <defs>
        <linearGradient
          id="f0d10d57-c069-4f96-8cbc-f6298f395c91"
          data-name="grad-21"
          x1="812.9"
          y1="-171.28"
          x2="753.57"
          y2="610.96"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.3" stopColor="#0d2b6c" />
          <stop offset="0.34" stopColor="#303472" />
          <stop offset="0.4" stopColor="#68427c" />
          <stop offset="0.45" stopColor="#8b4b83" />
          <stop offset="0.48" stopColor="#984e85" />
          <stop offset="0.82" stopColor="#ff9683" />
        </linearGradient>
        <linearGradient
          id="ec29a5b1-ca2b-4641-9bcb-d8608b55670f"
          x1="870.41"
          y1="836.59"
          x2="637.27"
          y2="202.46"
          xlinkHref="#f0d10d57-c069-4f96-8cbc-f6298f395c91"
        />
        <radialGradient
          id="b976d605-c618-4181-b318-1a92e138aba0"
          data-name="grad-30"
          cx="209.4"
          cy="317.45"
          r="5.99"
          gradientTransform="translate(-56.96) scale(1.08 1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.18" stopColor="#3bece3" stopOpacity="0.3" />
          <stop offset="0.31" stopColor="#5defe5" stopOpacity="0.33" />
          <stop offset="0.94" stopColor="#fffff1" stopOpacity="0.5" />
        </radialGradient>
        <linearGradient
          id="a35ff387-350d-4ce9-9401-6884c69a18ac"
          data-name="grad-14"
          x1="170.03"
          y1="312.52"
          x2="170.02"
          y2="314.23"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.54" stopColor="#2ca3ad" />
          <stop offset="0.82" stopColor="#3ffff1" />
        </linearGradient>
        <linearGradient
          id="bc86e68a-c5ff-4ede-8ac5-30378800becd"
          x1="170.02"
          y1="312.9"
          x2="170.03"
          y2="314.96"
          gradientTransform="translate(0 0)"
          xlinkHref="#a35ff387-350d-4ce9-9401-6884c69a18ac"
        />
        <linearGradient
          id="a04da219-5c68-42da-bcff-f82a50eb10d5"
          x1="170"
          y1="313.29"
          x2="170.04"
          y2="315.62"
          gradientTransform="translate(0 0)"
          xlinkHref="#a35ff387-350d-4ce9-9401-6884c69a18ac"
        />
        <linearGradient
          id="fc228e66-99eb-4f01-9b0e-dc7cad51689b"
          x1="169.97"
          y1="313.69"
          x2="170.05"
          y2="316.22"
          gradientTransform="translate(0 0)"
          xlinkHref="#a35ff387-350d-4ce9-9401-6884c69a18ac"
        />
        <linearGradient
          id="b2908da2-5a77-44fd-a910-be692fae1523"
          x1="169.94"
          y1="314.09"
          x2="170.05"
          y2="316.74"
          gradientTransform="translate(0 0)"
          xlinkHref="#a35ff387-350d-4ce9-9401-6884c69a18ac"
        />
        <linearGradient
          id="ef6ab5bd-2de0-4285-8a3c-f4a3a5cc915d"
          x1="169.9"
          y1="314.49"
          x2="170.05"
          y2="317.19"
          xlinkHref="#a35ff387-350d-4ce9-9401-6884c69a18ac"
        />
        <linearGradient
          id="bf8fae05-7fe1-4034-b903-10dc01ef06d7"
          x1="169.94"
          y1="315.6"
          x2="170.05"
          y2="318.36"
          gradientTransform="translate(0 0)"
          xlinkHref="#a35ff387-350d-4ce9-9401-6884c69a18ac"
        />
        <linearGradient
          id="bb2713cf-bc3b-460d-ab2e-480ced31c8fc"
          x1="169.97"
          y1="316.7"
          x2="170.05"
          y2="319.48"
          gradientTransform="translate(0 0)"
          xlinkHref="#a35ff387-350d-4ce9-9401-6884c69a18ac"
        />
        <linearGradient
          id="a43c1288-3157-458a-b0f7-bdce74a6907b"
          x1="169.99"
          y1="317.81"
          x2="170.04"
          y2="320.55"
          gradientTransform="translate(0 0)"
          xlinkHref="#a35ff387-350d-4ce9-9401-6884c69a18ac"
        />
        <linearGradient
          id="e6197561-0607-406c-ae74-a62e742d1af4"
          x1="170.01"
          y1="318.91"
          x2="170.03"
          y2="321.57"
          gradientTransform="translate(0 0)"
          xlinkHref="#a35ff387-350d-4ce9-9401-6884c69a18ac"
        />
        <linearGradient
          id="f905e77b-0bfa-4c39-b986-3fc207010e13"
          x1="170.03"
          y1="320.02"
          x2="170.02"
          y2="322.54"
          xlinkHref="#a35ff387-350d-4ce9-9401-6884c69a18ac"
        />
        <linearGradient
          id="e46a31d4-81b3-461f-9676-21cc13e3109a"
          data-name="grad-190"
          x1="501.88"
          y1="333.38"
          x2="501.86"
          y2="336.94"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.22" stopColor="#35323c" />
          <stop offset="0.43" stopColor="#7a7a42" />
          <stop offset="0.63" stopColor="#b1b347" />
          <stop offset="0.79" stopColor="#d9dc4a" />
          <stop offset="0.92" stopColor="#f1f64c" />
          <stop offset="1" stopColor="#faff4d" />
        </linearGradient>
        <linearGradient
          id="f108cb73-3876-459d-88fa-452b53becd2d"
          data-name="grad-198"
          x1="501.85"
          y1="334.18"
          x2="501.88"
          y2="338.46"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.27" stopColor="#4b4945" />
          <stop offset="0.47" stopColor="#8d8d51" />
          <stop offset="0.63" stopColor="#bdbf5a" />
          <stop offset="0.75" stopColor="#dadd60" />
          <stop offset="0.82" stopColor="#e5e962" />
          <stop offset="1" stopColor="#faff64" />
        </linearGradient>
        <linearGradient
          id="f7e06a76-7f1f-44bf-96e5-12e6110ee45c"
          data-name="grad-197"
          x1="501.81"
          y1="334.99"
          x2="501.9"
          y2="339.83"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.17" stopColor="#272341" />
          <stop offset="0.41" stopColor="#7a7959" />
          <stop offset="0.61" stopColor="#b7b86a" />
          <stop offset="0.75" stopColor="#dddf75" />
          <stop offset="0.82" stopColor="#ebee79" />
          <stop offset="1" stopColor="#fbff7b" />
        </linearGradient>
        <linearGradient
          id="f3591900-c5c6-4146-ab7c-0a50a00caf2a"
          data-name="grad-196"
          x1="501.76"
          y1="335.81"
          x2="501.92"
          y2="341.07"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.31" stopColor="#565456" />
          <stop offset="0.56" stopColor="#a8a975" />
          <stop offset="0.74" stopColor="#dcdf89" />
          <stop offset="0.82" stopColor="#f0f491" />
          <stop offset="1" stopColor="#fbff91" />
        </linearGradient>
        <linearGradient
          id="e1368b2d-d874-42e8-a53c-864b3dc51192"
          data-name="grad-195"
          x1="501.69"
          y1="336.65"
          x2="501.93"
          y2="342.16"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.44" stopColor="#818070" />
          <stop offset="0.7" stopColor="#d5d798" />
          <stop offset="0.82" stopColor="#f6f9a8" />
          <stop offset="1" stopColor="#fcffa8" />
        </linearGradient>
        <linearGradient
          id="a2c8370b-994b-4cd3-9aa6-925c06c8f7f6"
          data-name="grad-47"
          x1="501.62"
          y1="337.48"
          x2="501.92"
          y2="343.09"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.54" stopColor="#a3a38d" />
          <stop offset="0.82" stopColor="#fcffbf" />
        </linearGradient>
        <linearGradient
          id="aa5d989c-58c8-44b4-ba93-7447ba524819"
          data-name="grad-194"
          x1="501.69"
          y1="339.78"
          x2="501.93"
          y2="345.52"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.2" stopColor="#332f4b" />
          <stop offset="0.43" stopColor="#888773" />
          <stop offset="0.62" stopColor="#c6c891" />
          <stop offset="0.75" stopColor="#ecf0a3" />
          <stop offset="0.82" stopColor="#fbffaa" />
        </linearGradient>
        <linearGradient
          id="f73d7dfe-6189-4bbb-a5e5-b4cb18a25d21"
          data-name="grad-193"
          x1="501.75"
          y1="342.07"
          x2="501.92"
          y2="347.84"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.25" stopColor="#4d4b53" />
          <stop offset="0.4" stopColor="#8a8a6a" />
          <stop offset="0.54" stopColor="#babd7d" />
          <stop offset="0.66" stopColor="#dde18b" />
          <stop offset="0.76" stopColor="#f2f793" />
          <stop offset="0.82" stopColor="#faff96" />
        </linearGradient>
        <linearGradient
          id="ba786cdf-4f44-4864-84a1-0f5691710191"
          data-name="grad-192"
          x1="501.8"
          y1="344.36"
          x2="501.9"
          y2="350.06"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.22" stopColor="#4a484c" />
          <stop offset="0.34" stopColor="#7f805c" />
          <stop offset="0.45" stopColor="#abad69" />
          <stop offset="0.56" stopColor="#cdd174" />
          <stop offset="0.66" stopColor="#e5ea7b" />
          <stop offset="0.75" stopColor="#f4fa7f" />
          <stop offset="0.82" stopColor="#f9ff81" />
        </linearGradient>
        <linearGradient
          id="b0220acf-819f-43e7-9e2c-b1a2965318a6"
          data-name="grad-191"
          x1="501.84"
          y1="346.66"
          x2="501.88"
          y2="352.17"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.18" stopColor="#403d44" />
          <stop offset="0.27" stopColor="#70704f" />
          <stop offset="0.36" stopColor="#9a9c58" />
          <stop offset="0.45" stopColor="#bcc060" />
          <stop offset="0.54" stopColor="#d6db66" />
          <stop offset="0.64" stopColor="#e9ef6a" />
          <stop offset="0.73" stopColor="#f4fb6c" />
          <stop offset="0.82" stopColor="#f8ff6d" />
        </linearGradient>
        <linearGradient
          id="ae95efd4-a1a7-4502-b659-c1dd9dd4f1e1"
          data-name="grad-126"
          x1="501.88"
          y1="348.96"
          x2="501.85"
          y2="354.2"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.14" stopColor="#302d3e" />
          <stop offset="0.21" stopColor="#5e5e44" />
          <stop offset="0.28" stopColor="#878949" />
          <stop offset="0.35" stopColor="#aaae4e" />
          <stop offset="0.43" stopColor="#c6cb52" />
          <stop offset="0.51" stopColor="#dce254" />
          <stop offset="0.6" stopColor="#ebf256" />
          <stop offset="0.69" stopColor="#f4fc58" />
          <stop offset="0.82" stopColor="#f7ff58" />
        </linearGradient>
        <radialGradient
          id="a2f24b3c-2f41-4971-8328-651dc7188e59"
          data-name="grad-210"
          cx="501.67"
          cy="343"
          r="19"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.01" stopColor="#ebff41" stopOpacity="0.6" />
          <stop offset="0.27" stopColor="#f2ff7d" stopOpacity="0.39" />
          <stop offset="0.58" stopColor="#f9ffbc" stopOpacity="0.18" />
          <stop offset="0.81" stopColor="#fdffe2" stopOpacity="0.05" />
          <stop offset="0.94" stopColor="#fffff1" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="bbd329a1-d8f0-4c44-a510-f767b6044657"
          x1="811.47"
          y1="292.26"
          x2="811.46"
          y2="294.63"
          xlinkHref="#e46a31d4-81b3-461f-9676-21cc13e3109a"
        />
        <linearGradient
          id="feedaf93-b197-4a76-979d-12709f33978a"
          x1="811.46"
          y1="292.78"
          x2="811.47"
          y2="295.64"
          xlinkHref="#f108cb73-3876-459d-88fa-452b53becd2d"
        />
        <linearGradient
          id="eae72780-d09c-406f-9c9e-bfa80100350a"
          x1="811.43"
          y1="293.33"
          x2="811.49"
          y2="296.56"
          xlinkHref="#f7e06a76-7f1f-44bf-96e5-12e6110ee45c"
        />
        <linearGradient
          id="f6e813e7-02b1-4e78-a786-b9cd0d01bc59"
          x1="811.39"
          y1="293.88"
          x2="811.5"
          y2="297.38"
          xlinkHref="#f3591900-c5c6-4146-ab7c-0a50a00caf2a"
        />
        <linearGradient
          id="adb605a5-5701-4202-b90e-8d80773a9e28"
          x1="811.35"
          y1="294.43"
          x2="811.51"
          y2="298.11"
          xlinkHref="#e1368b2d-d874-42e8-a53c-864b3dc51192"
        />
        <linearGradient
          id="f9b01663-1b1d-4bbc-8fdb-d74538c34a65"
          x1="811.3"
          y1="294.99"
          x2="811.51"
          y2="298.73"
          xlinkHref="#a2c8370b-994b-4cd3-9aa6-925c06c8f7f6"
        />
        <linearGradient
          id="ad4b3df9-6d7b-46c5-9b00-7ec156ef89fd"
          x1="811.35"
          y1="296.52"
          x2="811.51"
          y2="300.35"
          xlinkHref="#aa5d989c-58c8-44b4-ba93-7447ba524819"
        />
        <linearGradient
          id="bfcd7fc3-0ba9-46a2-8ea3-6250172e2b73"
          x1="811.39"
          y1="298.05"
          x2="811.5"
          y2="301.89"
          xlinkHref="#f73d7dfe-6189-4bbb-a5e5-b4cb18a25d21"
        />
        <linearGradient
          id="faea537b-7379-49e7-bb87-c68da19064bf"
          x1="811.42"
          y1="299.58"
          x2="811.49"
          y2="303.37"
          xlinkHref="#ba786cdf-4f44-4864-84a1-0f5691710191"
        />
        <linearGradient
          id="aa9297af-dd7b-4f90-a575-4b7cd2ab871c"
          x1="811.45"
          y1="301.11"
          x2="811.48"
          y2="304.78"
          xlinkHref="#b0220acf-819f-43e7-9e2c-b1a2965318a6"
        />
        <linearGradient
          id="a133e560-1a39-4b49-aca8-0873de928c22"
          x1="811.48"
          y1="302.64"
          x2="811.46"
          y2="306.13"
          xlinkHref="#ae95efd4-a1a7-4502-b659-c1dd9dd4f1e1"
        />
        <radialGradient
          id="b132fd94-8785-4bb3-899a-a30bf11d01dc"
          cx="811.34"
          cy="298.67"
          r="12.67"
          xlinkHref="#a2f24b3c-2f41-4971-8328-651dc7188e59"
        />
        <linearGradient
          id="eaad2924-4298-416c-ba15-527c9262b0f3"
          x1="422.88"
          y1="363.38"
          x2="422.86"
          y2="366.94"
          xlinkHref="#e46a31d4-81b3-461f-9676-21cc13e3109a"
        />
        <linearGradient
          id="ee6b977a-208b-47ec-a653-6fdd5f782421"
          x1="422.85"
          y1="364.18"
          x2="422.88"
          y2="368.46"
          xlinkHref="#f108cb73-3876-459d-88fa-452b53becd2d"
        />
        <linearGradient
          id="be608cb4-a52d-4a20-971e-4ca3df437c45"
          x1="422.81"
          y1="364.99"
          x2="422.9"
          y2="369.83"
          xlinkHref="#f7e06a76-7f1f-44bf-96e5-12e6110ee45c"
        />
        <linearGradient
          id="aa2ce541-1d4d-444c-8ed6-e3357e22928f"
          x1="422.76"
          y1="365.81"
          x2="422.92"
          y2="371.07"
          xlinkHref="#f3591900-c5c6-4146-ab7c-0a50a00caf2a"
        />
        <linearGradient
          id="bbef9391-6792-439d-9b29-463840043de5"
          x1="422.69"
          y1="366.65"
          x2="422.93"
          y2="372.16"
          xlinkHref="#e1368b2d-d874-42e8-a53c-864b3dc51192"
        />
        <linearGradient
          id="acfd1daa-f9bd-4cfc-9d8e-432faa4718be"
          x1="422.62"
          y1="367.48"
          x2="422.92"
          y2="373.09"
          xlinkHref="#a2c8370b-994b-4cd3-9aa6-925c06c8f7f6"
        />
        <linearGradient
          id="bc6f45d7-3cbd-4529-9938-4fcdb4dd1e63"
          x1="422.69"
          y1="369.78"
          x2="422.93"
          y2="375.52"
          xlinkHref="#aa5d989c-58c8-44b4-ba93-7447ba524819"
        />
        <linearGradient
          id="e5b3cabd-3df2-4a61-a5d5-58cd6e87ef52"
          x1="422.75"
          y1="372.07"
          x2="422.92"
          y2="377.84"
          xlinkHref="#f73d7dfe-6189-4bbb-a5e5-b4cb18a25d21"
        />
        <linearGradient
          id="a6d78bb1-0ae5-47f5-9867-739a45af8894"
          x1="422.8"
          y1="374.36"
          x2="422.9"
          y2="380.06"
          xlinkHref="#ba786cdf-4f44-4864-84a1-0f5691710191"
        />
        <linearGradient
          id="f13e1cbb-21e4-408c-abe9-61ebdebcefa4"
          x1="422.84"
          y1="376.66"
          x2="422.88"
          y2="382.17"
          xlinkHref="#b0220acf-819f-43e7-9e2c-b1a2965318a6"
        />
        <linearGradient
          id="e671cc7a-a85f-4d78-8ccd-a02cb845ba9f"
          x1="422.88"
          y1="378.96"
          x2="422.85"
          y2="384.2"
          xlinkHref="#ae95efd4-a1a7-4502-b659-c1dd9dd4f1e1"
        />
        <radialGradient
          id="bbe4c46c-cd3d-4fe8-b75e-234175846a04"
          cx="422.67"
          cy="373"
          xlinkHref="#a2f24b3c-2f41-4971-8328-651dc7188e59"
        />
        <linearGradient
          id="f79ad1d0-cdba-45c0-8bca-243e60aed2e8"
          x1="969.47"
          y1="346.26"
          x2="969.46"
          y2="348.63"
          xlinkHref="#e46a31d4-81b3-461f-9676-21cc13e3109a"
        />
        <linearGradient
          id="bdf8fa79-c14b-4a47-91c0-56755d2d7047"
          x1="969.46"
          y1="346.78"
          x2="969.47"
          y2="349.64"
          xlinkHref="#f108cb73-3876-459d-88fa-452b53becd2d"
        />
        <linearGradient
          id="ea39fe11-2975-43aa-9313-0faf556d293a"
          x1="969.43"
          y1="347.33"
          x2="969.49"
          y2="350.56"
          xlinkHref="#f7e06a76-7f1f-44bf-96e5-12e6110ee45c"
        />
        <linearGradient
          id="a3a4404a-f59d-4443-b978-8cea11831787"
          x1="969.39"
          y1="347.88"
          x2="969.5"
          y2="351.38"
          xlinkHref="#f3591900-c5c6-4146-ab7c-0a50a00caf2a"
        />
        <linearGradient
          id="b5537cef-6ea1-404c-8020-511f990ec718"
          x1="969.35"
          y1="348.43"
          x2="969.51"
          y2="352.11"
          xlinkHref="#e1368b2d-d874-42e8-a53c-864b3dc51192"
        />
        <linearGradient
          id="b412f2c1-e03f-4206-bea1-169cdebaf686"
          x1="969.3"
          y1="348.99"
          x2="969.51"
          y2="352.73"
          xlinkHref="#a2c8370b-994b-4cd3-9aa6-925c06c8f7f6"
        />
        <linearGradient
          id="a407e284-0245-4acd-9b19-7981e24873bb"
          x1="969.35"
          y1="350.52"
          x2="969.51"
          y2="354.35"
          xlinkHref="#aa5d989c-58c8-44b4-ba93-7447ba524819"
        />
        <linearGradient
          id="b8387ab6-7fe9-470b-9b4e-f75007c1f810"
          x1="969.39"
          y1="352.05"
          x2="969.5"
          y2="355.89"
          xlinkHref="#f73d7dfe-6189-4bbb-a5e5-b4cb18a25d21"
        />
        <linearGradient
          id="fad103bf-1b52-4ebc-8da7-2944d2aed1cd"
          x1="969.42"
          y1="353.58"
          x2="969.49"
          y2="357.37"
          xlinkHref="#ba786cdf-4f44-4864-84a1-0f5691710191"
        />
        <linearGradient
          id="bfd2880a-1934-4626-8831-2279275d5f5a"
          x1="969.45"
          y1="355.11"
          x2="969.48"
          y2="358.78"
          xlinkHref="#b0220acf-819f-43e7-9e2c-b1a2965318a6"
        />
        <linearGradient
          id="aa79cc45-88c6-4ef2-8a4f-a5fce747f60e"
          x1="969.48"
          y1="356.64"
          x2="969.46"
          y2="360.13"
          xlinkHref="#ae95efd4-a1a7-4502-b659-c1dd9dd4f1e1"
        />
        <radialGradient
          id="bfde810d-c5c0-4d0b-ae98-9c21dd8dcf86"
          cx="969.34"
          cy="352.67"
          r="12.67"
          xlinkHref="#a2f24b3c-2f41-4971-8328-651dc7188e59"
        />
        <linearGradient
          id="e266dbc6-aa67-45ec-a0a6-727c6f93e003"
          x1="995.47"
          y1="312.26"
          x2="995.46"
          y2="314.63"
          xlinkHref="#e46a31d4-81b3-461f-9676-21cc13e3109a"
        />
        <linearGradient
          id="abd7a46c-2622-4563-a380-d0150b5669b6"
          x1="995.46"
          y1="312.78"
          x2="995.47"
          y2="315.64"
          xlinkHref="#f108cb73-3876-459d-88fa-452b53becd2d"
        />
        <linearGradient
          id="a2b05b19-b7c7-499e-ac1c-c5dbf0ea5eb3"
          x1="995.43"
          y1="313.33"
          x2="995.49"
          y2="316.56"
          xlinkHref="#f7e06a76-7f1f-44bf-96e5-12e6110ee45c"
        />
        <linearGradient
          id="b6d37c0c-c217-45c5-98d8-0d09619cd987"
          x1="995.39"
          y1="313.88"
          x2="995.5"
          y2="317.38"
          xlinkHref="#f3591900-c5c6-4146-ab7c-0a50a00caf2a"
        />
        <linearGradient
          id="f04d7b9e-743a-4ed9-b381-1c8b5350dfc7"
          x1="995.35"
          y1="314.43"
          x2="995.51"
          y2="318.11"
          xlinkHref="#e1368b2d-d874-42e8-a53c-864b3dc51192"
        />
        <linearGradient
          id="fc7ace0d-7f6f-4878-a048-7e11ab13292f"
          x1="995.3"
          y1="314.99"
          x2="995.51"
          y2="318.73"
          xlinkHref="#a2c8370b-994b-4cd3-9aa6-925c06c8f7f6"
        />
        <linearGradient
          id="a3bc8db7-0218-41b7-9a90-401f02ee26e4"
          x1="995.35"
          y1="316.52"
          x2="995.51"
          y2="320.35"
          xlinkHref="#aa5d989c-58c8-44b4-ba93-7447ba524819"
        />
        <linearGradient
          id="b974e3b4-e6f5-4b97-8efc-cd6a70be3641"
          x1="995.39"
          y1="318.05"
          x2="995.5"
          y2="321.89"
          xlinkHref="#f73d7dfe-6189-4bbb-a5e5-b4cb18a25d21"
        />
        <linearGradient
          id="f590a4c1-631e-4f42-a8b1-af658d5d82ec"
          x1="995.42"
          y1="319.58"
          x2="995.49"
          y2="323.37"
          xlinkHref="#ba786cdf-4f44-4864-84a1-0f5691710191"
        />
        <linearGradient
          id="ad3dab32-b163-4c88-9af9-5f712e113a31"
          x1="995.45"
          y1="321.11"
          x2="995.48"
          y2="324.78"
          xlinkHref="#b0220acf-819f-43e7-9e2c-b1a2965318a6"
        />
        <linearGradient
          id="e41a8de4-0578-4e1e-906e-dd7629697134"
          x1="995.48"
          y1="322.64"
          x2="995.46"
          y2="326.13"
          xlinkHref="#ae95efd4-a1a7-4502-b659-c1dd9dd4f1e1"
        />
        <radialGradient
          id="a88701de-ddb7-4c82-842b-cc999587d8bf"
          cx="995.34"
          cy="318.67"
          r="12.67"
          xlinkHref="#a2f24b3c-2f41-4971-8328-651dc7188e59"
        />
        <linearGradient
          id="f2947948-b5c2-41a6-b964-a1fac0d45965"
          x1="1282.09"
          y1="324.42"
          x2="1282.05"
          y2="331.72"
          xlinkHref="#e46a31d4-81b3-461f-9676-21cc13e3109a"
        />
        <linearGradient
          id="b73c1d82-195a-499a-bd55-640349d8d781"
          x1="1282.04"
          y1="326.04"
          x2="1282.09"
          y2="334.83"
          xlinkHref="#f108cb73-3876-459d-88fa-452b53becd2d"
        />
        <linearGradient
          id="f63dd7d1-5f2d-4424-b7cb-980d00b1cb2a"
          x1="1281.96"
          y1="327.71"
          x2="1282.14"
          y2="337.66"
          xlinkHref="#f7e06a76-7f1f-44bf-96e5-12e6110ee45c"
        />
        <linearGradient
          id="b3a97687-d507-4dcf-8073-376a9c2b4b2a"
          data-name="grad-28"
          x1="1281.85"
          y1="329.41"
          x2="1282.18"
          y2="340.19"
          xlinkHref="#f3591900-c5c6-4146-ab7c-0a50a00caf2a"
        />
        <linearGradient
          id="bc239816-8614-484d-a446-e27d38f1f249"
          data-name="grad-26"
          x1="1281.72"
          y1="331.12"
          x2="1282.2"
          y2="342.43"
          xlinkHref="#e1368b2d-d874-42e8-a53c-864b3dc51192"
        />
        <linearGradient
          id="bcf7eec9-a311-449b-8549-f1ebfc805dd5"
          x1="1281.56"
          y1="332.84"
          x2="1282.19"
          y2="344.34"
          xlinkHref="#a2c8370b-994b-4cd3-9aa6-925c06c8f7f6"
        />
        <linearGradient
          id="e103a088-567f-4c6f-8f45-ba5a0f150745"
          x1="1281.7"
          y1="337.55"
          x2="1282.2"
          y2="349.33"
          xlinkHref="#aa5d989c-58c8-44b4-ba93-7447ba524819"
        />
        <linearGradient
          id="aa887489-ef79-4504-bedb-4e3d82a6b296"
          x1="1281.83"
          y1="342.25"
          x2="1282.19"
          y2="354.09"
          xlinkHref="#f73d7dfe-6189-4bbb-a5e5-b4cb18a25d21"
        />
        <linearGradient
          id="af6c3ec6-82db-47f8-a352-267d20394c42"
          x1="1281.94"
          y1="346.96"
          x2="1282.15"
          y2="358.64"
          xlinkHref="#ba786cdf-4f44-4864-84a1-0f5691710191"
        />
        <linearGradient
          id="aa2343be-7655-4c7d-b7b6-e32323a2968f"
          x1="1282.03"
          y1="351.67"
          x2="1282.1"
          y2="362.99"
          xlinkHref="#b0220acf-819f-43e7-9e2c-b1a2965318a6"
        />
        <linearGradient
          id="f055da16-953f-43e3-bb88-4b4fd943bc99"
          x1="1282.1"
          y1="356.4"
          x2="1282.04"
          y2="367.14"
          xlinkHref="#ae95efd4-a1a7-4502-b659-c1dd9dd4f1e1"
        />
        <radialGradient
          id="ec05867d-2463-4df3-8eb8-16ede8436748"
          cx="1281.67"
          cy="344.16"
          r="39"
          xlinkHref="#a2f24b3c-2f41-4971-8328-651dc7188e59"
        />
        <linearGradient
          id="b8580682-6b84-40ef-a816-addbb2c78d9a"
          x1="1303.09"
          y1="473.42"
          x2="1303.05"
          y2="480.72"
          xlinkHref="#e46a31d4-81b3-461f-9676-21cc13e3109a"
        />
        <linearGradient
          id="a91146ca-867d-40cd-83a3-64884ff3213e"
          x1="1303.04"
          y1="475.04"
          x2="1303.09"
          y2="483.83"
          xlinkHref="#f108cb73-3876-459d-88fa-452b53becd2d"
        />
        <linearGradient
          id="ede75fb9-28de-4db1-9167-0d039d0d3856"
          x1="1302.96"
          y1="476.71"
          x2="1303.14"
          y2="486.66"
          xlinkHref="#f7e06a76-7f1f-44bf-96e5-12e6110ee45c"
        />
        <linearGradient
          id="e67dbd60-aedf-40cb-9c80-fd876c627070"
          x1="1302.85"
          y1="478.41"
          x2="1303.18"
          y2="489.19"
          xlinkHref="#f3591900-c5c6-4146-ab7c-0a50a00caf2a"
        />
        <linearGradient
          id="b9e5a795-68d2-48db-9265-aa16acdb0960"
          x1="1302.72"
          y1="480.12"
          x2="1303.2"
          y2="491.43"
          xlinkHref="#e1368b2d-d874-42e8-a53c-864b3dc51192"
        />
        <linearGradient
          id="b43e5881-efd0-44f5-b77b-772f0515daf6"
          x1="1302.56"
          y1="481.84"
          x2="1303.19"
          y2="493.34"
          xlinkHref="#a2c8370b-994b-4cd3-9aa6-925c06c8f7f6"
        />
        <linearGradient
          id="ad0b7413-ada2-45ef-ae93-836dbc21acfd"
          x1="1302.7"
          y1="486.55"
          x2="1303.2"
          y2="498.33"
          xlinkHref="#aa5d989c-58c8-44b4-ba93-7447ba524819"
        />
        <linearGradient
          id="b96144d9-6141-4ff6-8aca-783e8dde018f"
          x1="1302.83"
          y1="491.25"
          x2="1303.19"
          y2="503.09"
          xlinkHref="#f73d7dfe-6189-4bbb-a5e5-b4cb18a25d21"
        />
        <linearGradient
          id="f53b0898-5b99-443c-bd81-7a293f2986db"
          x1="1302.94"
          y1="495.96"
          x2="1303.15"
          y2="507.64"
          xlinkHref="#ba786cdf-4f44-4864-84a1-0f5691710191"
        />
        <linearGradient
          id="e6845bf2-9d4a-4443-a1e7-3efc01fd199c"
          x1="1303.03"
          y1="500.67"
          x2="1303.1"
          y2="511.99"
          xlinkHref="#b0220acf-819f-43e7-9e2c-b1a2965318a6"
        />
        <linearGradient
          id="a0a0d3ef-26d9-47c6-838b-68e36d75b29e"
          x1="1303.1"
          y1="505.4"
          x2="1303.04"
          y2="516.14"
          xlinkHref="#ae95efd4-a1a7-4502-b659-c1dd9dd4f1e1"
        />
        <radialGradient
          id="b487387a-e7bd-428a-9e49-f8bb91e24037"
          cx="1302.67"
          cy="493.16"
          r="39"
          xlinkHref="#a2f24b3c-2f41-4971-8328-651dc7188e59"
        />
        <radialGradient
          id="e419dd99-7238-40ae-bd03-4aeb143be87f"
          cx="251.81"
          cy="312.45"
          r="5.99"
          xlinkHref="#b976d605-c618-4181-b318-1a92e138aba0"
        />
        <linearGradient
          id="b4b035fe-8d53-4b54-a630-f1a89c0e4291"
          x1="216.03"
          y1="307.52"
          x2="216.02"
          y2="309.23"
          xlinkHref="#a35ff387-350d-4ce9-9401-6884c69a18ac"
        />
        <linearGradient
          id="f18aa09f-03f8-4703-9671-4a72634480af"
          x1="216.02"
          y1="307.9"
          x2="216.03"
          y2="309.96"
          gradientTransform="translate(0 0)"
          xlinkHref="#a35ff387-350d-4ce9-9401-6884c69a18ac"
        />
        <linearGradient
          id="b7d74724-baf7-4d29-b9fd-432755d8c985"
          x1="216"
          y1="308.29"
          x2="216.04"
          y2="310.62"
          gradientTransform="translate(0 0)"
          xlinkHref="#a35ff387-350d-4ce9-9401-6884c69a18ac"
        />
        <linearGradient
          id="f3227212-5716-46df-b375-d253278d85c6"
          x1="215.97"
          y1="308.69"
          x2="216.05"
          y2="311.22"
          gradientTransform="translate(0 0)"
          xlinkHref="#a35ff387-350d-4ce9-9401-6884c69a18ac"
        />
        <linearGradient
          id="a52441bb-4c21-4c7c-b368-806446ee3d70"
          x1="215.94"
          y1="309.09"
          x2="216.05"
          y2="311.74"
          gradientTransform="translate(0 0)"
          xlinkHref="#a35ff387-350d-4ce9-9401-6884c69a18ac"
        />
        <linearGradient
          id="eff01fcc-9bdf-41f4-b121-31efba8abfbb"
          x1="215.9"
          y1="309.49"
          x2="216.05"
          y2="312.19"
          xlinkHref="#a35ff387-350d-4ce9-9401-6884c69a18ac"
        />
        <linearGradient
          id="ae15538c-f9e5-414f-a332-e5163a867b1c"
          x1="215.94"
          y1="310.6"
          x2="216.05"
          y2="313.36"
          gradientTransform="translate(0 0)"
          xlinkHref="#a35ff387-350d-4ce9-9401-6884c69a18ac"
        />
        <linearGradient
          id="fad8facb-cd10-4065-8f4f-b15be47b4f04"
          x1="215.97"
          y1="311.7"
          x2="216.05"
          y2="314.48"
          gradientTransform="translate(0 0)"
          xlinkHref="#a35ff387-350d-4ce9-9401-6884c69a18ac"
        />
        <linearGradient
          id="a1c10317-8150-4156-b4f4-53d97ed694af"
          x1="215.99"
          y1="312.81"
          x2="216.04"
          y2="315.55"
          gradientTransform="translate(0 0)"
          xlinkHref="#a35ff387-350d-4ce9-9401-6884c69a18ac"
        />
        <linearGradient
          id="fd8a780d-94f9-4ab9-8878-4168d3e6b90c"
          x1="216.01"
          y1="313.91"
          x2="216.03"
          y2="316.57"
          gradientTransform="translate(0 0)"
          xlinkHref="#a35ff387-350d-4ce9-9401-6884c69a18ac"
        />
        <linearGradient
          id="bd258222-dbd0-4a2b-bce5-f998336bbd6b"
          x1="216.03"
          y1="315.02"
          x2="216.02"
          y2="317.54"
          xlinkHref="#a35ff387-350d-4ce9-9401-6884c69a18ac"
        />
        <linearGradient
          id="a47cfe28-edc2-439d-99f7-950f3e8e50a5"
          x1="631.88"
          y1="313.38"
          x2="631.86"
          y2="316.94"
          xlinkHref="#e46a31d4-81b3-461f-9676-21cc13e3109a"
        />
        <linearGradient
          id="b18b728d-e990-4b2f-aa41-bb25a4cd355d"
          x1="631.85"
          y1="314.18"
          x2="631.88"
          y2="318.46"
          xlinkHref="#f108cb73-3876-459d-88fa-452b53becd2d"
        />
        <linearGradient
          id="b9330299-fd9b-4e36-8005-d40c7e90168c"
          x1="631.81"
          y1="314.99"
          x2="631.9"
          y2="319.83"
          xlinkHref="#f7e06a76-7f1f-44bf-96e5-12e6110ee45c"
        />
        <linearGradient
          id="a6890239-d7c9-4b73-a565-3e46c2435f24"
          x1="631.76"
          y1="315.81"
          x2="631.92"
          y2="321.07"
          xlinkHref="#f3591900-c5c6-4146-ab7c-0a50a00caf2a"
        />
        <linearGradient
          id="e5417d92-da41-4f5d-af6e-d5fdbc0053f5"
          x1="631.69"
          y1="316.65"
          x2="631.93"
          y2="322.16"
          xlinkHref="#e1368b2d-d874-42e8-a53c-864b3dc51192"
        />
        <linearGradient
          id="aed27ad7-28fa-4e87-90a4-78cf0da1cd78"
          x1="631.62"
          y1="317.48"
          x2="631.92"
          y2="323.09"
          xlinkHref="#a2c8370b-994b-4cd3-9aa6-925c06c8f7f6"
        />
        <linearGradient
          id="a63149d5-971d-450e-b1e7-0cdaf6cf3110"
          x1="631.69"
          y1="319.78"
          x2="631.93"
          y2="325.52"
          xlinkHref="#aa5d989c-58c8-44b4-ba93-7447ba524819"
        />
        <linearGradient
          id="e9e03a91-3800-41ba-b797-5918b0d1b98e"
          x1="631.75"
          y1="322.07"
          x2="631.92"
          y2="327.84"
          xlinkHref="#f73d7dfe-6189-4bbb-a5e5-b4cb18a25d21"
        />
        <linearGradient
          id="f5273b89-2da0-4638-b0f3-b936845d12f9"
          x1="631.8"
          y1="324.36"
          x2="631.9"
          y2="330.06"
          xlinkHref="#ba786cdf-4f44-4864-84a1-0f5691710191"
        />
        <linearGradient
          id="b16f21d2-d6c2-4504-919a-5b12422f896c"
          x1="631.84"
          y1="326.66"
          x2="631.88"
          y2="332.17"
          xlinkHref="#b0220acf-819f-43e7-9e2c-b1a2965318a6"
        />
        <linearGradient
          id="b0a538b1-c6a2-44d9-8334-e0850719b6a5"
          x1="631.88"
          y1="328.96"
          x2="631.85"
          y2="334.2"
          xlinkHref="#ae95efd4-a1a7-4502-b659-c1dd9dd4f1e1"
        />
        <radialGradient
          id="f019a494-9601-4989-adca-79d2715021e5"
          cx="631.67"
          cy="323"
          xlinkHref="#a2f24b3c-2f41-4971-8328-651dc7188e59"
        />
        <linearGradient
          id="a3b39100-32dd-4d46-9482-d9cc113836ef"
          x1="193.88"
          y1="481.38"
          x2="193.86"
          y2="484.94"
          xlinkHref="#e46a31d4-81b3-461f-9676-21cc13e3109a"
        />
        <linearGradient
          id="b527b5f1-f9f2-4d72-8569-4f8b866afd9f"
          x1="193.85"
          y1="482.18"
          x2="193.88"
          y2="486.46"
          xlinkHref="#f108cb73-3876-459d-88fa-452b53becd2d"
        />
        <linearGradient
          id="a82ac099-985c-4b9b-bda8-97f43260215e"
          x1="193.81"
          y1="482.99"
          x2="193.9"
          y2="487.83"
          xlinkHref="#f7e06a76-7f1f-44bf-96e5-12e6110ee45c"
        />
        <linearGradient
          id="a003f0a7-43bf-4f0e-bcc9-dd6e792e963c"
          x1="193.76"
          y1="483.81"
          x2="193.92"
          y2="489.07"
          xlinkHref="#f3591900-c5c6-4146-ab7c-0a50a00caf2a"
        />
        <linearGradient
          id="eabe069d-3792-49c6-89d4-931b379dd5f7"
          x1="193.69"
          y1="484.65"
          x2="193.93"
          y2="490.16"
          xlinkHref="#e1368b2d-d874-42e8-a53c-864b3dc51192"
        />
        <linearGradient
          id="b947bc29-6398-4e62-902b-0102d1fc1cf6"
          x1="193.62"
          y1="485.48"
          x2="193.92"
          y2="491.09"
          xlinkHref="#a2c8370b-994b-4cd3-9aa6-925c06c8f7f6"
        />
        <linearGradient
          id="e58a81fc-7a18-43cd-babf-f9f7b6b52ac0"
          x1="193.69"
          y1="487.78"
          x2="193.93"
          y2="493.52"
          xlinkHref="#aa5d989c-58c8-44b4-ba93-7447ba524819"
        />
        <linearGradient
          id="b5ceecec-c8d1-4eca-827f-438a3abaf636"
          x1="193.75"
          y1="490.07"
          x2="193.92"
          y2="495.84"
          xlinkHref="#f73d7dfe-6189-4bbb-a5e5-b4cb18a25d21"
        />
        <linearGradient
          id="a4d6b615-1227-40af-a037-65669ab8cac9"
          x1="193.8"
          y1="492.36"
          x2="193.9"
          y2="498.06"
          xlinkHref="#ba786cdf-4f44-4864-84a1-0f5691710191"
        />
        <linearGradient
          id="b20a5d33-45c5-49f1-a539-21b488d16d09"
          x1="193.84"
          y1="494.66"
          x2="193.88"
          y2="500.17"
          xlinkHref="#b0220acf-819f-43e7-9e2c-b1a2965318a6"
        />
        <linearGradient
          id="bc7b3891-aa23-49b3-b4ca-16b3503db929"
          x1="193.88"
          y1="496.96"
          x2="193.85"
          y2="502.2"
          xlinkHref="#ae95efd4-a1a7-4502-b659-c1dd9dd4f1e1"
        />
        <radialGradient
          id="ed828bcd-c270-40ae-a351-12025fe77116"
          cx="193.67"
          cy="491"
          xlinkHref="#a2f24b3c-2f41-4971-8328-651dc7188e59"
        />
        <linearGradient
          id="bffd6cf8-a6be-4452-9d35-df238200afff"
          x1="848.07"
          y1="855.15"
          x2="848.03"
          y2="862.45"
          xlinkHref="#e46a31d4-81b3-461f-9676-21cc13e3109a"
        />
        <linearGradient
          id="b4588049-c0fe-4605-80a5-b78c51f56c8c"
          x1="848.01"
          y1="856.77"
          x2="848.07"
          y2="865.56"
          xlinkHref="#f108cb73-3876-459d-88fa-452b53becd2d"
        />
        <linearGradient
          id="bd531b56-1959-46ab-bfcb-1d6076168161"
          x1="847.93"
          y1="858.44"
          x2="848.11"
          y2="868.39"
          xlinkHref="#f7e06a76-7f1f-44bf-96e5-12e6110ee45c"
        />
        <linearGradient
          id="b0802ffa-c7db-47e2-b579-84645b638a0b"
          x1="847.82"
          y1="860.13"
          x2="848.15"
          y2="870.92"
          xlinkHref="#f3591900-c5c6-4146-ab7c-0a50a00caf2a"
        />
        <linearGradient
          id="ebd74319-1a86-431c-a060-3583f9d304f3"
          x1="847.69"
          y1="861.85"
          x2="848.17"
          y2="873.16"
          xlinkHref="#e1368b2d-d874-42e8-a53c-864b3dc51192"
        />
        <linearGradient
          id="e8888fe9-6aba-40e1-9a8a-e2d0c7ce10fd"
          x1="847.54"
          y1="863.56"
          x2="848.16"
          y2="875.07"
          xlinkHref="#a2c8370b-994b-4cd3-9aa6-925c06c8f7f6"
        />
        <linearGradient
          id="fbc7c430-c476-40f6-9583-ec454f3c3817"
          x1="847.68"
          y1="868.28"
          x2="848.18"
          y2="880.06"
          xlinkHref="#aa5d989c-58c8-44b4-ba93-7447ba524819"
        />
        <linearGradient
          id="e7d03105-e4b6-4c51-b70f-fa55a97292b9"
          x1="847.8"
          y1="872.98"
          x2="848.16"
          y2="884.82"
          xlinkHref="#f73d7dfe-6189-4bbb-a5e5-b4cb18a25d21"
        />
        <linearGradient
          id="a6aec762-96e9-4f6d-8993-a2c4f7839e07"
          x1="847.91"
          y1="877.69"
          x2="848.12"
          y2="889.37"
          xlinkHref="#ba786cdf-4f44-4864-84a1-0f5691710191"
        />
        <linearGradient
          id="a5363db2-4d8c-440a-95ef-7cbba758ec67"
          x1="848"
          y1="882.4"
          x2="848.07"
          y2="893.72"
          xlinkHref="#b0220acf-819f-43e7-9e2c-b1a2965318a6"
        />
        <linearGradient
          id="ee31f54a-7a88-43f4-bcf9-9e1bd62be08a"
          x1="848.08"
          y1="887.13"
          x2="848.02"
          y2="897.87"
          xlinkHref="#ae95efd4-a1a7-4502-b659-c1dd9dd4f1e1"
        />
        <radialGradient
          id="ae341de5-b83b-4046-9ea0-330db9d7bbbc"
          cx="847.64"
          cy="874.89"
          r="39"
          xlinkHref="#a2f24b3c-2f41-4971-8328-651dc7188e59"
        />
        <image
          id="bb88751c-daa6-47ba-aca7-7d20e3ea221b"
          width="82"
          height="82"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFIAAABSCAYAAADHLIObAAAACXBIWXMAAAsSAAALEgHS3X78AAAEE0lEQVR4Xu3aXU4bVxTA8f+5dzw4NiZQ2lASUlE1UiVeswE2kfUA20k3wQboo1+C8iEQFkowjrHB9szc0weClEZtqdSTzkQ6/ydbupKtn+7HjD2iqnj/vXDfAO/f5ZBGOaRRDmmUQxrlkEY5pFEOaZRDGuWQRjmkUQ5plEMa5ZBGOaRRDmmUQxrlkEY5pFEOaZRDGuWQRjmkUQ5plEMa5ZBGOaRRDmmUQxrlkEZl9w2oMwH5/L1CY59BlCY+Hykg+yA7IH0OBWCHXe2D7oM2EbSJS1teQqDfz045zbvsLnXZXTrlNKffz17efuc/zdQm1LQZKQccRtjN2peXS+28aE/mZQ6wvJQtZovWbLa2NofDco/digbNzEZA3i1lIDAY5PlyetBK2YpqeJhi7ACEqroWSR+LUI4Xk3DD5uYCSPsNWeq1HzZ3iJscRXjeuuhJN0v5qgZ9FCRsoNUqQMjCKKmeZ5pn9KrROgBHxT7PK6H+g6hWSEFkH5UzjmL3fCune96Nmq0R+FFT+CnBU0XWAZJyoRq7EjSLmoXx5FyYbk3PNo4Wt5iCUt/yqhVSUQ44DI8Hv7aKnnaiZmtB2FSVbUnpF0L4CWH90+ALSekBEmIQlaSRqlvq48FjZfNQFa3u+bivWq2QByDwKLTb7ZaW867GtJ5SeAK6LcjPqvpUhFUAVe0JElW1UqVQSQspmbfb7cWMR+UBpL0al3etkADfkUsZYywkW5KUllV0TeB7gqyLyhqqD+F2GyDotaAjhQ8h8V5jttTSGDvkMrzvg75ytV9HvjqGuaqK5kmymAghyd+eHYqAEkKSLCbRPM1V9dXxXwz9n6sVcg90/uxjCkVRLspyVlTllSYdKvKeJB9AhwgjhBHokCQfFHmvSYdFVV4tynIWiqKcP/tY67KGmiEFuOR1uplMik6WTYVwQdIzkLdKeoPIO4UThZPb1+kNyFuSngnhopNl05vJpLjkdar7VqfWPfJ2/b5IB9uHJWzftK4GoxQyCSFRJRRl9vmpDZyEkN4BgyDliN4PN6z8Xr7kRaLmGdmIOxtADiAyGOQs01nR7mpZzTZCK24kTbcX5BJGqajOs9g+H8t0xIRrNjcXe9CIW8WmQMInzBVOW7Mr6fzTLWK7p9djtoqmIELNe+QX6R5UY46LRe/JtEr5MG/poCxmJ2UxO8lbOqhSPlz0nkzHHDcKEZo1I++S3yD0+/24srMSK7YCQOQ0jfvjamdnp3oBte+JX9ZEyG/yh91GQt71Lf3VUOvlz301Ge7LmnTYfNM5pFEOaZRDGuWQRjmkUQ5plEMa5ZBGOaRRDmmUQxrlkEY5pFEOaZRDGuWQRjmkUQ5plEMa5ZBGOaRRDmmUQxrlkEY5pFEOaZRDGuWQRjmkUX8ADjDWY0qKNpgAAAAASUVORK5CYII="
        />
        <image
          id="aecf4499-81b5-487f-a287-f50cdd7e7263"
          width="88"
          height="87"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABXCAYAAACAw4LhAAAACXBIWXMAAAsSAAALEgHS3X78AAAFL0lEQVR4Xu3a3VJbVRiH8edda+8ECpZvi9FSWnqg4FlvoDeBt+BllF6Gt2BuwhmPOx4RnQ4obTFGCSDIV7Kz1t8DwI+e6IyzJrvO+h0Fsg+YZ955V8jeJoksHfdPF2T/TQ6cWA6cWA6cWA6cWA6cWA6cWA6cWA6cWA6cWA6cWA6cWA6cWA6cWA6cWA6cWA6cWA6cWA6cWA6cWA6cWA6cWA6cWA6cWA6cWA6cWA6cWA6cWA6cWA6cWPFPF9SFgf31Z8E78dyt1f35YAPbAlsH6/CVAazzVB3QFqjuoeu+IuxLcHQ6xT77jSmeNqd42txnv0GnU3x5/ff/bbLrps4TbG1wnb29cmJmphka1YQGowaANYuhH5ZXVycng/XV1WoTIjWd5FpOsIF91m67HhTNOTdZmM36iuWC4n5Bcd9XLBdms805N9mD4rN22729o+uilofcFhgbGx6OmkHlXefCPW/+A/k4B2C446DwU4glcBQ2Nja0cT3BtZviWk2wgT0H1+WFZ2mpcdmP0w0rF0zhvmGPwT4B+8Swx6Zwv2HlwmU/TrO01Ojywj+H2k1ynSbYNtttx8aGby2tNMo7mpLCnEW/DG4lSmtIywDR9B7mIuhSE2FQmgutgxU46Aw3t7cDm5u12cl1OeSsDa7HTnF0NN+cmYhTg6vRvHnXArdmZh8b9ljE9wEM94vQjqTvIO4qxG5zojg6uXLn8/NHg2Uej+py8I19Rfx5oO0UF8cLEwXMVNI9Cr/ivHtksAZajYotsCWwpevXWjVYc949ovArlXSvgJmL44WJHju1OfjGviIEfL75yF32ZxuNqTitQVy0aB8Z9oCoh6CHYB+a2QIwDWBmDhRAkWjOcKVFFd4FazRdvOzPxrnNR1HXUzxWYw/8HOxTZtyo0Sg1Gk5hWiBay9ADYQ8wWkiLGO8hTQBgZkgRsyBZNBQRFaZLjXReNhqXnzIzfA72bMxrYuwrAuCIwqKZq8yVhZVNM+5gTJsxjeyOmTWBAmcOZw4ozKx5/R7TN9feKaxsVubKaOaOKMa+HqAmgecZyUmxVKxGqgYSF4gziTNMF5IGwIioSFQERpIG1+9xdnPtxUjVoFSsnBTnGY11cm+NfUU8A33OSVwbzlbllJ0zsEM8k5KVDjlJDjMP5jC7jXaG0UfqmvEqYq/M1CXYoRV2Xp0Pq+84iV+MeT1ADSbYgOP293Fy8dfh8Mqdhej7cnoj4i6Ol2C7wI+SDoFT4PTm9Y9guzheirgrpzch+v7wyp1NLv46PG5/H+uwI/Ln4MTGPsE3tAnx6/Y3I3q9q5Nz/Raari8fu2Z6DXol9BppH2lfXP/OTK/lYzc0Xf/kXL/R61193f6mNnGhPhMM8MeX611e+NbBSnPS7K6VLEN86FyxGm8m2OF+iXG0B+4HVfQupdPu0utBiydhq2ZfwtdlgoHr20DPILZ4Ejg4GE4uurOhqkOZfyO0A/oW9K3Qjsy/Gao6nFx0ZxwcDFs8Cc8g1iku1CzwrS3Q9vZ2gPmBt+rUR/9zCGEvVnoZK70MIez56H/2Vp3C/GB7ezts1SzsrVqtiLf8L+5o1Dkw3EbudPzd9bs+8JED8OzH085pWF9fD3WOC/UP/M7fVa594Fvv6nMRY/9X+d96V4K+rZafIv5PcuDEcuDEcuDEcuDEcuDEcuDEcuDEcuDEcuDEcuDEcuDEcuDEcuDEcuDEcuDEcuDEcuDEcuDEcuDEcuDEcuDEcuDEcuDEcuDEcuDEcuDEcuDEcuDEcuDEfgfgPI8gfIDmYQAAAABJRU5ErkJggg=="
        />
      </defs>
      <g id="b0f98ec0-9561-44d9-a48d-0786f27edef1" data-name="sky">
        <rect
          x="6.67"
          y="30"
          width="1523"
          height="300"
          fill="url(#f0d10d57-c069-4f96-8cbc-f6298f395c91)"
        />
        <g opacity="0.35">
          <path
            d="M756.67,64.5c0,.55,0,1.1,0,1.65,0,.12,0,.23,0,.35s0,.49,0,.73c0,.51,0,1-.06,1.54,0,.16,0,.32,0,.48a.62.62,0,0,1,0,.13c0,.15,0,.3,0,.46s0,.36,0,.54,0,.46,0,.7,0,.34,0,.52c0,.53-.09,1.06-.14,1.58s-.09.87-.14,1.3-.07.72-.12,1.07-.1.79-.16,1.19c0,.22-.05.44-.09.65s0,.33-.07.49,0,.31-.07.47c-.1.67-.21,1.33-.33,2s-.27,1.45-.42,2.17a1.77,1.77,0,0,1,0,.2q-.1.56-.24,1.11a.31.31,0,0,1,0,.13q-.15.72-.33,1.44c-.22.95-.47,1.9-.73,2.85h0a.26.26,0,0,1,0,.11v0a.56.56,0,0,0,0,.12,5.44,5.44,0,0,1-.15.54l-.12.42c-.07.27-.15.53-.24.8-.15.52-.31,1-.47,1.53-.06.21-.13.43-.21.64-.12.38-.25.75-.38,1.13a.88.88,0,0,1-.05.15.52.52,0,0,1-.06.16c-.16.47-.33.95-.5,1.42h0l-.51,1.36a.78.78,0,0,1-.05.14s0,0,0,.07a.11.11,0,0,1,0,.07,4.37,4.37,0,0,1-.18.46s0,0,0,0a3,3,0,0,1-.15.38,1.78,1.78,0,0,1-.12.29c-.08.21-.16.42-.25.62-.23.57-.47,1.14-.73,1.7a.14.14,0,0,1,0,.06c0,.1-.09.21-.14.31a.3.3,0,0,1,0,.08c-.14.32-.29.64-.43,1a3.39,3.39,0,0,1-.18.39v0h0v0a.37.37,0,0,1,0,.11.67.67,0,0,1-.06.12.66.66,0,0,1-.09.19c-.08.19-.17.37-.26.55-.21.44-.42.88-.65,1.32l-.51,1-.37.71h0s0,0,0,0h0a0,0,0,0,1,0,0s0,0,0,0h0c0,.08-.07.15-.11.22a2.12,2.12,0,0,1-.11.21l-.12.22c-.07.13-.14.27-.22.4s-.21.4-.33.6-.22.4-.34.6l0,0c0,.08-.09.16-.14.24a.3.3,0,0,1-.06.11c-.14.26-.29.51-.45.77,0,0,0,0,0,0h0l0,0s0,0,0,0l0,0,0,0c0,.06-.07.11-.1.16l0,.06-.11.18,0,0c-.2.35-.41.69-.63,1s-.29.49-.45.73-.23.38-.36.57-.32.5-.49.75-.21.33-.33.5l-.55.82-.29.42c-.24.36-.49.72-.75,1.07l-.1.15-.09.12,0,0,0,0,0,0v0l-.1.14c-.1.15-.21.29-.32.44a1.63,1.63,0,0,1-.17.22l0,0h0a.41.41,0,0,1-.1.14s0,0,0,0,0,0,0,0l-.25.33c-.18.25-.37.5-.56.74a0,0,0,0,1,0,0,.31.31,0,0,1-.09.11h0a1.88,1.88,0,0,1-.18.24l-.05.06h0a0,0,0,0,1,0,0v0l0,.06,0,0,0,0h0s0,0,0,0l0,.07-.13.16s0,0,0,0l0,.07a1.34,1.34,0,0,1-.11.14,3.15,3.15,0,0,1-.24.3l0,0-.1.12a.27.27,0,0,1-.07.08h0l-.05.06,0,0h0l0,0a.79.79,0,0,1-.12.15.13.13,0,0,1,0,.06l0,.05h0l-.07.08-.19.23a2.17,2.17,0,0,1-.24.29l-.08.1-.05.06-.06.07q-.39.48-.81,1l-.35.41c-.06.07-.12.15-.19.22l-.07.07h0s0,0,0,0h0v0h0q-.5.57-1,1.11l-.17.19,0,0,0,.06a2.19,2.19,0,0,1-.21.23l-.07.07a3.46,3.46,0,0,1-.33.35.94.94,0,0,1-.14.16l-.78.82-.24.25-.28.29c-.09.09-.18.19-.28.28l0,0a.6.6,0,0,1-.08.08.27.27,0,0,1-.07.08h0l-.07.07-.07.09-.7.68-.05,0a2.08,2.08,0,0,1-.21.21l-.06.05-.24.23,0,0-.72.69-.11.1-.2.18s0,0,0,0l0,0s0,0,0,0l0,0h0l0,0-.14.13h0l-.1.09,0,0-.52.47,0,0,0,0-.07.06-.21.19-.18.16-.49.44a.41.41,0,0,1-.1.09s0,0,0,0,0,0,0,0l0,0,0,.05s0,0,0,0h0l0,0-.12.11a1,1,0,0,1-.15.14l-.14.12-.08.06-.08.07h0l0,0-.06.05,0,0h0a.48.48,0,0,1-.12.1l0,0,0,0s0,0,0,0l-.09.08c-.14.13-.29.25-.43.36s0,0,0,0l-.77.64-.32.26,0,0-.07.06-.05,0,0,0h0l0,0h0l-.5.4,0,0c-.38.3-.76.6-1.14.88l-.13.1-.09.07,0,0s0,0,0,0c-.29.23-.59.45-.89.67-.45.34-.9.67-1.36,1l-1.28.89-1.25.84c-.86.57-1.72,1.12-2.6,1.65-.43.27-.87.53-1.32.79s-.88.52-1.33.77c-.86.49-1.73,1-2.6,1.42l-.15.08-1.25.63q-1.42.74-2.88,1.38c-.94.43-1.89.84-2.85,1.24h0c-.73.3-1.46.6-2.2.88-1.47.58-3,1.11-4.48,1.59-.75.24-1.51.48-2.28.7-.42.14-.85.26-1.27.37l-.65.17-.12,0-1,.28-.3.08-.93.23-.32.07-.72.17c-.42.1-.83.19-1.25.27l-1,.22c-1.1.23-2.21.43-3.32.6l-1.24.19c-1.19.18-2.4.34-3.61.46-.64.07-1.29.13-1.94.18l-.61,0h-.2l-.34,0h-.08a.22.22,0,0,1-.11,0h-.11l-1.27.08h-.22l-1,0c-.25,0-.49,0-.74,0H670l-.41,0q-1.2,0-2.4,0l-1.72,0h-.59l-1.45-.05-.52,0-.33,0c-.74,0-1.48-.08-2.22-.14l-.73-.06-.25,0-.88-.08-.72-.07-.71-.08-1.18-.14-.24,0q-.86-.1-1.71-.24c-.59-.08-1.17-.18-1.75-.28l-1.33-.23q-3.83-.7-7.52-1.73l-1.47-.42c-.59-.17-1.18-.35-1.76-.54s-1.14-.36-1.7-.56l-.73-.25c-1.11-.39-2.22-.8-3.31-1.22l-.75-.31c-.73-.29-1.45-.6-2.17-.91l-.56-.25-2-.89-.18-.09c-.77-.36-1.53-.74-2.28-1.12l-.09-.05c-.78-.4-1.56-.81-2.33-1.24a87.34,87.34,0,0,1-10.38-6.68c-.65-.49-1.29-1-1.93-1.49l-.45-.36c-1-.76-1.91-1.55-2.83-2.37-.36-.3-.71-.61-1.06-.93-.06,0-.11-.1-.17-.15-.53-.48-1.06-1-1.57-1.45s-1.26-1.21-1.88-1.83l-1.1-1.14c-.29-.29-.57-.59-.85-.89-.12-.13-.24-.25-.35-.38-.44-.46-.86-.93-1.28-1.41s-1.11-1.26-1.65-1.91l-.06-.07A89.08,89.08,0,0,1,585.43,101c-.62-1.38-1.2-2.77-1.74-4.19-.28-.7-.54-1.41-.8-2.13q-1.1-3.06-2-6.23l-.21-.79c-.12-.43-.24-.86-.34-1.3s-.18-.71-.26-1.06c-.13-.54-.26-1.09-.38-1.64-.32-1.46-.61-2.94-.85-4.44-.09-.54-.17-1.09-.25-1.63,0-.34-.1-.67-.14-1q-.27-2-.45-4c0-.16,0-.33,0-.49s0-.4,0-.6,0-.15,0-.23c0-.23,0-.46,0-.69s0-.2,0-.3c0-.35-.05-.7-.06-1s0-.45,0-.68,0-.52,0-.77,0-.68,0-1c0-.14,0-.28,0-.43,0-.62,0-1.25,0-1.87s0-1.5,0-2.25c0-.16,0-.32,0-.48s0-.34,0-.52l0-.65,0-.66c0-.1,0-.2,0-.3s0-.18,0-.27,0-.46,0-.69,0-.39,0-.59a2.45,2.45,0,0,1,0-.27q.11-1.5.27-3a3.11,3.11,0,0,1,0-.32.76.76,0,0,1,0-.15c0-.05,0-.09,0-.14a1.53,1.53,0,0,1,0-.3l.06-.53s0-.11,0-.16h0c0-.33.09-.66.14-1a3,3,0,0,1,.06-.42s0-.09,0-.13a88.65,88.65,0,0,1,6-21.7H749.77v0a2.49,2.49,0,0,1,.11.29.54.54,0,0,1,.05.11c.15.36.29.72.44,1.09l0,.05h0l.09.24c.14.35.28.71.41,1.06,0,.1.08.21.11.31l0,.09a.3.3,0,0,1,0,.08l.12.32,0,.14.21.59a2.83,2.83,0,0,1,.11.31c.08.2.15.4.22.6l.15.47c.1.28.19.56.28.85s.17.49.24.74.07.22.11.34a2.41,2.41,0,0,0,.08.25v0a.08.08,0,0,1,0,0,1.12,1.12,0,0,0,.05.13h0c0,.08,0,.16.07.23s.08.24.11.36c.13.43.25.85.37,1.27s.25.87.36,1.31.18.66.26,1,.16.61.23.92l.18.74c.1.41.19.83.28,1.25l.18.82,0,.16.06.27v0c0,.21.09.43.13.65,0,0,0,0,0,0s0,.24.07.36.05.25.07.37l0,.15s0,.09,0,.14h0a2,2,0,0,1,0,.26.06.06,0,0,1,0,0,.36.36,0,0,1,0,.1.09.09,0,0,1,0,0s0,.05,0,.08a.5.5,0,0,1,0,.12c0,.16.06.32.09.49a.13.13,0,0,1,0,.06v0a.06.06,0,0,1,0,0v0a.25.25,0,0,0,0,.08c0,.12.05.25.06.38s0,0,0,0a.22.22,0,0,1,0,.08.19.19,0,0,1,0,.08l.09.62c.07.42.13.85.19,1.29,0,.12,0,.25.05.37,0,.28.08.57.11.85,0,.11,0,.22,0,.33h0v0h0c0,.06,0,.12,0,.19a.31.31,0,0,1,0,.1h0l0,.24s0,0,0,0a.17.17,0,0,1,0,.07h0a.06.06,0,0,1,0,0v.09a3.11,3.11,0,0,1,0,.32c0,.26.06.53.08.8a2,2,0,0,1,0,.34c0,.11,0,.22,0,.33v0l0,.31s0,0,0,0c0,.2,0,.41,0,.61a2.11,2.11,0,0,1,0,.25v0a1.79,1.79,0,0,1,0,.23,1.79,1.79,0,0,1,0,.23s0,.09,0,.13a1.55,1.55,0,0,1,0,.22c0,.11,0,.22,0,.33s0,.23,0,.34l0,.47a0,0,0,0,1,0,0c0,.13,0,.27,0,.4V60a1.69,1.69,0,0,1,0,.23,1.09,1.09,0,0,1,0,.18c0,.14,0,.28,0,.43a2.71,2.71,0,0,1,0,.29c0,.1,0,.2,0,.3h0c0,.1,0,.19,0,.28v.07c0,.13,0,.27,0,.41s0,.3,0,.46C756.66,63.26,756.67,63.88,756.67,64.5Z"
            fill="#ff866e"
          />
          <path
            d="M709.24,109c-22.86,8-41.19-23.75-51.72-37.5S630.9,72.69,609.84,78,578,58.24,578.58,51.7a91.5,91.5,0,0,0-.91,12.8,90.43,90.43,0,0,0,1.21,14.72c8.66,6.56,23.64,14.68,41.2,10.43C647.87,82.93,664.83,99,678,116.56c7.1,9.46,26.69,15.61,43.24,19.26a89.56,89.56,0,0,0,32.25-47.57C753.22,88.41,732,101.11,709.24,109Z"
            fill="#8e3a7c"
            opacity="0.28"
          />
          <path
            d="M718.83,125.46c-26.66,9.28-48-27.7-60.32-43.73s-31,1.37-55.6,7.51c-9.57,2.39-17.32-.6-23.18-5.58a89.4,89.4,0,0,0,5.7,17.34,50.52,50.52,0,0,0,29.42,1.88c32.4-7.85,52.18,10.91,67.53,31.38,3.84,5.11,10.79,9.39,19.07,12.93a89.77,89.77,0,0,0,38.12-30.07C733.08,120.05,726,123,718.83,125.46Z"
            fill="#8e3a7c"
            opacity="0.28"
          />
          <path
            d="M725,103.82c-26.66,9.28-48-27.7-60.32-43.73s-31,1.36-55.6,7.5c-14.46,3.62-24.78-5.07-30.68-14.35a91,91,0,0,0-.7,11.26c0,2.74.13,5.45.37,8.12,10.38,6.64,25.58,12.82,43,8.62,32.4-7.85,52.19,10.91,67.54,31.38,6.48,8.64,21.89,14.9,37.54,19.26a89.61,89.61,0,0,0,26.14-39.42A270,270,0,0,1,725,103.82Z"
            fill="#8cdff2"
            opacity="0.28"
          />
          <path
            d="M676.66,153.5c-12.92-10.22-23.43-27.14-30.73-36.67-10.88-14.21-26.86-2.16-47.45,5a89.91,89.91,0,0,0,15.18,14.38c17.67-1,31.15,6.46,42.21,17a90.29,90.29,0,0,0,20.79.21Z"
            fill="#8cdff2"
            opacity="0.28"
          />
          <path
            d="M645.59,30c-11,3.39-21.64,9.34-31.09,10.36a18.25,18.25,0,0,1-13.14-3.06,16.74,16.74,0,0,1-3.12-2.89A22.92,22.92,0,0,1,595.33,30Z"
            fill="#f7c99a"
            opacity="0.35"
          />
          <path
            d="M756.59,60.83h0c-.81.41-1.64.8-2.49,1.18a94.86,94.86,0,0,1-27.73,8.12c-9.73,1.09-18.41-.25-23.21-5.63C691.66,51.64,683.6,35.88,670.46,30h30.15a57.08,57.08,0,0,1,4.58,6.71c4.54,7.69,12.78,7.72,21.53,4.49a65,65,0,0,0,9.9-4.79A107.51,107.51,0,0,0,746.3,30h3.47l.12.29a.54.54,0,0,1,.05.11c.15.36.29.72.44,1.09l0,.05h0a2.44,2.44,0,0,0,.1.24c.14.35.28.71.41,1.06,0,.1.08.21.11.31l0,.09a.3.3,0,0,1,0,.08l.12.32,0,.14.21.59a2.83,2.83,0,0,1,.11.31c.13.35.25.71.37,1.07s.19.56.28.85.17.49.24.74.07.22.11.34a2.41,2.41,0,0,0,.08.25v0a.08.08,0,0,1,0,0,1.12,1.12,0,0,0,.05.13h0c0,.08,0,.16.07.23s.08.24.11.36c.13.43.25.85.37,1.27s.25.87.36,1.31.18.66.26,1,.16.61.23.92l.18.74c.1.41.19.83.28,1.25l.18.82,0,.16.06.27v0c0,.21.09.43.13.65,0,0,0,0,0,0s0,.24.07.36.05.25.07.37l0,.15s0,.09,0,.14h0a2,2,0,0,1,0,.26.06.06,0,0,1,0,0,.36.36,0,0,1,0,.1.09.09,0,0,1,0,0s0,.05,0,.08a.5.5,0,0,1,0,.12c0,.16.06.32.09.49a.13.13,0,0,1,0,.06v0a.06.06,0,0,1,0,0s0,.06,0,.1.05.25.06.38,0,0,0,0a.22.22,0,0,1,0,.08c0,.23.07.47.11.7.07.42.13.85.19,1.29,0,.12,0,.25.05.37,0,.28.08.57.11.85,0,.11,0,.22,0,.33h0v0a.57.57,0,0,1,0,.18.31.31,0,0,1,0,.1h0l0,.24s0,0,0,0a.17.17,0,0,1,0,.07h0a.06.06,0,0,1,0,0v.09a3.11,3.11,0,0,1,0,.32c0,.26.06.53.08.8a2,2,0,0,1,0,.34c0,.11,0,.22,0,.33v0l0,.31s0,0,0,0c0,.18,0,.37,0,.56a.09.09,0,0,0,0,0,2.11,2.11,0,0,1,0,.25v0a1.79,1.79,0,0,1,0,.23c0,.12,0,.25,0,.37s0,.14,0,.21,0,.22,0,.33,0,.23,0,.34l0,.47,0,.53a1.69,1.69,0,0,1,0,.23,1.09,1.09,0,0,1,0,.18C756.58,60.54,756.59,60.68,756.59,60.83Z"
            fill="#f7c99a"
            opacity="0.35"
          />
          <path
            d="M756.67,64.5c0,.55,0,1.1,0,1.65,0,.12,0,.23,0,.35s0,.49,0,.73c0,.51,0,1-.06,1.54,0,.16,0,.32,0,.48a.62.62,0,0,1,0,.13c0,.15,0,.3,0,.46s0,.36,0,.54,0,.46,0,.7,0,.34,0,.52c0,.53-.09,1.06-.14,1.58s-.09.87-.14,1.3-.07.72-.12,1.07-.1.79-.16,1.19c0,.22-.05.44-.09.65s0,.33-.07.49,0,.31-.07.47c-.1.67-.21,1.33-.33,2s-.26,1.45-.41,2.17h0c-11.71,2.71-23.44,3.61-32,1.1a19.54,19.54,0,0,1-8.23-4.5c-16.93-16.37-27.44-37.43-51.82-36.85s-48.44,20.48-66.06,9.65c-6.86-4.21-10.07-12.29-11.44-20.58.33-.45.66-.9,1-1.34.14-.2.92-.19,1.16,0h13.12a23.51,23.51,0,0,0,3.22,4.62,17.29,17.29,0,0,0,13.26,5.9c15.58-.2,21.67-7,31.34-10.52h29c2.74.42,5.32.85,7.75,1.34,13.82,2.73,23,7.06,31.86,20a14.6,14.6,0,0,0,10.62,6.34c8.15,1.07,18.46-2.74,27.84-7.71,0,0,0,0,0,0a.22.22,0,0,1,0,.08c0,.23.07.47.11.7.07.42.13.85.19,1.29,0,.12,0,.25.05.37,0,.28.08.57.11.85,0,.11,0,.22,0,.33h0v0h0a.57.57,0,0,1,0,.18.31.31,0,0,1,0,.1h0l0,.24s0,0,0,0a.17.17,0,0,1,0,.07h0a.06.06,0,0,1,0,0v.09a3.11,3.11,0,0,1,0,.32c0,.26.06.53.08.8a2,2,0,0,1,0,.34c0,.11,0,.22,0,.33v0l0,.31s0,0,0,0c0,.2,0,.41,0,.61a2.11,2.11,0,0,1,0,.25v0a1.79,1.79,0,0,1,0,.23,1.79,1.79,0,0,1,0,.23s0,.09,0,.13h0c0,.07,0,.14,0,.21s0,.22,0,.33a1.82,1.82,0,0,1,0,.32c0,.17,0,.33,0,.49a0,0,0,0,1,0,0c0,.13,0,.27,0,.4V60a1.69,1.69,0,0,1,0,.23,1.09,1.09,0,0,1,0,.18c0,.14,0,.28,0,.43a2.71,2.71,0,0,1,0,.29c0,.1,0,.2,0,.3h0c0,.1,0,.19,0,.28v.07c0,.13,0,.27,0,.41s0,.3,0,.46C756.66,63.26,756.67,63.88,756.67,64.5Z"
            fill="#8e3a7c"
            opacity="0.28"
          />
          <path
            d="M624.13,30c-7.12,2.33-13.93,4.33-20.28,4.62a29.78,29.78,0,0,1-5.61-.21,22.94,22.94,0,0,1-8.61-3A18.84,18.84,0,0,1,587.51,30Z"
            fill="#8e3a7c"
            opacity="0.28"
          />
          <path
            d="M756.61,61.42h0c-.84.2-1.68.4-2.52.58-9.47,2.13-19,3.15-26.91,2.33-6.21-.64-11.46-2.42-15-5.69-9.87-9.18-17.64-19.83-27-27.31-.57-.46-1.15-.91-1.74-1.34h30.62l.62.86A15.32,15.32,0,0,0,726,37.23a32.06,32.06,0,0,0,10.59-.82,72.38,72.38,0,0,0,13.78-4.86h0l.09.24c.14.35.28.71.41,1.06l.18.48.12.32,0,.14.21.59a2.83,2.83,0,0,1,.11.31c.08.2.15.4.22.6l.15.47.21.62.06.18c.09.26.17.53.25.79s.13.4.19.6a.07.07,0,0,1,0,0c0,.09.07.18.09.27a.22.22,0,0,1,0,.1c0,.12.07.24.11.36.13.43.25.85.37,1.27s.25.87.36,1.31c.24.88.46,1.76.67,2.65.1.41.19.83.28,1.25l.18.82,0,.16.06.27.06.32q.15.7.27,1.41a2.33,2.33,0,0,1,.05.28.36.36,0,0,1,0,.1s0,.06,0,.09a.22.22,0,0,1,0,.08.5.5,0,0,1,0,.12l.06.31,0,.18c0,.1,0,.2.05.3s0,.06,0,.1l0,.2v0s0,0,0,0a.22.22,0,0,1,0,.08s0,0,0,.08c.06.41.13.83.18,1.24,0,.22.07.44.1.67,0,0,0,.08,0,.12l0,.25c0,.28.08.57.11.85,0,.11,0,.22,0,.33s0,0,0,0h0s0,0,0,0,0,.24,0,.36a2.71,2.71,0,0,1,0,.41c0,.11,0,.21,0,.32,0,.26.06.53.08.8l0,.34c0,.42.08.84.11,1.27a.09.09,0,0,0,0,0,.49.49,0,0,1,0,.12s0,.09,0,.13v0c0,.2,0,.4,0,.6s0,.14,0,.21,0,.22,0,.33,0,.23,0,.34l0,.47,0,.53v0c0,.26,0,.53,0,.79,0,.1,0,.2,0,.29S756.61,61.32,756.61,61.42Z"
            fill="#8e3a7c"
            opacity="0.28"
          />
          <path
            d="M756.67,64.5c0,.55,0,1.1,0,1.65,0,.12,0,.23,0,.35s0,.49,0,.73c0,.51,0,1-.06,1.54,0,.16,0,.32,0,.48a.62.62,0,0,1,0,.13c0,.15,0,.3,0,.46s0,.36,0,.54,0,.46,0,.7,0,.34,0,.52c0,.53-.09,1.06-.14,1.58s-.09.87-.14,1.3-.07.72-.12,1.07-.1.79-.16,1.19c0,.22-.05.44-.09.65s0,.33-.07.49,0,.31-.07.47c-.1.67-.21,1.33-.33,2s-.27,1.45-.42,2.17a1.77,1.77,0,0,1,0,.2q-.1.56-.24,1.11a.31.31,0,0,1,0,.13q-.15.72-.33,1.44c-.22.95-.47,1.9-.73,2.85h0a.26.26,0,0,1,0,.11v0a.56.56,0,0,0,0,.12,5.44,5.44,0,0,1-.15.54l-.12.42c-.07.27-.15.53-.24.8-.15.52-.31,1-.47,1.53-.06.21-.13.43-.21.64-.12.38-.25.75-.38,1.13a.88.88,0,0,1-.05.15.52.52,0,0,1-.06.16c-.16.47-.33.95-.5,1.42h0l-.51,1.36a.78.78,0,0,1-.05.14s0,0,0,.07a.11.11,0,0,1,0,.07,4.37,4.37,0,0,1-.18.46s0,0,0,0a3,3,0,0,1-.15.38,1.78,1.78,0,0,1-.12.29c-.08.21-.16.42-.25.62-.23.57-.47,1.14-.73,1.7a.14.14,0,0,1,0,.06c0,.1-.09.21-.14.31a.3.3,0,0,1,0,.08c-.14.32-.29.64-.43,1a3.39,3.39,0,0,1-.18.39v0h0v0a.37.37,0,0,1,0,.11.67.67,0,0,1-.06.12.66.66,0,0,1-.09.19c-.08.19-.17.37-.26.55-.21.44-.42.88-.65,1.32l-.51,1-.37.71h0s0,0,0,0h0a0,0,0,0,1,0,0s0,0,0,0h0c0,.08-.07.15-.11.22a2.12,2.12,0,0,1-.11.21l-.12.22c-.07.13-.14.27-.22.4s-.21.4-.33.6-.22.4-.34.6l0,0c0,.08-.09.16-.14.24a.3.3,0,0,1-.06.11c-.14.26-.29.51-.45.77,0,0,0,0,0,0h0l0,0s0,0,0,0l0,0,0,0c0,.06-.07.11-.1.16l0,.06-.11.18,0,0c-.2.35-.41.69-.63,1s-.29.49-.45.73-.23.38-.36.57-.32.5-.49.75-.21.33-.33.5l-.55.82-.29.42c-.24.36-.49.72-.75,1.07l-.1.15-.09.12,0,0,0,0,0,0v0l-.1.14c-.1.15-.21.29-.32.44a1.63,1.63,0,0,1-.17.22l0,0h0a.41.41,0,0,1-.1.14s0,0,0,0,0,0,0,0l-.25.33c-.18.25-.37.5-.56.74a0,0,0,0,1,0,0,.31.31,0,0,1-.09.11h0a1.88,1.88,0,0,1-.18.24l-.05.06h0a0,0,0,0,1,0,0v0a.38.38,0,0,1-.08.11l0,0h0s0,0,0,0l0,.07-.13.16s0,0,0,0l0,.07a1.34,1.34,0,0,1-.11.14,3.15,3.15,0,0,1-.24.3l0,0-.1.12a.27.27,0,0,1-.07.08h0l-.05.06,0,0h0l0,0a.79.79,0,0,1-.12.15.13.13,0,0,1,0,.06l0,.05h0l-.07.08-.19.23a2.17,2.17,0,0,1-.24.29l-.08.1-.05.06-.06.07q-.39.48-.81,1l-.35.41c-.06.07-.12.15-.19.22l-.07.07h0s0,0,0,0l0,0h0q-.5.57-1,1.11l-.17.19,0,0,0,.06a2.19,2.19,0,0,1-.21.23l-.07.07a3.46,3.46,0,0,1-.33.35.94.94,0,0,1-.14.16l-.78.82-.24.25-.28.29c-.09.09-.18.19-.28.28l0,0a.6.6,0,0,1-.08.08.27.27,0,0,1-.07.08l-.15.16-.7.68-.05,0a2.08,2.08,0,0,1-.21.21l-.06.05a3.44,3.44,0,0,1-.27.27l-.72.69-.11.1-.2.18s0,0,0,0l0,0s0,0,0,0l0,0h0l0,0-.14.13h0l-.1.09,0,0-.52.47,0,0,0,0a1.62,1.62,0,0,1-.28.25l-.18.16-.49.44a.41.41,0,0,1-.1.09s0,0,0,0,0,0,0,0l0,0,0,.05s0,0,0,0h0l0,0-.12.11a1,1,0,0,1-.15.14l-.14.12a.91.91,0,0,1-.16.13h0l0,0-.06.05,0,0h0a.48.48,0,0,1-.12.1l0,0,0,0s0,0,0,0l-.09.08c-.14.13-.29.25-.43.36s0,0,0,0l-.77.64-.32.26,0,0-.07.06-.05,0,0,0h0l0,0h0l-.5.4,0,0c-.38.3-.76.6-1.14.88l-.13.1-.09.07,0,0s0,0,0,0c-.29.23-.59.45-.89.67-.45.34-.9.67-1.36,1l-1.28.89-1.25.84c-.86.57-1.72,1.12-2.6,1.65-.43.27-.87.53-1.32.79s-.88.52-1.33.77c-.86.49-1.73,1-2.6,1.42l-.15.08-1.25.63q-1.42.74-2.88,1.38-2.49,1.16-5.06,2.12c-1.47.58-3,1.11-4.48,1.59-.75.24-1.51.48-2.28.7-.42.14-.85.26-1.27.37l-.65.17-.12,0-1,.28-.3.08-.93.23-.32.07-.72.17c-.42.1-.83.19-1.25.27l-1,.22c-1.1.23-2.21.43-3.32.6l-1.24.19c-1.19.18-2.4.34-3.61.46-.64.07-1.29.13-1.94.18l-.5,0h-.31l-.34,0h-.08a.22.22,0,0,1-.11,0h-.11l-1.27.08h-.22l-1,0c-.25,0-.49,0-.74,0H670l-.41,0q-1.2,0-2.4,0h-2.31l-1.45-.05-.52,0-.33,0c-.74,0-1.48-.08-2.22-.14l-.73-.06-.25,0-.88-.08-.72-.07-.71-.08-1.18-.14-.24,0q-.86-.1-1.71-.24c-.59-.08-1.17-.18-1.75-.28l-1.33-.23q-3.83-.7-7.52-1.73l-1.47-.42c-.59-.17-1.18-.35-1.76-.54s-1.14-.36-1.7-.56l-.73-.25c-1.11-.39-2.22-.8-3.31-1.22l-.75-.31c-.73-.29-1.45-.6-2.17-.91l-.56-.25-2-.89-.18-.09c-.77-.36-1.53-.74-2.28-1.12l-.09-.05c-.78-.4-1.56-.81-2.33-1.24a89.42,89.42,0,0,0,14.17,1.13c1.89,0,3.76-.06,5.62-.18a88.21,88.21,0,0,0,19.75-3.48h0a89.26,89.26,0,0,0,28-14c1.5-1.11,3-2.26,4.38-3.48q1.18-1,2.34-2A88.27,88.27,0,0,0,709.23,109h0c1-1.33,2-2.7,3-4.09a88.79,88.79,0,0,0,14.16-34.8q.51-2.86.82-5.79c.24-2.19.4-4.42.47-6.66q.06-1.56.06-3.12a90.55,90.55,0,0,0-1-13.36c-.2-1.33-.43-2.66-.69-4q-.72-3.67-1.74-7.23h25.49a2.49,2.49,0,0,1,.11.29.54.54,0,0,1,.05.11c.15.36.29.72.44,1.09l0,.05h0l.09.24c.14.35.28.71.41,1.06,0,.1.08.21.11.31l0,.09c.15.37.29.75.42,1.13a2.83,2.83,0,0,1,.11.31c.13.35.25.71.37,1.07s.19.56.28.85.17.49.24.74.07.22.11.34a2.41,2.41,0,0,0,.08.25v0a.08.08,0,0,1,0,0,1.12,1.12,0,0,0,.05.13h0c0,.08,0,.16.07.23s.08.24.11.36c.13.43.25.85.37,1.27s.25.87.36,1.31.18.66.26,1,.16.61.23.92l.18.74c.1.41.19.83.28,1.25l.18.82,0,.16.06.27v0c0,.21.09.43.13.65,0,0,0,0,0,0s0,.24.07.36.05.25.07.37l0,.15s0,.09,0,.14h0a2,2,0,0,1,0,.26.06.06,0,0,1,0,0,.36.36,0,0,1,0,.1.09.09,0,0,1,0,0s0,.05,0,.08a.5.5,0,0,1,0,.12c0,.16.06.32.09.49a.13.13,0,0,1,0,.06v0a.06.06,0,0,1,0,0v0a.25.25,0,0,0,0,.08c0,.12.05.25.06.38s0,0,0,0a.22.22,0,0,1,0,.08.19.19,0,0,1,0,.08l.09.62c.07.42.13.85.19,1.29,0,.12,0,.25.05.37,0,.28.08.57.11.85,0,.11,0,.22,0,.33h0v0a.57.57,0,0,1,0,.18.31.31,0,0,1,0,.1h0l0,.24s0,0,0,0a.17.17,0,0,1,0,.07h0a.06.06,0,0,1,0,0v.09a3.11,3.11,0,0,1,0,.32c0,.26.06.53.08.8a2,2,0,0,1,0,.34c0,.11,0,.22,0,.33v0l0,.31s0,0,0,0c0,.2,0,.41,0,.61a2.11,2.11,0,0,1,0,.25v0a1.79,1.79,0,0,1,0,.23,1.79,1.79,0,0,1,0,.23s0,.09,0,.13a1.55,1.55,0,0,1,0,.22c0,.11,0,.22,0,.33a1.82,1.82,0,0,1,0,.32l0,.52c0,.13,0,.27,0,.4V60a1.69,1.69,0,0,1,0,.23,1.09,1.09,0,0,1,0,.18c0,.14,0,.28,0,.43a2.71,2.71,0,0,1,0,.29c0,.19,0,.39,0,.59v.07c0,.13,0,.27,0,.41s0,.3,0,.46C756.66,63.26,756.67,63.88,756.67,64.5Z"
            fill="#422151"
            opacity="0.34"
          />
        </g>
        <g opacity="0.42">
          <polygon
            points="502.44 49.23 505.67 51 502.44 52.77 500.67 56 498.9 52.77 495.67 51 498.9 49.23 500.67 46 502.44 49.23"
            fill="#8af1eb"
          />
          <use
            transform="translate(459.67 10)"
            xlinkHref="#bb88751c-daa6-47ba-aca7-7d20e3ea221b"
          />
        </g>
        <g opacity="0.15">
          <polygon
            points="449.44 92.23 452.67 94 449.44 95.77 447.67 99 445.9 95.77 442.67 94 445.9 92.23 447.67 89 449.44 92.23"
            fill="#8af1eb"
          />
          <use
            transform="translate(406.67 53)"
            xlinkHref="#bb88751c-daa6-47ba-aca7-7d20e3ea221b"
          />
        </g>
        <g opacity="0.49">
          <polygon
            points="906.44 39.23 909.67 41 906.44 42.77 904.67 46 902.9 42.77 899.67 41 902.9 39.23 904.67 36 906.44 39.23"
            fill="#8af1eb"
          />
          <use
            transform="translate(863.67)"
            xlinkHref="#bb88751c-daa6-47ba-aca7-7d20e3ea221b"
          />
        </g>
        <g opacity="0.51">
          <polygon
            points="1069.44 49.23 1072.67 51 1069.44 52.77 1067.67 56 1065.9 52.77 1062.67 51 1065.9 49.23 1067.67 46 1069.44 49.23"
            fill="#8af1eb"
          />
          <use
            transform="translate(1026.67 10)"
            xlinkHref="#bb88751c-daa6-47ba-aca7-7d20e3ea221b"
          />
        </g>
        <g opacity="0.51">
          <polygon
            points="1378.44 93.23 1381.67 95 1378.44 96.77 1376.67 100 1374.9 96.77 1371.67 95 1374.9 93.23 1376.67 90 1378.44 93.23"
            fill="#8af1eb"
          />
          <use
            transform="translate(1335.67 54)"
            xlinkHref="#bb88751c-daa6-47ba-aca7-7d20e3ea221b"
          />
        </g>
        <g opacity="0.5">
          <polygon
            points="1207.32 55.85 1212.17 58.5 1207.32 61.15 1204.67 66 1202.02 61.15 1197.17 58.5 1202.02 55.85 1204.67 51 1207.32 55.85"
            fill="#8af1eb"
          />
          <use
            transform="translate(1160.67 15)"
            xlinkHref="#aecf4499-81b5-487f-a287-f50cdd7e7263"
          />
        </g>
        <g opacity="0.5">
          <polygon
            points="1431.32 48.85 1436.17 51.5 1431.32 54.15 1428.67 59 1426.02 54.15 1421.17 51.5 1426.02 48.85 1428.67 44 1431.32 48.85"
            fill="#8af1eb"
          />
          <use
            transform="translate(1384.67 8)"
            xlinkHref="#aecf4499-81b5-487f-a287-f50cdd7e7263"
          />
        </g>
        <circle cx="1300.67" cy="8" r="2" fill="#efef8b" opacity="0.47" />
        <circle cx="1323.67" cy="39" r="2" fill="#efef8b" opacity="0.47" />
        <circle cx="1286.67" cy="81" r="2" fill="#efef8b" opacity="0.47" />
        <circle cx="1237.67" cy="64" r="2" fill="#efef8b" opacity="0.47" />
        <circle cx="1138.67" cy="59" r="2" fill="#efef8b" opacity="0.47" />
        <circle cx="1438.67" cy="142" r="2" fill="#efef8b" opacity="0.47" />
      </g>
      <g id="f067f595-6e2e-4b16-9358-d0bbc2326c6d" data-name="background">
        <g>
          <rect x="1485.67" y="90" width="43" height="226" fill="#6d265c" />
          <rect
            x="1485.67"
            y="90"
            width="5"
            height="226"
            fill="#e9847e"
            opacity="0.46"
          />
          <g>
            <polygon
              points="1405.54 132 1405.54 211.47 1405.54 330.67 1371.13 310.8 1371.13 191.6 1405.54 132"
              fill="#822c69"
            />
            <polygon
              points="1405.54 132 1405.54 211.47 1371.13 191.6 1405.54 132"
              fill="#e9847e"
              opacity="0.46"
            />
            <polygon
              points="1438.38 190.69 1405.54 132 1405.54 211.47 1405.54 330.67 1439.95 309.72 1438.38 190.69"
              fill="#6d265c"
            />
          </g>
          <polygon
            points="1405.67 132 1405.67 211 1438.67 191 1405.67 132"
            fill="#631c56"
          />
          <polygon
            points="1431.67 237.67 1431.67 242 1436.67 238.33 1436.67 234 1431.67 237.67"
            fill="#baa36a"
          />
          <polygon
            points="1417.67 224.67 1417.67 229 1422.67 225.33 1422.67 221 1417.67 224.67"
            fill="#baa36a"
          />
          <polygon
            points="1426.67 206.67 1426.67 211 1431.67 207.33 1431.67 203 1426.67 206.67"
            fill="#baa36a"
          />
          <rect x="1496.67" y="100" width="10" height="4" fill="#baa36a" />
          <rect x="1514.67" y="118" width="10" height="4" fill="#baa36a" />
          <rect x="1514.67" y="132" width="10" height="4" fill="#baa36a" />
          <rect x="1514.67" y="140" width="10" height="4" fill="#baa36a" />
          <rect x="1504.67" y="145" width="10" height="4" fill="#baa36a" />
          <rect x="1504.67" y="153" width="10" height="4" fill="#baa36a" />
          <rect x="1509.67" y="201" width="10" height="4" fill="#baa36a" />
          <rect x="1499.67" y="180" width="10" height="4" fill="#baa36a" />
          <rect x="1514.67" y="211" width="10" height="4" fill="#baa36a" />
          <rect x="1499.67" y="240" width="10" height="4" fill="#baa36a" />
        </g>
        <g>
          <rect x="207.67" y="101" width="40" height="246" fill="#7c5aa0" />
          <rect
            x="207.67"
            y="101"
            width="6"
            height="246"
            fill="#7ac1b3"
            opacity="0.46"
          />
          <rect
            x="230.67"
            y="206"
            width="5"
            height="1"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="2"
            opacity="0.46"
          />
          <rect
            x="234.67"
            y="223"
            width="5"
            height="1"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="2"
            opacity="0.46"
          />
          <rect
            x="216.67"
            y="183"
            width="5"
            height="1"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="2"
            opacity="0.46"
          />
          <rect
            x="234.67"
            y="175"
            width="5"
            height="1"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="2"
            opacity="0.46"
          />
          <rect
            x="218.67"
            y="154"
            width="5"
            height="1"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="2"
            opacity="0.46"
          />
          <rect
            x="235.67"
            y="134"
            width="5"
            height="1"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="2"
            opacity="0.46"
          />
          <rect
            x="230.67"
            y="120"
            width="5"
            height="1"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="2"
            opacity="0.46"
          />
          <rect
            x="222.67"
            y="110"
            width="5"
            height="1"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="2"
            opacity="0.46"
          />
        </g>
        <g>
          <rect
            x="300.67"
            y="144.18"
            width="29"
            height="224.82"
            fill="#6d4c89"
          />
          <rect
            x="300.67"
            y="144.18"
            width="4"
            height="224.82"
            fill="#e9847e"
            opacity="0.46"
          />
          <rect x="272.67" y="93" width="29" height="224.82" fill="#6d4c89" />
          <rect
            x="272.67"
            y="93"
            width="6"
            height="224.82"
            fill="#e9847e"
            opacity="0.46"
          />
          <line
            x1="272.67"
            y1="317.82"
            x2="272.67"
            y2="93"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.91"
            opacity="0.46"
          />
          <line
            x1="272.67"
            y1="93"
            x2="278.67"
            y2="93"
            fill="#e9847e"
            opacity="0.46"
          />
          <rect
            x="293.67"
            y="96.66"
            width="5"
            height="0.91"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.91"
            opacity="0.46"
          />
          <rect
            x="290.67"
            y="117.68"
            width="5"
            height="0.91"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.91"
            opacity="0.46"
          />
          <rect
            x="283.67"
            y="131.38"
            width="5"
            height="0.91"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.91"
            opacity="0.46"
          />
          <rect
            x="283.67"
            y="149.66"
            width="5"
            height="0.91"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.91"
            opacity="0.46"
          />
          <rect
            x="290.67"
            y="135.04"
            width="5"
            height="0.91"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.91"
            opacity="0.46"
          />
          <rect
            x="289.67"
            y="156.97"
            width="5"
            height="0.91"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.91"
            opacity="0.46"
          />
          <rect
            x="308.67"
            y="147.83"
            width="5"
            height="0.91"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.91"
            opacity="0.46"
          />
          <rect
            x="319.67"
            y="161.54"
            width="5"
            height="0.91"
            fill="none"
            stroke="#eda948"
            strokeMiterlimit="10"
            strokeWidth="1.91"
            opacity="0.46"
          />
          <rect
            x="319.67"
            y="154.23"
            width="5"
            height="0.91"
            fill="none"
            stroke="#eda948"
            strokeMiterlimit="10"
            strokeWidth="1.91"
            opacity="0.46"
          />
          <rect
            x="312.67"
            y="177.99"
            width="5"
            height="0.91"
            fill="none"
            stroke="#eda948"
            strokeMiterlimit="10"
            strokeWidth="1.91"
            opacity="0.46"
          />
          <rect
            x="317.67"
            y="181.65"
            width="5"
            height="0.91"
            fill="none"
            stroke="#eda948"
            strokeMiterlimit="10"
            strokeWidth="1.91"
            opacity="0.46"
          />
          <rect
            x="317.67"
            y="235.57"
            width="5"
            height="0.91"
            fill="none"
            stroke="#eda948"
            strokeMiterlimit="10"
            strokeWidth="1.91"
            opacity="0.46"
          />
          <rect
            x="311.67"
            y="221.86"
            width="5"
            height="0.91"
            fill="none"
            stroke="#eda948"
            strokeMiterlimit="10"
            strokeWidth="1.91"
            opacity="0.46"
          />
          <rect
            x="283.67"
            y="170.68"
            width="5"
            height="0.91"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.91"
            opacity="0.46"
          />
          <rect
            x="290.67"
            y="177.08"
            width="5"
            height="0.91"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.91"
            opacity="0.46"
          />
          <rect
            x="290.67"
            y="182.56"
            width="5"
            height="0.91"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.91"
            opacity="0.46"
          />
          <rect
            x="287.67"
            y="201.75"
            width="5"
            height="0.91"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.91"
            opacity="0.46"
          />
          <rect
            x="287.67"
            y="215.46"
            width="5"
            height="0.91"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.91"
            opacity="0.46"
          />
          <rect
            x="290.67"
            y="227.34"
            width="5"
            height="0.91"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="1.91"
            opacity="0.46"
          />
        </g>
        {/* <rect
          x="6.67"
          y="310"
          width="1523"
          height="497"
          fill="url(#ec29a5b1-ca2b-4641-9bcb-d8608b55670f)"
        /> */}
        <g>
          <path
            d="M827,352.61l-.23-1.84-.6-4.83c-2.44-3.35-.25-2.08-.4-3.23,2.56-.19-.29-2.35-.44-3.6-2.76-.29-.36-1.52-.47-2.19-.74-2.22-.16-1.31-.21-1.92.86-1-.08-1.21-.12-1.82.83-2.6-.09-1.23-.17-1.9-1.23-.15-.24-1.76-.38-2.91s-.27-2.38-.4-3.4c-.17-1.17-.5-4-.72-5.8a43,43,0,0,1-.59-4.78l-.55-4.43c-1.88-.06-3.68-.7-5.7-.93L817.7,323l1,8.07c.24,3.23.68,5.49,1,8.07,3.15,2.94.62,5,.87,7-1.11.62.47,3.78.62,5l.23,1.89Z"
            fill="#6d4c89"
          />
          <path
            d="M917.23,315.18l-4.18.29-4.83.35c-3.5.66-4,.28-6.3.44-5.17-.38-4.83.35-7.5.54,1.89,2.74-5.51.39-8.45.6,1.71,1-2.55.18-3.85.27l-4,.28a11.14,11.14,0,0,1-4.56.75c1.21,1.91-2.19-.27-3.57-.17-2.75,2.09-2.52.18-3.79.27-.09-1-2.53.18-3.81.27.65.7-2.54.18-3.81.27.9.52-2.53.18-3.8.27-2,.71-2.52.18-3.77.27l-3.72.26c-5.66-1.12-4.89.35-7.25.52-5,.42-4.66.33-6.88.49-1.69.67-4.35.31-6.38.45-1.27-1.07-4,.28-5.74.41l-14.81,1.05.83,6.78,1.25-.09,3.52-.25c1.47-1,3.36-.23,5.47-.38,1.56-.88,2.18-.16,3.37-.24,2.84-1,2.43-.18,3.73-.27-.36.91.91.43,1.48.27a9.38,9.38,0,0,1,1.74-.5c1.48.63,2.25-.16,3.41-.24.66,3.25,2.17,1.4,3.43.92,2.7,0,2.6-1.35,3.86-1.44,3.14-.67,3.09-.77,4.25-.72,1.5-.43,2.22.26,3.55.17l4-.29,4.1-.29c.14,0,2.75-.2,4.13-.29,2.81,1.07,2.77-.2,4.16-.3,1.4.92,2.64-.41,4.06-.46-1.18-1.16,2.86,0,4.23-.13,2.28.89,5.47-.39,8.13-.58a34.78,34.78,0,0,0,3.79-.19l2-.19c.59,0,1.33-.12,2-.17.37,2.49,3.11.1,4.47-.08-3.26-1.57,2.65-.42,4-.52.16-.8,2.51-.24,3.79-.31,1,2.27,2.55-.14,3.71-.22,4.67.86,4.43-.32,6.3-.45l9-.64Z"
            fill="#6d4c89"
          />
          <path
            d="M826.78,352.62a19.75,19.75,0,0,1,1.26-3.1,31.37,31.37,0,0,1,1.67-2.92l.12-.19.31,0a5.32,5.32,0,0,0,1.19-.26c.36-.12.56-.3.57-.44a4,4,0,0,0,0-1,2.56,2.56,0,0,1,.6-1.88l1.07-1.14.5,1.61a.71.71,0,0,0,.08.2s0,0,0-.08a.65.65,0,0,0-.37-.21c-.39,0-.4.07-.39,0l.15-.18c.27-.35.56-.83.85-1.3s.58-1,.91-1.49a7.33,7.33,0,0,1,1.31-1.58l-.29.32a7.63,7.63,0,0,1,2.91-2.77c1.08-.63,2.09-1.07,2.93-1.6l-.78,1.14a2.77,2.77,0,0,1,.39-1,4.1,4.1,0,0,1,.54-.64,5.87,5.87,0,0,1,1-.71,13.42,13.42,0,0,1,1.78-.84c1.14-.45,2.24-.81,3.27-1.17s2.1-.84,3.21-1.22,2.24-.76,3.37-1.09a68.63,68.63,0,0,1,13.89-2.42l.45,0,.46.18a8.48,8.48,0,0,0,3.8.2,32.76,32.76,0,0,1,5.18-.39l.12,4a3.84,3.84,0,0,1-1.14-.06,2.48,2.48,0,0,1-.39-.1l-.19-.07-.18-.09-.25-.16a2.65,2.65,0,0,1-.34-.33,1.3,1.3,0,0,1-.15-.2l-.06-.1-.09-.18a2.1,2.1,0,0,1,0-1.7,1.58,1.58,0,0,1,.18-.3l.08-.12c.07-.07.13-.14.21-.21a2.1,2.1,0,0,1,.5-.34l.17-.07.05,0a1.83,1.83,0,0,1,.25-.06,2.32,2.32,0,0,1,.56-.06h.24c.51,0,.85.1,1.23.16.74.12,1.45.26,2.15.4l.32.07.25.14a3.85,3.85,0,0,0,1.61.4c.71.05,1.49,0,2.52,0a5.19,5.19,0,0,1,.9.07l.62.11c.35.05.72.09,1.14.12a10.57,10.57,0,0,1,3.06.52l1,2.4a1.42,1.42,0,0,0,0-.94,1.32,1.32,0,0,0-.38-.6c-.17-.13-.11-.06,0,0a5.54,5.54,0,0,0,.85.26l1.1.26c.4.1.79.18,1.33.36l.92.32.15.83c0,.12,0,.2.37.43a6.08,6.08,0,0,0,1.48.49l1.93.39a8.87,8.87,0,0,1,2.23.75l-.16-.07a21.69,21.69,0,0,1,4.47,2.64c1.32.95,2.65,1.95,3.92,3a38.7,38.7,0,0,1,3.61,3.4,27.7,27.7,0,0,1,3.09,3.83,46.27,46.27,0,0,0-7.62-6c-1.35-.87-2.76-1.63-4.17-2.45a19.12,19.12,0,0,0-4.13-1.94l-.16-.06a7,7,0,0,0-1.58-.33l-2-.25a9.3,9.3,0,0,1-2.31-.62,4.22,4.22,0,0,1-1.29-.89,3.55,3.55,0,0,1-.89-1.55l1.08,1.16c-.21-.06-.58-.12-.94-.18l-1.17-.18a8.68,8.68,0,0,1-1.39-.34,3.31,3.31,0,0,1-1-.59,2.18,2.18,0,0,1-.61-2.57l1,2.4a7.8,7.8,0,0,0-2-.21c-.44,0-.93,0-1.44-.09l-.66-.08h-.4c-.7,0-1.64.13-2.66.1a7.19,7.19,0,0,1-3.39-.8l.58.21c-.67-.13-1.34-.26-2-.35-.31-.05-.65-.09-.84-.1h0a1.37,1.37,0,0,0,.31,0l.21-.06.05,0,.16-.07a1.92,1.92,0,0,0,.48-.32l.2-.21.08-.11a1.7,1.7,0,0,0,.18-.31,2.05,2.05,0,0,0,0-1.68l-.09-.17-.06-.1-.14-.19a2,2,0,0,0-.33-.32,1.17,1.17,0,0,0-.22-.14l-.15-.08-.13-.05-.13,0h-.1l.11,4A29.91,29.91,0,0,0,874,331a19.57,19.57,0,0,1-2.73.16,8.71,8.71,0,0,1-3.07-.6l.91.14a73.94,73.94,0,0,0-13.17,2c-1.07.26-2.14.56-3.2.88s-2.05.7-3.26,1.08l-3.25.95a11.86,11.86,0,0,0-1.38.52,3.81,3.81,0,0,0-.42.24s0,0,0,0a.66.66,0,0,0,.08-.27l-.78,1.15c-1.12.58-2.21,1-3.11,1.41a5.48,5.48,0,0,0-2.12,1.62l-.18.25-.1.07a4.86,4.86,0,0,0-.94,1c-.34.41-.67.86-1,1.32a15.35,15.35,0,0,1-1.18,1.44,4.19,4.19,0,0,1-.47.4,1.58,1.58,0,0,1-1.17.3,1.29,1.29,0,0,1-.72-.43,1.65,1.65,0,0,1-.26-.44,3.34,3.34,0,0,1-.16-.62l1.58.47c-.12.08-.22.22-.26.64a4.07,4.07,0,0,1-.32,1.64,1.89,1.89,0,0,1-.75.76,2.84,2.84,0,0,1-.83.31,6.46,6.46,0,0,1-1.5.09l.43-.22A30.89,30.89,0,0,0,826.78,352.62Z"
            fill="#6d4c89"
          />
          <path
            d="M869.56,333.62c3.21.18-.15-1.26-.36-2.94.93.32.81-.62.44-1.85a30.68,30.68,0,0,1-1.11-3.59c2.07-2.56.85-.82.52-1.53-.25-1.81-.89-1.4-.89-1.4"
            fill="none"
            stroke="#6d4c89"
            strokeMiterlimit="10"
            strokeWidth="4.17"
          />
        </g>
        <g>
          <g>
            <polygon
              points="1111.67 322.67 1112.74 265.61 1115.82 265.61 1117.02 324.16 1111.67 324.16 1111.67 322.67"
              fill="#6d4c89"
            />
            <path
              d="M1132.86,248.8c0,2.34-5.71,4.31-13.5,4.92-3.22,3.57-2,8.48-2,8.48h-6.21a7.77,7.77,0,0,0-1.74-8.48c-7.83-.59-13.57-2.57-13.57-4.92,0-2.83,8.29-5.12,18.52-5.12S1132.86,246,1132.86,248.8Z"
              fill="#6d4c89"
            />
            <polygon
              points="1114.23 324.67 1117.02 324.67 1115.88 269.41 1114.43 270.89 1114.23 324.67"
              fill="#6d4c89"
              opacity="0.42"
            />
            <circle cx="1114.48" cy="265.14" r="6.22" fill="#6d4c89" />
            <path
              d="M1115.22,259s5.48,9.64-5.68,9.95a6.22,6.22,0,1,0,5.68-9.95Z"
              fill="#6d4c89"
              opacity="0.21"
            />
          </g>
          <ellipse
            cx="1114.35"
            cy="244.82"
            rx="18.45"
            ry="6.82"
            fill="#6d4c89"
          />
        </g>
        <g>
          <circle
            cx="1314.19"
            cy="224.92"
            r="79.29"
            fill="none"
            stroke="#4d3468"
            strokeMiterlimit="10"
            strokeWidth="6.37"
          />
          <circle
            cx="1315.12"
            cy="225.05"
            r="43.37"
            fill="none"
            stroke="#4d3468"
            strokeMiterlimit="10"
            strokeWidth="5.1"
          />
          <circle cx="1315.12" cy="225.05" r="6.65" fill="#3d2651" />
          <polyline
            points="1371.06 169.67 1314.99 224.92 1390.48 203.24"
            fill="none"
            stroke="#4d3468"
            strokeMiterlimit="10"
            strokeWidth="0.8"
          />
          <polyline
            points="1377.75 272.33 1314.86 224.79 1392.28 238.73"
            fill="none"
            stroke="#4d3468"
            strokeMiterlimit="10"
            strokeWidth="0.8"
          />
          <polyline
            points="1314.06 304.08 1314.86 224.79 1352.73 294.23"
            fill="none"
            stroke="#4d3468"
            strokeMiterlimit="10"
            strokeWidth="0.8"
          />
          <polyline
            points="1247.89 268.42 1314.86 224.79 1281.78 297.31"
            fill="none"
            stroke="#4d3468"
            strokeMiterlimit="10"
            strokeWidth="0.8"
          />
          <polyline
            points="1239.85 197.29 1314.86 224.79 1235.19 231.71"
            fill="none"
            stroke="#4d3468"
            strokeMiterlimit="10"
            strokeWidth="0.8"
          />
          <polyline
            points="1286.09 150.75 1314.86 224.79 1257.33 169.67"
            fill="none"
            stroke="#4d3468"
            strokeMiterlimit="10"
            strokeWidth="0.8"
          />
          <polyline
            points="1347.29 152.85 1314.86 224.79 1317.01 145.1"
            fill="none"
            stroke="#4d3468"
            strokeMiterlimit="10"
            strokeWidth="0.8"
          />
          <ellipse cx="1272.1" cy="154.46" rx="14.5" ry="8.72" fill="#4d3468" />
          <ellipse
            cx="1319.25"
            cy="141.72"
            rx="14.5"
            ry="8.72"
            fill="#4d3468"
          />
          <ellipse cx="1361.3" cy="157.01" rx="14.5" ry="8.72" fill="#4d3468" />
          <ellipse
            cx="1388.06"
            cy="187.59"
            rx="14.5"
            ry="8.72"
            fill="#4d3468"
          />
          <ellipse
            cx="1393.16"
            cy="223.27"
            rx="14.5"
            ry="8.72"
            fill="#4d3468"
          />
          <ellipse cx="1388.06" cy="261.5" rx="14.5" ry="8.72" fill="#4d3468" />
          <ellipse cx="1358.75" cy="290.8" rx="14.5" ry="8.72" fill="#4d3468" />
          <g>
            <ellipse
              cx="1315.43"
              cy="303.55"
              rx="14.5"
              ry="8.72"
              fill="#4d3468"
            />
            <path
              d="M1319.25,311c-8,0-14.5-3.9-14.5-8.72,0-2.81,2.22-5.3,5.65-6.89-5.53,1.23-9.47,4.42-9.47,8.17,0,4.81,6.49,8.71,14.5,8.71a21.18,21.18,0,0,0,8.85-1.82A23.14,23.14,0,0,1,1319.25,311Z"
              fill="#dba877"
              opacity="0.57"
            />
          </g>
          <polyline
            points="1247.81 323.5 1314.72 224.65 1379.24 319.77"
            fill="none"
            stroke="#4d3468"
            strokeMiterlimit="10"
            strokeWidth="7.18"
          />
          <ellipse
            cx="1274.65"
            cy="293.35"
            rx="14.5"
            ry="8.72"
            fill="#4d3468"
          />
          <ellipse
            cx="1240.25"
            cy="264.05"
            rx="14.5"
            ry="8.72"
            fill="#4d3468"
          />
          <ellipse
            cx="1230.05"
            cy="224.54"
            rx="14.5"
            ry="8.72"
            fill="#4d3468"
          />
          <ellipse cx="1242.8" cy="187.59" rx="14.5" ry="8.72" fill="#4d3468" />
        </g>
        <g>
          <path
            d="M705.74,381.7l2.07-2.77,3.85-5.15a3.86,3.86,0,0,1,2.07-2.77l.35-.47c-.11-.28,1.13-1.51,1.72-2.31,2.57-2.3,1.22-1.84,1.9-2.69,5.4-3.61,1.36-1.66,1.95-2.45.78,1,1.2-1.61,1.55-2.07.09-2.64.52-.71.52-.71-2.6,4.86-.41-.65-1.12-1.77-1.35,0-1.11-1.47-1.51-2.19-.67.3-.79-1.46-1.38-2.4-.21,2.3-1.36-1.67-2-2.79,1.58-2.87-1.26-2.35-2-3.47l-12.29-19.45-13.12,2.69-8.08,10.76.88,1.38,2.34,3.67c.53.89,1.06,1.72,1.62,2.59s1.14,1.75,1.77,2.74c4.53,2.78,1.82,2.05,2.36,3.09.41.53,1,2.12,1.66,3.22,4.55-2.59,1.71,1.84,2.34,3,.38.15,1.18,2.5,1.88,3.6-2.57,2.32.6,2.74,1.47,3.65-.63,4.16,1.92,1.67,2.55,2.66.4,1.22,1.24,1.73,1.81,2.67s1.09,1.88,1.58,2.65Z"
            fill="#6d4c89"
          />
          <path
            d="M726.77,368.37c-.14.69-.56-.89-1.31-2.09.93-.69-.88-1.22-1.28-1.9-2.49,1.93-.77-1.38-1.15-2-7.14.5-1.31-2.09-1.31-2.09-2.06-1.43,0,.2-.44.72,1.14,1.16-1,1.26-1.63,2.06.23,4.42-1.14,2.25-1.84,3-1.35-.46-1.41,1.35-2,2.14-1.1.95-1.4,1.13-1.7,1.71a4.3,4.3,0,0,0-.37,1.07c-.26.21.1.14.77,0s1.65-.45,2.61-.65c.89.23,2.2-.42,3.25-.63.79.83,2.07-.44,3-.63-.17,1.57,1.81-.37,2.42-.49C725.52,367.94,726.77,368.37,726.77,368.37Z"
            fill="#6d4c89"
          />
          <path
            d="M708.65,363c-.85.11,0-.09.68-.21.67-3.58,1.74-.28,2.71-.48.12,2,2.44-.31,3.43-.56a7.65,7.65,0,0,1,2.86-.73c2.16,2.46,1.88-.46,2.47-.56-1,1.38.92-.14.92-.14,1.41-.91-.43-.06-.75.53-1.87,2-.73,1.45-1.32,2.25-1.56-1.14-.49,2-1.34,2.8-.62,1.33-1.91,1.55-2.51,2.34,0-.38-.8,1.14-1.25,1.72s-.82,1.06-.82,1.06c-1.1-.12-1.46.3-3.4.71S706,372.63,704,373c-.56.74-3.41.71-3.41.71-.19.15,0-.15.45-.69s1-1.3,1.64-2.1c-.07-1.08,1.54-1.63,2.14-2.54-.11-1.72,1.13-1.84,1.73-2.64-1.21-.38,0-.83.65-1.49C708.78,364.23,708.65,363,708.65,363Z"
            fill="#6d4c89"
          />
          <path
            d="M695.49,365.69c-4.84,2.34-.4.73.4.4-3.69,2,2-.9,3-1.1-.78,1.86,1.23.58,1.79.57a6.54,6.54,0,0,0,1.6-.44c1.09-.19,1-.55,1.49-.82,1.28-.21,1-.51,1.45-.61.66.2,1.8-.65,2.41-.7-.29-.1,1,0,1,0,.33-.51,0-.92.45-1.26a5.72,5.72,0,0,0,1.63-1.53c-1.16-.81,1.17-2.4,1.87-3.12-1,1,1.41-1.26,2-2.06-1.5-1.34.91-1.72,1.33-2.16,2-1.69.76-.62.76-.62,1.87-1.6-.44.09-1,.21,3.38,1-1.41.29-2.39.5a26.47,26.47,0,0,0-3.6.78,12.08,12.08,0,0,1-2.74.54c.08.08-1.75-.3-2.38,0,.36.65-1,.72-1,.72-.57-.8-.37-.14-.71.46.6-.74-.78,1.52-1.37,2.31-.15-2.55-2,1.09-2.49,2.13,4.59,1.4-.78,2.23-1.38,3-1,1.23-1.18,1.39-1.54,1.91C694.17,367.11,695.49,365.69,695.49,365.69Z"
            fill="#6d4c89"
          />
          <path
            d="M690.4,357.67c1.21.11-.48.76.34.43.17-1.72,2.09-.92,3.06-1.12,2.58,1.12,2.68-.83,3.62-1,3.19-1.57,1.73-.15,2.7-.35.67,0,1.86-.66,2.46-.71.44-1.41.94,0,.94,0-.51-.74.26-.95.62-1.28a9.5,9.5,0,0,0,1.47-1.5c.81-1.76,1.72-2.29,2.6-3.46l3.35-4.46L698.44,347l-.6.79-1.49,2a14.13,14.13,0,0,1-1.79,2.75c.73-.79-1.48,1.61-2.07,2.4a15.89,15.89,0,0,1-1.36,2.26C689.47,358,690.4,357.67,690.4,357.67Z"
            fill="#6d4c89"
          />
          <path
            d="M706.47,336.27,693.39,339l-2.09,2.78-3.89,5.15a13,13,0,0,0-2.09,2.78c-.44.49,1.46-.3,3.4-.7,2.07.88,4.37-.89,6.31-1.29l3.41-.7Z"
            fill="#6d4c89"
          />
          <polygon
            points="680.26 341.69 693.39 338.95 701.46 328.24 688.34 330.93 680.26 341.69"
            fill="#6d4c89"
          />
          <path
            d="M713.73,371c2-2.19-.31-.5-.87-1.38-.71-.06-.49-1-.91-1.61.1-.13-.94-1.3-1.42-2.07a4.91,4.91,0,0,0-1.33-2.37c0-.38-1.42-2-2.05-3,.57,0,.28-.36-.24-.92.16-1.19-1.27-1.26-1.62-1.85.62-.16-.6-1-1-1.68-.74-1.19-.81-1.33-1.16-1.88-.82-2.4-2.34-3.7-3.51-5.55l-11.29-17.81"
            fill="#6d4c89"
          />
          <path
            d="M705.74,381.7l13-2.65,2.07-2.77,3.84-5.14a7.3,7.3,0,0,0,2.07-2.77c.76-1.4-.36.08-1,.2a13.64,13.64,0,0,0-2.42.49c-1.28,1.41-2.09.38-3.17.6,1.6.76-2.14.47-3.11.66,1.89-.92-1.41-.19-2.11.07a7.21,7.21,0,0,0-1.27.62c.08-.42-.89,1.18-2.07,2.77Z"
            fill="#6d4c89"
          />
        </g>
        <path
          d="M1529.67,310q.49,350,1,700-1054.14,76.23-1072-27Q448.49,924.16,775,807c195.7-59.6,228.15-86.27,228.7-100,.39-9.65-4.68-17.31-10.32-26.06-15-23.21-44-46.81-142.65-63.65-80.44-13.73-136.43-5.36-182.64-15.92-27.34-6.25-64-14.53-68.38-16.37a45.29,45.29,0,0,0-6-2,43.45,43.45,0,0,0-5-1c-6-.87-12-2.08-18-3-1.51-.23-11-1.69-22-4-11.14-2.34-17.55-4.29-20-5-11.77-3.43-14.68-5.15-17-7-2.06-1.65-8.73-7-10-16-1.18-8.42,3-15,5-18,2.35-3.64,5.23-6.09,11-11a126.76,126.76,0,0,1,12-9,165,165,0,0,1,15-9,198.12,198.12,0,0,1,35-14c8.69-2.63,15.19-4,22.36-5.59,20-4.31,29.7-5.11,37.64-6.41,46.29-7.6,43.36-42.36,114-58,140-31,148.82-83,161-106Z"
          fill="#41275b"
        />
        <g>
          <ellipse cx="1212.67" cy="330.5" rx="24" ry="5.5" fill="#5a3e77" />
          <ellipse cx="1212.17" cy="328" rx="24" ry="5.5" fill="#6d4c89" />
          <circle cx="1209.67" cy="296" r="34" fill="#663f6d" />
          <path
            d="M1185.67,300a34,34,0,0,1,34-34,33.56,33.56,0,0,1,7.48.84,34,34,0,1,0-25,62.32A34,34,0,0,1,1185.67,300Z"
            fill="#d0827d"
          />
          <path
            d="M1188.35,269.52a48.66,48.66,0,0,0,10.48,2.89,60.17,60.17,0,0,0,10.8.82c.9,0,1.81-.07,2.71-.1s1.8-.09,2.7-.21l2.7-.29,2.68-.45c1.8-.24,3.54-.76,5.31-1.16s3.49-1,5.26-1.5c-.84.35-1.69.69-2.54,1s-1.7.71-2.58.95c-1.76.5-3.49,1.11-5.3,1.44-.9.2-1.79.4-2.7.57l-2.73.36a25.13,25.13,0,0,1-2.74.25c-.92,0-1.84.14-2.76.12a49.67,49.67,0,0,1-11-1.07,48.38,48.38,0,0,1-5.31-1.44A32.61,32.61,0,0,1,1188.35,269.52Z"
            fill="#a285c1"
          />
          <path
            d="M1207.17,329.5c.87.18,1.73.35,2.58.5a34,34,0,0,0,26.83-54.77h0S1247.17,324.5,1207.17,329.5Z"
            fill="#5a3e77"
          />
          <path
            d="M1180.17,279.1a69.93,69.93,0,0,0,7.09,2.85c2.4.83,4.84,1.56,7.3,2.15a65.32,65.32,0,0,0,15,2,47.72,47.72,0,0,0,7.56-.41c1.26-.13,2.49-.39,3.74-.62s2.46-.56,3.67-.94,2.4-.78,3.59-1.2l1.75-.74a18,18,0,0,0,1.72-.81,47.74,47.74,0,0,0,6.57-3.87,41.1,41.1,0,0,1-13.4,7.36,40.4,40.4,0,0,1-7.52,1.73,49.51,49.51,0,0,1-7.69.5,61.94,61.94,0,0,1-15.21-2.25A63.46,63.46,0,0,1,1180.17,279.1Z"
            fill="#a285c1"
          />
          <path
            d="M1176.14,290.36a50.38,50.38,0,0,0,7.84,3.93,63.89,63.89,0,0,0,8.29,2.75,66.29,66.29,0,0,0,17.27,2.19,69.59,69.59,0,0,0,17.29-2.15,91.36,91.36,0,0,0,16.5-5.88c-1.3.67-2.6,1.37-3.92,2s-2.66,1.25-4,1.78-2.73,1.09-4.13,1.54c-.7.23-1.4.48-2.1.69l-2.12.61c-1.41.43-2.86.71-4.3,1s-2.89.56-4.36.72a65.06,65.06,0,0,1-8.82.64,63.72,63.72,0,0,1-17.48-2.45A52.81,52.81,0,0,1,1176.14,290.36Z"
            fill="#a285c1"
          />
          <path
            d="M1176.42,303.09a36.52,36.52,0,0,0,7.43,4.54l2,.89c.67.29,1.36.52,2,.77s1.35.54,2.05.72l2.09.59a58,58,0,0,0,17.2,1.83l4.34-.27c1.44-.13,2.87-.42,4.3-.62a85.43,85.43,0,0,0,8.51-1.85l1.06-.25,1-.34,2.08-.69,4.14-1.36,8.1-3.31c-2.62,1.28-5.27,2.52-7.92,3.76l-4.12,1.51-2.07.75-1,.38-1.06.29c-1.41.39-2.83.77-4.25,1.13-.72.17-1.41.41-2.14.51l-2.17.36c-1.46.22-2.9.53-4.36.68l-4.4.32a56.11,56.11,0,0,1-17.44-2.1A39.74,39.74,0,0,1,1176.42,303.09Z"
            fill="#a285c1"
          />
          <path
            d="M1183.05,317.14a49.35,49.35,0,0,0,12.84,4.58,58.71,58.71,0,0,0,13.53,1.38c1.13,0,2.27-.1,3.4-.14l1.7-.08,1.69-.22,3.38-.46c1.11-.24,2.23-.47,3.34-.69l1.68-.34c.55-.14,1.09-.31,1.64-.46l3.29-.94c2.18-.67,4.29-1.55,6.47-2.28-1,.48-2.08.95-3.13,1.4s-2.09,1-3.18,1.34l-3.27,1.09c-.55.17-1.09.37-1.64.53l-1.68.41c-1.12.27-2.24.54-3.36.79l-3.42.51-1.72.24-1.72.12c-1.16.05-2.31.18-3.46.18a55.48,55.48,0,0,1-13.71-1.63,52,52,0,0,1-6.57-2.14A37.23,37.23,0,0,1,1183.05,317.14Z"
            fill="#a285c1"
          />
        </g>
        <g>
          <g>
            <polygon
              points="1159.71 341.64 1161.33 255.62 1165.96 255.62 1167.78 343.9 1159.71 343.9 1159.71 341.64"
              fill="#6d4c89"
            />
            <path
              d="M1191.66,230.28c0,3.53-8.61,6.51-20.35,7.42-4.86,5.38-3,12.78-3,12.78h-9.37a11.69,11.69,0,0,0-2.62-12.77c-11.8-.9-20.46-3.89-20.46-7.43,0-4.26,12.5-7.71,27.92-7.71S1191.66,226,1191.66,230.28Z"
              fill="#6d4c89"
            />
            <polygon
              points="1163.57 344.67 1167.78 344.67 1166.06 261.36 1163.88 263.58 1163.57 344.67"
              fill="#6d4c89"
              opacity="0.42"
            />
            <circle cx="1163.95" cy="254.92" r="9.37" fill="#6d4c89" />
            <path
              d="M1165.06,245.61s8.26,14.55-8.56,15a9.37,9.37,0,1,0,8.56-15Z"
              fill="#6d4c89"
              opacity="0.21"
            />
          </g>
          <ellipse
            cx="1163.75"
            cy="224.28"
            rx="27.81"
            ry="10.28"
            fill="#6d4c89"
          />
        </g>
        <g>
          <g>
            <path
              d="M1484.57,301.84c7.42-12.27,10-15.06,6.8-23.31s-6.19-1.21-3-16.75S1479.47,241.62,1474,241s-31.32,14.57-27,22.82,6.23,31.68,1.54,33.63S1475.83,316.28,1484.57,301.84Z"
              fill="#396039"
            />
            <path
              d="M1479.59,273.31c-.24-6.68,9.84-9.35,6.56-12.38s-7.16-10.93-10.32-6.8-5.58,10.2-8,6.8-5.1-3.52-6.68,0-.24,7.89-4,6.8-5.46.6-5,4.24,3.28,2.19,5.7,6.56,13.36,3.76,11.54,1.34S1479.59,273.31,1479.59,273.31Z"
              fill="#447244"
            />
            <path
              d="M1498.41,261.78c5.46-8.62,13.11-16.51,20.76-9.11s-5.1,20.64,0,25.86,4,18.45,0,18.94-23.07.48-28,2.79-11.42-6.19-11.54-14.45S1498.41,261.78,1498.41,261.78Z"
              fill="#6b996b"
            />
            <path
              d="M1469.64,312.89c12.79,9.74,13.72-24.16,0-21.25s-18.21,2.06-22.58-4-15.3,4.62-15.66,7.65,3.15,13.24,10.68,16.15S1462,307.06,1469.64,312.89Z"
              fill="#447244"
            />
            <path
              d="M1496.07,319.68c-12.79,9.75-13.72-24.15,0-21.24s18.21,2.06,22.58-4,15.29,4.62,15.66,7.65-3.16,13.23-10.69,16.15S1503.72,313.86,1496.07,319.68Z"
              fill="#447244"
            />
            <path
              d="M1512,308c1.82-3.64,7.16,3.4,7.16,3.4s-.36-4.74,2.55-6.44,4.25,2.68,4.25,2.68c.24-3.4,7.16-.25,5.22,3.8h0a16.18,16.18,0,0,1-7.57,6.76,13.37,13.37,0,0,1-5.41.69l-6.52-1.65S1510.19,311.67,1512,308Z"
              fill="#396039"
            />
            <path
              d="M1485.66,314.22c-2.55,4.49-4,44.92,0,63.49,0,0-11.65-2.06-15.29-.12-.37,1.21-.37.12-.37.12s16.15-56.21,2.07-72.72-29.38,0-29.38,0,4.13-9.71,13.23-10.44,21.61,11.05,22.22,13.36c0,0,.48-17.73-5.22-23.92s1.57-10.68,1.57-10.68-7.52,2.31,4.62,18.09c6.29,8.18,1.82,23.43,1.82,23.43s3.88-11.9,13.6-9.35,15.53,13.84,24.64,13.11c0,0-10.68-.61-19.18-5.7S1485.66,314.22,1485.66,314.22Z"
              fill="#704d3c"
            />
            <path
              d="M1499,312.31a11.15,11.15,0,0,0-13.29,1.91c-.87,1.55-1.62,7.36-2.06,15.07-2.92-10.06,2.31-22,4-23.06a9.21,9.21,0,0,1,7-.75,21.19,21.19,0,0,1,6.4,3Z"
              fill="#634b42"
            />
            <path
              d="M1476.62,308.58c1.33,3,2.79,11.93,1.15,16.52h0c-.31-8.33-1.91-15.66-5.7-20.11a27.32,27.32,0,0,0-2.53-2.6l-.57-1.7C1471,301.78,1475.28,305.54,1476.62,308.58Z"
              fill="#44322c"
            />
            <path
              d="M1496.25,310.43c3.52-1.14,3.74-6.07,7.91-5.79s4.66,6.29,8.12,10.17,6.28,3,9,4.38-7.56,16.17-17.16,10.8-8.69-4.45-12-6.64S1488.41,313,1496.25,310.43Z"
              fill="#6b996b"
            />
            <g>
              <path d="M1478,302.81c.07.22.06.25,0,.11v-.11Z" fill="#7f2c03" />
              <path
                d="M1477.9,300.67c-.45-5.64-1.68-13.09-5-16.68a7.25,7.25,0,0,1-2.17-4.39l1.67-.32c.59,2.7,2.43,6.58,6.69,12.12l.28.38C1479.09,295,1478.09,298.25,1477.9,300.67Z"
                fill="#634b42"
              />
            </g>
            <path
              d="M1464.75,300.23c-2.31-2.89.23-7.13-3.4-9.19s-7.36,2.67-12.38,4-6.92-.93-10-1.34-2.62,17.66,8.35,18.48,9.69,1.09,13.67,1.1S1469.88,306.68,1464.75,300.23Z"
              fill="#6b996b"
            />
            <path
              d="M1469.37,266.16c2.4-3.78,5.74-7.23,9.09-4s-2.23,9,0,11.32,1.75,8.07,0,8.28-10.09.22-12.27,1.22-5-2.7-5-6.32S1469.37,266.16,1469.37,266.16Z"
              fill="#6b996b"
            />
            <path
              d="M1445.47,308.14c.69,1.05,2.71.85,3.88.38s1.85-4.06,3.74-3.43,2.8,2.49,4.9,1.88,1.19-2.86,3.88-2.9c2.48,0,5,1,5.08,2.36l0,.34h0a1.69,1.69,0,0,0,0,.33c-.49,3.55-3.35,6.17-5.86,6.17-4,0-2.7-.27-13.67-1.1a8.76,8.76,0,0,1-4-1.28C1442.11,310.09,1444.78,307.1,1445.47,308.14Z"
              fill="#447244"
            />
            <path
              d="M1494.77,323.33c2.67,0,8,2.91,8.74.24s6.07-3.28,6.68-2.07,3.88,2.8,5.7,1.83,3.64,1.45,2.81,2.41c-3.38,3.82-9.08,7.31-14.54,4.25-6.66-3.72-8.26-4.42-9.73-5.23C1493.81,324.3,1492.72,323.33,1494.77,323.33Z"
              fill="#396039"
            />
            <path
              d="M1484.81,292.61c1.7-3.76,5.83-3,8.74-2.55s2.07,4.37,4.37,2.55,7.41,2.55,5.48,5.71h0c-5.16.36-10.08.92-12.27,1.94-3.09,1.43-6.73-1.29-9.08-5.52l-1-2.14h0S1483.11,296.38,1484.81,292.61Z"
              fill="#447244"
            />
            <path
              d="M1515.65,290.31c-1.09-3.42,3.76-6.32,0-6.32s-10,3.77-9.35-1.7-1.09-8.37-5.22-8-7.27-8.49-5-10.5-12.87,3.82-6.2,9.53,9.11,3.88,8.86,6.56,0,8.25,5.1,9.1-1.44,7.77,2.38,9.35S1518.56,299.41,1515.65,290.31Z"
              fill="#447244"
            />
            <path
              d="M1470,377.71s1-3.48,2.29-9c10.14-5.21,10.87-22.14,10.89-22.64,0,11.51.75,23.6,2.48,31.61,0,0-11.65-2.06-15.29-.12C1470,378.8,1470,377.71,1470,377.71Z"
              fill="#44322c"
            />
            <path
              d="M1482.1,377.2c.07-3.28-1.07-6.38-1.49-9.63a65.22,65.22,0,0,1-.19-9.78c.12-3.26.46-6.5.68-9.74s.47-6.49.64-9.73c.09-1.62.18-3.24.2-4.86a16.73,16.73,0,0,0-.09-2.37c-.12-.74-.39-1.56-.57-2.35a29.27,29.27,0,0,1-.83-4.85,9.83,9.83,0,0,1,.66-4.93c.73-1.46,1.44-2.93,2.28-4.34a11.31,11.31,0,0,1,3.25-3.7,8.14,8.14,0,0,1,4.75-1.14,21.32,21.32,0,0,1,4.84.68,21.33,21.33,0,0,0-4.84-.5,7.84,7.84,0,0,0-4.55,1.25,11.2,11.2,0,0,0-3,3.64c-.8,1.4-1.48,2.88-2.17,4.34a9.71,9.71,0,0,0-.54,4.65,29.62,29.62,0,0,0,.84,4.74c.19.8.44,1.53.6,2.39a16.31,16.31,0,0,1,.11,2.5c0,1.63-.08,3.26-.16,4.89-.37,6.5-1,13-1.5,19.46a65.57,65.57,0,0,0,0,9.71C1481.26,370.74,1482.29,373.92,1482.1,377.2Z"
              fill="#44322c"
            />
            <path
              d="M1479.53,346.09a31.56,31.56,0,0,0,0,4,5.85,5.85,0,0,1-.24,2.06,5.5,5.5,0,0,1-1.07,1.79,10.91,10.91,0,0,0-3,7.06,17.13,17.13,0,0,0,0,3.92,11.93,11.93,0,0,0,.44,1.9c.2.61.44,1.29.6,1.94a32.42,32.42,0,0,1,.86,8c-.14-1.34-.3-2.67-.53-4a31.33,31.33,0,0,0-.87-3.89c-.2-.64-.43-1.22-.66-1.89a12.42,12.42,0,0,1-.49-2,16.48,16.48,0,0,1-.11-4.09,14.92,14.92,0,0,1,1-4,9.49,9.49,0,0,1,1-1.83,10.68,10.68,0,0,1,1.35-1.53,5,5,0,0,0,1.06-1.59,5.7,5.7,0,0,0,.32-1.9A24.5,24.5,0,0,1,1479.53,346.09Z"
              fill="#44322c"
            />
            <path
              d="M1479.53,294.49c.1.77.26,1.52.43,2.27a10.25,10.25,0,0,1,.4,2.3,4.77,4.77,0,0,1-.13,1.19,4.1,4.1,0,0,0-.19,1.08,9.53,9.53,0,0,0,.43,2.19c.89,2.91,1.74,6,1.32,9.2a14.73,14.73,0,0,1-.51,2.3l-.28,1.09-.2,1.12a31.31,31.31,0,0,0-.23,4.55,55.25,55.25,0,0,0,1,9.13,40.64,40.64,0,0,1-1.59-9.11,25,25,0,0,1,.14-4.66l.18-1.16.29-1.15a15.46,15.46,0,0,0,.45-2.21,15,15,0,0,0-.1-4.49c-.24-1.5-.67-3-1-4.47a9.38,9.38,0,0,1-.36-2.34,2.36,2.36,0,0,1,.1-.63c0-.2.11-.35.16-.54a5,5,0,0,0,.17-1.09,11,11,0,0,0-.23-2.27A17.77,17.77,0,0,1,1479.53,294.49Z"
              fill="#44322c"
            />
          </g>
          <g>
            <path
              d="M1410.26,324.19c6.13-10.12,8.22-12.42,5.61-19.23s-5.11-1-2.5-13.82-7.31-16.62-11.82-17.13-25.84,12-22.24,18.83,5.15,26.14,1.27,27.75S1403.05,336.11,1410.26,324.19Z"
              fill="#396039"
            />
            <path
              d="M1406.16,300.66c-.2-5.51,8.11-7.72,5.4-10.22s-5.9-9-8.51-5.61-4.61,8.41-6.61,5.61-4.21-2.9-5.51,0-.2,6.51-3.3,5.61-4.51.5-4.11,3.5,2.7,1.81,4.71,5.41,11,3.11,9.51,1.1S1406.16,300.66,1406.16,300.66Z"
              fill="#447244"
            />
            <path
              d="M1421.68,291.14c4.51-7.11,10.82-13.62,17.13-7.51s-4.21,17,0,21.33,3.3,15.23,0,15.63-19,.4-23.14,2.3-9.41-5.11-9.51-11.92S1421.68,291.14,1421.68,291.14Z"
              fill="#6b996b"
            />
            <path
              d="M1397.94,333.31c10.56,8,11.32-19.93,0-17.53s-15,1.7-18.63-3.31-12.62,3.81-12.92,6.31,2.61,10.92,8.82,13.33S1391.63,328.5,1397.94,333.31Z"
              fill="#447244"
            />
            <path
              d="M1419.75,338.92c-10.56,8-11.32-19.93,0-17.53s15,1.7,18.63-3.31,12.62,3.81,12.92,6.31-2.61,10.92-8.82,13.32S1426.06,334.11,1419.75,338.92Z"
              fill="#447244"
            />
            <path
              d="M1432.9,329.3c1.5-3,5.91,2.81,5.91,2.81s-.3-3.91,2.1-5.31,3.51,2.2,3.51,2.2c.2-2.8,5.91-.2,4.31,3.14h0a13.3,13.3,0,0,1-6.25,5.57,11,11,0,0,1-4.47.58l-5.38-1.37S1431.4,332.31,1432.9,329.3Z"
              fill="#396039"
            />
            <path
              d="M1411.16,334.41c-2.1,3.71-3.3,37.06,0,52.38,0,0-9.61-1.7-12.62-.1-.3,1-.3.1-.3.1s13.32-46.37,1.71-60-24.24,0-24.24,0,3.4-8,10.92-8.62,17.82,9.12,18.32,11c0,0,.4-14.62-4.3-19.73s1.3-8.81,1.3-8.81-6.21,1.9,3.81,14.92c5.19,6.75,1.5,19.33,1.5,19.33s3.2-9.82,11.22-7.71,12.82,11.42,20.33,10.81c0,0-8.82-.5-15.83-4.7S1411.16,334.41,1411.16,334.41Z"
              fill="#704d3c"
            />
            <path
              d="M1422.13,332.84a9.19,9.19,0,0,0-11,1.57c-.72,1.28-1.34,6.07-1.7,12.43-2.41-8.3,1.9-18.14,3.27-19a7.52,7.52,0,0,1,5.75-.62,17.57,17.57,0,0,1,5.28,2.51Z"
              fill="#634b42"
            />
            <path
              d="M1403.7,329.75c1.1,2.51,2.31,9.85,1,13.64h0c-.25-6.88-1.57-12.92-4.7-16.59a22.58,22.58,0,0,0-2.08-2.15l-.48-1.41C1399.1,324.14,1402.6,327.25,1403.7,329.75Z"
              fill="#44322c"
            />
            <path
              d="M1419.9,331.28c2.9-.94,3.09-5,6.52-4.77s3.85,5.18,6.7,8.39,5.19,2.5,7.46,3.61-6.23,13.34-14.16,8.91-7.16-3.67-9.9-5.48S1413.43,333.38,1419.9,331.28Z"
              fill="#6b996b"
            />
            <g>
              <path d="M1404.87,325c.06.18.06.2,0,.09V325Z" fill="#7f2c03" />
              <path
                d="M1404.76,323.23c-.37-4.65-1.39-10.8-4.11-13.76a6,6,0,0,1-1.79-3.62l1.38-.27c.48,2.23,2,5.43,5.52,10l.23.31C1405.74,318.53,1404.92,321.23,1404.76,323.23Z"
                fill="#634b42"
              />
            </g>
            <path
              d="M1393.91,322.87c-1.9-2.39.19-5.88-2.81-7.59s-6.06,2.2-10.21,3.3-5.71-.77-8.21-1.11-2.17,14.57,6.88,15.25,8,.9,11.28.9S1398.14,328.19,1393.91,322.87Z"
              fill="#6b996b"
            />
            <path
              d="M1397.73,294.75c2-3.11,4.73-6,7.49-3.28s-1.84,7.45,0,9.33,1.45,6.66,0,6.84-8.33.17-10.12,1-4.12-2.24-4.17-5.22S1397.73,294.75,1397.73,294.75Z"
              fill="#6b996b"
            />
            <path
              d="M1378,329.39c.57.87,2.23.71,3.2.31s1.52-3.34,3.08-2.83,2.31,2.06,4,1.56,1-2.36,3.19-2.4c2,0,4.12.81,4.19,2a2.83,2.83,0,0,1,0,.29h0l0,.26c-.4,2.93-2.76,5.1-4.83,5.09-3.28,0-2.23-.22-11.28-.9a7.4,7.4,0,0,1-3.33-1.06C1375.23,331,1377.44,328.53,1378,329.39Z"
              fill="#447244"
            />
            <path
              d="M1418.68,341.92c2.2,0,6.61,2.4,7.21.2s5-2.7,5.51-1.7,3.2,2.3,4.7,1.5,3,1.2,2.32,2c-2.79,3.15-7.49,6-12,3.51-5.49-3.07-6.81-3.65-8-4.32C1417.89,342.73,1417,341.92,1418.68,341.92Z"
              fill="#396039"
            />
            <path
              d="M1410.46,316.58c1.41-3.1,4.81-2.5,7.21-2.1s1.71,3.6,3.61,2.1,6.11,2.1,4.52,4.71h0c-4.26.29-8.32.76-10.13,1.6-2.54,1.18-5.54-1.06-7.49-4.55l-.84-1.77h0S1409.06,319.69,1410.46,316.58Z"
              fill="#447244"
            />
            <path
              d="M1435.9,314.68c-.9-2.82,3.11-5.21,0-5.21s-8.21,3.11-7.71-1.4-.9-6.91-4.31-6.61-6-7-4.1-8.66-10.62,3.15-5.11,7.86,7.51,3.2,7.31,5.4,0,6.82,4.21,7.52-1.2,6.41,2,7.71S1438.31,322.19,1435.9,314.68Z"
              fill="#447244"
            />
            <path
              d="M1398.24,386.79s.83-2.87,1.89-7.4c8.37-4.3,9-18.27,9-18.68,0,9.5.63,19.47,2.05,26.08,0,0-9.61-1.7-12.62-.1C1398.24,387.69,1398.24,386.79,1398.24,386.79Z"
              fill="#44322c"
            />
            <path
              d="M1408.23,386.37c0-2.71-.89-5.27-1.23-7.95a54.35,54.35,0,0,1-.17-8.07c.11-2.69.39-5.36.57-8s.39-5.35.53-8c.07-1.34.14-2.67.16-4a15.77,15.77,0,0,0-.07-2c-.1-.61-.33-1.28-.47-1.93a24.36,24.36,0,0,1-.69-4,8.22,8.22,0,0,1,.55-4.06c.6-1.21,1.18-2.42,1.88-3.58a9.48,9.48,0,0,1,2.68-3.06,6.78,6.78,0,0,1,3.92-.94,18.45,18.45,0,0,1,4,.56,17.84,17.84,0,0,0-4-.41,6.45,6.45,0,0,0-3.75,1,9,9,0,0,0-2.52,3c-.66,1.15-1.22,2.38-1.79,3.58a8,8,0,0,0-.45,3.83,23.87,23.87,0,0,0,.7,3.92c.15.66.36,1.26.49,2a13.12,13.12,0,0,1,.09,2.06c0,1.35-.07,2.69-.13,4-.31,5.37-.84,10.72-1.24,16.06a53.54,53.54,0,0,0,0,8C1407.53,381,1408.38,383.66,1408.23,386.37Z"
              fill="#44322c"
            />
            <path
              d="M1406.11,360.7a24.38,24.38,0,0,0,0,3.31,5,5,0,0,1-.2,1.7,4.8,4.8,0,0,1-.88,1.48,9,9,0,0,0-2.48,5.82,13.5,13.5,0,0,0,0,3.24,8.5,8.5,0,0,0,.36,1.57c.16.5.36,1.05.49,1.59a26.91,26.91,0,0,1,.71,6.62,36.89,36.89,0,0,0-1.15-6.49c-.17-.53-.36-1-.55-1.56a10.44,10.44,0,0,1-.4-1.65A13.2,13.2,0,0,1,1402,373a12.54,12.54,0,0,1,.79-3.29,8.78,8.78,0,0,1,.81-1.51,9.21,9.21,0,0,1,1.12-1.26,4.16,4.16,0,0,0,.87-1.31,4.54,4.54,0,0,0,.27-1.57A19.4,19.4,0,0,1,1406.11,360.7Z"
              fill="#44322c"
            />
            <path
              d="M1406.11,318.13c.08.63.21,1.25.35,1.87a9.21,9.21,0,0,1,.33,1.9,4,4,0,0,1-.11,1,3.07,3.07,0,0,0-.15.89,7.24,7.24,0,0,0,.35,1.81,18.2,18.2,0,0,1,1.09,7.59,13.09,13.09,0,0,1-.42,1.9l-.23.9-.17.92a24.74,24.74,0,0,0-.19,3.75,45.69,45.69,0,0,0,.85,7.54,34,34,0,0,1-1.31-7.52,21.58,21.58,0,0,1,.11-3.85l.16-.95.23-.95a12.8,12.8,0,0,0,.38-1.82,12.5,12.5,0,0,0-.09-3.71c-.19-1.23-.55-2.44-.85-3.68a7.63,7.63,0,0,1-.29-1.93,3.46,3.46,0,0,1,.21-1,4.56,4.56,0,0,0,.14-.9C1406.53,320.67,1406.1,319.41,1406.11,318.13Z"
              fill="#44322c"
            />
          </g>
          <g>
            <path
              d="M1338,331.31c5.52-9.13,7.41-11.21,5.06-17.36s-4.61-.9-2.26-12.47-6.6-15-10.67-15.47-23.33,10.85-20.07,17,4.64,23.6,1.14,25.05S1331.49,342.07,1338,331.31Z"
              fill="#396039"
            />
            <path
              d="M1334.29,310.07c-.18-5,7.32-7,4.88-9.23s-5.33-8.14-7.68-5.06-4.16,7.59-6,5.06-3.8-2.62-5,0-.19,5.88-3,5.07-4.07.45-3.71,3.16,2.45,1.63,4.25,4.88,10,2.81,8.59,1S1334.29,310.07,1334.29,310.07Z"
              fill="#447244"
            />
            <path
              d="M1348.3,301.48c4.07-6.42,9.77-12.3,15.47-6.79s-3.8,15.38,0,19.26,3,13.75,0,14.11-17.18.36-20.89,2.08-8.5-4.61-8.59-10.76S1348.3,301.48,1348.3,301.48Z"
              fill="#6b996b"
            />
            <path
              d="M1326.87,339.54c9.53,7.26,10.22-18,0-15.82s-13.56,1.54-16.81-3-11.4,3.44-11.67,5.7,2.35,9.86,8,12S1321.18,335.2,1326.87,339.54Z"
              fill="#447244"
            />
            <path
              d="M1346.56,344.61c-9.53,7.25-10.22-18,0-15.83s13.56,1.54,16.82-3,11.39,3.43,11.66,5.7-2.35,9.85-8,12S1352.26,340.27,1346.56,344.61Z"
              fill="#447244"
            />
            <path
              d="M1358.43,335.93c1.36-2.72,5.34,2.53,5.34,2.53s-.27-3.53,1.9-4.79,3.16,2,3.16,2c.18-2.53,5.33-.18,3.89,2.84h0a12,12,0,0,1-5.64,5,9.94,9.94,0,0,1-4,.52l-4.86-1.24S1357.08,338.64,1358.43,335.93Z"
              fill="#396039"
            />
            <path
              d="M1338.81,340.54c-1.9,3.34-3,33.45,0,47.29,0,0-8.68-1.54-11.39-.09-.27.9-.27.09-.27.09s12-41.87,1.53-54.16-21.88,0-21.88,0,3.08-7.24,9.86-7.78,16.09,8.23,16.54,9.95c0,0,.37-13.21-3.88-17.82s1.17-7.95,1.17-7.95-5.6,1.71,3.44,13.47c4.68,6.09,1.35,17.45,1.35,17.45s2.9-8.86,10.13-7,11.57,10.3,18.36,9.76c0,0-8-.45-14.29-4.25S1338.81,340.54,1338.81,340.54Z"
              fill="#704d3c"
            />
            <path
              d="M1348.71,339.12a8.29,8.29,0,0,0-9.9,1.42c-.65,1.15-1.21,5.48-1.54,11.22-2.17-7.49,1.72-16.38,3-17.17a6.78,6.78,0,0,1,5.19-.56,15.63,15.63,0,0,1,4.77,2.27Z"
              fill="#634b42"
            />
            <path
              d="M1332.07,336.33c1,2.26,2.08,8.89.86,12.31h0c-.23-6.2-1.42-11.66-4.25-15a18.37,18.37,0,0,0-1.88-1.94l-.42-1.27C1327.91,331.27,1331.08,334.07,1332.07,336.33Z"
              fill="#44322c"
            />
            <path
              d="M1346.69,337.72c2.63-.85,2.79-4.53,5.9-4.32s3.47,4.68,6,7.58,4.68,2.26,6.74,3.26-5.63,12-12.78,8-6.47-3.31-8.95-4.94S1340.86,339.61,1346.69,337.72Z"
              fill="#6b996b"
            />
            <g>
              <path d="M1333.13,332c0,.16,0,.18,0,.08V332Z" fill="#7f2c03" />
              <path
                d="M1333,330.44c-.34-4.2-1.25-9.75-3.71-12.42a5.37,5.37,0,0,1-1.62-3.27l1.24-.24c.44,2,1.81,4.9,5,9l.21.28C1333.91,326.2,1333.17,328.64,1333,330.44Z"
                fill="#634b42"
              />
            </g>
            <path
              d="M1323.23,330.12c-1.72-2.16.17-5.31-2.53-6.85s-5.48,2-9.22,3-5.15-.7-7.42-1-2,13.15,6.22,13.76,7.22.81,10.18.82S1327.05,334.92,1323.23,330.12Z"
              fill="#6b996b"
            />
            <path
              d="M1326.68,304.74c1.78-2.81,4.27-5.38,6.76-3s-1.66,6.73,0,8.43,1.31,6,0,6.17-7.51.16-9.14.91-3.72-2-3.76-4.71S1326.68,304.74,1326.68,304.74Z"
              fill="#6b996b"
            />
            <path
              d="M1308.88,336c.51.78,2,.63,2.88.28s1.38-3,2.79-2.56,2.09,1.86,3.65,1.41.88-2.13,2.89-2.17c1.85,0,3.72.73,3.78,1.76a2.11,2.11,0,0,1,0,.26h0q0,.11,0,.24c-.36,2.65-2.49,4.6-4.36,4.6-3,0-2-.2-10.18-.82a6.6,6.6,0,0,1-3-.95C1306.37,337.46,1308.36,335.23,1308.88,336Z"
              fill="#447244"
            />
            <path
              d="M1345.59,347.32c2,0,6,2.17,6.51.18s4.52-2.44,5-1.54,2.89,2.08,4.25,1.36,2.71,1.08,2.09,1.79c-2.52,2.85-6.76,5.45-10.83,3.17-5-2.77-6.16-3.29-7.25-3.89C1344.88,348.05,1344.07,347.32,1345.59,347.32Z"
              fill="#396039"
            />
            <path
              d="M1338.18,324.44c1.26-2.8,4.34-2.26,6.51-1.9s1.53,3.26,3.25,1.9,5.52,1.9,4.08,4.25h0c-3.84.27-7.51.69-9.14,1.45-2.3,1.06-5-1-6.76-4.11l-.77-1.6h0S1336.91,327.25,1338.18,324.44Z"
              fill="#447244"
            />
            <path
              d="M1361.14,322.72c-.81-2.54,2.81-4.7,0-4.7s-7.41,2.81-7-1.26-.81-6.24-3.89-6-5.42-6.33-3.7-7.82-9.59,2.85-4.62,7.1,6.79,2.89,6.61,4.88,0,6.15,3.79,6.78-1.07,5.79,1.77,7S1363.31,329.51,1361.14,322.72Z"
              fill="#447244"
            />
            <path
              d="M1327.15,387.83s.74-2.6,1.7-6.69c7.55-3.87,8.09-16.49,8.11-16.86,0,8.58.56,17.58,1.85,23.55,0,0-8.68-1.54-11.39-.09C1327.15,388.64,1327.15,387.83,1327.15,387.83Z"
              fill="#44322c"
            />
            <path
              d="M1336.16,387.45c0-2.45-.8-4.76-1.11-7.18a47.85,47.85,0,0,1-.15-7.28c.27-4.85.76-9.67,1-14.5.06-1.21.13-2.42.15-3.62a12.78,12.78,0,0,0-.07-1.77c-.09-.55-.29-1.16-.43-1.75a22.87,22.87,0,0,1-.61-3.61,7.4,7.4,0,0,1,.49-3.68c.55-1.08,1.07-2.17,1.7-3.23a8.4,8.4,0,0,1,2.42-2.75,6,6,0,0,1,3.54-.85,16.18,16.18,0,0,1,3.6.5,16.24,16.24,0,0,0-3.6-.37,5.94,5.94,0,0,0-3.39.93,8.35,8.35,0,0,0-2.28,2.72c-.59,1-1.09,2.14-1.61,3.23a7.33,7.33,0,0,0-.41,3.46,22.32,22.32,0,0,0,.63,3.53c.14.6.33,1.14.45,1.78a13.11,13.11,0,0,1,.08,1.86c0,1.22-.06,2.43-.12,3.65-.28,4.84-.76,9.67-1.11,14.49a48.47,48.47,0,0,0,0,7.23C1335.53,382.63,1336.3,385,1336.16,387.45Z"
              fill="#44322c"
            />
            <path
              d="M1334.24,364.27a24.86,24.86,0,0,0,0,3,4.46,4.46,0,0,1-.18,1.53,4.12,4.12,0,0,1-.8,1.34,8.08,8.08,0,0,0-2.23,5.26,11.89,11.89,0,0,0,0,2.92,8.58,8.58,0,0,0,.32,1.42c.15.45.33.95.45,1.44a24.06,24.06,0,0,1,.64,6,33.58,33.58,0,0,0-1-5.86,16.55,16.55,0,0,1-.86-2.9,12,12,0,0,1-.08-3.05,11.41,11.41,0,0,1,.72-3,7.13,7.13,0,0,1,.73-1.36,8,8,0,0,1,1-1.14,4.14,4.14,0,0,0,.79-1.18,4.45,4.45,0,0,0,.23-1.42A18.78,18.78,0,0,1,1334.24,364.27Z"
              fill="#44322c"
            />
            <path
              d="M1334.24,325.84c.08.57.2,1.13.33,1.69a8.86,8.86,0,0,1,.29,1.71,4.41,4.41,0,0,1-.09.89,2.79,2.79,0,0,0-.15.81,6.94,6.94,0,0,0,.33,1.63,16.35,16.35,0,0,1,1,6.85,12.56,12.56,0,0,1-.38,1.72,12.58,12.58,0,0,0-.36,1.64,22.45,22.45,0,0,0-.17,3.39,41.15,41.15,0,0,0,.76,6.8,30.47,30.47,0,0,1-1.18-6.79,19.2,19.2,0,0,1,.1-3.47,12.79,12.79,0,0,1,.35-1.72,11.65,11.65,0,0,0,.34-1.64,11.41,11.41,0,0,0-.07-3.35c-.18-1.12-.51-2.21-.78-3.33a7.1,7.1,0,0,1-.26-1.74,3.1,3.1,0,0,1,.19-.87,3.79,3.79,0,0,0,.13-.82C1334.62,328.13,1334.24,327,1334.24,325.84Z"
              fill="#44322c"
            />
          </g>
          <g>
            <path
              d="M1226,343.31c5.52-9.13,7.41-11.21,5.06-17.36s-4.61-.9-2.26-12.47-6.6-15-10.67-15.47-23.33,10.85-20.07,17,4.64,23.6,1.14,25.05S1219.49,354.07,1226,343.31Z"
              fill="#396039"
            />
            <path
              d="M1222.29,322.07c-.18-5,7.32-7,4.88-9.23s-5.33-8.14-7.68-5.06-4.16,7.59-6,5.06-3.8-2.62-5,0-.19,5.88-3,5.07-4.07.45-3.71,3.16,2.45,1.63,4.25,4.88,10,2.81,8.59,1S1222.29,322.07,1222.29,322.07Z"
              fill="#447244"
            />
            <path
              d="M1236.3,313.48c4.07-6.42,9.77-12.3,15.47-6.79s-3.8,15.38,0,19.26,3,13.75,0,14.11-17.18.36-20.89,2.08-8.5-4.61-8.59-10.76S1236.3,313.48,1236.3,313.48Z"
              fill="#6b996b"
            />
            <path
              d="M1214.87,351.54c9.53,7.26,10.22-18,0-15.82s-13.56,1.54-16.81-3-11.4,3.44-11.67,5.7,2.35,9.86,8,12S1209.18,347.2,1214.87,351.54Z"
              fill="#447244"
            />
            <path
              d="M1234.56,356.61c-9.53,7.25-10.22-18,0-15.83s13.56,1.54,16.82-3,11.39,3.43,11.66,5.7-2.35,9.85-8,12S1240.26,352.27,1234.56,356.61Z"
              fill="#447244"
            />
            <path
              d="M1246.43,347.93c1.36-2.72,5.34,2.53,5.34,2.53s-.27-3.53,1.9-4.79,3.16,2,3.16,2c.18-2.53,5.33-.18,3.89,2.84h0a12,12,0,0,1-5.64,5,9.94,9.94,0,0,1-4,.52l-4.86-1.24S1245.08,350.64,1246.43,347.93Z"
              fill="#396039"
            />
            <path
              d="M1226.81,352.54c-1.9,3.34-3,33.45,0,47.29,0,0-8.68-1.54-11.39-.09-.27.9-.27.09-.27.09s12-41.87,1.53-54.16-21.88,0-21.88,0,3.08-7.24,9.86-7.78,16.09,8.23,16.54,9.95c0,0,.37-13.21-3.88-17.82s1.17-7.95,1.17-7.95-5.6,1.71,3.44,13.47c4.68,6.09,1.35,17.45,1.35,17.45s2.9-8.86,10.13-7,11.57,10.3,18.36,9.76c0,0-8-.45-14.29-4.25S1226.81,352.54,1226.81,352.54Z"
              fill="#704d3c"
            />
            <path
              d="M1236.71,351.12a8.29,8.29,0,0,0-9.9,1.42c-.65,1.15-1.21,5.48-1.54,11.22-2.17-7.49,1.72-16.38,3-17.17a6.78,6.78,0,0,1,5.19-.56,15.63,15.63,0,0,1,4.77,2.27Z"
              fill="#634b42"
            />
            <path
              d="M1220.07,348.33c1,2.26,2.08,8.89.86,12.31h0c-.23-6.2-1.42-11.66-4.25-15a18.37,18.37,0,0,0-1.88-1.94l-.42-1.27C1215.91,343.27,1219.08,346.07,1220.07,348.33Z"
              fill="#44322c"
            />
            <path
              d="M1234.69,349.72c2.63-.85,2.79-4.53,5.9-4.32s3.47,4.68,6,7.58,4.68,2.26,6.74,3.26-5.63,12-12.78,8-6.47-3.31-8.95-4.94S1228.86,351.61,1234.69,349.72Z"
              fill="#6b996b"
            />
            <g>
              <path d="M1221.13,344c0,.16,0,.18,0,.08V344Z" fill="#7f2c03" />
              <path
                d="M1221,342.44c-.34-4.2-1.25-9.75-3.71-12.42a5.37,5.37,0,0,1-1.62-3.27l1.24-.24c.44,2,1.81,4.9,5,9l.21.28C1221.91,338.2,1221.17,340.64,1221,342.44Z"
                fill="#634b42"
              />
            </g>
            <path
              d="M1211.23,342.12c-1.72-2.16.17-5.31-2.53-6.85s-5.48,2-9.22,3-5.15-.7-7.42-1-2,13.15,6.22,13.76,7.22.81,10.18.82S1215.05,346.92,1211.23,342.12Z"
              fill="#6b996b"
            />
            <path
              d="M1214.68,316.74c1.78-2.81,4.27-5.38,6.76-3s-1.66,6.73,0,8.43,1.31,6,0,6.17-7.51.16-9.14.91-3.72-2-3.76-4.71S1214.68,316.74,1214.68,316.74Z"
              fill="#6b996b"
            />
            <path
              d="M1196.88,348c.51.78,2,.63,2.88.28s1.38-3,2.79-2.56,2.09,1.86,3.65,1.41.88-2.13,2.89-2.17c1.85,0,3.72.73,3.78,1.76a2.11,2.11,0,0,1,0,.26h0q0,.11,0,.24c-.36,2.65-2.49,4.6-4.36,4.6-3,0-2-.2-10.18-.82a6.6,6.6,0,0,1-3-.95C1194.37,349.46,1196.36,347.23,1196.88,348Z"
              fill="#447244"
            />
            <path
              d="M1233.59,359.32c2,0,6,2.17,6.51.18s4.52-2.44,5-1.54,2.89,2.08,4.25,1.36,2.71,1.08,2.09,1.79c-2.52,2.85-6.76,5.45-10.83,3.17-5-2.77-6.16-3.29-7.25-3.89C1232.88,360.05,1232.07,359.32,1233.59,359.32Z"
              fill="#396039"
            />
            <path
              d="M1226.18,336.44c1.26-2.8,4.34-2.26,6.51-1.9s1.53,3.26,3.25,1.9,5.52,1.9,4.08,4.25h0c-3.84.27-7.51.69-9.14,1.45-2.3,1.06-5-1-6.76-4.11l-.77-1.6h0S1224.91,339.25,1226.18,336.44Z"
              fill="#447244"
            />
            <path
              d="M1249.14,334.72c-.81-2.54,2.81-4.7,0-4.7s-7.41,2.81-7-1.26-.81-6.24-3.89-6-5.42-6.33-3.7-7.82-9.59,2.85-4.62,7.1,6.79,2.89,6.61,4.88,0,6.15,3.79,6.78-1.07,5.79,1.77,7S1251.31,341.51,1249.14,334.72Z"
              fill="#447244"
            />
            <path
              d="M1215.15,399.83s.74-2.6,1.7-6.69c7.55-3.87,8.09-16.49,8.11-16.86,0,8.58.56,17.58,1.85,23.55,0,0-8.68-1.54-11.39-.09C1215.15,400.64,1215.15,399.83,1215.15,399.83Z"
              fill="#44322c"
            />
            <path
              d="M1224.16,399.45c0-2.45-.8-4.76-1.11-7.18a47.85,47.85,0,0,1-.15-7.28c.27-4.85.76-9.67,1-14.5.06-1.21.13-2.42.15-3.62a12.78,12.78,0,0,0-.07-1.77c-.09-.55-.29-1.16-.43-1.75a22.87,22.87,0,0,1-.61-3.61,7.4,7.4,0,0,1,.49-3.68c.55-1.08,1.07-2.17,1.7-3.23a8.4,8.4,0,0,1,2.42-2.75,6,6,0,0,1,3.54-.85,16.18,16.18,0,0,1,3.6.5,16.24,16.24,0,0,0-3.6-.37,5.94,5.94,0,0,0-3.39.93,8.35,8.35,0,0,0-2.28,2.72c-.59,1-1.09,2.14-1.61,3.23a7.33,7.33,0,0,0-.41,3.46,22.32,22.32,0,0,0,.63,3.53c.14.6.33,1.14.45,1.78a13.11,13.11,0,0,1,.08,1.86c0,1.22-.06,2.43-.12,3.65-.28,4.84-.76,9.67-1.11,14.49a48.47,48.47,0,0,0,0,7.23C1223.53,394.63,1224.3,397,1224.16,399.45Z"
              fill="#44322c"
            />
            <path
              d="M1222.24,376.27a24.86,24.86,0,0,0,0,3,4.46,4.46,0,0,1-.18,1.53,4.12,4.12,0,0,1-.8,1.34,8.08,8.08,0,0,0-2.23,5.26,11.89,11.89,0,0,0,0,2.92,8.58,8.58,0,0,0,.32,1.42c.15.45.33.95.45,1.44a24.06,24.06,0,0,1,.64,6,33.58,33.58,0,0,0-1-5.86,16.55,16.55,0,0,1-.86-2.9,12,12,0,0,1-.08-3.05,11.41,11.41,0,0,1,.72-3,7.13,7.13,0,0,1,.73-1.36,8,8,0,0,1,1-1.14,4.14,4.14,0,0,0,.79-1.18,4.45,4.45,0,0,0,.23-1.42A18.78,18.78,0,0,1,1222.24,376.27Z"
              fill="#44322c"
            />
            <path
              d="M1222.24,337.84c.08.57.2,1.13.33,1.69a8.86,8.86,0,0,1,.29,1.71,4.41,4.41,0,0,1-.09.89,2.79,2.79,0,0,0-.15.81,6.94,6.94,0,0,0,.33,1.63,16.35,16.35,0,0,1,1,6.85,12.56,12.56,0,0,1-.38,1.72,12.58,12.58,0,0,0-.36,1.64,22.45,22.45,0,0,0-.17,3.39,41.15,41.15,0,0,0,.76,6.8,30.47,30.47,0,0,1-1.18-6.79,19.2,19.2,0,0,1,.1-3.47,12.79,12.79,0,0,1,.35-1.72,11.65,11.65,0,0,0,.34-1.64,11.41,11.41,0,0,0-.07-3.35c-.18-1.12-.51-2.21-.78-3.33a7.1,7.1,0,0,1-.26-1.74,3.1,3.1,0,0,1,.19-.87,3.79,3.79,0,0,0,.13-.82C1222.62,340.13,1222.24,339,1222.24,337.84Z"
              fill="#44322c"
            />
          </g>
          <g>
            <path
              d="M1286,327.31c5.52-9.13,7.41-11.21,5.06-17.36s-4.61-.9-2.26-12.47-6.6-15-10.67-15.47-23.33,10.85-20.07,17,4.64,23.6,1.14,25.05S1279.49,338.07,1286,327.31Z"
              fill="#396039"
            />
            <path
              d="M1282.29,306.07c-.18-5,7.32-7,4.88-9.23s-5.33-8.14-7.68-5.06-4.16,7.59-6,5.06-3.8-2.62-5,0-.19,5.88-3,5.07-4.07.45-3.71,3.16,2.45,1.63,4.25,4.88,10,2.81,8.59,1S1282.29,306.07,1282.29,306.07Z"
              fill="#447244"
            />
            <path
              d="M1296.3,297.48c4.07-6.42,9.77-12.3,15.47-6.79s-3.8,15.38,0,19.26,3,13.75,0,14.11-17.18.36-20.89,2.08-8.5-4.61-8.59-10.76S1296.3,297.48,1296.3,297.48Z"
              fill="#6b996b"
            />
            <path
              d="M1274.87,335.54c9.53,7.26,10.22-18,0-15.82s-13.56,1.54-16.81-3-11.4,3.44-11.67,5.7,2.35,9.86,8,12S1269.18,331.2,1274.87,335.54Z"
              fill="#447244"
            />
            <path
              d="M1294.56,340.61c-9.53,7.25-10.22-18,0-15.83s13.56,1.54,16.82-3,11.39,3.43,11.66,5.7-2.35,9.85-8,12S1300.26,336.27,1294.56,340.61Z"
              fill="#447244"
            />
            <path
              d="M1306.43,331.93c1.36-2.72,5.34,2.53,5.34,2.53s-.27-3.53,1.9-4.79,3.16,2,3.16,2c.18-2.53,5.33-.18,3.89,2.84h0a12,12,0,0,1-5.64,5,9.94,9.94,0,0,1-4,.52l-4.86-1.24S1305.08,334.64,1306.43,331.93Z"
              fill="#396039"
            />
            <path
              d="M1286.81,336.54c-1.9,3.34-3,33.45,0,47.29,0,0-8.68-1.54-11.39-.09-.27.9-.27.09-.27.09s12-41.87,1.53-54.16-21.88,0-21.88,0,3.08-7.24,9.86-7.78,16.09,8.23,16.54,9.95c0,0,.37-13.21-3.88-17.82s1.17-7.95,1.17-7.95-5.6,1.71,3.44,13.47c4.68,6.09,1.35,17.45,1.35,17.45s2.9-8.86,10.13-7,11.57,10.3,18.36,9.76c0,0-8-.45-14.29-4.25S1286.81,336.54,1286.81,336.54Z"
              fill="#704d3c"
            />
            <path
              d="M1296.71,335.12a8.29,8.29,0,0,0-9.9,1.42c-.65,1.15-1.21,5.48-1.54,11.22-2.17-7.49,1.72-16.38,3-17.17a6.78,6.78,0,0,1,5.19-.56,15.63,15.63,0,0,1,4.77,2.27Z"
              fill="#634b42"
            />
            <path
              d="M1280.07,332.33c1,2.26,2.08,8.89.86,12.31h0c-.23-6.2-1.42-11.66-4.25-15a18.37,18.37,0,0,0-1.88-1.94l-.42-1.27C1275.91,327.27,1279.08,330.07,1280.07,332.33Z"
              fill="#44322c"
            />
            <path
              d="M1294.69,333.72c2.63-.85,2.79-4.53,5.9-4.32s3.47,4.68,6,7.58,4.68,2.26,6.74,3.26-5.63,12-12.78,8-6.47-3.31-8.95-4.94S1288.86,335.61,1294.69,333.72Z"
              fill="#6b996b"
            />
            <g>
              <path d="M1281.13,328c0,.16,0,.18,0,.08V328Z" fill="#7f2c03" />
              <path
                d="M1281,326.44c-.34-4.2-1.25-9.75-3.71-12.42a5.37,5.37,0,0,1-1.62-3.27l1.24-.24c.44,2,1.81,4.9,5,9l.21.28C1281.91,322.2,1281.17,324.64,1281,326.44Z"
                fill="#634b42"
              />
            </g>
            <path
              d="M1271.23,326.12c-1.72-2.16.17-5.31-2.53-6.85s-5.48,2-9.22,3-5.15-.7-7.42-1-2,13.15,6.22,13.76,7.22.81,10.18.82S1275.05,330.92,1271.23,326.12Z"
              fill="#6b996b"
            />
            <path
              d="M1274.68,300.74c1.78-2.81,4.27-5.38,6.76-3s-1.66,6.73,0,8.43,1.31,6,0,6.17-7.51.16-9.14.91-3.72-2-3.76-4.71S1274.68,300.74,1274.68,300.74Z"
              fill="#6b996b"
            />
            <path
              d="M1256.88,332c.51.78,2,.63,2.88.28s1.38-3,2.79-2.56,2.09,1.86,3.65,1.41.88-2.13,2.89-2.17c1.85,0,3.72.73,3.78,1.76a2.11,2.11,0,0,1,0,.26h0q0,.11,0,.24c-.36,2.65-2.49,4.6-4.36,4.6-3,0-2-.2-10.18-.82a6.6,6.6,0,0,1-3-.95C1254.37,333.46,1256.36,331.23,1256.88,332Z"
              fill="#447244"
            />
            <path
              d="M1293.59,343.32c2,0,6,2.17,6.51.18s4.52-2.44,5-1.54,2.89,2.08,4.25,1.36,2.71,1.08,2.09,1.79c-2.52,2.85-6.76,5.45-10.83,3.17-5-2.77-6.16-3.29-7.25-3.89C1292.88,344.05,1292.07,343.32,1293.59,343.32Z"
              fill="#396039"
            />
            <path
              d="M1286.18,320.44c1.26-2.8,4.34-2.26,6.51-1.9s1.53,3.26,3.25,1.9,5.52,1.9,4.08,4.25h0c-3.84.27-7.51.69-9.14,1.45-2.3,1.06-5-1-6.76-4.11l-.77-1.6h0S1284.91,323.25,1286.18,320.44Z"
              fill="#447244"
            />
            <path
              d="M1309.14,318.72c-.81-2.54,2.81-4.7,0-4.7s-7.41,2.81-7-1.26-.81-6.24-3.89-6-5.42-6.33-3.7-7.82-9.59,2.85-4.62,7.1,6.79,2.89,6.61,4.88,0,6.15,3.79,6.78-1.07,5.79,1.77,7S1311.31,325.51,1309.14,318.72Z"
              fill="#447244"
            />
            <path
              d="M1275.15,383.83s.74-2.6,1.7-6.69c7.55-3.87,8.09-16.49,8.11-16.86,0,8.58.56,17.58,1.85,23.55,0,0-8.68-1.54-11.39-.09C1275.15,384.64,1275.15,383.83,1275.15,383.83Z"
              fill="#44322c"
            />
            <path
              d="M1284.16,383.45c0-2.45-.8-4.76-1.11-7.18a47.85,47.85,0,0,1-.15-7.28c.27-4.85.76-9.67,1-14.5.06-1.21.13-2.42.15-3.62a12.78,12.78,0,0,0-.07-1.77c-.09-.55-.29-1.16-.43-1.75a22.87,22.87,0,0,1-.61-3.61,7.4,7.4,0,0,1,.49-3.68c.55-1.08,1.07-2.17,1.7-3.23a8.4,8.4,0,0,1,2.42-2.75,6,6,0,0,1,3.54-.85,16.18,16.18,0,0,1,3.6.5,16.24,16.24,0,0,0-3.6-.37,5.94,5.94,0,0,0-3.39.93,8.35,8.35,0,0,0-2.28,2.72c-.59,1-1.09,2.14-1.61,3.23a7.33,7.33,0,0,0-.41,3.46,22.32,22.32,0,0,0,.63,3.53c.14.6.33,1.14.45,1.78a13.11,13.11,0,0,1,.08,1.86c0,1.22-.06,2.43-.12,3.65-.28,4.84-.76,9.67-1.11,14.49a48.47,48.47,0,0,0,0,7.23C1283.53,378.63,1284.3,381,1284.16,383.45Z"
              fill="#44322c"
            />
            <path
              d="M1282.24,360.27a24.86,24.86,0,0,0,0,3,4.46,4.46,0,0,1-.18,1.53,4.12,4.12,0,0,1-.8,1.34,8.08,8.08,0,0,0-2.23,5.26,11.89,11.89,0,0,0,0,2.92,8.58,8.58,0,0,0,.32,1.42c.15.45.33.95.45,1.44a24.06,24.06,0,0,1,.64,6,33.58,33.58,0,0,0-1-5.86,16.55,16.55,0,0,1-.86-2.9,12,12,0,0,1-.08-3.05,11.41,11.41,0,0,1,.72-3,7.13,7.13,0,0,1,.73-1.36,8,8,0,0,1,1-1.14,4.14,4.14,0,0,0,.79-1.18,4.45,4.45,0,0,0,.23-1.42A18.78,18.78,0,0,1,1282.24,360.27Z"
              fill="#44322c"
            />
            <path
              d="M1282.24,321.84c.08.57.2,1.13.33,1.69a8.86,8.86,0,0,1,.29,1.71,4.41,4.41,0,0,1-.09.89,2.79,2.79,0,0,0-.15.81,6.94,6.94,0,0,0,.33,1.63,16.35,16.35,0,0,1,1,6.85,12.56,12.56,0,0,1-.38,1.72,12.58,12.58,0,0,0-.36,1.64,22.45,22.45,0,0,0-.17,3.39,41.15,41.15,0,0,0,.76,6.8,30.47,30.47,0,0,1-1.18-6.79,19.2,19.2,0,0,1,.1-3.47,12.79,12.79,0,0,1,.35-1.72,11.65,11.65,0,0,0,.34-1.64,11.41,11.41,0,0,0-.07-3.35c-.18-1.12-.51-2.21-.78-3.33a7.1,7.1,0,0,1-.26-1.74,3.1,3.1,0,0,1,.19-.87,3.79,3.79,0,0,0,.13-.82C1282.62,324.13,1282.24,323,1282.24,321.84Z"
              fill="#44322c"
            />
          </g>
          <g>
            <path
              d="M1181,357.31c5.52-9.13,7.41-11.21,5.06-17.36s-4.61-.9-2.26-12.47-6.6-15-10.67-15.47-23.33,10.85-20.07,17,4.64,23.6,1.14,25.05S1174.49,368.07,1181,357.31Z"
              fill="#396039"
            />
            <path
              d="M1177.29,336.07c-.18-5,7.32-7,4.88-9.23s-5.33-8.14-7.68-5.06-4.16,7.59-6,5.06-3.8-2.62-5,0-.19,5.88-3,5.07-4.07.45-3.71,3.16,2.45,1.63,4.25,4.88,10,2.81,8.59,1S1177.29,336.07,1177.29,336.07Z"
              fill="#447244"
            />
            <path
              d="M1191.3,327.48c4.07-6.42,9.77-12.3,15.47-6.79s-3.8,15.38,0,19.26,3,13.75,0,14.11-17.18.36-20.89,2.08-8.5-4.61-8.59-10.76S1191.3,327.48,1191.3,327.48Z"
              fill="#6b996b"
            />
            <path
              d="M1169.87,365.54c9.53,7.26,10.22-18,0-15.82s-13.56,1.54-16.81-3-11.4,3.44-11.67,5.7,2.35,9.86,8,12S1164.18,361.2,1169.87,365.54Z"
              fill="#447244"
            />
            <path
              d="M1189.56,370.61c-9.53,7.25-10.22-18,0-15.83s13.56,1.54,16.82-3,11.39,3.43,11.66,5.7-2.35,9.85-8,12S1195.26,366.27,1189.56,370.61Z"
              fill="#447244"
            />
            <path
              d="M1201.43,361.93c1.36-2.72,5.34,2.53,5.34,2.53s-.27-3.53,1.9-4.79,3.16,2,3.16,2c.18-2.53,5.33-.18,3.89,2.84h0a12,12,0,0,1-5.64,5,9.94,9.94,0,0,1-4,.52l-4.86-1.24S1200.08,364.64,1201.43,361.93Z"
              fill="#396039"
            />
            <path
              d="M1181.81,366.54c-1.9,3.34-3,33.45,0,47.29,0,0-8.68-1.54-11.39-.09-.27.9-.27.09-.27.09s12-41.87,1.53-54.16-21.88,0-21.88,0,3.08-7.24,9.86-7.78,16.09,8.23,16.54,9.95c0,0,.37-13.21-3.88-17.82s1.17-7.95,1.17-7.95-5.6,1.71,3.44,13.47c4.68,6.09,1.35,17.45,1.35,17.45s2.9-8.86,10.13-7,11.57,10.3,18.36,9.76c0,0-8-.45-14.29-4.25S1181.81,366.54,1181.81,366.54Z"
              fill="#704d3c"
            />
            <path
              d="M1191.71,365.12a8.29,8.29,0,0,0-9.9,1.42c-.65,1.15-1.21,5.48-1.54,11.22-2.17-7.49,1.72-16.38,3-17.17a6.78,6.78,0,0,1,5.19-.56,15.63,15.63,0,0,1,4.77,2.27Z"
              fill="#634b42"
            />
            <path
              d="M1175.07,362.33c1,2.26,2.08,8.89.86,12.31h0c-.23-6.2-1.42-11.66-4.25-15a18.37,18.37,0,0,0-1.88-1.94l-.42-1.27C1170.91,357.27,1174.08,360.07,1175.07,362.33Z"
              fill="#44322c"
            />
            <path
              d="M1189.69,363.72c2.63-.85,2.79-4.53,5.9-4.32s3.47,4.68,6,7.58,4.68,2.26,6.74,3.26-5.63,12-12.78,8-6.47-3.31-8.95-4.94S1183.86,365.61,1189.69,363.72Z"
              fill="#6b996b"
            />
            <g>
              <path d="M1176.13,358c0,.16,0,.18,0,.08V358Z" fill="#7f2c03" />
              <path
                d="M1176,356.44c-.34-4.2-1.25-9.75-3.71-12.42a5.37,5.37,0,0,1-1.62-3.27l1.24-.24c.44,2,1.81,4.9,5,9l.21.28C1176.91,352.2,1176.17,354.64,1176,356.44Z"
                fill="#634b42"
              />
            </g>
            <path
              d="M1166.23,356.12c-1.72-2.16.17-5.31-2.53-6.85s-5.48,2-9.22,3-5.15-.7-7.42-1-2,13.15,6.22,13.76,7.22.81,10.18.82S1170.05,360.92,1166.23,356.12Z"
              fill="#6b996b"
            />
            <path
              d="M1169.68,330.74c1.78-2.81,4.27-5.38,6.76-3s-1.66,6.73,0,8.43,1.31,6,0,6.17-7.51.16-9.14.91-3.72-2-3.76-4.71S1169.68,330.74,1169.68,330.74Z"
              fill="#6b996b"
            />
            <path
              d="M1151.88,362c.51.78,2,.63,2.88.28s1.38-3,2.79-2.56,2.09,1.86,3.65,1.41.88-2.13,2.89-2.17c1.85,0,3.72.73,3.78,1.76a2.11,2.11,0,0,1,0,.26h0q0,.11,0,.24c-.36,2.65-2.49,4.6-4.36,4.6-3,0-2-.2-10.18-.82a6.6,6.6,0,0,1-3-.95C1149.37,363.46,1151.36,361.23,1151.88,362Z"
              fill="#447244"
            />
            <path
              d="M1188.59,373.32c2,0,6,2.17,6.51.18s4.52-2.44,5-1.54,2.89,2.08,4.25,1.36,2.71,1.08,2.09,1.79c-2.52,2.85-6.76,5.45-10.83,3.17-5-2.77-6.16-3.29-7.25-3.89C1187.88,374.05,1187.07,373.32,1188.59,373.32Z"
              fill="#396039"
            />
            <path
              d="M1181.18,350.44c1.26-2.8,4.34-2.26,6.51-1.9s1.53,3.26,3.25,1.9,5.52,1.9,4.08,4.25h0c-3.84.27-7.51.69-9.14,1.45-2.3,1.06-5-1-6.76-4.11l-.77-1.6h0S1179.91,353.25,1181.18,350.44Z"
              fill="#447244"
            />
            <path
              d="M1204.14,348.72c-.81-2.54,2.81-4.7,0-4.7s-7.41,2.81-7-1.26-.81-6.24-3.89-6-5.42-6.33-3.7-7.82-9.59,2.85-4.62,7.1,6.79,2.89,6.61,4.88,0,6.15,3.79,6.78-1.07,5.79,1.77,7S1206.31,355.51,1204.14,348.72Z"
              fill="#447244"
            />
            <path
              d="M1170.15,413.83s.74-2.6,1.7-6.69c7.55-3.87,8.09-16.49,8.11-16.86,0,8.58.56,17.58,1.85,23.55,0,0-8.68-1.54-11.39-.09C1170.15,414.64,1170.15,413.83,1170.15,413.83Z"
              fill="#44322c"
            />
            <path
              d="M1179.16,413.45c0-2.45-.8-4.76-1.11-7.18a47.85,47.85,0,0,1-.15-7.28c.27-4.85.76-9.67,1-14.5.06-1.21.13-2.42.15-3.62a12.78,12.78,0,0,0-.07-1.77c-.09-.55-.29-1.16-.43-1.75a22.87,22.87,0,0,1-.61-3.61,7.4,7.4,0,0,1,.49-3.68c.55-1.08,1.07-2.17,1.7-3.23a8.4,8.4,0,0,1,2.42-2.75,6,6,0,0,1,3.54-.85,16.18,16.18,0,0,1,3.6.5,16.24,16.24,0,0,0-3.6-.37,5.94,5.94,0,0,0-3.39.93,8.35,8.35,0,0,0-2.28,2.72c-.59,1-1.09,2.14-1.61,3.23a7.33,7.33,0,0,0-.41,3.46,22.32,22.32,0,0,0,.63,3.53c.14.6.33,1.14.45,1.78a13.11,13.11,0,0,1,.08,1.86c0,1.22-.06,2.43-.12,3.65-.28,4.84-.76,9.67-1.11,14.49a48.47,48.47,0,0,0,0,7.23C1178.53,408.63,1179.3,411,1179.16,413.45Z"
              fill="#44322c"
            />
            <path
              d="M1177.24,390.27a24.86,24.86,0,0,0,0,3,4.46,4.46,0,0,1-.18,1.53,4.12,4.12,0,0,1-.8,1.34,8.08,8.08,0,0,0-2.23,5.26,11.89,11.89,0,0,0,0,2.92,8.58,8.58,0,0,0,.32,1.42c.15.45.33.95.45,1.44a24.06,24.06,0,0,1,.64,6,33.58,33.58,0,0,0-1-5.86,16.55,16.55,0,0,1-.86-2.9,12,12,0,0,1-.08-3.05,11.41,11.41,0,0,1,.72-3,7.13,7.13,0,0,1,.73-1.36,8,8,0,0,1,1-1.14,4.14,4.14,0,0,0,.79-1.18,4.45,4.45,0,0,0,.23-1.42A18.78,18.78,0,0,1,1177.24,390.27Z"
              fill="#44322c"
            />
            <path
              d="M1177.24,351.84c.08.57.2,1.13.33,1.69a8.86,8.86,0,0,1,.29,1.71,4.41,4.41,0,0,1-.09.89,2.79,2.79,0,0,0-.15.81,6.94,6.94,0,0,0,.33,1.63,16.35,16.35,0,0,1,1,6.85,12.56,12.56,0,0,1-.38,1.72,12.58,12.58,0,0,0-.36,1.64,22.45,22.45,0,0,0-.17,3.39,41.15,41.15,0,0,0,.76,6.8,30.47,30.47,0,0,1-1.18-6.79,19.2,19.2,0,0,1,.1-3.47,12.79,12.79,0,0,1,.35-1.72,11.65,11.65,0,0,0,.34-1.64,11.41,11.41,0,0,0-.07-3.35c-.18-1.12-.51-2.21-.78-3.33a7.1,7.1,0,0,1-.26-1.74,3.1,3.1,0,0,1,.19-.87,3.79,3.79,0,0,0,.13-.82C1177.62,354.13,1177.24,353,1177.24,351.84Z"
              fill="#44322c"
            />
          </g>
        </g>
        <path
          d="M838.67,310s-42.83,53-90,43-93.47,17-73,49-174.26,49.33-212,71c-108,62,10.13,238-5,264-11.93,20.51-25.57,55.94-236.36,70H6.67V311Z"
          fill="#3d2651"
        />
        <path
          d="M1529.67,352q.49,309.51,1,619c-90,11.84-215.46,25.2-366,31-154.85,6-461.7,17.79-475-47-3.37-16.42,13.24-32.27,36-54,58.18-55.53,137.38-57.89,207.19-104.89,9-6.09,15.61-11.84,17.81-13.11,218-126-263-257,19-303,78.66-12.83,221-106.87,282.28-103.31C1302.15,379.6,1458.1,328.28,1529.67,352Z"
          fill="#334c23"
        />
        <path
          d="M521.67,539.83c-5.79-21.17,40.57-38.62,58.2-54.14-1.13.35-2.24.72-3.35,1.09l-2.2.74-.7.25c-40,13.91-71.77,35.9-72.82,56v0c0,.43,0,.87,0,1.3,0,.24,0,.48,0,.72,0,0,0,.09,0,.14.39,5.49,3.18,10.82,8.85,15.76a36.31,36.31,0,0,0,9.43,5.33c14.15,5.48,40,10.46,72.8,15.55C568.7,573.84,526,555.71,521.67,539.83Z"
          fill="#d8a084"
          opacity="0.35"
        />
        <path
          d="M421.67,617c-2,17,19.64,72.43-3,109-26,42-124,67-170,79.16C454,791.37,447.12,755.85,458.67,736c9.84-16.9-18.73-59.67-37-132C423.14,611,423,605.45,421.67,617Z"
          fill="#321b49"
        />
        <path
          d="M688.17,351.5c-30,21-18.46,32.42-18.46,32.42l1.07-.33c2-23.48,39.64-39.7,77.89-31.59a61.65,61.65,0,0,0,27.44-.63C761.17,353.5,718.17,330.5,688.17,351.5Z"
          fill="#2b193f"
        />
        <path
          d="M646.67,552c-8.39,30.77,7-47,28-48s118-45,129-64,133-36,143-34c0,0-88,28-108,44s-20,17-20,17-55,46-90,39S649.67,541,646.67,552Z"
          fill="#d8a084"
          opacity="0.35"
        />
        <path
          d="M6.67,441.07c0-52.07,172-52.07,198-79.07s169-54,217-52.5S720.19,311,661,311l177.66-2-832,1Z"
          fill="#334c23"
        />
        <rect x="363.67" y="224" width="35" height="89" fill="#8161a3" />
        <rect x="447.67" y="230" width="35" height="89" fill="#8161a3" />
        <line
          x1="49.67"
          y1="68"
          x2="64.57"
          y2="68"
          fill="#e9847e"
          opacity="0.46"
        />
        <rect
          x="76.81"
          y="78"
          width="12.41"
          height="1"
          fill="none"
          stroke="#efda45"
          strokeMiterlimit="10"
          strokeWidth="3.15"
          opacity="0.46"
        />
        <rect
          x="94.36"
          y="95"
          width="12.41"
          height="1"
          fill="none"
          stroke="#efda45"
          strokeMiterlimit="10"
          strokeWidth="3.15"
          opacity="0.46"
        />
        <rect
          x="76.98"
          y="110"
          width="12.41"
          height="1"
          fill="none"
          stroke="#efda45"
          strokeMiterlimit="10"
          strokeWidth="3.15"
          opacity="0.46"
        />
        <g>
          <polygon
            points="182.15 116.61 178.04 317 188.81 317 182.15 116.61"
            fill="#6d4c89"
          />
          <circle cx="183.17" cy="197.59" r="20.5" fill="#6d4c89" />
        </g>
        <line
          x1="207.67"
          y1="310"
          x2="207.67"
          y2="101"
          fill="none"
          stroke="#48edcd"
          strokeMiterlimit="10"
          strokeWidth="2"
          opacity="0.46"
        />
        <polygon
          points="513.58 212 535.49 212 558.59 253.58 551.86 257.94 560.97 269.42 560.97 311 513.58 311 513.58 212"
          fill="#822c69"
        />
        <polygon
          points="535.49 212 527.17 212 558.59 253.58 535.49 212"
          fill="#4e3668"
        />
        <polygon
          points="551.86 257.94 545.13 261.5 560.97 269.42 551.86 257.94"
          fill="#4e3668"
        />
        <rect x="393.67" y="151" width="29" height="165" fill="#6d4c89" />
        <rect
          x="393.67"
          y="151"
          width="6"
          height="200"
          fill="#e9847e"
          opacity="0.46"
        />
        <line
          x1="393.67"
          y1="351"
          x2="393.67"
          y2="151"
          fill="none"
          stroke="#efda45"
          strokeMiterlimit="10"
          strokeWidth="1.8"
          opacity="0.46"
        />
        <line
          x1="393.67"
          y1="151"
          x2="399.67"
          y2="151"
          fill="#e9847e"
          opacity="0.46"
        />
        <rect
          x="414.67"
          y="154.25"
          width="5"
          height="0.81"
          fill="none"
          stroke="#efda45"
          strokeMiterlimit="10"
          strokeWidth="1.8"
          opacity="0.46"
        />
        <rect
          x="411.67"
          y="172.95"
          width="5"
          height="0.81"
          fill="none"
          stroke="#efda45"
          strokeMiterlimit="10"
          strokeWidth="1.8"
          opacity="0.46"
        />
        <rect
          x="404.67"
          y="185.15"
          width="5"
          height="0.81"
          fill="none"
          stroke="#efda45"
          strokeMiterlimit="10"
          strokeWidth="1.8"
          opacity="0.46"
        />
        <rect
          x="404.67"
          y="201.41"
          width="5"
          height="0.81"
          fill="none"
          stroke="#efda45"
          strokeMiterlimit="10"
          strokeWidth="1.8"
          opacity="0.46"
        />
        <rect
          x="411.67"
          y="188.4"
          width="5"
          height="0.81"
          fill="none"
          stroke="#efda45"
          strokeMiterlimit="10"
          strokeWidth="1.8"
          opacity="0.46"
        />
        <rect
          x="410.67"
          y="207.91"
          width="5"
          height="0.81"
          fill="none"
          stroke="#efda45"
          strokeMiterlimit="10"
          strokeWidth="1.8"
          opacity="0.46"
        />
        <rect
          x="404.67"
          y="220.11"
          width="5"
          height="0.81"
          fill="none"
          stroke="#efda45"
          strokeMiterlimit="10"
          strokeWidth="1.8"
          opacity="0.46"
        />
        <rect
          x="401.67"
          y="263.8"
          width="5"
          height="0.81"
          fill="none"
          stroke="#efda45"
          strokeMiterlimit="10"
          strokeWidth="1.8"
          opacity="0.46"
        />
        <rect
          x="405.67"
          y="243.8"
          width="5"
          height="0.81"
          fill="none"
          stroke="#efda45"
          strokeMiterlimit="10"
          strokeWidth="1.8"
          opacity="0.46"
        />
        <rect
          x="411.67"
          y="230.67"
          width="5"
          height="0.81"
          fill="none"
          stroke="#efda45"
          strokeMiterlimit="10"
          strokeWidth="1.8"
          opacity="0.46"
        />
        <g>
          <path
            d="M57.8,68h49.8a14.07,14.07,0,0,1,14.07,14.07V299.93A14.07,14.07,0,0,1,107.6,314H63.74a14.07,14.07,0,0,1-14.07-14.07V76.13A8.13,8.13,0,0,1,57.8,68Z"
            fill="#8161a3"
          />
          <path
            d="M57.86,68h5.51a1.2,1.2,0,0,1,1.2,1.2V306.55A7.45,7.45,0,0,1,57.12,314h0a7.45,7.45,0,0,1-7.45-7.45V76.19A8.19,8.19,0,0,1,57.86,68Z"
            fill="#e9847e"
            opacity="0.46"
          />
          <path
            d="M49.67,314l.5-238a7.74,7.74,0,0,1,7-7.5"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="3.15"
            opacity="0.46"
          />
          <rect
            x="70.98"
            y="130"
            width="12.41"
            height="1"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="3.15"
            opacity="0.46"
          />
          <rect
            x="100.36"
            y="115"
            width="12.41"
            height="1"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="3.15"
            opacity="0.46"
          />
          <rect
            x="91.88"
            y="138"
            width="12.41"
            height="1"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="3.15"
            opacity="0.46"
          />
          <rect
            x="70.98"
            y="153"
            width="12.41"
            height="1"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="3.15"
            opacity="0.46"
          />
          <rect
            x="94.36"
            y="160"
            width="12.41"
            height="1"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="3.15"
            opacity="0.46"
          />
          <rect
            x="94.36"
            y="166"
            width="12.41"
            height="1"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="3.15"
            opacity="0.46"
          />
          <rect
            x="75.91"
            y="186"
            width="12.41"
            height="1"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="3.15"
            opacity="0.46"
          />
          <rect
            x="75.91"
            y="201"
            width="12.41"
            height="1"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="3.15"
            opacity="0.46"
          />
          <rect
            x="94.36"
            y="215"
            width="12.41"
            height="1"
            fill="none"
            stroke="#efda45"
            strokeMiterlimit="10"
            strokeWidth="3.15"
            opacity="0.46"
          />
          <path
            d="M117.37,131h10a14.32,14.32,0,0,1,14.32,14.32V295.7A14.32,14.32,0,0,1,127.91,310l-10.32.41a14.34,14.34,0,0,1-14.89-14.35l.35-150.8A14.32,14.32,0,0,1,117.37,131Z"
            fill="#6d4c89"
          />
          <rect
            x="4.67"
            y="130"
            width="59"
            height="188"
            rx="13"
            fill="#6d4c89"
          />
          <rect
            x="20.67"
            y="192"
            width="5"
            height="1"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="2"
            opacity="0.46"
          />
          <rect
            x="31.67"
            y="168"
            width="5"
            height="1"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="2"
            opacity="0.46"
          />
          <rect
            x="40.67"
            y="148"
            width="5"
            height="1"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="2"
            opacity="0.46"
          />
          <rect
            x="15.67"
            y="149"
            width="5"
            height="1"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="2"
            opacity="0.46"
          />
          <rect
            x="40.67"
            y="193"
            width="5"
            height="1"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="2"
            opacity="0.46"
          />
          <rect
            x="41.67"
            y="214"
            width="5"
            height="1"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="2"
            opacity="0.46"
          />
          <rect
            x="15.67"
            y="224"
            width="5"
            height="1"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="2"
            opacity="0.46"
          />
          <g>
            <polygon
              points="149 202.54 149 252.59 149 327.67 127.33 315.15 127.33 240.07 149 202.54"
              fill="#7c57a3"
            />
            <polygon
              points="149 202.54 149 252.59 127.33 240.07 149 202.54"
              fill="#e9847e"
              opacity="0.46"
            />
            <polygon
              points="169.68 239.51 149 202.54 149 252.59 149 327.67 170.67 314.47 169.68 239.51"
              fill="#6d4c89"
            />
          </g>
          <rect
            x="119.67"
            y="201"
            width="5"
            height="1"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="2"
            opacity="0.46"
          />
          <rect
            x="111.67"
            y="220"
            width="5"
            height="1"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="2"
            opacity="0.46"
          />
          <rect
            x="118.67"
            y="233"
            width="5"
            height="1"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="2"
            opacity="0.46"
          />
          <rect
            x="124.67"
            y="182"
            width="5"
            height="1"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="2"
            opacity="0.46"
          />
          <rect
            x="113.67"
            y="160"
            width="5"
            height="1"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="2"
            opacity="0.46"
          />
          <rect
            x="122.67"
            y="148"
            width="5"
            height="1"
            fill="none"
            stroke="#7ac1b3"
            strokeMiterlimit="10"
            strokeWidth="2"
            opacity="0.46"
          />
        </g>
        <g>
          <g>
            <polygon
              points="431.77 273.46 459.76 234.02 459.76 321.92 431.18 338.09 431.77 273.46"
              fill="#4d3768"
              stroke="#72bdc1"
              strokeMiterlimit="10"
              strokeWidth="0.57"
            />
            <polygon
              points="424.32 269.16 459.76 234.02 431.77 273.46 431.18 338.09 424.32 333.79 424.32 269.16"
              fill="#81b5b4"
            />
            <line
              x1="445.47"
              y1="297.87"
              x2="459.76"
              y2="289.37"
              fill="#5f467a"
              stroke="#72bdc1"
              strokeMiterlimit="10"
              strokeWidth="0.57"
            />
            <line
              x1="436.02"
              y1="308.27"
              x2="459.76"
              y2="294.1"
              fill="#5f467a"
              stroke="#72bdc1"
              strokeMiterlimit="10"
              strokeWidth="0.57"
            />
            <line
              x1="444.2"
              y1="266.14"
              x2="459.76"
              y2="257.31"
              fill="#5f467a"
              stroke="#72bdc1"
              strokeMiterlimit="10"
              strokeWidth="0.57"
            />
            <line
              x1="449.45"
              y1="258.98"
              x2="459.76"
              y2="253.93"
              fill="#5f467a"
              stroke="#72bdc1"
              strokeMiterlimit="10"
              strokeWidth="0.57"
            />
          </g>
          <g>
            <polygon
              points="498.21 272.14 470.23 232.69 470.23 320.6 498.8 336.76 498.21 272.14"
              fill="#4d3768"
              stroke="#72bdc1"
              strokeMiterlimit="10"
              strokeWidth="0.57"
            />
            <polygon
              points="505.67 267.83 470.23 232.69 498.21 272.14 498.8 336.76 505.67 332.46 505.67 267.83"
              fill="#6a9e9e"
            />
            <line
              x1="484.51"
              y1="296.54"
              x2="470.23"
              y2="288.05"
              fill="#5f467a"
              stroke="#72bdc1"
              strokeMiterlimit="10"
              strokeWidth="0.57"
            />
            <line
              x1="493.96"
              y1="306.95"
              x2="470.23"
              y2="292.77"
              fill="#5f467a"
              stroke="#72bdc1"
              strokeMiterlimit="10"
              strokeWidth="0.57"
            />
            <line
              x1="485.79"
              y1="264.81"
              x2="470.23"
              y2="255.98"
              fill="#5f467a"
              stroke="#72bdc1"
              strokeMiterlimit="10"
              strokeWidth="0.57"
            />
            <line
              x1="480.54"
              y1="257.65"
              x2="470.23"
              y2="252.6"
              fill="#5f467a"
              stroke="#72bdc1"
              strokeMiterlimit="10"
              strokeWidth="0.57"
            />
          </g>
          <polygon
            points="462.91 234.02 445.47 281.41 459.76 281.75 462.91 234.02"
            fill="#81b5b4"
          />
          <polygon
            points="465.87 234.02 470.25 281.75 483.64 281.41 465.87 234.02"
            fill="#81b5b4"
          />
          <polygon
            points="445.47 281.41 445.47 346.74 459.76 346.38 459.76 281.75 445.47 281.41"
            fill="#6a9e9e"
          />
          <polygon
            points="470.25 281.75 470.23 346.74 483.64 346.74 483.64 281.41 470.25 281.75"
            fill="#6a9e9e"
          />
          <polygon
            points="470.23 346.74 465.87 310.54 465.87 234.02 470.25 281.75 470.23 346.74"
            fill="#4d3768"
            stroke="#72bdc1"
            strokeMiterlimit="10"
            strokeWidth="0.57"
          />
          <polygon
            points="459.76 346.38 462.91 312.25 462.91 234.02 459.76 281.75 459.76 346.38"
            fill="#4d3768"
            stroke="#72bdc1"
            strokeMiterlimit="10"
            strokeWidth="0.57"
          />
        </g>
        <g>
          <ellipse cx="67.13" cy="355.2" rx="41.55" ry="11.8" fill="#d0827d" />
          <ellipse cx="67.13" cy="351.89" rx="41.55" ry="11.8" fill="#6d4c89" />
          <ellipse cx="67.13" cy="351.89" rx="41.55" ry="11.8" fill="#6d4c89" />
          <path
            d="M62.18,223c-25.69,0-46.51,29.91-46.51,66.81s20.82,66.8,46.51,66.8,46.5-29.91,46.5-66.8S87.86,223,62.18,223Zm0,106.48c-15.26,0-27.62-17.76-27.62-39.67s12.36-39.68,27.62-39.68,27.61,17.76,27.61,39.68S77.43,329.48,62.18,329.48Z"
            fill="#663f6d"
          />
          <g>
            <path
              d="M65.72,250.46a19.84,19.84,0,0,0-3.54-.33c-15.26,0-27.62,17.76-27.62,39.68s12.36,39.67,27.62,39.67a19.84,19.84,0,0,0,3.54-.33c-13.58-2.5-24.08-19.16-24.08-39.34S52.14,253,65.72,250.46Z"
              fill="#563e70"
            />
            <path
              d="M69.26,223a34.67,34.67,0,0,0-3.54.19c24,2.6,43,31.43,43,66.62s-18.93,64-43,66.61a32,32,0,0,0,3.54.19c25.68,0,46.5-29.91,46.5-66.8S94.94,223,69.26,223Z"
              fill="#563e70"
            />
          </g>
          <g>
            <path
              d="M64.77,329.3a18.72,18.72,0,0,0,2.6.18c15.25,0,27.62-17.76,27.62-39.67s-12.37-39.68-27.62-39.68a18.72,18.72,0,0,0-2.6.18c14,1.88,25,18.84,25,39.5S78.81,327.42,64.77,329.3Z"
              fill="#d0827d"
            />
            <path
              d="M20.86,289.81c0-35.65,19.44-64.77,43.91-66.7-.86-.07-1.72-.11-2.59-.11-25.69,0-46.51,29.91-46.51,66.81s20.82,66.8,46.51,66.8c.87,0,1.73,0,2.59-.1C40.3,354.57,20.86,325.45,20.86,289.81Z"
              fill="#d0827d"
            />
          </g>
          <rect
            x="85.07"
            y="249.63"
            width="5.19"
            height="1.04"
            fill="#c6bb7b"
          />
          <rect
            x="37.39"
            y="249.63"
            width="5.19"
            height="1.04"
            fill="#c6bb7b"
          />
          <rect
            x="35.03"
            y="251.99"
            width="5.19"
            height="1.04"
            fill="#c6bb7b"
          />
          <rect
            x="31.72"
            y="254.35"
            width="5.19"
            height="1.04"
            fill="#c6bb7b"
          />
          <rect
            x="27.47"
            y="271.82"
            width="5.19"
            height="1.04"
            fill="#c6bb7b"
          />
          <rect x="27.47" y="287.4" width="5.19" height="1.04" fill="#c6bb7b" />
          <rect x="44" y="243.49" width="5.19" height="1.04" fill="#c6bb7b" />
          <rect
            x="63.36"
            y="228.38"
            width="5.19"
            height="1.04"
            fill="#c6bb7b"
          />
          <rect
            x="62.88"
            y="231.69"
            width="5.19"
            height="1.04"
            fill="#c6bb7b"
          />
          <rect
            x="71.85"
            y="234.99"
            width="5.19"
            height="1.04"
            fill="#c6bb7b"
          />
          <rect x="77.05" y="241.6" width="5.19" height="1.04" fill="#c6bb7b" />
          <rect
            x="89.32"
            y="251.52"
            width="5.19"
            height="1.04"
            fill="#c6bb7b"
          />
          <rect
            x="95.46"
            y="282.21"
            width="5.19"
            height="1.04"
            fill="#c6bb7b"
          />
          <rect
            x="87.91"
            y="328.95"
            width="5.19"
            height="1.04"
            fill="#c6bb7b"
          />
          <rect
            x="94.99"
            y="269.93"
            width="5.19"
            height="1.04"
            fill="#c6bb7b"
          />
          <rect
            x="91.68"
            y="259.07"
            width="5.19"
            height="1.04"
            fill="#c6bb7b"
          />
        </g>
        <g>
          <ellipse cx="259.67" cy="320.5" rx="24" ry="5.5" fill="#5a3e77" />
          <ellipse cx="259.17" cy="318" rx="24" ry="5.5" fill="#6d4c89" />
          <circle cx="256.67" cy="286" r="34" fill="#663f6d" />
          <path
            d="M232.67,290a34,34,0,0,1,34-34,33.56,33.56,0,0,1,7.48.84,34,34,0,1,0-25,62.32A34,34,0,0,1,232.67,290Z"
            fill="#d0827d"
          />
          <path
            d="M235.35,259.52a48.66,48.66,0,0,0,10.48,2.89,60.17,60.17,0,0,0,10.8.82c.9,0,1.81-.07,2.71-.1s1.8-.09,2.7-.21l2.7-.29,2.68-.45c1.8-.24,3.54-.76,5.31-1.16s3.49-1,5.26-1.5c-.84.35-1.69.69-2.54,1s-1.69.71-2.58.95c-1.76.5-3.49,1.11-5.3,1.44-.9.2-1.79.4-2.7.57l-2.73.36a25.13,25.13,0,0,1-2.74.25c-.92,0-1.84.14-2.76.12a49.67,49.67,0,0,1-10.95-1.07,48.38,48.38,0,0,1-5.31-1.44A32.61,32.61,0,0,1,235.35,259.52Z"
            fill="#a285c1"
          />
          <path
            d="M254.17,319.5c.87.18,1.73.35,2.58.5a34,34,0,0,0,26.83-54.77h0S294.17,314.5,254.17,319.5Z"
            fill="#5a3e77"
          />
          <path
            d="M227.17,269.1a69.93,69.93,0,0,0,7.09,2.85c2.4.83,4.84,1.56,7.3,2.15a65.32,65.32,0,0,0,15,2,47.72,47.72,0,0,0,7.56-.41c1.26-.13,2.49-.39,3.74-.62s2.46-.56,3.67-.94,2.4-.78,3.59-1.2l1.75-.74a18,18,0,0,0,1.72-.81,47.74,47.74,0,0,0,6.57-3.87,41.1,41.1,0,0,1-13.4,7.36,40.4,40.4,0,0,1-7.52,1.73,49.51,49.51,0,0,1-7.69.5,61.94,61.94,0,0,1-15.21-2.25A63.46,63.46,0,0,1,227.17,269.1Z"
            fill="#a285c1"
          />
          <path
            d="M223.14,280.36a50.38,50.38,0,0,0,7.84,3.93,63.89,63.89,0,0,0,8.29,2.75,66.29,66.29,0,0,0,17.27,2.19,69.59,69.59,0,0,0,17.29-2.15,91.36,91.36,0,0,0,16.5-5.88c-1.3.67-2.6,1.37-3.92,2s-2.66,1.25-4,1.78-2.73,1.09-4.13,1.54c-.7.23-1.4.48-2.1.69l-2.12.61c-1.41.43-2.86.71-4.3,1s-2.89.56-4.36.72a65.06,65.06,0,0,1-8.82.64,63.72,63.72,0,0,1-17.48-2.45A52.81,52.81,0,0,1,223.14,280.36Z"
            fill="#a285c1"
          />
          <path
            d="M223.42,293.09a36.52,36.52,0,0,0,7.43,4.54l2,.89c.67.29,1.36.52,2,.77s1.35.54,2,.72l2.09.59a58,58,0,0,0,17.2,1.83l4.34-.27c1.44-.13,2.87-.42,4.3-.62a85.43,85.43,0,0,0,8.51-1.85l1.06-.25,1-.34,2.08-.69,4.14-1.36,8.1-3.31c-2.62,1.28-5.27,2.52-7.92,3.76L277.73,299l-2.07.75-1,.38-1.06.29c-1.41.39-2.83.77-4.25,1.13-.72.17-1.41.41-2.14.51l-2.17.36c-1.46.22-2.9.53-4.36.68l-4.4.32a56.11,56.11,0,0,1-17.44-2.1A39.74,39.74,0,0,1,223.42,293.09Z"
            fill="#a285c1"
          />
          <path
            d="M230.05,307.14a49.35,49.35,0,0,0,12.84,4.58,58.71,58.71,0,0,0,13.53,1.38c1.13,0,2.27-.1,3.4-.14l1.7-.08,1.69-.22,3.38-.46c1.11-.24,2.23-.47,3.34-.69l1.68-.34c.55-.14,1.09-.31,1.64-.46l3.29-.94c2.18-.67,4.29-1.55,6.47-2.28-1,.48-2.08.95-3.13,1.4s-2.09,1-3.18,1.34l-3.27,1.09c-.55.17-1.09.37-1.64.53l-1.68.41c-1.12.27-2.24.54-3.36.79l-3.42.51-1.72.24-1.72.12c-1.16.05-2.31.18-3.46.18a55.48,55.48,0,0,1-13.71-1.63,52,52,0,0,1-6.57-2.14A37.23,37.23,0,0,1,230.05,307.14Z"
            fill="#a285c1"
          />
        </g>
        <g>
          <polygon
            points="644.55 222.31 670.53 231.59 696.51 240.87 696.67 315.05 670.61 324.36 644.4 315.05 644.55 222.31"
            fill="#663f6d"
          />
          <polygon
            points="696.4 222.27 696.51 240.87 670.53 231.59 696.4 222.27"
            fill="#663f6d"
          />
          <polygon
            points="670.53 250.15 696.51 240.87 670.53 231.59 644.4 240.81 670.53 250.15"
            fill="none"
            stroke="#e59661"
            strokeMiterlimit="10"
            strokeWidth="0.59"
          />
          <polygon
            points="644.4 259.48 670.53 250.15 696.67 259.48 670.46 268.73 644.4 259.48"
            fill="none"
            stroke="#e59661"
            strokeMiterlimit="10"
            strokeWidth="0.59"
          />
          <polygon
            points="644.4 278.04 670.46 268.73 696.53 277.98 670.46 287.29 644.4 278.04"
            fill="none"
            stroke="#e59661"
            strokeMiterlimit="10"
            strokeWidth="0.59"
          />
          <polygon
            points="696.51 296.55 670.53 305.82 644.4 296.6 670.46 287.29 696.51 296.55"
            fill="none"
            stroke="#e59661"
            strokeMiterlimit="10"
            strokeWidth="0.59"
          />
          <polygon
            points="644.4 315.05 670.53 305.82 696.67 315.05 670.61 324.36 644.4 315.05"
            fill="none"
            stroke="#e59661"
            strokeMiterlimit="10"
            strokeWidth="0.59"
          />
          <line
            x1="670.53"
            y1="231.59"
            x2="670.61"
            y2="324.36"
            fill="none"
            stroke="#e59661"
            strokeMiterlimit="10"
            strokeWidth="0.59"
          />
          <polygon
            points="644.55 222.31 670.46 213 696.4 222.27 670.53 231.59 644.55 222.31"
            fill="#e59661"
          />
        </g>
        <g>
          <rect x="789.67" y="203" width="9.28" height="113" fill="#6d4c89" />
          <rect x="789.67" y="203" width="2" height="113" fill="#e59661" />
          <rect x="949.67" y="203" width="2" height="113" fill="#e59661" />
          <rect x="868.67" y="238" width="2" height="18" fill="#e59661" />
          <rect x="951.67" y="203" width="9.28" height="113" fill="#6d4c89" />
          <rect x="770.67" y="256" width="186" height="15" fill="#6d4c89" />
          <path
            d="M798.67,203q1.46,2.58,3.13,5c1.1,1.61,2.25,3.19,3.46,4.7a84.72,84.72,0,0,0,7.76,8.6,79.69,79.69,0,0,0,8.7,7.44l2.32,1.66L826.4,232c1.61,1,3.22,2,4.88,2.87,13.25,7.26,28.34,10.37,43.43,10.14,1.89-.06,3.78,0,5.65-.2l2.82-.2c.94-.08,1.87-.23,2.81-.33a92.51,92.51,0,0,0,11.08-2,94.42,94.42,0,0,0,10.75-3.4c.89-.3,1.74-.72,2.61-1.07s1.74-.73,2.58-1.15l2.56-1.21,2.5-1.33a96.72,96.72,0,0,0,26.55-21.71c1.29-1.46,2.49-3,3.67-4.56s2.32-3.15,3.38-4.82a59.43,59.43,0,0,1-5.25,10.68,82.24,82.24,0,0,1-7,9.75A86.22,86.22,0,0,1,931,232.1a81.6,81.6,0,0,1-32,17.48,91.92,91.92,0,0,1-12,2.49c-1,.13-2,.29-3,.39l-3.05.24c-2,.21-4.08.2-6.11.27s-4.08-.08-6.12-.12-4.08-.28-6.11-.5l-3-.43L858,251.7l-1.51-.29-3-.6c-1-.22-2-.5-3-.75-2-.47-3.94-1.17-5.89-1.77-1-.35-1.93-.72-2.89-1.08l-1.43-.56-1.41-.63a71.54,71.54,0,0,1-10.81-5.81,74.55,74.55,0,0,1-24.64-26.3A55.85,55.85,0,0,1,798.67,203Z"
            fill="#6d4c89"
          />
          <line
            x1="873.67"
            y1="238"
            x2="873.67"
            y2="263"
            fill="none"
            stroke="#6d4c89"
            strokeMiterlimit="10"
            strokeWidth="8"
          />
          <polygon
            points="956.67 271 1017.99 310 956.67 256 956.67 271"
            fill="#6d4c89"
          />
          <polygon
            points="770.67 271 709.35 310 770.67 256 770.67 271"
            fill="#6d4c89"
          />
        </g>
      </g>
      <g id="a5a4cb57-0d73-43c2-8577-ef332738c7de" data-name="decor12">
        <g>
          <rect x="223.67" y="728" width="38" height="2" fill="#845460" />
          <g>
            <ellipse cx="242.67" cy="730.2" rx="19" ry="3.2" fill="#845460" />
            <ellipse cx="242.66" cy="727.72" rx="19" ry="3.2" fill="#ead3cb" />
          </g>
        </g>
        <g>
          <rect x="211.67" y="771.71" width="33" height="1.74" fill="#845460" />
          <g>
            <ellipse
              cx="228.17"
              cy="773.62"
              rx="16.5"
              ry="2.78"
              fill="#845460"
            />
            <ellipse
              cx="228.16"
              cy="771.47"
              rx="16.5"
              ry="2.78"
              fill="#ead3cb"
            />
          </g>
        </g>
        <g>
          <rect x="214.67" y="747.71" width="33" height="1.74" fill="#845460" />
          <g>
            <ellipse
              cx="231.17"
              cy="749.62"
              rx="16.5"
              ry="2.78"
              fill="#845460"
            />
            <ellipse
              cx="231.16"
              cy="747.47"
              rx="16.5"
              ry="2.78"
              fill="#ead3cb"
            />
          </g>
        </g>
        <g>
          <rect x="231.67" y="759.13" width="23" height="1.21" fill="#845460" />
          <g>
            <ellipse
              cx="243.17"
              cy="760.46"
              rx="11.5"
              ry="1.94"
              fill="#845460"
            />
            <ellipse
              cx="243.16"
              cy="758.96"
              rx="11.5"
              ry="1.94"
              fill="#ead3cb"
            />
          </g>
        </g>
        <g>
          <path
            d="M203.78,360.33s21.34,7.78,39.37-11.17c0,0,5.63-2.71-3.91-9.34s-11.57,1.95-11.57,1.95-3.47-8-10.44-3.22,1,8.64-1.31,11-6.69-4.38-10.33-3.86-7.59,6.81-4.7,10.71Z"
            fill="#396039"
          />
          <path
            d="M223.59,354.83c2.93-1.71-2.22-3.84-1.52-5.51s4.6.63,7.3,1.61,3.45-2,4.27-5.76.66-6.24,5.6-5.35,12.1,2,8.74,6.49-9.34,10.3-13.11,9.71-5.83,6.07-7.74,5.24S221,356.31,223.59,354.83Z"
            fill="#426642"
          />
          <path
            d="M221.21,344.88c-3-.79-3-5-.23-5.3s2.87,4.18,5.48,4.07,6.83-.93,3.5,2.59S221.21,344.88,221.21,344.88Z"
            fill="#2f4f2f"
          />
          <path
            d="M210.71,359c-3.89-.11-6.13-2.94-5.59-4.15s1.89-4.74,4.1-2.37,7.46.42,7.81,3.6S210.71,359,210.71,359Z"
            fill="#2f4f2f"
          />
          <path
            d="M216.58,364.26c-5.41-1.16-7.62,1.51-8.48-.73s-2.52-3.92-.37-5.84,3.89.84,6.25.1.81-4.51,4.22-3S223,365.64,216.58,364.26Z"
            fill="#426642"
          />
          <path
            d="M223.56,363.15c-4.81,1.11-4.46-1.55-3.68-3.32s4.8-.39,6.06-2.08,6.09-.9,7-3.13,2.92-6.62,5.88-5,8.44,5.67,2.21,6-10.35,5.19-12.76,6.48A8.94,8.94,0,0,1,223.56,363.15Z"
            fill="#659965"
          />
        </g>
        <g>
          <path
            d="M67.58,406.48s-22.3,27.55-57,17.33c0,0-8.83,1-.82-15.44s15.92-6.84,15.92-6.84S25.17,388.22,37,388.82s4.09,12.15,8.5,13.4,5.8-11.18,10.74-13.46S70.09,391.54,68.84,399Z"
            fill="#396039"
          />
          <path
            d="M39,415.35c-4.78.15.44-6.83-1.49-8.46s-5.45,4.56-8.28,8-5.62.22-9-4.08-4.7-7.66-10.44-2.48S-4.38,420.78,2.7,424s18.27,5.94,22.7,2.09,11.17,3.24,13.08.59S43.15,415.23,39,415.35Z"
            fill="#426642"
          />
          <path
            d="M35.85,400.36c3.36-3.5.69-9-3-7.14S31.8,401,28.42,403s-9.27,4.34-2.84,6.25S35.85,400.36,35.85,400.36Z"
            fill="#2f4f2f"
          />
          <path
            d="M58,410.4c4.88-3.31,6-8.84,4.54-10s-5.34-4.68-6.69.23-9.23,6.62-7.69,11.08S58,410.4,58,410.4Z"
            fill="#2f4f2f"
          />
          <path
            d="M53.75,422.05c6.16-5.93,10.63-4.22,10.33-7.87s.77-7.18-3.14-8-4.43,4.27-7.89,5.21-3.83-5.26-7.23-.52S46.48,429.05,53.75,422.05Z"
            fill="#426642"
          />
          <path
            d="M44.19,426.25c6.8-2.44,4.7-5.65,2.63-7.35s-6.35,3.4-9,2.2-8.3,3.77-10.87,1.59-7.81-6.31-10.57-1.78-7.21,14.31.92,9.71,16.38-1.6,20.24-1.86A13.08,13.08,0,0,0,44.19,426.25Z"
            fill="#659965"
          />
        </g>
        <g>
          <rect
            x="169.56"
            y="317.77"
            width="0.92"
            height="16.23"
            fill="#6c6575"
          />
          <ellipse
            cx="170.17"
            cy="317.45"
            rx="6.5"
            ry="5.99"
            fill="url(#b976d605-c618-4181-b318-1a92e138aba0)"
            style={{ mixBlendMode: 'overlay' }}
          />
          <g>
            <ellipse
              cx="170.02"
              cy="313.47"
              rx="1.88"
              ry="0.37"
              fill="url(#a35ff387-350d-4ce9-9401-6884c69a18ac)"
            />
            <ellipse
              cx="170.02"
              cy="314.11"
              rx="2.6"
              ry="0.48"
              fill="url(#bc86e68a-c5ff-4ede-8ac5-30378800becd)"
            />
            <ellipse
              cx="170.02"
              cy="314.76"
              rx="3.31"
              ry="0.6"
              fill="url(#a04da219-5c68-42da-bcff-f82a50eb10d5)"
            />
            <ellipse
              cx="170.02"
              cy="315.4"
              rx="4.03"
              ry="0.72"
              fill="url(#fc228e66-99eb-4f01-9b0e-dc7cad51689b)"
            />
            <ellipse
              cx="170.02"
              cy="316.04"
              rx="4.74"
              ry="0.83"
              fill="url(#b2908da2-5a77-44fd-a910-be692fae1523)"
            />
            <ellipse
              cx="170.02"
              cy="316.69"
              rx="5.45"
              ry="0.95"
              fill="url(#ef6ab5bd-2de0-4285-8a3c-f4a3a5cc915d)"
            />
            <ellipse
              cx="170.02"
              cy="317.63"
              rx="4.92"
              ry="0.87"
              fill="url(#bf8fae05-7fe1-4034-b903-10dc01ef06d7)"
            />
            <ellipse
              cx="170.02"
              cy="318.58"
              rx="4.38"
              ry="0.78"
              fill="url(#bb2713cf-bc3b-460d-ab2e-480ced31c8fc)"
            />
            <ellipse
              cx="170.02"
              cy="319.53"
              rx="3.84"
              ry="0.7"
              fill="url(#a43c1288-3157-458a-b0f7-bdce74a6907b)"
            />
            <ellipse
              cx="170.02"
              cy="320.47"
              rx="3.31"
              ry="0.62"
              fill="url(#e6197561-0607-406c-ae74-a62e742d1af4)"
            />
            <ellipse
              cx="170.02"
              cy="321.42"
              rx="2.77"
              ry="0.54"
              fill="url(#f905e77b-0bfa-4c39-b986-3fc207010e13)"
            />
          </g>
        </g>
        <g>
          <path
            d="M194,325.19c2-3.37,2.74-4.14,1.87-6.41s-1.7-.33-.83-4.6a4.44,4.44,0,0,0-3.94-5.71c-1.5-.17-8.61,4-7.41,6.27s1.72,8.71.43,9.24S191.59,329.16,194,325.19Z"
            fill="#396039"
          />
          <path
            d="M192.63,317.35c-.07-1.84,2.7-2.57,1.8-3.41s-2-3-2.84-1.87-1.53,2.81-2.2,1.87-1.4-1-1.84,0-.06,2.17-1.1,1.87-1.5.17-1.36,1.17.9.6,1.56,1.8,3.67,1,3.17.37S192.63,317.35,192.63,317.35Z"
            fill="#447244"
          />
          <path
            d="M197.8,314.18c1.5-2.37,3.6-4.54,5.7-2.51s-1.4,5.68,0,7.11,1.1,5.07,0,5.21-6.34.13-7.7.76-3.14-1.7-3.17-4S197.8,314.18,197.8,314.18Z"
            fill="#6b996b"
          />
          <path
            d="M189.89,328.22c3.52,2.68,3.77-6.64,0-5.84s-5,.57-6.21-1.1-4.2,1.27-4.3,2.1a5.38,5.38,0,0,0,2.94,4.44C184.38,328.62,187.79,326.62,189.89,328.22Z"
            fill="#447244"
          />
          <path
            d="M197.15,330.09c-3.51,2.68-3.77-6.64,0-5.84s5,.57,6.21-1.1,4.2,1.27,4.3,2.1a5.37,5.37,0,0,1-2.93,4.44C202.66,330.49,199.26,328.49,197.15,330.09Z"
            fill="#447244"
          />
          <path
            d="M201.53,326.89c.5-1,2,.93,2,.93s-.1-1.3.7-1.77,1.17.74,1.17.74c.07-.94,2-.07,1.44,1h0a4.48,4.48,0,0,1-2.08,1.86,3.62,3.62,0,0,1-1.49.19l-1.79-.45A4.29,4.29,0,0,1,201.53,326.89Z"
            fill="#396039"
          />
          <path
            d="M194.29,328.59c-.7,1.23-1.1,12.34,0,17.45,0,0-3.2-.57-4.2,0-.1.33-.1,0-.1,0s4.44-15.45.57-20-8.08,0-8.08,0,1.14-2.67,3.64-2.87,5.94,3,6.11,3.67c0,0,.13-4.87-1.44-6.57a1.82,1.82,0,0,1,.43-2.93s-2.06.63,1.27,5c1.73,2.25.5,6.44.5,6.44s1.07-3.27,3.74-2.57,4.27,3.8,6.77,3.6a13.18,13.18,0,0,1-5.27-1.57A3.09,3.09,0,0,0,194.29,328.59Z"
            fill="#704d3c"
          />
          <path
            d="M198,328.07a3.06,3.06,0,0,0-3.66.52,15.42,15.42,0,0,0-.56,4.14c-.81-2.76.63-6,1.08-6.34a2.55,2.55,0,0,1,1.92-.2,5.71,5.71,0,0,1,1.76.84Z"
            fill="#634b42"
          />
          <path
            d="M191.81,327a8.27,8.27,0,0,1,.32,4.54h0c-.09-2.29-.53-4.3-1.57-5.53a6.73,6.73,0,0,0-.7-.71l-.15-.47A6,6,0,0,1,191.81,327Z"
            fill="#44322c"
          />
          <path
            d="M197.2,327.55c1-.32,1-1.67,2.18-1.59s1.28,1.72,2.23,2.79,1.73.84,2.48,1.2-2.07,4.45-4.71,3-2.39-1.22-3.3-1.82S195.05,328.25,197.2,327.55Z"
            fill="#6b996b"
          />
          <g>
            <path d="M192.2,325.45c0,.06,0,.07,0,0v0Z" fill="#7f2c03" />
            <path
              d="M192.16,324.86c-.12-1.54-.46-3.59-1.37-4.58a2.05,2.05,0,0,1-.6-1.2l.46-.09a9.36,9.36,0,0,0,1.84,3.33l.08.1C192.49,323.3,192.21,324.2,192.16,324.86Z"
              fill="#634b42"
            />
          </g>
          <path
            d="M188.55,324.74c-.64-.79.06-1.95-.94-2.52s-2,.73-3.4,1.1-1.9-.26-2.74-.37-.72,4.85,2.3,5.08,2.66.3,3.75.3S190,326.52,188.55,324.74Z"
            fill="#6b996b"
          />
          <path
            d="M189.82,315.38c.65-1,1.57-2,2.49-1.1s-.61,2.49,0,3.11.49,2.22,0,2.28a18.51,18.51,0,0,0-3.37.34c-.6.28-1.37-.75-1.39-1.74S189.82,315.38,189.82,315.38Z"
            fill="#6b996b"
          />
          <path
            d="M183.25,326.92c.19.29.74.23,1.06.1s.51-1.11,1-.94.77.68,1.35.52.33-.79,1.06-.8,1.38.27,1.4.65a.28.28,0,0,1,0,.09h0s0,.06,0,.09a1.88,1.88,0,0,1-1.61,1.7c-1.09,0-.74-.08-3.75-.3a2.42,2.42,0,0,1-1.11-.35C182.32,327.45,183.06,326.63,183.25,326.92Z"
            fill="#447244"
          />
          <path
            d="M196.8,331.09c.73,0,2.2.8,2.4.07s1.67-.9,1.83-.57a1.45,1.45,0,0,0,1.57.5c.5-.26,1,.4.77.66-.93,1.05-2.49,2-4,1.17-1.83-1-2.27-1.21-2.68-1.43C196.53,331.36,196.23,331.09,196.8,331.09Z"
            fill="#396039"
          />
          <path
            d="M194.06,322.65c.47-1,1.6-.83,2.4-.7s.57,1.2,1.2.7,2,.7,1.51,1.57h0a12.4,12.4,0,0,0-3.37.53c-.85.4-1.85-.35-2.5-1.51l-.28-.59h0S193.59,323.69,194.06,322.65Z"
            fill="#447244"
          />
          <path
            d="M202.54,322c-.31-.94,1-1.74,0-1.74s-2.74,1-2.57-.47-.3-2.3-1.44-2.2-2-2.33-1.37-2.88-3.53,1-1.7,2.62,2.5,1.06,2.44,1.8,0,2.27,1.4,2.5-.4,2.14.65,2.57S203.34,324.52,202.54,322Z"
            fill="#447244"
          />
          <path
            d="M190,346s.28-1,.63-2.47c2.79-1.43,3-6.08,3-6.22a47.2,47.2,0,0,0,.68,8.69s-3.2-.57-4.2,0C190,346.34,190,346,190,346Z"
            fill="#44322c"
          />
          <path
            d="M193.32,345.9a20,20,0,0,0-.41-2.65,18.56,18.56,0,0,1,0-2.69c.11-1.78.27-3.56.36-5.35,0-.44.05-.89.05-1.33a4.8,4.8,0,0,0,0-.66c0-.2-.11-.42-.15-.64a4.46,4.46,0,0,1,0-2.68,5.74,5.74,0,0,1,1.51-2.22,2.24,2.24,0,0,1,1.31-.31,6,6,0,0,1,1.33.19,3.52,3.52,0,0,0-2.58.2,5.76,5.76,0,0,0-1.45,2.19,4.42,4.42,0,0,0,.09,2.59c.05.22.12.42.17.65a5.39,5.39,0,0,1,0,.69c0,.45,0,.9,0,1.34-.11,1.79-.3,3.57-.43,5.35a19.82,19.82,0,0,0,0,2.67A18.23,18.23,0,0,1,193.32,345.9Z"
            fill="#44322c"
          />
          <path
            d="M192.61,337.35a6.73,6.73,0,0,0,0,1.1,1.43,1.43,0,0,1-.36,1.06,3,3,0,0,0-.83,1.94,4.34,4.34,0,0,0,0,1.08,8.69,8.69,0,0,0,.29,1.05,8.7,8.7,0,0,1,.23,2.21,12,12,0,0,0-.38-2.17,5.8,5.8,0,0,1-.32-1.07,5.25,5.25,0,0,1,0-1.12,3.12,3.12,0,0,1,.91-2C192.7,338.9,192.42,338.05,192.61,337.35Z"
            fill="#44322c"
          />
          <path
            d="M192.61,323.17c0,.42.2.81.23,1.25a5.3,5.3,0,0,1-.09.63,2.2,2.2,0,0,0,.12.6,6.17,6.17,0,0,1,.36,2.53c0,.44-.23.83-.27,1.24a8.65,8.65,0,0,0-.07,1.25,15.2,15.2,0,0,0,.29,2.51,11.29,11.29,0,0,1-.44-2.51,6.88,6.88,0,0,1,0-1.28c0-.43.21-.84.25-1.24a6.12,6.12,0,0,0-.31-2.46,2.76,2.76,0,0,1-.1-.65c0-.24.12-.4.12-.62C192.75,324,192.61,323.59,192.61,323.17Z"
            fill="#44322c"
          />
        </g>
        <g>
          <path
            d="M206.53,359.6s-20.69,24.45-54.48,14.07c0,0-8.49.66-1.26-14.11S166,353.81,166,353.81s-.93-12.15,10.51-11.25,4.32,11.21,8.62,12.49,5.24-10,9.95-11.95,13.47,3,12.48,9.73Z"
            fill="#396039"
          />
          <path
            d="M179.21,366.82c-4.62,0,.21-6.22-1.7-7.76s-5.13,4-7.75,7.08-5.41,0-8.81-4-4.78-7.13-10.16-2.58-13.3,10.88-6.37,14,17.83,6,22,2.6,10.89,3.3,12.65.94S183.21,366.84,179.21,366.82Z"
            fill="#426642"
          />
          <path
            d="M175.7,353.05c3.15-3.09.4-8.17-3.1-6.6s-.78,7.09-4,8.79-8.81,3.67-2.55,5.61S175.7,353.05,175.7,353.05Z"
            fill="#2f4f2f"
          />
          <path
            d="M197.37,362.89c4.61-2.87,5.5-7.88,4.08-9s-5.3-4.44-6.45,0-8.71,5.75-7.09,9.87S197.37,362.89,197.37,362.89Z"
            fill="#2f4f2f"
          />
          <path
            d="M193.65,373.38c5.76-5.21,10.14-3.52,9.74-6.86s.52-6.53-3.28-7.35-4.15,3.75-7.45,4.51-3.87-4.91-7-.7S186.85,379.54,193.65,373.38Z"
            fill="#426642"
          />
          <path
            d="M184.55,376.92c6.49-2,4.37-5,2.31-6.62s-6,2.9-8.62,1.72-7.89,3.19-10.44,1.13-7.74-6-10.27-1.95S151,384,158.72,380.08s15.77-1,19.49-1.08A12.22,12.22,0,0,0,184.55,376.92Z"
            fill="#659965"
          />
        </g>
        <g>
          <path
            d="M21,361.19c2-3.37,2.74-4.14,1.87-6.41s-1.7-.33-.83-4.6a4.44,4.44,0,0,0-3.94-5.71c-1.5-.17-8.61,4-7.41,6.27s1.72,8.71.43,9.24S18.59,365.16,21,361.19Z"
            fill="#396039"
          />
          <path
            d="M19.63,353.35c-.07-1.84,2.7-2.57,1.8-3.41s-2-3-2.84-1.87-1.53,2.81-2.2,1.87-1.4-1-1.84,0-.06,2.17-1.1,1.87S12,352,12.09,353s.9.6,1.56,1.8,3.67,1,3.17.37S19.63,353.35,19.63,353.35Z"
            fill="#447244"
          />
          <path
            d="M24.8,350.18c1.5-2.37,3.6-4.54,5.7-2.51s-1.4,5.68,0,7.11,1.1,5.07,0,5.21-6.34.13-7.7.76-3.14-1.7-3.17-4S24.8,350.18,24.8,350.18Z"
            fill="#6b996b"
          />
          <path
            d="M16.89,364.22c3.52,2.68,3.77-6.64,0-5.84s-5,.57-6.21-1.1-4.2,1.27-4.3,2.1a5.38,5.38,0,0,0,2.94,4.44C11.38,364.62,14.79,362.62,16.89,364.22Z"
            fill="#447244"
          />
          <path
            d="M24.15,366.09c-3.51,2.68-3.77-6.64,0-5.84s5,.57,6.21-1.1,4.2,1.27,4.3,2.1a5.37,5.37,0,0,1-2.93,4.44C29.66,366.49,26.26,364.49,24.15,366.09Z"
            fill="#447244"
          />
          <path
            d="M28.53,362.89c.5-1,2,.93,2,.93s-.1-1.3.7-1.77,1.17.74,1.17.74c.07-.94,2-.07,1.44,1h0a4.48,4.48,0,0,1-2.08,1.86,3.62,3.62,0,0,1-1.49.19l-1.79-.45A4.29,4.29,0,0,1,28.53,362.89Z"
            fill="#396039"
          />
          <path
            d="M21.29,364.59c-.7,1.23-1.1,12.34,0,17.45,0,0-3.2-.57-4.2,0-.1.33-.1,0-.1,0s4.44-15.45.57-20-8.08,0-8.08,0,1.14-2.67,3.64-2.87,5.94,3,6.11,3.67c0,0,.13-4.87-1.44-6.57a1.82,1.82,0,0,1,.43-2.93s-2.06.63,1.27,5c1.73,2.25.5,6.44.5,6.44s1.07-3.27,3.74-2.57,4.27,3.8,6.77,3.6a13.18,13.18,0,0,1-5.27-1.57A3.09,3.09,0,0,0,21.29,364.59Z"
            fill="#704d3c"
          />
          <path
            d="M25,364.07a3.06,3.06,0,0,0-3.66.52,15.42,15.42,0,0,0-.56,4.14c-.81-2.76.63-6,1.08-6.34a2.55,2.55,0,0,1,1.92-.2,5.71,5.71,0,0,1,1.76.84Z"
            fill="#634b42"
          />
          <path
            d="M18.81,363a8.27,8.27,0,0,1,.32,4.54h0c-.09-2.29-.53-4.3-1.57-5.53a6.73,6.73,0,0,0-.7-.71l-.15-.47A6,6,0,0,1,18.81,363Z"
            fill="#44322c"
          />
          <path
            d="M24.2,363.55c1-.32,1-1.67,2.18-1.59s1.28,1.72,2.23,2.79,1.73.84,2.48,1.2-2.07,4.45-4.71,3-2.39-1.22-3.3-1.82S22.05,364.25,24.2,363.55Z"
            fill="#6b996b"
          />
          <g>
            <path d="M19.2,361.45c0,.06,0,.07,0,0v0Z" fill="#7f2c03" />
            <path
              d="M19.16,360.86c-.12-1.54-.46-3.59-1.37-4.58a2.05,2.05,0,0,1-.6-1.2l.46-.09a9.36,9.36,0,0,0,1.84,3.33l.08.1C19.49,359.3,19.21,360.2,19.16,360.86Z"
              fill="#634b42"
            />
          </g>
          <path
            d="M15.55,360.74c-.64-.79.06-1.95-.94-2.52s-2,.73-3.4,1.1-1.9-.26-2.74-.37-.72,4.85,2.3,5.08,2.66.3,3.75.3S17,362.52,15.55,360.74Z"
            fill="#6b996b"
          />
          <path
            d="M16.82,351.38c.65-1,1.57-2,2.49-1.1s-.61,2.49,0,3.11.49,2.22,0,2.28a18.51,18.51,0,0,0-3.37.34c-.6.28-1.37-.75-1.39-1.74S16.82,351.38,16.82,351.38Z"
            fill="#6b996b"
          />
          <path
            d="M10.25,362.92c.19.29.74.23,1.06.1s.51-1.11,1-.94.77.68,1.35.52.33-.79,1.06-.8,1.38.27,1.4.65a.28.28,0,0,1,0,.09h0s0,.06,0,.09a1.88,1.88,0,0,1-1.61,1.7c-1.09,0-.74-.08-3.75-.3a2.42,2.42,0,0,1-1.11-.35C9.32,363.45,10.06,362.63,10.25,362.92Z"
            fill="#447244"
          />
          <path
            d="M23.8,367.09c.73,0,2.2.8,2.4.07s1.67-.9,1.83-.57a1.45,1.45,0,0,0,1.57.5c.5-.26,1,.4.77.66-.93,1.05-2.49,2-4,1.17-1.83-1-2.27-1.21-2.68-1.43C23.53,367.36,23.23,367.09,23.8,367.09Z"
            fill="#396039"
          />
          <path
            d="M21.06,358.65c.47-1,1.6-.83,2.4-.7s.57,1.2,1.2.7,2,.7,1.51,1.57h0a12.4,12.4,0,0,0-3.37.53c-.85.4-1.85-.35-2.5-1.51l-.28-.59h0S20.59,359.69,21.06,358.65Z"
            fill="#447244"
          />
          <path
            d="M29.54,358c-.31-.94,1-1.74,0-1.74s-2.74,1-2.57-.47-.3-2.3-1.44-2.2-2-2.33-1.37-2.88-3.53,1-1.7,2.62,2.5,1.06,2.44,1.8,0,2.27,1.4,2.5-.4,2.14.65,2.57S30.34,360.52,29.54,358Z"
            fill="#447244"
          />
          <path
            d="M17,382s.28-1,.63-2.47c2.79-1.43,3-6.08,3-6.22a47.2,47.2,0,0,0,.68,8.69s-3.2-.57-4.2,0C17,382.34,17,382,17,382Z"
            fill="#44322c"
          />
          <path
            d="M20.32,381.9a20,20,0,0,0-.41-2.65,18.56,18.56,0,0,1-.05-2.69c.11-1.78.27-3.56.36-5.35,0-.44.05-.89.05-1.33a4.8,4.8,0,0,0,0-.66c0-.2-.11-.42-.15-.64a4.46,4.46,0,0,1-.05-2.68,5.74,5.74,0,0,1,1.51-2.22,2.24,2.24,0,0,1,1.31-.31,6,6,0,0,1,1.33.19,3.52,3.52,0,0,0-2.58.2A5.76,5.76,0,0,0,20.17,366a4.42,4.42,0,0,0,.09,2.59c0,.22.12.42.17.65a5.39,5.39,0,0,1,0,.69c0,.45,0,.9,0,1.34-.11,1.79-.3,3.57-.43,5.35a19.82,19.82,0,0,0,0,2.67A18.23,18.23,0,0,1,20.32,381.9Z"
            fill="#44322c"
          />
          <path
            d="M19.61,373.35a6.73,6.73,0,0,0,0,1.1,1.43,1.43,0,0,1-.36,1.06,3,3,0,0,0-.83,1.94,4.34,4.34,0,0,0,0,1.08,8.69,8.69,0,0,0,.29,1.05,8.7,8.7,0,0,1,.23,2.21,12,12,0,0,0-.38-2.17,5.8,5.8,0,0,1-.32-1.07,5.25,5.25,0,0,1,0-1.12,3.12,3.12,0,0,1,.91-2C19.7,374.9,19.42,374.05,19.61,373.35Z"
            fill="#44322c"
          />
          <path
            d="M19.61,359.17c0,.42.2.81.23,1.25a5.3,5.3,0,0,1-.09.63,2.2,2.2,0,0,0,.12.6,6.17,6.17,0,0,1,.36,2.53c-.05.44-.23.83-.27,1.24a8.65,8.65,0,0,0-.07,1.25,15.2,15.2,0,0,0,.29,2.51,11.29,11.29,0,0,1-.44-2.51,6.88,6.88,0,0,1,0-1.28c0-.43.21-.84.25-1.24a6.12,6.12,0,0,0-.31-2.46,2.76,2.76,0,0,1-.1-.65c0-.24.12-.4.12-.62C19.75,360,19.61,359.59,19.61,359.17Z"
            fill="#44322c"
          />
        </g>
        <g>
          <path
            d="M280.13,334.31s-14.88,17.15-39.85,9.32c0,0-6.22.36-1.1-10.06s11.06-3.9,11.06-3.9-.84-8.67,7.58-7.88,3.31,8,6.49,9,3.73-7.07,7.16-8.38,9.93,2.28,9.3,7.09Z"
            fill="#396039"
          />
          <path
            d="M260.15,339.11c-3.39-.07.07-4.43-1.35-5.56s-3.71,2.78-5.6,4.95-4-.05-6.53-3-3.6-5.15-7.49-2-9.64,7.58-4.5,9.91,13.17,4.48,16.18,2.14,8,2.48,9.31.83S263.09,339.17,260.15,339.11Z"
            fill="#426642"
          />
          <path
            d="M257.4,329.25c2.27-2.16.18-5.81-2.37-4.74s-.48,5-2.82,6.21-6.42,2.5-1.8,4S257.4,329.25,257.4,329.25Z"
            fill="#2f4f2f"
          />
          <path
            d="M273.44,336.54c3.36-2,3.94-5.55,2.88-6.35s-3.95-3.23-4.73-.08-6.33,4-5.09,6.94S273.44,336.54,273.44,336.54Z"
            fill="#2f4f2f"
          />
          <path
            d="M270.85,344c4.16-3.64,7.4-2.37,7.06-4.76s.3-4.64-2.5-5.28-3,2.62-5.42,3.12-2.9-3.55-5.15-.59S265.92,348.26,270.85,344Z"
            fill="#426642"
          />
          <path
            d="M264.2,346.37c4.75-1.36,3.15-3.52,1.62-4.69s-4.39,2-6.32,1.12-5.76,2.16-7.65.66-5.76-4.36-7.57-1.52-4.63,9.06,1,6.35,11.57-.48,14.3-.52A8.9,8.9,0,0,0,264.2,346.37Z"
            fill="#659965"
          />
        </g>
        <g>
          <g>
            <rect
              x="810.83"
              y="299.53"
              width="1.27"
              height="22.47"
              rx="0.64"
              fill="#a39bb2"
            />
            <g>
              <ellipse
                cx="811.47"
                cy="293.57"
                rx="2.61"
                ry="0.51"
                fill="url(#bbd329a1-d8f0-4c44-a510-f767b6044657)"
              />
              <ellipse
                cx="811.47"
                cy="294.46"
                rx="3.6"
                ry="0.67"
                fill="url(#feedaf93-b197-4a76-979d-12709f33978a)"
              />
              <ellipse
                cx="811.47"
                cy="295.35"
                rx="4.59"
                ry="0.83"
                fill="url(#eae72780-d09c-406f-9c9e-bfa80100350a)"
              />
              <ellipse
                cx="811.47"
                cy="296.24"
                rx="5.57"
                ry="0.99"
                fill="url(#f6e813e7-02b1-4e78-a786-b9cd0d01bc59)"
              />
              <ellipse
                cx="811.47"
                cy="297.13"
                rx="6.56"
                ry="1.15"
                fill="url(#adb605a5-5701-4202-b90e-8d80773a9e28)"
              />
              <ellipse
                cx="811.47"
                cy="298.03"
                rx="7.55"
                ry="1.31"
                fill="url(#f9b01663-1b1d-4bbc-8fdb-d74538c34a65)"
              />
              <ellipse
                cx="811.47"
                cy="299.34"
                rx="6.81"
                ry="1.2"
                fill="url(#ad4b3df9-6d7b-46c5-9b00-7ec156ef89fd)"
              />
              <ellipse
                cx="811.47"
                cy="300.65"
                rx="6.07"
                ry="1.09"
                fill="url(#bfcd7fc3-0ba9-46a2-8ea3-6250172e2b73)"
              />
              <ellipse
                cx="811.47"
                cy="301.96"
                rx="5.32"
                ry="0.98"
                fill="url(#faea537b-7379-49e7-bb87-c68da19064bf)"
              />
              <ellipse
                cx="811.47"
                cy="303.27"
                rx="4.58"
                ry="0.86"
                fill="url(#aa9297af-dd7b-4f90-a575-4b7cd2ab871c)"
              />
              <ellipse
                cx="811.47"
                cy="304.58"
                rx="3.84"
                ry="0.75"
                fill="url(#a133e560-1a39-4b49-aca8-0873de928c22)"
              />
            </g>
          </g>
          <circle
            cx="811.34"
            cy="298.67"
            r="12.67"
            fill="url(#b132fd94-8785-4bb3-899a-a30bf11d01dc)"
          />
        </g>
        <g>
          <g>
            <rect
              x="421.91"
              y="374.29"
              width="1.91"
              height="33.71"
              rx="0.95"
              fill="#a39bb2"
            />
            <g>
              <ellipse
                cx="422.87"
                cy="365.36"
                rx="3.91"
                ry="0.77"
                fill="url(#eaad2924-4298-416c-ba15-527c9262b0f3)"
              />
              <ellipse
                cx="422.87"
                cy="366.7"
                rx="5.39"
                ry="1.01"
                fill="url(#ee6b977a-208b-47ec-a653-6fdd5f782421)"
              />
              <ellipse
                cx="422.87"
                cy="368.03"
                rx="6.88"
                ry="1.25"
                fill="url(#be608cb4-a52d-4a20-971e-4ca3df437c45)"
              />
              <ellipse
                cx="422.87"
                cy="369.37"
                rx="8.36"
                ry="1.49"
                fill="url(#aa2ce541-1d4d-444c-8ed6-e3357e22928f)"
              />
              <ellipse
                cx="422.87"
                cy="370.7"
                rx="9.84"
                ry="1.72"
                fill="url(#bbef9391-6792-439d-9b29-463840043de5)"
              />
              <ellipse
                cx="422.87"
                cy="372.04"
                rx="11.33"
                ry="1.96"
                fill="url(#acfd1daa-f9bd-4cfc-9d8e-432faa4718be)"
              />
              <ellipse
                cx="422.87"
                cy="374"
                rx="10.21"
                ry="1.8"
                fill="url(#bc6f45d7-3cbd-4529-9938-4fcdb4dd1e63)"
              />
              <ellipse
                cx="422.87"
                cy="375.97"
                rx="9.1"
                ry="1.63"
                fill="url(#e5b3cabd-3df2-4a61-a5d5-58cd6e87ef52)"
              />
              <ellipse
                cx="422.87"
                cy="377.94"
                rx="7.99"
                ry="1.46"
                fill="url(#a6d78bb1-0ae5-47f5-9867-739a45af8894)"
              />
              <ellipse
                cx="422.87"
                cy="379.91"
                rx="6.87"
                ry="1.3"
                fill="url(#f13e1cbb-21e4-408c-abe9-61ebdebcefa4)"
              />
              <ellipse
                cx="422.87"
                cy="381.87"
                rx="5.76"
                ry="1.13"
                fill="url(#e671cc7a-a85f-4d78-8ccd-a02cb845ba9f)"
              />
            </g>
          </g>
          <circle
            cx="422.67"
            cy="373"
            r="19"
            fill="url(#bbe4c46c-cd3d-4fe8-b75e-234175846a04)"
          />
        </g>
        <g>
          <path
            d="M456.91,353.65c3.84-6.35,5.15-7.79,3.52-12.06s-3.2-.63-1.57-8.67-4.59-10.44-7.42-10.75-16.21,7.54-13.95,11.81,3.23,16.4.8,17.41S452.39,361.13,456.91,353.65Z"
            fill="#396039"
          />
          <path
            d="M454.33,338.89c-.12-3.46,5.09-4.84,3.4-6.41s-3.71-5.66-5.34-3.52-2.89,5.28-4.15,3.52-2.64-1.83-3.46,0-.12,4.08-2.07,3.52-2.83.31-2.58,2.19,1.7,1.14,3,3.4,6.91,2,6,.69S454.33,338.89,454.33,338.89Z"
            fill="#447244"
          />
          <path
            d="M464.07,332.92c2.83-4.47,6.79-8.55,10.75-4.72s-2.64,10.69,0,13.39,2.07,9.55,0,9.8-11.94.25-14.52,1.45-5.9-3.21-6-7.48S464.07,332.92,464.07,332.92Z"
            fill="#6b996b"
          />
          <path
            d="M449.18,359.37c6.62,5.05,7.1-12.5,0-11s-9.43,1.06-11.69-2.08-7.92,2.39-8.1,4,1.63,6.85,5.53,8.36S445.22,356.36,449.18,359.37Z"
            fill="#447244"
          />
          <path
            d="M462.86,362.89c-6.62,5.05-7.1-12.5,0-11s9.43,1.07,11.69-2.07,7.92,2.39,8.11,4-1.64,6.85-5.53,8.36S466.82,359.88,462.86,362.89Z"
            fill="#447244"
          />
          <path
            d="M471.11,356.86c.95-1.89,3.71,1.76,3.71,1.76s-.19-2.45,1.32-3.33,2.2,1.38,2.2,1.38c.13-1.76,3.71-.13,2.7,2h0a8.38,8.38,0,0,1-3.91,3.5,7.1,7.1,0,0,1-2.81.36l-3.37-.86S470.17,358.74,471.11,356.86Z"
            fill="#396039"
          />
          <path
            d="M457.48,360.06c-1.32,2.33-2.08,23.26,0,32.87,0,0-6-1.07-7.92-.06-.19.63-.19.06-.19.06s8.36-29.1,1.07-37.64-15.21,0-15.21,0,2.14-5,6.85-5.41,11.19,5.72,11.5,6.92c0,0,.25-9.18-2.7-12.38s.81-5.53.81-5.53-3.89,1.19,2.39,9.36c3.26,4.23.95,12.13.95,12.13s2-6.16,7-4.84,8.05,7.16,12.76,6.79a24.78,24.78,0,0,1-9.93-3A5.8,5.8,0,0,0,457.48,360.06Z"
            fill="#704d3c"
          />
          <path
            d="M464.36,359.08a5.76,5.76,0,0,0-6.88,1c-.46.8-.85,3.81-1.07,7.8-1.51-5.2,1.19-11.38,2-11.93a4.73,4.73,0,0,1,3.6-.39,10.92,10.92,0,0,1,3.32,1.58Z"
            fill="#634b42"
          />
          <path
            d="M452.79,357.14c.7,1.57,1.45,6.18.6,8.56h0c-.16-4.32-1-8.11-2.95-10.41a14.11,14.11,0,0,0-1.31-1.35l-.29-.88A11.24,11.24,0,0,1,452.79,357.14Z"
            fill="#44322c"
          />
          <path
            d="M463,358.1c1.82-.59,1.93-3.14,4.09-3s2.41,3.25,4.2,5.26,3.26,1.57,4.68,2.26-3.91,8.38-8.88,5.6-4.5-2.31-6.21-3.44S458.9,359.42,463,358.1Z"
            fill="#6b996b"
          />
          <g>
            <path d="M453.53,354.16q0,.16,0,.06v-.06Z" fill="#7f2c03" />
            <path
              d="M453.46,353.05c-.24-2.92-.87-6.78-2.58-8.63a3.73,3.73,0,0,1-1.12-2.28l.86-.16c.31,1.39,1.26,3.4,3.46,6.27l.15.2C454.07,350.1,453.56,351.8,453.46,353.05Z"
              fill="#634b42"
            />
          </g>
          <path
            d="M446.65,352.82c-1.19-1.5.12-3.69-1.76-4.76s-3.81,1.38-6.41,2.07-3.58-.48-5.15-.69-1.36,9.14,4.32,9.56,5,.57,7.07.57S449.31,356.16,446.65,352.82Z"
            fill="#6b996b"
          />
          <path
            d="M449,335.18c1.24-1.95,3-3.74,4.71-2.06s-1.16,4.67,0,5.86.9,4.18,0,4.29-5.23.11-6.36.63-2.58-1.4-2.61-3.27S449,335.18,449,335.18Z"
            fill="#6b996b"
          />
          <path
            d="M436.67,356.92c.36.54,1.4.44,2,.19s1-2.1,1.93-1.77,1.46,1.28,2.54,1,.62-1.48,2-1.5,2.58.5,2.63,1.22c0,.06,0,.12,0,.18h0a.47.47,0,0,0,0,.17,3.55,3.55,0,0,1-3,3.19c-2.05,0-1.4-.14-7.07-.57a4.49,4.49,0,0,1-2.09-.66C434.93,357.93,436.31,356.38,436.67,356.92Z"
            fill="#447244"
          />
          <path
            d="M462.19,364.78c1.38,0,4.15,1.51,4.52.12s3.15-1.69,3.46-1.07a2.75,2.75,0,0,0,2.95.95c.95-.51,1.89.75,1.46,1.24-1.75,2-4.7,3.79-7.53,2.21-3.45-1.93-4.28-2.29-5-2.71C461.7,365.28,461.13,364.78,462.19,364.78Z"
            fill="#396039"
          />
          <path
            d="M457,348.88c.88-1.95,3-1.57,4.52-1.32s1.07,2.26,2.26,1.32,3.84,1.32,2.84,2.95h0a23.43,23.43,0,0,0-6.36,1c-1.59.74-3.48-.67-4.69-2.86l-.54-1.11h0S456.16,350.83,457,348.88Z"
            fill="#447244"
          />
          <path
            d="M473,347.68c-.57-1.76,1.95-3.26,0-3.26s-5.15,1.94-4.84-.88-.57-4.34-2.7-4.15-3.77-4.4-2.58-5.44-6.66,2-3.2,4.94,4.71,2,4.58,3.39,0,4.27,2.64,4.71-.75,4,1.23,4.84S474.51,352.4,473,347.68Z"
            fill="#447244"
          />
          <path
            d="M449.37,392.93s.52-1.8,1.18-4.65c5.25-2.69,5.63-11.46,5.64-11.71a87.76,87.76,0,0,0,1.29,16.36s-6-1.07-7.92-.06C449.37,393.5,449.37,392.93,449.37,392.93Z"
            fill="#44322c"
          />
          <path
            d="M455.63,392.66a32.8,32.8,0,0,0-.77-5,34.23,34.23,0,0,1-.1-5.06c.19-3.38.53-6.72.69-10.08,0-.84.09-1.68.1-2.52a8.32,8.32,0,0,0-.05-1.23c-.06-.38-.2-.8-.29-1.21a15.14,15.14,0,0,1-.43-2.51,5.13,5.13,0,0,1,.34-2.56c.38-.75.74-1.51,1.18-2.24a6.06,6.06,0,0,1,1.68-1.92,4.28,4.28,0,0,1,2.46-.59,11,11,0,0,1,2.5.36,10.51,10.51,0,0,0-2.5-.26,4,4,0,0,0-2.35.65c-1.35,1-2,2.64-2.71,4.13a5.09,5.09,0,0,0-.28,2.4,15.86,15.86,0,0,0,.44,2.46c.1.41.23.79.31,1.23a11.52,11.52,0,0,1,.06,1.3c0,.84-.05,1.69-.09,2.53-.19,3.36-.53,6.72-.77,10.07a33.78,33.78,0,0,0,0,5A32.33,32.33,0,0,1,455.63,392.66Z"
            fill="#44322c"
          />
          <path
            d="M454.3,376.56a14.44,14.44,0,0,0,0,2.08,3,3,0,0,1-.13,1.06,2.9,2.9,0,0,1-.55.93,5.58,5.58,0,0,0-1.55,3.65,8.61,8.61,0,0,0,0,2,15.47,15.47,0,0,0,.53,2,17.14,17.14,0,0,1,.45,4.15,23,23,0,0,0-.72-4.07,10.89,10.89,0,0,1-.6-2,8.87,8.87,0,0,1-.06-2.12,8.13,8.13,0,0,1,.5-2.07,4.87,4.87,0,0,1,1.21-1.74,2.63,2.63,0,0,0,.55-.82,3.15,3.15,0,0,0,.17-1A14.48,14.48,0,0,1,454.3,376.56Z"
            fill="#44322c"
          />
          <path
            d="M454.3,349.85c.07.8.38,1.54.43,2.37,0,.4-.17.84-.16,1.17a4.52,4.52,0,0,0,.22,1.13,11.32,11.32,0,0,1,.68,4.77c-.1.83-.43,1.56-.51,2.33a15.49,15.49,0,0,0-.12,2.36,28.9,28.9,0,0,0,.53,4.72,21.42,21.42,0,0,1-.82-4.71,13.08,13.08,0,0,1,.07-2.42c.08-.82.4-1.58.48-2.33a11.58,11.58,0,0,0-.59-4.64,4.85,4.85,0,0,1-.18-1.21,2.19,2.19,0,0,1,.13-.61,2.61,2.61,0,0,0,.09-.57C454.57,351.44,454.31,350.65,454.3,349.85Z"
            fill="#44322c"
          />
        </g>
        <g>
          <path
            d="M698.24,305.71c1.79-3,2.4-3.64,1.64-5.64s-1.5-.29-.73-4.05a3.91,3.91,0,0,0-3.47-5c-1.32-.14-7.57,3.53-6.51,5.52s1.5,7.66.37,8.13S696.12,309.2,698.24,305.71Z"
            fill="#396039"
          />
          <path
            d="M697,298.81c-.06-1.61,2.38-2.26,1.59-3s-1.74-2.64-2.5-1.65-1.35,2.47-1.94,1.65-1.23-.85-1.61,0-.06,1.91-1,1.64-1.32.15-1.2,1,.79.53,1.38,1.58,3.23.91,2.79.33S697,298.81,697,298.81Z"
            fill="#447244"
          />
          <path
            d="M701.58,296c1.32-2.08,3.17-4,5-2.2s-1.23,5,0,6.25,1,4.47,0,4.58-5.58.12-6.78.68-2.76-1.5-2.79-3.49S701.58,296,701.58,296Z"
            fill="#6b996b"
          />
          <path
            d="M694.62,308.38c3.1,2.36,3.32-5.84,0-5.14s-4.4.5-5.45-1-3.7,1.11-3.79,1.84A4.74,4.74,0,0,0,688,308C689.78,308.73,692.78,307,694.62,308.38Z"
            fill="#447244"
          />
          <path
            d="M701,310c-3.09,2.36-3.31-5.84,0-5.13s4.41.5,5.46-1,3.7,1.11,3.79,1.85a4.72,4.72,0,0,1-2.58,3.9C705.86,310.38,702.86,308.62,701,310Z"
            fill="#447244"
          />
          <path
            d="M704.87,307.21c.44-.88,1.73.82,1.73.82s-.09-1.15.62-1.56,1,.65,1,.65c.06-.82,1.74-.06,1.27.92h0a3.92,3.92,0,0,1-1.83,1.63,3.28,3.28,0,0,1-1.31.17l-1.58-.4A3.79,3.79,0,0,1,704.87,307.21Z"
            fill="#396039"
          />
          <path
            d="M698.5,308.7c-.62,1.09-1,10.86,0,15.35,0,0-2.82-.49-3.7,0-.09.29-.09,0-.09,0s3.91-13.59.5-17.58-7.1,0-7.1,0,1-2.35,3.2-2.52,5.22,2.67,5.37,3.23c0,0,.12-4.29-1.26-5.79a1.61,1.61,0,0,1,.38-2.58s-1.82.56,1.11,4.38c1.53,2,.44,5.66.44,5.66s.94-2.88,3.29-2.26,3.76,3.35,6,3.17a11.63,11.63,0,0,1-4.64-1.38A2.72,2.72,0,0,0,698.5,308.7Z"
            fill="#704d3c"
          />
          <path
            d="M701.71,308.24a2.68,2.68,0,0,0-3.21.46,13.75,13.75,0,0,0-.5,3.65,7.13,7.13,0,0,1,1-5.58,2.18,2.18,0,0,1,1.68-.18,5.27,5.27,0,0,1,1.55.74Z"
            fill="#634b42"
          />
          <path
            d="M696.31,307.34a7.18,7.18,0,0,1,.28,4h0a8.07,8.07,0,0,0-1.38-4.86,7.33,7.33,0,0,0-.61-.63c-.08-.25-.14-.41-.14-.41A5.16,5.16,0,0,1,696.31,307.34Z"
            fill="#44322c"
          />
          <path
            d="M701.06,307.79c.85-.28.9-1.47,1.91-1.4s1.13,1.52,2,2.46,1.52.73,2.19,1-1.83,3.91-4.15,2.62-2.1-1.08-2.9-1.61A1.85,1.85,0,0,1,701.06,307.79Z"
            fill="#6b996b"
          />
          <g>
            <path d="M696.66,305.94c0,.06,0,.06,0,0v0Z" fill="#7f2c03" />
            <path
              d="M696.62,305.43c-.11-1.37-.4-3.17-1.2-4a1.77,1.77,0,0,1-.53-1.06l.41-.08a7.91,7.91,0,0,0,1.61,2.94l.07.09C696.91,304.05,696.67,304.84,696.62,305.43Z"
              fill="#634b42"
            />
          </g>
          <path
            d="M693.44,305.32c-.55-.7.06-1.72-.82-2.22s-1.78.64-3,1-1.68-.22-2.41-.32-.64,4.27,2,4.47,2.34.26,3.3.26A1.85,1.85,0,0,0,693.44,305.32Z"
            fill="#6b996b"
          />
          <path
            d="M694.56,297.08c.58-.91,1.39-1.74,2.2-1s-.54,2.18,0,2.73.42,2,0,2a16.57,16.57,0,0,0-3,.29c-.53.25-1.21-.65-1.22-1.52S694.56,297.08,694.56,297.08Z"
            fill="#6b996b"
          />
          <path
            d="M688.78,307.23c.17.26.66.21.94.09s.45-1,.9-.83.68.61,1.19.46.29-.69.94-.7,1.2.23,1.22.57v.08h0a.22.22,0,0,0,0,.08,1.65,1.65,0,0,1-1.42,1.49c-1,0-.65-.06-3.3-.26a2.18,2.18,0,0,1-1-.31C688,307.7,688.62,307,688.78,307.23Z"
            fill="#447244"
          />
          <path
            d="M700.7,310.9c.65,0,1.94.71,2.11.06s1.47-.79,1.62-.5a1.27,1.27,0,0,0,1.38.44c.44-.23.88.36.68.59-.82.92-2.2,1.77-3.52,1-1.61-.9-2-1.07-2.35-1.27C700.47,311.14,700.21,310.9,700.7,310.9Z"
            fill="#396039"
          />
          <path
            d="M698.29,303.48c.41-.91,1.41-.73,2.12-.62s.5,1.06,1.05.62,1.79.62,1.33,1.38h0a10.87,10.87,0,0,0-3,.47c-.74.34-1.63-.31-2.19-1.34l-.25-.51h0S697.88,304.39,698.29,303.48Z"
            fill="#447244"
          />
          <path
            d="M705.75,302.92c-.27-.82.91-1.53,0-1.53s-2.41.91-2.26-.41-.26-2-1.26-1.93-1.76-2.06-1.21-2.54-3.11.92-1.49,2.3,2.2.94,2.14,1.59,0,2,1.23,2.2-.35,1.88.58,2.26S706.45,305.12,705.75,302.92Z"
            fill="#447244"
          />
          <path
            d="M694.71,324.05s.25-.84.56-2.17c2.45-1.25,2.62-5.35,2.63-5.47a41,41,0,0,0,.6,7.64s-2.82-.49-3.7,0C694.71,324.32,694.71,324.05,694.71,324.05Z"
            fill="#44322c"
          />
          <path
            d="M697.64,323.93a17.06,17.06,0,0,0-.36-2.33,15.5,15.5,0,0,1,0-2.36c.09-1.58.24-3.14.31-4.71a6.44,6.44,0,0,0-.1-2.32,3.88,3.88,0,0,1,0-2.36,4.82,4.82,0,0,1,1.33-2,3.13,3.13,0,0,1,2.31-.11,3.11,3.11,0,0,0-2.27.19,5,5,0,0,0-1.27,1.92,3.87,3.87,0,0,0,.08,2.28c0,.19.11.37.15.57a4.19,4.19,0,0,1,0,.61c0,.39,0,.79,0,1.18-.1,1.57-.26,3.14-.37,4.7a15.36,15.36,0,0,0,0,2.35A16.79,16.79,0,0,1,697.64,323.93Z"
            fill="#44322c"
          />
          <path
            d="M697,316.41a7.83,7.83,0,0,0,0,1,1.2,1.2,0,0,1-.32.92A2.62,2.62,0,0,0,696,320a3.89,3.89,0,0,0,.25,1.87,7.09,7.09,0,0,1,.22,1.94,10.94,10.94,0,0,0-.33-1.9,4,4,0,0,1-.31-1.93,2.72,2.72,0,0,1,.8-1.77C697.1,317.77,696.85,317,697,316.41Z"
            fill="#44322c"
          />
          <path
            d="M697,303.93c0,.38.18.72.2,1.11,0,.19-.08.39-.08.55a2.06,2.06,0,0,0,.1.53,5.35,5.35,0,0,1,.32,2.22c0,.39-.2.73-.24,1.09a5.76,5.76,0,0,0-.06,1.1,13.74,13.74,0,0,0,.26,2.21,9.22,9.22,0,0,1-.38-2.2,7.08,7.08,0,0,1,0-1.13c0-.38.19-.74.22-1.09a5.22,5.22,0,0,0-.27-2.17,2.61,2.61,0,0,1-.09-.57,4.18,4.18,0,0,0,.1-.54C697.14,304.68,697,304.31,697,303.93Z"
            fill="#44322c"
          />
        </g>
        <g>
          <path
            d="M671.24,311.71c1.79-3,2.4-3.64,1.64-5.64s-1.5-.29-.73-4.05a3.91,3.91,0,0,0-3.47-5c-1.32-.14-7.57,3.53-6.51,5.52s1.5,7.66.37,8.13S669.12,315.2,671.24,311.71Z"
            fill="#396039"
          />
          <path
            d="M670,304.81c-.06-1.61,2.38-2.26,1.59-3s-1.74-2.64-2.5-1.65-1.35,2.47-1.94,1.65-1.23-.85-1.61,0-.06,1.91-1,1.64-1.32.15-1.2,1,.79.53,1.38,1.58,3.23.91,2.79.33S670,304.81,670,304.81Z"
            fill="#447244"
          />
          <path
            d="M674.58,302c1.32-2.08,3.17-4,5-2.2s-1.23,5,0,6.25,1,4.47,0,4.58-5.58.12-6.78.68-2.76-1.5-2.79-3.49S674.58,302,674.58,302Z"
            fill="#6b996b"
          />
          <path
            d="M667.62,314.38c3.1,2.36,3.32-5.84,0-5.14s-4.4.5-5.45-1-3.7,1.11-3.79,1.84A4.74,4.74,0,0,0,661,314C662.78,314.73,665.78,313,667.62,314.38Z"
            fill="#447244"
          />
          <path
            d="M674,316c-3.09,2.36-3.31-5.84,0-5.13s4.41.5,5.46-1,3.7,1.11,3.79,1.85a4.72,4.72,0,0,1-2.58,3.9C678.86,316.38,675.86,314.62,674,316Z"
            fill="#447244"
          />
          <path
            d="M677.87,313.21c.44-.88,1.73.82,1.73.82s-.09-1.15.62-1.56,1,.65,1,.65c.06-.82,1.74-.06,1.27.92h0a3.92,3.92,0,0,1-1.83,1.63,3.28,3.28,0,0,1-1.31.17l-1.58-.4A3.79,3.79,0,0,1,677.87,313.21Z"
            fill="#396039"
          />
          <path
            d="M671.5,314.7c-.62,1.09-1,10.86,0,15.35,0,0-2.82-.49-3.7,0-.09.29-.09,0-.09,0s3.91-13.59.5-17.58-7.1,0-7.1,0,1-2.35,3.2-2.52,5.22,2.67,5.37,3.23c0,0,.12-4.29-1.26-5.79a1.61,1.61,0,0,1,.38-2.58s-1.82.56,1.11,4.38c1.53,2,.44,5.66.44,5.66s.94-2.88,3.29-2.26,3.76,3.35,6,3.17a11.63,11.63,0,0,1-4.64-1.38A2.72,2.72,0,0,0,671.5,314.7Z"
            fill="#704d3c"
          />
          <path
            d="M674.71,314.24a2.68,2.68,0,0,0-3.21.46,13.75,13.75,0,0,0-.5,3.65,7.13,7.13,0,0,1,1-5.58,2.18,2.18,0,0,1,1.68-.18,5.27,5.27,0,0,1,1.55.74Z"
            fill="#634b42"
          />
          <path
            d="M669.31,313.34a7.18,7.18,0,0,1,.28,4h0a8.07,8.07,0,0,0-1.38-4.86,7.33,7.33,0,0,0-.61-.63c-.08-.25-.14-.41-.14-.41A5.16,5.16,0,0,1,669.31,313.34Z"
            fill="#44322c"
          />
          <path
            d="M674.06,313.79c.85-.28.9-1.47,1.91-1.4s1.13,1.52,2,2.46,1.52.73,2.19,1-1.83,3.91-4.15,2.62-2.1-1.08-2.9-1.61A1.85,1.85,0,0,1,674.06,313.79Z"
            fill="#6b996b"
          />
          <g>
            <path d="M669.66,311.94c0,.06,0,.06,0,0v0Z" fill="#7f2c03" />
            <path
              d="M669.62,311.43c-.11-1.37-.4-3.17-1.2-4a1.77,1.77,0,0,1-.53-1.06l.41-.08a7.91,7.91,0,0,0,1.61,2.94l.07.09C669.91,310.05,669.67,310.84,669.62,311.43Z"
              fill="#634b42"
            />
          </g>
          <path
            d="M666.44,311.32c-.55-.7.06-1.72-.82-2.22s-1.78.64-3,1-1.68-.22-2.41-.32-.64,4.27,2,4.47,2.34.26,3.3.26A1.85,1.85,0,0,0,666.44,311.32Z"
            fill="#6b996b"
          />
          <path
            d="M667.56,303.08c.58-.91,1.39-1.74,2.2-1s-.54,2.18,0,2.73.42,2,0,2a16.57,16.57,0,0,0-3,.29c-.53.25-1.21-.65-1.22-1.52S667.56,303.08,667.56,303.08Z"
            fill="#6b996b"
          />
          <path
            d="M661.78,313.23c.17.26.66.21.94.09s.45-1,.9-.83.68.61,1.19.46.29-.69.94-.7,1.2.23,1.22.57v.08h0a.22.22,0,0,0,0,.08,1.65,1.65,0,0,1-1.42,1.49c-1,0-.65-.06-3.3-.26a2.18,2.18,0,0,1-1-.31C661,313.7,661.62,313,661.78,313.23Z"
            fill="#447244"
          />
          <path
            d="M673.7,316.9c.65,0,1.94.71,2.11.06s1.47-.79,1.62-.5a1.27,1.27,0,0,0,1.38.44c.44-.23.88.36.68.59-.82.92-2.2,1.77-3.52,1-1.61-.9-2-1.07-2.35-1.27C673.47,317.14,673.21,316.9,673.7,316.9Z"
            fill="#396039"
          />
          <path
            d="M671.29,309.48c.41-.91,1.41-.73,2.12-.62s.5,1.06,1.05.62,1.79.62,1.33,1.38h0a10.87,10.87,0,0,0-3,.47c-.74.34-1.63-.31-2.19-1.34l-.25-.51h0S670.88,310.39,671.29,309.48Z"
            fill="#447244"
          />
          <path
            d="M678.75,308.92c-.27-.82.91-1.53,0-1.53s-2.41.91-2.26-.41-.26-2-1.26-1.93-1.76-2.06-1.21-2.54-3.11.92-1.49,2.3,2.2.94,2.14,1.59,0,2,1.23,2.2-.35,1.88.58,2.26S679.45,311.12,678.75,308.92Z"
            fill="#447244"
          />
          <path
            d="M667.71,330.05s.25-.84.56-2.17c2.45-1.25,2.62-5.35,2.63-5.47a41,41,0,0,0,.6,7.64s-2.82-.49-3.7,0C667.71,330.32,667.71,330.05,667.71,330.05Z"
            fill="#44322c"
          />
          <path
            d="M670.64,329.93a17.06,17.06,0,0,0-.36-2.33,15.5,15.5,0,0,1,0-2.36c.09-1.58.24-3.14.31-4.71a6.44,6.44,0,0,0-.1-2.32,3.88,3.88,0,0,1,0-2.36,4.82,4.82,0,0,1,1.33-2,3.13,3.13,0,0,1,2.31-.11,3.11,3.11,0,0,0-2.27.19,5,5,0,0,0-1.27,1.92,3.87,3.87,0,0,0,.08,2.28c0,.19.11.37.15.57a4.19,4.19,0,0,1,0,.61c0,.39,0,.79,0,1.18-.1,1.57-.26,3.14-.37,4.7a15.36,15.36,0,0,0,0,2.35A16.79,16.79,0,0,1,670.64,329.93Z"
            fill="#44322c"
          />
          <path
            d="M670,322.41a7.83,7.83,0,0,0,0,1,1.2,1.2,0,0,1-.32.92A2.62,2.62,0,0,0,669,326a3.89,3.89,0,0,0,.25,1.87,7.09,7.09,0,0,1,.22,1.94,10.94,10.94,0,0,0-.33-1.9,4,4,0,0,1-.31-1.93,2.72,2.72,0,0,1,.8-1.77C670.1,323.77,669.85,323,670,322.41Z"
            fill="#44322c"
          />
          <path
            d="M670,309.93c0,.38.18.72.2,1.11,0,.19-.08.39-.08.55a2.06,2.06,0,0,0,.1.53,5.35,5.35,0,0,1,.32,2.22c0,.39-.2.73-.24,1.09a5.76,5.76,0,0,0-.06,1.1,13.74,13.74,0,0,0,.26,2.21,9.22,9.22,0,0,1-.38-2.2,7.08,7.08,0,0,1,0-1.13c0-.38.19-.74.22-1.09a5.22,5.22,0,0,0-.27-2.17,2.61,2.61,0,0,1-.09-.57,4.18,4.18,0,0,0,.1-.54C670.14,310.68,670,310.31,670,309.93Z"
            fill="#44322c"
          />
        </g>
        {/* <g>
          <path
            d="M695.43,286.82s8.47,17.58-2.24,27.18H709.8s-6.08-3-6.83-4.91-.83-14.33-6.05-21.7Z"
            fill="#6d4c89"
          />
          <path
            d="M697.56,287.69s.89-10.15,6.69-11.47c0,0-2.41,2.06-1.2,3.74,0,0,2.2-5,8.92-3.74,0,0-7.75.95-8.92,5.64a5.38,5.38,0,0,1,5.93,1.8S697.55,283.85,697.56,287.69Z"
            fill="#6d4c89"
          />
          <path
            d="M695.43,287.69s-.89-10.15-6.69-11.47c0,0,2.41,2.06,1.2,3.74,0,0-2.2-5-8.92-3.74,0,0,7.75.95,8.92,5.64a5.38,5.38,0,0,0-5.93,1.8S695.44,283.85,695.43,287.69Z"
            fill="#6d4c89"
          />
          <path
            d="M698.27,289.48s-11.21-14.6-23.72-9c0,0,7.07-.26,7.67.57,0,0-2.32-.36-2.2,1.92,0,0,4.81-2.31,6.16-1.16,0,0-2.67.53-2.51,1.66,0,0,4.29-1,5.39,0,0,0-2.76.65-1.66,2,0,0,3.79-1.64,5.61.82,0,0-1.59-.54-2.08,0C690.93,286.28,698,288,698.27,289.48Z"
            fill="#6d4c89"
          />
          <path
            d="M696.2,289.28s9.6-13.81,22.53-6.79c0,0-7-1-7.52-.2a2.21,2.21,0,0,1,2.37,2.19s-5-2.85-6.21-1.82c0,0,2.69.82,2.65,2,0,0-4.35-1.49-5.34-.58,0,0,2.8.95,1.85,2.19,0,0-3.91-2.06-5.46.27,0,0,1.51-.39,2,.25C703.12,286.75,696.32,287.78,696.2,289.28Z"
            fill="#6d4c89"
          />
          <path
            d="M698.52,288.69s-10.64-8.48-19.27,3c0,0,5.31-3.72,5.88-3.22a2.58,2.58,0,0,0-1.38,2.92s3.3-4.57,4.49-4.14c0,0-1.94,1.82-1.65,2.82,0,0,3.09-3.09,4.08-2.68,0,0-2,2-1,2.71,0,0,2.62-3.43,4.36-2,0,0-1.28.26-1.56,1.06C692.5,289.23,698.09,287.39,698.52,288.69Z"
            fill="#6d4c89"
          />
          <path
            d="M695.43,289s12.66-9.74,22.57,3c0,0-6.16-4.09-6.85-3.51a2.77,2.77,0,0,1,1.57,3.25s-3.79-5.07-5.19-4.57c0,0,2.24,2,1.88,3.14,0,0-3.57-3.41-4.73-2.92,0,0,2.31,2.18,1.08,3,0,0-3-3.8-5.08-2.13,0,0,1.49.27,1.81,1.16C702.49,289.46,696,287.51,695.43,289Z"
            fill="#6d4c89"
          />
          <path
            d="M697.28,289.28c-.46-5.87,5.73-12.7,10.17-12.27,0,0-8.78-1.71-10.2,3.55,0,0,1.77-7,4.37-7,0,0-5.73-1.56-6.76,3.27,0,0-3.09-6,0-6.86,0,0-7.08,1.89-4.05,6.58,0,0-3.24-2.7-7.08.85,0,0,7.54.15,8.82,3.13,0,0-3.31-2.13-5.26,0,0,0,6.65-1.1,8.32,3.81Z"
            fill="#6d4c89"
          />
          <path
            d="M696.92,289.28c-.36-4.53,4.42-9.79,7.84-9.47,0,0-6.77-1.31-7.87,2.75,0,0,1.37-5.38,3.38-5.38,0,0-4.42-1.21-5.22,2.53,0,0-2.38-4.67,0-5.3,0,0-5.46,1.45-3.12,5.08,0,0-2.5-2.09-5.46.65,0,0,5.81.11,6.8,2.42,0,0-2.55-1.65-4.06,0,0,0,5.13-.85,6.42,2.93Z"
            fill="#6d4c89"
          />
          <path
            d="M696.35,291.07s.52-5.87,3.87-6.63c0,0-1.4,1.19-.7,2.16,0,0,1.27-2.88,5.16-2.16,0,0-4.48.55-5.16,3.26a3.12,3.12,0,0,1,3.43,1S696.35,288.85,696.35,291.07Z"
            fill="#6d4c89"
          />
          <path
            d="M697.35,290.21s-.52-5.86-3.87-6.62c0,0,1.4,1.19.7,2.15,0,0-1.27-2.87-5.16-2.15,0,0,4.48.54,5.16,3.25a3.14,3.14,0,0,0-3.43,1S697.36,288,697.35,290.21Z"
            fill="#6d4c89"
          />
          <path
            d="M703,309.09c-.67-1.73-.8-12-4.64-19.36.52,2,4,16,2.19,20-.71,1.59,1.59,3.07,4.78,4.3h4.5S703.72,311,703,309.09Z"
            fill="#6d4c89"
            opacity="0.24"
          />
        </g> */}
        <g>
          <path
            d="M821.94,298.18s4.62,9.58-1.22,14.82h9.06s-3.32-1.63-3.73-2.68-.45-7.82-3.3-11.83Z"
            fill="#6d4c89"
          />
          <path
            d="M823.1,298.65s.49-5.54,3.65-6.25c0,0-1.31,1.12-.66,2,0,0,1.21-2.71,4.87-2,0,0-4.22.51-4.87,3.07a2.94,2.94,0,0,1,3.24,1S823.1,296.56,823.1,298.65Z"
            fill="#6d4c89"
          />
          <path
            d="M821.94,298.65s-.49-5.54-3.65-6.25c0,0,1.31,1.12.66,2,0,0-1.2-2.71-4.87-2,0,0,4.23.51,4.87,3.07a2.94,2.94,0,0,0-3.24,1S821.94,296.56,821.94,298.65Z"
            fill="#6d4c89"
          />
          <path
            d="M823.49,299.63s-6.12-8-12.94-4.91c0,0,3.86-.14,4.18.31,0,0-1.26-.2-1.2,1.05,0,0,2.63-1.26,3.37-.64,0,0-1.46.29-1.37.91,0,0,2.33-.56,2.94,0,0,0-1.51.35-.91,1.07,0,0,2.07-.89,3.06.45,0,0-.87-.3-1.13,0C819.49,297.88,823.33,298.81,823.49,299.63Z"
            fill="#6d4c89"
          />
          <path
            d="M822.36,299.52s5.23-7.54,12.29-3.71c0,0-3.83-.54-4.1-.11a1.21,1.21,0,0,1,1.29,1.2s-2.72-1.56-3.39-1c0,0,1.47.44,1.45,1.06,0,0-2.37-.81-2.91-.31,0,0,1.53.51,1,1.19,0,0-2.13-1.12-3,.15,0,0,.82-.21,1.11.14C826.13,298.14,822.43,298.7,822.36,299.52Z"
            fill="#6d4c89"
          />
          <path
            d="M823.63,299.19s-5.81-4.62-10.52,1.66c0,0,2.9-2,3.21-1.75a1.4,1.4,0,0,0-.75,1.59s1.8-2.49,2.45-2.26c0,0-1.06,1-.9,1.54,0,0,1.68-1.68,2.22-1.46,0,0-1.09,1.08-.53,1.48,0,0,1.44-1.88,2.38-1.08,0,0-.69.14-.85.58C820.34,299.49,823.39,298.49,823.63,299.19Z"
            fill="#6d4c89"
          />
          <path
            d="M821.94,299.35s6.91-5.32,12.31,1.66c0,0-3.36-2.23-3.73-1.92a1.52,1.52,0,0,1,.85,1.78s-2.06-2.77-2.83-2.49c0,0,1.22,1.09,1,1.71,0,0-2-1.86-2.59-1.6,0,0,1.26,1.2.59,1.66,0,0-1.64-2.08-2.77-1.17,0,0,.82.15,1,.64C825.79,299.62,822.23,298.55,821.94,299.35Z"
            fill="#6d4c89"
          />
          <path
            d="M823,299.52c-.25-3.21,3.12-6.93,5.55-6.7,0,0-4.79-.93-5.57,1.94,0,0,1-3.8,2.39-3.8,0,0-3.13-.85-3.69,1.78,0,0-1.69-3.29,0-3.74,0,0-3.86,1-2.21,3.59a2.86,2.86,0,0,0-3.86.46s4.11.08,4.81,1.71c0,0-1.81-1.16-2.87,0,0,0,3.63-.6,4.54,2.08Z"
            fill="#6d4c89"
          />
          <path
            d="M822.75,299.52c-.19-2.47,2.41-5.35,4.28-5.17,0,0-3.69-.71-4.29,1.5,0,0,.75-2.93,1.84-2.93,0,0-2.41-.66-2.85,1.37,0,0-1.3-2.54,0-2.88,0,0-3,.79-1.7,2.76a2.22,2.22,0,0,0-3,.36s3.17.06,3.71,1.32c0,0-1.39-.9-2.21,0,0,0,2.8-.46,3.5,1.6Z"
            fill="#6d4c89"
          />
          <path
            d="M822.44,300.49s.28-3.2,2.11-3.61c0,0-.76.65-.38,1.17a2.43,2.43,0,0,1,2.82-1.17s-2.45.3-2.82,1.77a1.72,1.72,0,0,1,1.87.57S822.44,299.28,822.44,300.49Z"
            fill="#6d4c89"
          />
          <path
            d="M823,300s-.28-3.19-2.11-3.61c0,0,.76.65.38,1.18a2.44,2.44,0,0,0-2.82-1.18s2.45.3,2.82,1.78a1.7,1.7,0,0,0-1.87.56S823,298.82,823,300Z"
            fill="#6d4c89"
          />
          <path
            d="M826.05,310.32c-.36-.94-.44-6.52-2.53-10.56.29,1.11,2.17,8.72,1.2,10.89-.39.87.87,1.68,2.6,2.35h2.46S826.46,311.37,826.05,310.32Z"
            fill="#6d4c89"
            opacity="0.24"
          />
        </g>
        <g>
          <path
            d="M620.43,289.82s8.47,17.58-2.24,27.18H634.8s-6.08-3-6.83-4.91-.83-14.33-6.05-21.7Z"
            fill="#6d4c89"
          />
          <path
            d="M622.56,290.69s.89-10.15,6.69-11.47c0,0-2.41,2.06-1.2,3.74,0,0,2.2-5,8.92-3.74,0,0-7.75.95-8.92,5.64a5.38,5.38,0,0,1,5.93,1.8S622.55,286.85,622.56,290.69Z"
            fill="#6d4c89"
          />
          <path
            d="M620.43,290.69s-.89-10.15-6.69-11.47c0,0,2.41,2.06,1.2,3.74,0,0-2.2-5-8.92-3.74,0,0,7.75.95,8.92,5.64a5.38,5.38,0,0,0-5.93,1.8S620.44,286.85,620.43,290.69Z"
            fill="#6d4c89"
          />
          <path
            d="M623.27,292.48s-11.21-14.6-23.72-9c0,0,7.07-.26,7.67.57,0,0-2.32-.36-2.2,1.92,0,0,4.81-2.31,6.16-1.16,0,0-2.67.53-2.51,1.66,0,0,4.29-1,5.39,0,0,0-2.76.65-1.66,2,0,0,3.79-1.64,5.61.82,0,0-1.59-.54-2.08,0C615.93,289.28,623,291,623.27,292.48Z"
            fill="#6d4c89"
          />
          <path
            d="M621.2,292.28s9.6-13.81,22.53-6.79c0,0-7-1-7.52-.2a2.21,2.21,0,0,1,2.37,2.19s-5-2.85-6.21-1.82c0,0,2.69.82,2.65,2,0,0-4.35-1.49-5.34-.58,0,0,2.8.95,1.85,2.19,0,0-3.91-2.06-5.46.27,0,0,1.51-.39,2,.25C628.12,289.75,621.32,290.78,621.2,292.28Z"
            fill="#6d4c89"
          />
          <path
            d="M623.52,291.69s-10.64-8.48-19.27,3c0,0,5.31-3.72,5.88-3.22a2.58,2.58,0,0,0-1.38,2.92s3.3-4.57,4.49-4.14c0,0-1.94,1.82-1.65,2.82,0,0,3.09-3.09,4.08-2.68,0,0-2,2-1,2.71,0,0,2.62-3.43,4.36-2,0,0-1.28.26-1.56,1.06C617.5,292.23,623.09,290.39,623.52,291.69Z"
            fill="#6d4c89"
          />
          <path
            d="M620.43,292s12.66-9.74,22.57,3c0,0-6.16-4.09-6.85-3.51a2.77,2.77,0,0,1,1.57,3.25s-3.79-5.07-5.19-4.57c0,0,2.24,2,1.88,3.14,0,0-3.57-3.41-4.73-2.92,0,0,2.31,2.18,1.08,3,0,0-3-3.8-5.08-2.13,0,0,1.49.27,1.81,1.16C627.49,292.46,621,290.51,620.43,292Z"
            fill="#6d4c89"
          />
          <path
            d="M622.28,292.28c-.46-5.87,5.73-12.7,10.17-12.27,0,0-8.78-1.71-10.2,3.55,0,0,1.77-7,4.37-7,0,0-5.73-1.56-6.76,3.27,0,0-3.09-6,0-6.86,0,0-7.08,1.89-4.05,6.58,0,0-3.24-2.7-7.08.85,0,0,7.54.15,8.82,3.13,0,0-3.31-2.13-5.26,0,0,0,6.65-1.1,8.32,3.81Z"
            fill="#6d4c89"
          />
          <path
            d="M621.92,292.28c-.36-4.53,4.42-9.79,7.84-9.47,0,0-6.77-1.31-7.87,2.75,0,0,1.37-5.38,3.38-5.38,0,0-4.42-1.21-5.22,2.53,0,0-2.38-4.67,0-5.3,0,0-5.46,1.45-3.12,5.08,0,0-2.5-2.09-5.46.65,0,0,5.81.11,6.8,2.42,0,0-2.55-1.65-4.06,0,0,0,5.13-.85,6.42,2.93Z"
            fill="#6d4c89"
          />
          <path
            d="M621.35,294.07s.52-5.87,3.87-6.63c0,0-1.4,1.19-.7,2.16,0,0,1.27-2.88,5.16-2.16,0,0-4.48.55-5.16,3.26a3.12,3.12,0,0,1,3.43,1S621.35,291.85,621.35,294.07Z"
            fill="#6d4c89"
          />
          <path
            d="M622.35,293.21s-.52-5.86-3.87-6.62c0,0,1.4,1.19.7,2.15,0,0-1.27-2.87-5.16-2.15,0,0,4.48.54,5.16,3.25a3.14,3.14,0,0,0-3.43,1S622.36,291,622.35,293.21Z"
            fill="#6d4c89"
          />
          <path
            d="M628,312.09c-.67-1.73-.8-12-4.64-19.36.52,2,4,16,2.19,20-.71,1.59,1.59,3.07,4.78,4.3h4.5S628.72,314,628,312.09Z"
            fill="#6d4c89"
            opacity="0.24"
          />
        </g>
        <g>
          <path
            d="M724.78,272.61s13.12,26.65-3.06,41.42l25.3-.22s-9.3-4.47-10.46-7.39-1.46-21.81-9.51-33Z"
            fill="#6d4c89"
          />
          <path
            d="M728,273.9s1.23-15.46,10-17.54c0,0-3.64,3.16-1.78,5.7,0,0,3.28-7.61,13.54-5.81,0,0-11.79,1.55-13.52,8.7a8.25,8.25,0,0,1,9.07,2.66S728,268.06,728,273.9Z"
            fill="#6d4c89"
          />
          <path
            d="M724.79,273.93s-1.5-15.44-10.34-17.37c0,0,3.69,3.1,1.88,5.67,0,0-3.42-7.55-13.64-5.57,0,0,11.81,1.34,13.67,8.46a8.25,8.25,0,0,0-9,2.82S724.75,268.09,724.79,273.93Z"
            fill="#6d4c89"
          />
          <path
            d="M729.13,276.62s-17.26-22.09-36.23-13.37c0,0,10.77-.5,11.68.76,0,0-3.53-.52-3.33,2.95,0,0,7.3-3.57,9.38-1.85,0,0-4.06.84-3.8,2.56,0,0,6.51-1.62,8.21-.11,0,0-4.21,1-2.51,3,0,0,5.75-2.55,8.55,1.17,0,0-2.42-.8-3.16.09C717.92,271.85,728.68,274.35,729.13,276.62Z"
            fill="#6d4c89"
          />
          <path
            d="M726,276.35s14.44-21.16,34.23-10.65c0,0-10.7-1.41-11.46-.2a3.36,3.36,0,0,1,3.64,3.3s-7.63-4.27-9.48-2.68c0,0,4.11,1.2,4.06,2.94,0,0-6.63-2.2-8.13-.81,0,0,4.28,1.4,2.84,3.31,0,0-6-3.09-8.31.48,0,0,2.29-.61,3.13.36C736.49,272.4,726.15,274.06,726,276.35Z"
            fill="#6d4c89"
          />
          <path
            d="M729.51,275.41s-16.31-12.76-29.31,4.89c0,0,8-5.74,8.92-5a3.91,3.91,0,0,0-2.07,4.46s5-7,6.79-6.37c0,0-2.94,2.8-2.48,4.32,0,0,4.67-4.74,6.17-4.12,0,0-3,3-1.44,4.13,0,0,3.95-5.26,6.62-3.06,0,0-1.94.42-2.36,1.63C720.35,276.31,728.83,273.45,729.51,275.41Z"
            fill="#6d4c89"
          />
          <path
            d="M724.8,275.89s19.16-15,34.42,4.33c0,0-9.45-6.14-10.48-5.25a4.22,4.22,0,0,1,2.43,4.94s-5.83-7.68-8-6.89c0,0,3.44,3,2.91,4.75,0,0-5.48-5.14-7.24-4.39,0,0,3.54,3.3,1.69,4.6,0,0-4.65-5.77-7.78-3.18,0,0,2.28.39,2.78,1.74C735.56,276.54,725.6,273.65,724.8,275.89Z"
            fill="#6d4c89"
          />
          <path
            d="M727.63,276.33c-.78-8.93,8.55-19.42,15.33-18.82,0,0-13.4-2.49-15.5,5.55,0,0,2.62-10.64,6.57-10.68,0,0-8.74-2.31-10.25,5.07,0,0-4.79-9.16-.09-10.45,0,0-10.75,3-6.09,10.07,0,0-5-4.07-10.77,1.4,0,0,11.49.12,13.48,4.65,0,0-5.07-3.21-8,.07,0,0,10.12-1.77,12.73,5.68Z"
            fill="#6d4c89"
          />
          <path
            d="M727.08,276.33c-.61-6.89,6.59-15,11.82-14.51,0,0-10.34-1.92-11.95,4.28,0,0,2-8.21,5.06-8.23,0,0-6.74-1.78-7.9,3.91,0,0-3.7-7.07-.07-8.07,0,0-8.29,2.29-4.7,7.77,0,0-3.82-3.14-8.3,1.08,0,0,8.86.09,10.39,3.59,0,0-3.9-2.48-6.18.05,0,0,7.8-1.36,9.81,4.38Z"
            fill="#6d4c89"
          />
          <path
            d="M726.23,279.06s.71-8.94,5.81-10.14c0,0-2.11,1.83-1,3.3,0,0,1.9-4.4,7.83-3.36,0,0-6.81.89-7.81,5a4.75,4.75,0,0,1,5.24,1.54S726.2,275.69,726.23,279.06Z"
            fill="#6d4c89"
          />
          <path
            d="M727.75,277.75s-.87-8.93-6-10c0,0,2.14,1.79,1.09,3.28,0,0-2-4.37-7.88-3.22,0,0,6.82.77,7.89,4.89a4.76,4.76,0,0,0-5.21,1.63S727.72,274.37,727.75,277.75Z"
            fill="#6d4c89"
          />
          <path
            d="M736.56,306.42c-1-2.62-1.39-18.21-7.32-29.42.81,3.1,6.24,24.28,3.59,30.38-1.06,2.43,2.47,4.65,7.34,6.49l6.85-.06S737.72,309.34,736.56,306.42Z"
            fill="#6d4c89"
            opacity="0.24"
          />
        </g>
        <g>
          <path
            d="M631.35,276.83s-8.65,22.74,2.28,35.17h-17s6.21-3.87,7-6.35.85-18.55,6.19-28.08Z"
            fill="#6d4c89"
          />
          <path
            d="M629.17,278s-.91-13.13-6.83-14.83c0,0,2.46,2.66,1.23,4.83,0,0-2.25-6.44-9.12-4.83,0,0,7.92,1.22,9.12,7.28,0,0-3.41-1.67-6.07,2.34C617.5,272.74,629.18,273,629.17,278Z"
            fill="#6d4c89"
          />
          <path
            d="M631.35,278s.91-13.13,6.83-14.83c0,0-2.46,2.66-1.23,4.83,0,0,2.25-6.44,9.12-4.83,0,0-7.92,1.22-9.12,7.28,0,0,3.41-1.67,6.06,2.34C643,272.74,631.34,273,631.35,278Z"
            fill="#6d4c89"
          />
          <path
            d="M628.45,280.27s11.45-18.9,24.22-11.63c0,0-7.22-.34-7.83.73,0,0,2.37-.46,2.25,2.49,0,0-4.91-3-6.3-1.51,0,0,2.73.69,2.57,2.15,0,0-4.38-1.32-5.51,0,0,0,2.83.84,1.7,2.56,0,0-3.87-2.12-5.73,1.06,0,0,1.62-.7,2.12.05C635.94,276.13,628.74,278.33,628.45,280.27Z"
            fill="#6d4c89"
          />
          <path
            d="M630.57,280s-9.81-17.87-23-8.79c0,0,7.17-1.28,7.68-.25,0,0-2.3-.18-2.42,2.83,0,0,5.1-3.69,6.35-2.35,0,0-2.75,1.05-2.71,2.53,0,0,4.43-1.92,5.45-.75,0,0-2.86,1.22-1.89,2.84,0,0,4-2.67,5.58.34,0,0-1.54-.5-2.1.33C623.49,276.74,630.43,278.07,630.57,280Z"
            fill="#6d4c89"
          />
          <path
            d="M628.19,279.24s10.86-11,19.69,3.95c0,0-5.43-4.83-6-4.18a3.54,3.54,0,0,1,1.42,3.78s-3.37-5.91-4.59-5.36c0,0,2,2.36,1.69,3.65,0,0-3.16-4-4.17-3.46,0,0,2,2.56,1,3.51,0,0-2.68-4.44-4.46-2.56,0,0,1.31.34,1.6,1.37C634.34,279.94,628.63,277.57,628.19,279.24Z"
            fill="#6d4c89"
          />
          <path
            d="M631.35,279.62S618.42,267,608.3,283.55c0,0,6.29-5.29,7-4.54,0,0-2.15,1.11-1.6,4.21,0,0,3.86-6.56,5.3-5.91,0,0-2.29,2.6-1.92,4.07,0,0,3.64-4.42,4.83-3.79,0,0-2.35,2.83-1.1,3.92,0,0,3.08-4.93,5.19-2.76,0,0-1.53.34-1.85,1.5C624.14,280.25,630.8,277.72,631.35,279.62Z"
            fill="#6d4c89"
          />
          <path
            d="M629.46,280c.47-7.59-5.85-16.43-10.39-15.88,0,0,9-2.21,10.42,4.6,0,0-1.81-9-4.47-9,0,0,5.85-2,6.91,4.24,0,0,3.16-7.83,0-8.89,0,0,7.23,2.44,4.14,8.52,0,0,3.3-3.5,7.23,1.1,0,0-7.7.19-9,4.05,0,0,3.38-2.76,5.37,0,0,0-6.79-1.42-8.5,4.93Z"
            fill="#6d4c89"
          />
          <path
            d="M629.83,280c.36-5.86-4.51-12.67-8-12.25,0,0,6.92-1.7,8,3.55,0,0-1.4-6.95-3.44-6.95,0,0,4.51-1.57,5.32,3.26,0,0,2.44-6,0-6.85,0,0,5.58,1.88,3.2,6.57,0,0,2.54-2.7,5.57.85,0,0-5.94.14-7,3.12,0,0,2.61-2.13,4.15,0,0,0-5.24-1.1-6.56,3.8Z"
            fill="#6d4c89"
          />
          <path
            d="M630.41,282.32s-.53-7.59-3.95-8.57c0,0,1.42,1.54.71,2.79a4.42,4.42,0,0,0-5.27-2.79s4.57.71,5.27,4.21c0,0-2-1-3.51,1.35C623.66,279.31,630.41,279.45,630.41,282.32Z"
            fill="#6d4c89"
          />
          <path
            d="M629.38,281.22s.53-7.59,4-8.58c0,0-1.43,1.54-.72,2.8a4.42,4.42,0,0,1,5.27-2.8s-4.57.71-5.27,4.22c0,0,2-1,3.51,1.35C636.13,278.21,629.38,278.35,629.38,281.22Z"
            fill="#6d4c89"
          />
          <path
            d="M623.64,305.65c.69-2.24.83-15.48,4.74-25.06-.53,2.64-4,20.68-2.23,25.84.73,2.06-1.63,4-4.88,5.57h-4.6S622.88,308.13,623.64,305.65Z"
            fill="#6d4c89"
            opacity="0.24"
          />
        </g>
        <g>
          <path
            d="M768.35,283.83s-8.65,22.74,2.28,35.17h-17s6.21-3.87,7-6.35.85-18.55,6.19-28.08Z"
            fill="#6d4c89"
          />
          <path
            d="M766.17,285s-.91-13.13-6.83-14.83c0,0,2.46,2.66,1.23,4.83,0,0-2.25-6.44-9.12-4.83,0,0,7.92,1.22,9.12,7.28,0,0-3.41-1.67-6.07,2.34C754.5,279.74,766.18,280,766.17,285Z"
            fill="#6d4c89"
          />
          <path
            d="M768.35,285s.91-13.13,6.83-14.83c0,0-2.46,2.66-1.23,4.83,0,0,2.25-6.44,9.12-4.83,0,0-7.92,1.22-9.12,7.28,0,0,3.41-1.67,6.06,2.34C780,279.74,768.34,280,768.35,285Z"
            fill="#6d4c89"
          />
          <path
            d="M765.45,287.27s11.45-18.9,24.22-11.63c0,0-7.22-.34-7.83.73,0,0,2.37-.46,2.25,2.49,0,0-4.91-3-6.3-1.51,0,0,2.73.69,2.57,2.15,0,0-4.38-1.32-5.51,0,0,0,2.83.84,1.7,2.56,0,0-3.87-2.12-5.73,1.06,0,0,1.62-.7,2.12.05C772.94,283.13,765.74,285.33,765.45,287.27Z"
            fill="#6d4c89"
          />
          <path
            d="M767.57,287s-9.81-17.87-23-8.79c0,0,7.17-1.28,7.68-.25,0,0-2.3-.18-2.42,2.83,0,0,5.1-3.69,6.35-2.35,0,0-2.75,1.05-2.71,2.53,0,0,4.43-1.92,5.45-.75,0,0-2.86,1.22-1.89,2.84,0,0,4-2.67,5.58.34,0,0-1.54-.5-2.1.33C760.49,283.74,767.43,285.07,767.57,287Z"
            fill="#6d4c89"
          />
          <path
            d="M765.19,286.24s10.86-11,19.69,3.95c0,0-5.43-4.83-6-4.18a3.54,3.54,0,0,1,1.42,3.78s-3.37-5.91-4.59-5.36c0,0,2,2.36,1.69,3.65,0,0-3.16-4-4.17-3.46,0,0,2,2.56,1,3.51,0,0-2.68-4.44-4.46-2.56,0,0,1.31.34,1.6,1.37C771.34,286.94,765.63,284.57,765.19,286.24Z"
            fill="#6d4c89"
          />
          <path
            d="M768.35,286.62S755.42,274,745.3,290.55c0,0,6.29-5.29,7-4.54,0,0-2.15,1.11-1.6,4.21,0,0,3.86-6.56,5.3-5.91,0,0-2.29,2.6-1.92,4.07,0,0,3.64-4.42,4.83-3.79,0,0-2.35,2.83-1.1,3.92,0,0,3.08-4.93,5.19-2.76,0,0-1.53.34-1.85,1.5C761.14,287.25,767.8,284.72,768.35,286.62Z"
            fill="#6d4c89"
          />
          <path
            d="M766.46,287c.47-7.59-5.85-16.43-10.39-15.88,0,0,9-2.21,10.42,4.6,0,0-1.81-9-4.47-9,0,0,5.85-2,6.91,4.24,0,0,3.16-7.83,0-8.89,0,0,7.23,2.44,4.14,8.52,0,0,3.3-3.5,7.23,1.1,0,0-7.7.19-9,4.05,0,0,3.38-2.76,5.37,0,0,0-6.79-1.42-8.5,4.93Z"
            fill="#6d4c89"
          />
          <path
            d="M766.83,287c.36-5.86-4.51-12.67-8-12.25,0,0,6.92-1.7,8,3.55,0,0-1.4-6.95-3.44-6.95,0,0,4.51-1.57,5.32,3.26,0,0,2.44-6,0-6.85,0,0,5.58,1.88,3.2,6.57,0,0,2.54-2.7,5.57.85,0,0-5.94.14-7,3.12,0,0,2.61-2.13,4.15,0,0,0-5.24-1.1-6.56,3.8Z"
            fill="#6d4c89"
          />
          <path
            d="M767.41,289.32s-.53-7.59-3.95-8.57c0,0,1.42,1.54.71,2.79a4.42,4.42,0,0,0-5.27-2.79s4.57.71,5.27,4.21c0,0-2-1-3.51,1.35C760.66,286.31,767.41,286.45,767.41,289.32Z"
            fill="#6d4c89"
          />
          <path
            d="M766.38,288.22s.53-7.59,4-8.58c0,0-1.43,1.54-.72,2.8a4.42,4.42,0,0,1,5.27-2.8s-4.57.71-5.27,4.22c0,0,2-1,3.51,1.35C773.13,285.21,766.38,285.35,766.38,288.22Z"
            fill="#6d4c89"
          />
          <path
            d="M760.64,312.65c.69-2.24.83-15.48,4.74-25.06-.53,2.64-4,20.68-2.23,25.84.73,2.06-1.63,4-4.88,5.57h-4.6S759.88,315.13,760.64,312.65Z"
            fill="#6d4c89"
            opacity="0.24"
          />
        </g>
        <g>
          <path
            d="M598.88,284.25s8.64,17.94-2.29,27.75h17s-6.21-3.05-7-5-.85-14.64-6.18-22.16Z"
            fill="#6d4c89"
          />
          <path
            d="M601.05,285.13s.91-10.37,6.84-11.71c0,0-2.47,2.1-1.24,3.81,0,0,2.25-5.08,9.12-3.81,0,0-7.91,1-9.12,5.75a5.53,5.53,0,0,1,6.07,1.84S601,281.21,601.05,285.13Z"
            fill="#6d4c89"
          />
          <path
            d="M598.88,285.13S598,274.76,592,273.42c0,0,2.46,2.1,1.23,3.81,0,0-2.25-5.08-9.11-3.81,0,0,7.91,1,9.11,5.75a5.52,5.52,0,0,0-6.06,1.84S598.88,281.21,598.88,285.13Z"
            fill="#6d4c89"
          />
          <path
            d="M601.77,287s-11.45-14.92-24.22-9.18c0,0,7.23-.27,7.83.58,0,0-2.36-.37-2.25,2,0,0,4.92-2.36,6.3-1.19,0,0-2.73.54-2.56,1.69,0,0,4.37-1,5.5,0,0,0-2.82.66-1.7,2,0,0,3.87-1.67,5.73.84,0,0-1.62-.55-2.12,0C594.28,283.69,601.49,285.43,601.77,287Z"
            fill="#6d4c89"
          />
          <path
            d="M599.66,286.75s9.8-14.1,23-6.93c0,0-7.17-1-7.68-.2a2.25,2.25,0,0,1,2.42,2.23s-5.1-2.91-6.34-1.86c0,0,2.75.84,2.7,2,0,0-4.43-1.51-5.44-.59,0,0,2.86,1,1.88,2.24,0,0-4-2.11-5.58.27,0,0,1.55-.4,2.1.26C606.73,284.17,599.79,285.22,599.66,286.75Z"
            fill="#6d4c89"
          />
          <path
            d="M602,286.15s-10.86-8.66-19.68,3.11c0,0,5.42-3.81,6-3.29a2.61,2.61,0,0,0-1.41,3s3.37-4.67,4.59-4.23c0,0-2,1.86-1.69,2.88,0,0,3.16-3.15,4.16-2.73,0,0-2,2-1,2.76,0,0,2.68-3.5,4.46-2,0,0-1.31.27-1.6,1.08C595.88,286.7,601.59,284.83,602,286.15Z"
            fill="#6d4c89"
          />
          <path
            d="M598.87,286.44s12.93-9.95,23.06,3.11c0,0-6.3-4.18-7-3.59a2.84,2.84,0,0,1,1.6,3.33s-3.86-5.18-5.3-4.67c0,0,2.29,2.05,1.92,3.21,0,0-3.64-3.48-4.83-3,0,0,2.36,2.23,1.1,3.09,0,0-3.07-3.89-5.19-2.18,0,0,1.53.28,1.85,1.19C606.08,286.94,599.42,285,598.87,286.44Z"
            fill="#6d4c89"
          />
          <path
            d="M600.77,286.75c-.48-6,5.84-13,10.39-12.53,0,0-9-1.74-10.43,3.63,0,0,1.82-7.12,4.47-7.12,0,0-5.85-1.6-6.91,3.34,0,0-3.16-6.17,0-7,0,0-7.22,1.93-4.14,6.72,0,0-3.3-2.76-7.23.87,0,0,7.71.15,9,3.2,0,0-3.37-2.18-5.37,0,0,0,6.79-1.12,8.5,3.89Z"
            fill="#6d4c89"
          />
          <path
            d="M600.4,286.75c-.37-4.62,4.51-10,8-9.66,0,0-6.92-1.35-8,2.8,0,0,1.4-5.49,3.44-5.49,0,0-4.51-1.24-5.32,2.57,0,0-2.44-4.76,0-5.4,0,0-5.57,1.48-3.19,5.18,0,0-2.55-2.13-5.58.67,0,0,5.94.11,6.95,2.47,0,0-2.61-1.68-4.15,0,0,0,5.24-.87,6.56,3Z"
            fill="#6d4c89"
          />
          <path
            d="M599.81,288.58s.53-6,4-6.77c0,0-1.43,1.22-.72,2.2,0,0,1.3-2.93,5.27-2.2,0,0-4.57.56-5.27,3.33a3.19,3.19,0,0,1,3.51,1.06S599.81,286.31,599.81,288.58Z"
            fill="#6d4c89"
          />
          <path
            d="M600.84,287.7s-.53-6-4-6.76c0,0,1.42,1.21.71,2.2,0,0-1.3-2.94-5.27-2.2,0,0,4.57.56,5.27,3.32a3.2,3.2,0,0,0-3.51,1.07S600.84,285.44,600.84,287.7Z"
            fill="#6d4c89"
          />
          <path
            d="M606.58,307c-.69-1.77-.83-12.22-4.74-19.78.53,2.08,4,16.32,2.23,20.39-.72,1.63,1.63,3.14,4.89,4.4h4.59S607.34,309,606.58,307Z"
            fill="#6d4c89"
            opacity="0.24"
          />
        </g>
        <g>
          <path
            d="M927.78,291.79s-7.37,14.95,1.71,23.24l-14.2-.12s5.23-2.51,5.88-4.15.81-12.24,5.33-18.5Z"
            fill="#6d4c89"
          />
          <path
            d="M926,292.51s-.69-8.68-5.63-9.85c0,0,2,1.78,1,3.2,0,0-1.85-4.27-7.6-3.26,0,0,6.61.87,7.59,4.88a4.62,4.62,0,0,0-5.09,1.5S926,289.23,926,292.51Z"
            fill="#6d4c89"
          />
          <path
            d="M927.77,292.52s.84-8.66,5.81-9.74c0,0-2.08,1.74-1.06,3.18,0,0,1.92-4.24,7.65-3.13,0,0-6.62.75-7.66,4.75a4.62,4.62,0,0,1,5.06,1.58S927.79,289.25,927.77,292.52Z"
            fill="#6d4c89"
          />
          <path
            d="M925.33,294s9.69-12.4,20.34-7.5c0,0-6-.28-6.56.43,0,0,2-.3,1.87,1.65,0,0-4.09-2-5.26-1,0,0,2.28.48,2.13,1.44,0,0-3.65-.91-4.6-.06,0,0,2.36.57,1.4,1.7,0,0-3.22-1.43-4.8.65,0,0,1.36-.44,1.78.06C931.63,291.36,925.59,292.76,925.33,294Z"
            fill="#6d4c89"
          />
          <path
            d="M927.11,293.88s-8.11-11.88-19.21-6c0,0,6-.8,6.43-.12a1.89,1.89,0,0,0-2,1.86s4.28-2.4,5.32-1.51c0,0-2.31.68-2.28,1.65,0,0,3.72-1.23,4.56-.45,0,0-2.4.78-1.59,1.86,0,0,3.36-1.74,4.66.27,0,0-1.29-.35-1.75.2C921.21,291.67,927,292.59,927.11,293.88Z"
            fill="#6d4c89"
          />
          <path
            d="M925.12,293.35s9.16-7.16,16.45,2.75c0,0-4.51-3.22-5-2.8a2.2,2.2,0,0,1,1.16,2.51s-2.79-3.93-3.81-3.58c0,0,1.64,1.57,1.39,2.43,0,0-2.62-2.66-3.46-2.32,0,0,1.69,1.71.8,2.32,0,0-2.21-3-3.71-1.71,0,0,1.09.23,1.33.91C930.27,293.86,925.5,292.25,925.12,293.35Z"
            fill="#6d4c89"
          />
          <path
            d="M927.77,293.62s-10.75-8.42-19.32,2.44c0,0,5.3-3.45,5.88-2.95a2.36,2.36,0,0,0-1.36,2.77s3.27-4.31,4.47-3.87c0,0-1.93,1.7-1.64,2.67,0,0,3.08-2.89,4.07-2.46,0,0-2,1.85-1,2.57,0,0,2.61-3.23,4.37-1.78,0,0-1.28.22-1.56,1C921.73,294,927.32,292.37,927.77,293.62Z"
            fill="#6d4c89"
          />
          <path
            d="M926.18,293.87c.44-5-4.8-10.9-8.61-10.56,0,0,7.53-1.4,8.7,3.11,0,0-1.46-6-3.68-6,0,0,4.9-1.29,5.75,2.85,0,0,2.69-5.15,0-5.87,0,0,6,1.66,3.42,5.65,0,0,2.78-2.28,6,.79,0,0-6.45.06-7.56,2.61,0,0,2.84-1.8,4.5,0,0,0-5.68-1-7.15,3.19Z"
            fill="#6d4c89"
          />
          <path
            d="M926.49,293.87c.34-3.86-3.7-8.4-6.64-8.14,0,0,5.8-1.08,6.71,2.4,0,0-1.13-4.61-2.84-4.62,0,0,3.78-1,4.43,2.19,0,0,2.08-4,0-4.52,0,0,4.66,1.28,2.64,4.36,0,0,2.15-1.76,4.66.6,0,0-5,.05-5.83,2,0,0,2.19-1.39,3.47,0,0,0-4.38-.77-5.51,2.46Z"
            fill="#6d4c89"
          />
          <path
            d="M927,295.4s-.4-5-3.26-5.69c0,0,1.19,1,.58,1.85,0,0-1.06-2.47-4.39-1.88,0,0,3.82.5,4.39,2.82a2.67,2.67,0,0,0-2.94.87S927,293.51,927,295.4Z"
            fill="#6d4c89"
          />
          <path
            d="M926.11,294.67s.49-5,3.36-5.64c0,0-1.2,1-.61,1.84,0,0,1.1-2.45,4.42-1.8,0,0-3.83.43-4.43,2.74a2.67,2.67,0,0,1,2.92.92S926.12,292.77,926.11,294.67Z"
            fill="#6d4c89"
          />
          <path
            d="M921.17,310.76c.59-1.47.78-10.22,4.11-16.51-.46,1.74-3.51,13.63-2,17.05.6,1.36-1.38,2.61-4.12,3.64l-3.85,0S920.52,312.4,921.17,310.76Z"
            fill="#6d4c89"
            opacity="0.24"
          />
        </g>
        <g>
          <g>
            <path
              d="M803.67,340s36-20,94,4l13.5-20.5s-56.5-20.5-87.5,1.5Z"
              fill="#415c93"
            />
            <line
              x1="803.17"
              y1="317.5"
              x2="803.17"
              y2="339.5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="852.17"
              y1="323.5"
              x2="852.17"
              y2="332.5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="862.17"
              y1="305.5"
              x2="862.17"
              y2="314.5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="900.17"
              y1="321.5"
              x2="900.17"
              y2="343.5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="911.17"
              y1="301.5"
              x2="911.17"
              y2="323.5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="823.17"
              y1="303.5"
              x2="823.17"
              y2="325.5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <path
              d="M803.17,320.72s24,16.78,49-.22c0,0,15,15,48,5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
            />
            <path
              d="M823.66,306.38s15.51,13.91,38.51,1c0,0,36,16.77,49-3.56"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
            />
          </g>
          <path
            d="M904,332s-36.46-17.27-86.65-2.88"
            fill="none"
            stroke="#dcceea"
            strokeMiterlimit="10"
            strokeDasharray="12"
          />
        </g>
        <g>
          <path
            d="M966.42,301.55s2.69,5.46-.62,8.48l5.17,0s-1.9-.91-2.14-1.51-.3-4.46-1.94-6.74Z"
            fill="#6d4c89"
          />
          <path
            d="M967.09,301.82s.25-3.17,2-3.59c0,0-.74.65-.36,1.16a2.4,2.4,0,0,1,2.77-1.18s-2.41.31-2.77,1.78a1.68,1.68,0,0,1,1.86.54S967.07,300.62,967.09,301.82Z"
            fill="#6d4c89"
          />
          <path
            d="M966.42,301.82s-.3-3.16-2.11-3.55c0,0,.75.63.38,1.16a2.39,2.39,0,0,0-2.79-1.14s2.42.27,2.8,1.73a1.7,1.7,0,0,0-1.85.58S966.42,300.63,966.42,301.82Z"
            fill="#6d4c89"
          />
          <path
            d="M967.31,302.37s-3.53-4.52-7.41-2.73c0,0,2.2-.1,2.39.15,0,0-.72-.1-.68.61,0,0,1.49-.73,1.92-.38,0,0-.83.17-.78.52,0,0,1.33-.33,1.68,0,0,0-.86.21-.51.62,0,0,1.17-.52,1.74.24,0,0-.49-.17-.64,0C965,301.4,967.22,301.91,967.31,302.37Z"
            fill="#6d4c89"
          />
          <path
            d="M966.67,302.32s3-4.33,7-2.18c0,0-2.19-.29-2.34,0a.68.68,0,0,1,.74.67s-1.56-.87-1.94-.55c0,0,.84.25.83.61,0,0-1.36-.45-1.66-.17,0,0,.87.29.58.68,0,0-1.23-.63-1.7.1,0,0,.47-.13.64.07C968.82,301.51,966.7,301.85,966.67,302.32Z"
            fill="#6d4c89"
          />
          <path
            d="M967.39,302.13a4.09,4.09,0,0,0-6,1s1.65-1.18,1.83-1a.81.81,0,0,0-.43.91s1-1.43,1.39-1.3c0,0-.6.57-.5.88,0,0,1-1,1.26-.84,0,0-.62.62-.3.84,0,0,.81-1.07,1.36-.62,0,0-.4.08-.49.33C965.51,302.31,967.25,301.72,967.39,302.13Z"
            fill="#6d4c89"
          />
          <path
            d="M966.43,302.22s3.92-3.07,7,.89c0,0-1.93-1.26-2.14-1.07a.86.86,0,0,1,.49,1s-1.19-1.57-1.63-1.41c0,0,.71.62.6,1,0,0-1.12-1.05-1.49-.9,0,0,.73.68.35.94,0,0-.95-1.18-1.59-.65,0,0,.47.08.57.36C968.63,302.36,966.59,301.77,966.43,302.22Z"
            fill="#6d4c89"
          />
          <path
            d="M967,302.31c-.16-1.82,1.76-4,3.14-3.85,0,0-2.74-.51-3.17,1.14,0,0,.54-2.18,1.34-2.19,0,0-1.78-.47-2.09,1,0,0-1-1.87,0-2.14,0,0-2.2.61-1.25,2.06a1.63,1.63,0,0,0-2.2.29s2.35,0,2.76.95c0,0-1-.66-1.64,0,0,0,2.07-.37,2.6,1.16Z"
            fill="#6d4c89"
          />
          <path
            d="M966.89,302.31c-.12-1.4,1.35-3.06,2.42-3,0,0-2.11-.39-2.44.88,0,0,.41-1.68,1-1.68,0,0-1.38-.37-1.62.8,0,0-.75-1.45,0-1.65,0,0-1.7.46-1,1.59a1.25,1.25,0,0,0-1.7.22s1.81,0,2.13.73c0,0-.8-.51-1.27,0,0,0,1.6-.28,2,.9Z"
            fill="#6d4c89"
          />
          <path
            d="M966.72,302.87s.14-1.83,1.19-2.07c0,0-.43.37-.21.67a1.37,1.37,0,0,1,1.6-.68s-1.4.18-1.6,1a1,1,0,0,1,1.07.32S966.71,302.18,966.72,302.87Z"
            fill="#6d4c89"
          />
          <path
            d="M967,302.6s-.18-1.82-1.22-2.05c0,0,.43.37.22.67a1.4,1.4,0,0,0-1.61-.66s1.39.16,1.61,1a1,1,0,0,0-1.06.34S967,301.91,967,302.6Z"
            fill="#6d4c89"
          />
          <path
            d="M968.83,308.47c-.21-.53-.28-3.72-1.5-6,.17.64,1.28,5,.74,6.22-.22.5.5.95,1.5,1.33l1.4,0S969.07,309.07,968.83,308.47Z"
            fill="#6d4c89"
            opacity="0.24"
          />
        </g>
        {/* <g>
          <path
            d="M1014.24,346.71c1.79-3,2.4-3.64,1.64-5.64s-1.5-.29-.73-4.05a3.91,3.91,0,0,0-3.47-5c-1.32-.14-7.57,3.53-6.51,5.52s1.5,7.66.37,8.13S1012.12,350.2,1014.24,346.71Z"
            fill="#396039"
          />
          <path
            d="M1013,339.81c-.06-1.61,2.38-2.26,1.59-3s-1.74-2.64-2.5-1.65-1.35,2.47-1.94,1.65-1.23-.85-1.61,0-.06,1.91-1,1.64-1.32.15-1.2,1,.79.53,1.38,1.58,3.23.91,2.79.33S1013,339.81,1013,339.81Z"
            fill="#447244"
          />
          <path
            d="M1017.58,337c1.32-2.08,3.17-4,5-2.2s-1.23,5,0,6.25,1,4.47,0,4.58-5.58.12-6.78.68-2.76-1.5-2.79-3.49S1017.58,337,1017.58,337Z"
            fill="#6b996b"
          />
          <path
            d="M1010.62,349.38c3.1,2.36,3.32-5.84,0-5.14s-4.4.5-5.45-1-3.7,1.11-3.79,1.84A4.74,4.74,0,0,0,1004,349C1005.78,349.73,1008.78,348,1010.62,349.38Z"
            fill="#447244"
          />
          <path
            d="M1017,351c-3.09,2.36-3.31-5.84,0-5.13s4.41.5,5.46-1,3.7,1.11,3.79,1.85a4.72,4.72,0,0,1-2.58,3.9C1021.86,351.38,1018.86,349.62,1017,351Z"
            fill="#447244"
          />
          <path
            d="M1020.87,348.21c.44-.88,1.73.82,1.73.82s-.09-1.15.62-1.56,1,.65,1,.65c.06-.82,1.74-.06,1.27.92h0a3.92,3.92,0,0,1-1.83,1.63,3.28,3.28,0,0,1-1.31.17l-1.58-.4A3.79,3.79,0,0,1,1020.87,348.21Z"
            fill="#396039"
          />
          <path
            d="M1014.5,349.7c-.62,1.09-1,10.86,0,15.35,0,0-2.82-.49-3.7,0-.09.29-.09,0-.09,0s3.91-13.59.5-17.58-7.1,0-7.1,0,1-2.35,3.2-2.52,5.22,2.67,5.37,3.23c0,0,.12-4.29-1.26-5.79a1.61,1.61,0,0,1,.38-2.58s-1.82.56,1.11,4.38c1.53,2,.44,5.66.44,5.66s.94-2.88,3.29-2.26,3.76,3.35,6,3.17a11.63,11.63,0,0,1-4.64-1.38A2.72,2.72,0,0,0,1014.5,349.7Z"
            fill="#704d3c"
          />
          <path
            d="M1017.71,349.24a2.68,2.68,0,0,0-3.21.46,13.75,13.75,0,0,0-.5,3.65,7.13,7.13,0,0,1,1-5.58,2.18,2.18,0,0,1,1.68-.18,5.27,5.27,0,0,1,1.55.74Z"
            fill="#634b42"
          />
          <path
            d="M1012.31,348.34a7.18,7.18,0,0,1,.28,4h0a8.07,8.07,0,0,0-1.38-4.86,7.33,7.33,0,0,0-.61-.63c-.08-.25-.14-.41-.14-.41A5.16,5.16,0,0,1,1012.31,348.34Z"
            fill="#44322c"
          />
          <path
            d="M1017.06,348.79c.85-.28.9-1.47,1.91-1.4s1.13,1.52,2,2.46,1.52.73,2.19,1-1.83,3.91-4.15,2.62-2.1-1.08-2.9-1.61A1.85,1.85,0,0,1,1017.06,348.79Z"
            fill="#6b996b"
          />
          <g>
            <path d="M1012.66,346.94c0,.06,0,.06,0,0v0Z" fill="#7f2c03" />
            <path
              d="M1012.62,346.43c-.11-1.37-.4-3.17-1.2-4a1.77,1.77,0,0,1-.53-1.06l.41-.08a7.91,7.91,0,0,0,1.61,2.94l.07.09C1012.91,345.05,1012.67,345.84,1012.62,346.43Z"
              fill="#634b42"
            />
          </g>
          <path
            d="M1009.44,346.32c-.55-.7.06-1.72-.82-2.22s-1.78.64-3,1-1.68-.22-2.41-.32-.64,4.27,2,4.47,2.34.26,3.3.26A1.85,1.85,0,0,0,1009.44,346.32Z"
            fill="#6b996b"
          />
          <path
            d="M1010.56,338.08c.58-.91,1.39-1.74,2.2-1s-.54,2.18,0,2.73.42,2,0,2a16.57,16.57,0,0,0-3,.29c-.53.25-1.21-.65-1.22-1.52S1010.56,338.08,1010.56,338.08Z"
            fill="#6b996b"
          />
          <path
            d="M1004.78,348.23c.17.26.66.21.94.09s.45-1,.9-.83.68.61,1.19.46.29-.69.94-.7,1.2.23,1.22.57v.08h0a.22.22,0,0,0,0,.08,1.65,1.65,0,0,1-1.42,1.49c-1,0-.65-.06-3.3-.26a2.18,2.18,0,0,1-1-.31C1004,348.7,1004.62,348,1004.78,348.23Z"
            fill="#447244"
          />
          <path
            d="M1016.7,351.9c.65,0,1.94.71,2.11.06s1.47-.79,1.62-.5a1.27,1.27,0,0,0,1.38.44c.44-.23.88.36.68.59-.82.92-2.2,1.77-3.52,1-1.61-.9-2-1.07-2.35-1.27C1016.47,352.14,1016.21,351.9,1016.7,351.9Z"
            fill="#396039"
          />
          <path
            d="M1014.29,344.48c.41-.91,1.41-.73,2.12-.62s.5,1.06,1.05.62,1.79.62,1.33,1.38h0a10.87,10.87,0,0,0-3,.47c-.74.34-1.63-.31-2.19-1.34l-.25-.51h0S1013.88,345.39,1014.29,344.48Z"
            fill="#447244"
          />
          <path
            d="M1021.75,343.92c-.27-.82.91-1.53,0-1.53s-2.41.91-2.26-.41-.26-2-1.26-1.93-1.76-2.06-1.21-2.54-3.11.92-1.49,2.3,2.2.94,2.14,1.59,0,2,1.23,2.2-.35,1.88.58,2.26S1022.45,346.12,1021.75,343.92Z"
            fill="#447244"
          />
          <path
            d="M1010.71,365.05s.25-.84.56-2.17c2.45-1.25,2.62-5.35,2.63-5.47a41,41,0,0,0,.6,7.64s-2.82-.49-3.7,0C1010.71,365.32,1010.71,365.05,1010.71,365.05Z"
            fill="#44322c"
          />
          <path
            d="M1013.64,364.93a17.06,17.06,0,0,0-.36-2.33,15.5,15.5,0,0,1,0-2.36c.09-1.58.24-3.14.31-4.71a6.44,6.44,0,0,0-.1-2.32,3.88,3.88,0,0,1,0-2.36,4.82,4.82,0,0,1,1.33-2,3.13,3.13,0,0,1,2.31-.11,3.11,3.11,0,0,0-2.27.19,5,5,0,0,0-1.27,1.92,3.87,3.87,0,0,0,.08,2.28c0,.19.11.37.15.57a4.19,4.19,0,0,1,0,.61c0,.39,0,.79,0,1.18-.1,1.57-.26,3.14-.37,4.7a15.36,15.36,0,0,0,0,2.35A16.79,16.79,0,0,1,1013.64,364.93Z"
            fill="#44322c"
          />
          <path
            d="M1013,357.41a7.83,7.83,0,0,0,0,1,1.2,1.2,0,0,1-.32.92A2.62,2.62,0,0,0,1012,361a3.89,3.89,0,0,0,.25,1.87,7.09,7.09,0,0,1,.22,1.94,10.94,10.94,0,0,0-.33-1.9,4,4,0,0,1-.31-1.93,2.72,2.72,0,0,1,.8-1.77C1013.1,358.77,1012.85,358,1013,357.41Z"
            fill="#44322c"
          />
          <path
            d="M1013,344.93c0,.38.18.72.2,1.11,0,.19-.08.39-.08.55a2.06,2.06,0,0,0,.1.53,5.35,5.35,0,0,1,.32,2.22c0,.39-.2.73-.24,1.09a5.76,5.76,0,0,0-.06,1.1,13.74,13.74,0,0,0,.26,2.21,9.22,9.22,0,0,1-.38-2.2,7.08,7.08,0,0,1,0-1.13c0-.38.19-.74.22-1.09a5.22,5.22,0,0,0-.27-2.17,2.61,2.61,0,0,1-.09-.57,4.18,4.18,0,0,0,.1-.54C1013.14,345.68,1013,345.31,1013,344.93Z"
            fill="#44322c"
          />
        </g> */}
        <g>
          <path
            d="M984.24,317.71c1.79-3,2.4-3.64,1.64-5.64s-1.5-.29-.73-4.05a3.91,3.91,0,0,0-3.47-5c-1.32-.14-7.57,3.53-6.51,5.52s1.5,7.66.37,8.13S982.12,321.2,984.24,317.71Z"
            fill="#396039"
          />
          <path
            d="M983,310.81c-.06-1.61,2.38-2.26,1.59-3s-1.74-2.64-2.5-1.65-1.35,2.47-1.94,1.65-1.23-.85-1.61,0-.06,1.91-1,1.64-1.32.15-1.2,1,.79.53,1.38,1.58,3.23.91,2.79.33S983,310.81,983,310.81Z"
            fill="#447244"
          />
          <path
            d="M987.58,308c1.32-2.08,3.17-4,5-2.2s-1.23,5,0,6.25,1,4.47,0,4.58-5.58.12-6.78.68-2.76-1.5-2.79-3.49S987.58,308,987.58,308Z"
            fill="#6b996b"
          />
          <path
            d="M980.62,320.38c3.1,2.36,3.32-5.84,0-5.14s-4.4.5-5.45-1-3.7,1.11-3.79,1.84A4.74,4.74,0,0,0,974,320C975.78,320.73,978.78,319,980.62,320.38Z"
            fill="#447244"
          />
          <path
            d="M987,322c-3.09,2.36-3.31-5.84,0-5.13s4.41.5,5.46-1,3.7,1.11,3.79,1.85a4.72,4.72,0,0,1-2.58,3.9C991.86,322.38,988.86,320.62,987,322Z"
            fill="#447244"
          />
          <path
            d="M990.87,319.21c.44-.88,1.73.82,1.73.82s-.09-1.15.62-1.56,1,.65,1,.65c.06-.82,1.74-.06,1.27.92h0a3.92,3.92,0,0,1-1.83,1.63,3.28,3.28,0,0,1-1.31.17l-1.58-.4A3.79,3.79,0,0,1,990.87,319.21Z"
            fill="#396039"
          />
          <path
            d="M984.5,320.7c-.62,1.09-1,10.86,0,15.35,0,0-2.82-.49-3.7,0-.09.29-.09,0-.09,0s3.91-13.59.5-17.58-7.1,0-7.1,0,1-2.35,3.2-2.52,5.22,2.67,5.37,3.23c0,0,.12-4.29-1.26-5.79a1.61,1.61,0,0,1,.38-2.58s-1.82.56,1.11,4.38c1.53,2,.44,5.66.44,5.66s.94-2.88,3.29-2.26,3.76,3.35,6,3.17a11.63,11.63,0,0,1-4.64-1.38A2.72,2.72,0,0,0,984.5,320.7Z"
            fill="#704d3c"
          />
          <path
            d="M987.71,320.24a2.68,2.68,0,0,0-3.21.46,13.75,13.75,0,0,0-.5,3.65,7.13,7.13,0,0,1,1-5.58,2.18,2.18,0,0,1,1.68-.18,5.27,5.27,0,0,1,1.55.74Z"
            fill="#634b42"
          />
          <path
            d="M982.31,319.34a7.18,7.18,0,0,1,.28,4h0a8.07,8.07,0,0,0-1.38-4.86,7.33,7.33,0,0,0-.61-.63c-.08-.25-.14-.41-.14-.41A5.16,5.16,0,0,1,982.31,319.34Z"
            fill="#44322c"
          />
          <path
            d="M987.06,319.79c.85-.28.9-1.47,1.91-1.4s1.13,1.52,2,2.46,1.52.73,2.19,1-1.83,3.91-4.15,2.62-2.1-1.08-2.9-1.61A1.85,1.85,0,0,1,987.06,319.79Z"
            fill="#6b996b"
          />
          <g>
            <path d="M982.66,317.94c0,.06,0,.06,0,0v0Z" fill="#7f2c03" />
            <path
              d="M982.62,317.43c-.11-1.37-.4-3.17-1.2-4a1.77,1.77,0,0,1-.53-1.06l.41-.08a7.91,7.91,0,0,0,1.61,2.94l.07.09C982.91,316.05,982.67,316.84,982.62,317.43Z"
              fill="#634b42"
            />
          </g>
          <path
            d="M979.44,317.32c-.55-.7.06-1.72-.82-2.22s-1.78.64-3,1-1.68-.22-2.41-.32-.64,4.27,2,4.47,2.34.26,3.3.26A1.85,1.85,0,0,0,979.44,317.32Z"
            fill="#6b996b"
          />
          <path
            d="M980.56,309.08c.58-.91,1.39-1.74,2.2-1s-.54,2.18,0,2.73.42,2,0,2a16.57,16.57,0,0,0-3,.29c-.53.25-1.21-.65-1.22-1.52S980.56,309.08,980.56,309.08Z"
            fill="#6b996b"
          />
          <path
            d="M974.78,319.23c.17.26.66.21.94.09s.45-1,.9-.83.68.61,1.19.46.29-.69.94-.7,1.2.23,1.22.57v.08h0a.22.22,0,0,0,0,.08,1.65,1.65,0,0,1-1.42,1.49c-1,0-.65-.06-3.3-.26a2.18,2.18,0,0,1-1-.31C974,319.7,974.62,319,974.78,319.23Z"
            fill="#447244"
          />
          <path
            d="M986.7,322.9c.65,0,1.94.71,2.11.06s1.47-.79,1.62-.5a1.27,1.27,0,0,0,1.38.44c.44-.23.88.36.68.59-.82.92-2.2,1.77-3.52,1-1.61-.9-2-1.07-2.35-1.27C986.47,323.14,986.21,322.9,986.7,322.9Z"
            fill="#396039"
          />
          <path
            d="M984.29,315.48c.41-.91,1.41-.73,2.12-.62s.5,1.06,1.05.62,1.79.62,1.33,1.38h0a10.87,10.87,0,0,0-3,.47c-.74.34-1.63-.31-2.19-1.34l-.25-.51h0S983.88,316.39,984.29,315.48Z"
            fill="#447244"
          />
          <path
            d="M991.75,314.92c-.27-.82.91-1.53,0-1.53s-2.41.91-2.26-.41-.26-2-1.26-1.93-1.76-2.06-1.21-2.54-3.11.92-1.49,2.3,2.2.94,2.14,1.59,0,2,1.23,2.2-.35,1.88.58,2.26S992.45,317.12,991.75,314.92Z"
            fill="#447244"
          />
          <path
            d="M980.71,336.05s.25-.84.56-2.17c2.45-1.25,2.62-5.35,2.63-5.47a41,41,0,0,0,.6,7.64s-2.82-.49-3.7,0C980.71,336.32,980.71,336.05,980.71,336.05Z"
            fill="#44322c"
          />
          <path
            d="M983.64,335.93a17.06,17.06,0,0,0-.36-2.33,15.5,15.5,0,0,1,0-2.36c.09-1.58.24-3.14.31-4.71a6.44,6.44,0,0,0-.1-2.32,3.88,3.88,0,0,1,0-2.36,4.82,4.82,0,0,1,1.33-2,3.13,3.13,0,0,1,2.31-.11,3.11,3.11,0,0,0-2.27.19,5,5,0,0,0-1.27,1.92,3.87,3.87,0,0,0,.08,2.28c0,.19.11.37.15.57a4.19,4.19,0,0,1,0,.61c0,.39,0,.79,0,1.18-.1,1.57-.26,3.14-.37,4.7a15.36,15.36,0,0,0,0,2.35A16.79,16.79,0,0,1,983.64,335.93Z"
            fill="#44322c"
          />
          <path
            d="M983,328.41a7.83,7.83,0,0,0,0,1,1.2,1.2,0,0,1-.32.92A2.62,2.62,0,0,0,982,332a3.89,3.89,0,0,0,.25,1.87,7.09,7.09,0,0,1,.22,1.94,10.94,10.94,0,0,0-.33-1.9,4,4,0,0,1-.31-1.93,2.72,2.72,0,0,1,.8-1.77C983.1,329.77,982.85,329,983,328.41Z"
            fill="#44322c"
          />
          <path
            d="M983,315.93c0,.38.18.72.2,1.11,0,.19-.08.39-.08.55a2.06,2.06,0,0,0,.1.53,5.35,5.35,0,0,1,.32,2.22c0,.39-.2.73-.24,1.09a5.76,5.76,0,0,0-.06,1.1,13.74,13.74,0,0,0,.26,2.21,9.22,9.22,0,0,1-.38-2.2,7.08,7.08,0,0,1,0-1.13c0-.38.19-.74.22-1.09a5.22,5.22,0,0,0-.27-2.17,2.61,2.61,0,0,1-.09-.57,4.18,4.18,0,0,0,.1-.54C983.14,316.68,983,316.31,983,315.93Z"
            fill="#44322c"
          />
        </g>
        {/* <g>
          <g>
            <rect
              x="968.83"
              y="353.53"
              width="1.27"
              height="22.47"
              rx="0.64"
              fill="#a39bb2"
            />
            <g>
              <ellipse
                cx="969.47"
                cy="347.57"
                rx="2.61"
                ry="0.51"
                fill="url(#f79ad1d0-cdba-45c0-8bca-243e60aed2e8)"
              />
              <ellipse
                cx="969.47"
                cy="348.46"
                rx="3.6"
                ry="0.67"
                fill="url(#bdf8fa79-c14b-4a47-91c0-56755d2d7047)"
              />
              <ellipse
                cx="969.47"
                cy="349.35"
                rx="4.59"
                ry="0.83"
                fill="url(#ea39fe11-2975-43aa-9313-0faf556d293a)"
              />
              <ellipse
                cx="969.47"
                cy="350.24"
                rx="5.57"
                ry="0.99"
                fill="url(#a3a4404a-f59d-4443-b978-8cea11831787)"
              />
              <ellipse
                cx="969.47"
                cy="351.13"
                rx="6.56"
                ry="1.15"
                fill="url(#b5537cef-6ea1-404c-8020-511f990ec718)"
              />
              <ellipse
                cx="969.47"
                cy="352.03"
                rx="7.55"
                ry="1.31"
                fill="url(#b412f2c1-e03f-4206-bea1-169cdebaf686)"
              />
              <ellipse
                cx="969.47"
                cy="353.34"
                rx="6.81"
                ry="1.2"
                fill="url(#a407e284-0245-4acd-9b19-7981e24873bb)"
              />
              <ellipse
                cx="969.47"
                cy="354.65"
                rx="6.07"
                ry="1.09"
                fill="url(#b8387ab6-7fe9-470b-9b4e-f75007c1f810)"
              />
              <ellipse
                cx="969.47"
                cy="355.96"
                rx="5.32"
                ry="0.98"
                fill="url(#fad103bf-1b52-4ebc-8da7-2944d2aed1cd)"
              />
              <ellipse
                cx="969.47"
                cy="357.27"
                rx="4.58"
                ry="0.86"
                fill="url(#bfd2880a-1934-4626-8831-2279275d5f5a)"
              />
              <ellipse
                cx="969.47"
                cy="358.58"
                rx="3.84"
                ry="0.75"
                fill="url(#aa79cc45-88c6-4ef2-8a4f-a5fce747f60e)"
              />
            </g>
          </g>
          <circle
            cx="969.34"
            cy="352.67"
            r="12.67"
            fill="url(#bfde810d-c5c0-4d0b-ae98-9c21dd8dcf86)"
          />
        </g> */}
        <g>
          <g>
            <rect
              x="994.83"
              y="319.53"
              width="1.27"
              height="22.47"
              rx="0.64"
              fill="#a39bb2"
            />
            <g>
              <ellipse
                cx="995.47"
                cy="313.57"
                rx="2.61"
                ry="0.51"
                fill="url(#e266dbc6-aa67-45ec-a0a6-727c6f93e003)"
              />
              <ellipse
                cx="995.47"
                cy="314.46"
                rx="3.6"
                ry="0.67"
                fill="url(#abd7a46c-2622-4563-a380-d0150b5669b6)"
              />
              <ellipse
                cx="995.47"
                cy="315.35"
                rx="4.59"
                ry="0.83"
                fill="url(#a2b05b19-b7c7-499e-ac1c-c5dbf0ea5eb3)"
              />
              <ellipse
                cx="995.47"
                cy="316.24"
                rx="5.57"
                ry="0.99"
                fill="url(#b6d37c0c-c217-45c5-98d8-0d09619cd987)"
              />
              <ellipse
                cx="995.47"
                cy="317.13"
                rx="6.56"
                ry="1.15"
                fill="url(#f04d7b9e-743a-4ed9-b381-1c8b5350dfc7)"
              />
              <ellipse
                cx="995.47"
                cy="318.03"
                rx="7.55"
                ry="1.31"
                fill="url(#fc7ace0d-7f6f-4878-a048-7e11ab13292f)"
              />
              <ellipse
                cx="995.47"
                cy="319.34"
                rx="6.81"
                ry="1.2"
                fill="url(#a3bc8db7-0218-41b7-9a90-401f02ee26e4)"
              />
              <ellipse
                cx="995.47"
                cy="320.65"
                rx="6.07"
                ry="1.09"
                fill="url(#b974e3b4-e6f5-4b97-8efc-cd6a70be3641)"
              />
              <ellipse
                cx="995.47"
                cy="321.96"
                rx="5.32"
                ry="0.98"
                fill="url(#f590a4c1-631e-4f42-a8b1-af658d5d82ec)"
              />
              <ellipse
                cx="995.47"
                cy="323.27"
                rx="4.58"
                ry="0.86"
                fill="url(#ad3dab32-b163-4c88-9af9-5f712e113a31)"
              />
              <ellipse
                cx="995.47"
                cy="324.58"
                rx="3.84"
                ry="0.75"
                fill="url(#e41a8de4-0578-4e1e-906e-dd7629697134)"
              />
            </g>
          </g>
          <circle
            cx="995.34"
            cy="318.67"
            r="12.67"
            fill="url(#a88701de-ddb7-4c82-842b-cc999587d8bf)"
          />
        </g>
        {/* <g>
          <g>
            <path
              d="M1104.33,330.08a5.05,5.05,0,0,0,.06-.67,4.5,4.5,0,0,0,0-1,8,8,0,0,0-.19-.85,2.81,2.81,0,0,1-.08-.76c0-.28.09-.55.11-.83a1.67,1.67,0,0,0-.06-.63,4.08,4.08,0,0,0-.17-.42,3,3,0,0,0-.25-.37.06.06,0,0,1,0-.08,3.12,3.12,0,0,0-1.48-1.29,3,3,0,0,0-1.82-.13,1,1,0,0,1-.23.23,2.06,2.06,0,0,1-.68.25,1.36,1.36,0,0,0-.71.37,6.65,6.65,0,0,0-.48.77,1.43,1.43,0,0,1-.32.33,1.27,1.27,0,0,1-.39.18,1.07,1.07,0,0,0-.4.26,2.57,2.57,0,0,0-.28.37c-.1.12-.22.23-.33.34a2.91,2.91,0,0,0-.24.27,4.21,4.21,0,0,0-.51,1.62,2.25,2.25,0,0,1-.38.9,3.84,3.84,0,0,1-.57.57,2.07,2.07,0,0,0-.43.5,2,2,0,0,0-.19.91c0,.74,0,1.49-.06,2.23,0,.18-.06.36-.1.54s-.1.33-.13.5a1.14,1.14,0,0,0,0,.66,4.4,4.4,0,0,0,.31.56,1.73,1.73,0,0,1,.28.89,1.35,1.35,0,0,0,0,.49,1,1,0,0,0,.21.35,5.39,5.39,0,0,1,.55.63s0,0,0,0a2.81,2.81,0,0,0,.76.46,3.1,3.1,0,0,0,1.28.2,4.15,4.15,0,0,1,.86-.45,9.22,9.22,0,0,0,1-.44,2.66,2.66,0,0,0,.45-.29c.14-.11.27-.25.41-.35s.59-.36.85-.58a1.55,1.55,0,0,0,.36-.45,4.61,4.61,0,0,0,.22-.51,2,2,0,0,1,.29-.46,3.59,3.59,0,0,1,.39-.39l.55-.48a13.4,13.4,0,0,0,.67-1.37,3.15,3.15,0,0,0-.24-.56c-.15-.27-.32-.53-.47-.8a.07.07,0,0,1,0-.1c.25-.06.5-.1.74-.17a1,1,0,0,0,.47-.27.92.92,0,0,0,.18-.32C1104.27,330.36,1104.31,330.22,1104.33,330.08Z"
              fill="#396039"
            />
            <path
              d="M1102,323.76a36.38,36.38,0,0,0-1.77,3.6c-.54,1.22-1,2.46-1.52,3.7-1,2.5-1.77,5-2.52,7.6s-1.43,5.14-2.06,7.74-1.16,5.21-1.68,7.83l.73-3.94.86-3.91c.61-2.6,1.25-5.2,2-7.76s1.6-5.1,2.57-7.59A51,51,0,0,1,1102,323.76Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1089.48,341.49c0-.32,0-.64,0-1a21,21,0,0,0-1.46-4.71c-.16-.15-.31-.31-.46-.47s-.32-.43-.48-.65l-.56-.77a6.07,6.07,0,0,1-.89-1.57c-.1-.28-.14-.57-.22-.86s-.11-.38-.18-.57c-1.83-2.45-3.74-3.78-4.93-3.21a1.21,1.21,0,0,0-.43.33l-.07.25a3.82,3.82,0,0,0-.11,1.21,5.09,5.09,0,0,0,.24,1.16,8,8,0,0,1,.39,1.35,4.94,4.94,0,0,1,0,1.27,6.08,6.08,0,0,0-.09,1.28,1.69,1.69,0,0,0,.37,1.06,3.2,3.2,0,0,0,.67.49,3.35,3.35,0,0,1,.73.68.9.9,0,0,1,.25.68c0,.26-.15.51-.19.78a2.15,2.15,0,0,0,.55,1.74,8.56,8.56,0,0,0,1.48,1.28c.28.22.56.43.82.67l.39.37c.14.15.26.31.39.47a8.07,8.07,0,0,0,2,1.51,12.22,12.22,0,0,1,1,.68,2.41,2.41,0,0,0,1-2.12A5.27,5.27,0,0,1,1089.48,341.49Z"
              fill="#2f4f2f"
            />
            <path
              d="M1079.88,327.53a87.83,87.83,0,0,1,7.46,12.93,71.79,71.79,0,0,1,2.74,7,43.14,43.14,0,0,1,1.71,7.27,51,51,0,0,0-1.79-7.24,71.6,71.6,0,0,0-2.79-6.93c-1-2.25-2.18-4.47-3.41-6.64S1081.28,329.59,1079.88,327.53Z"
              fill="#87f139"
            />
          </g>
          <g>
            <path
              d="M1089.36,343.3c0-.25-.07-.5-.09-.76a17,17,0,0,0-1.75-3.5c-.14-.1-.29-.21-.42-.32s-.31-.29-.46-.45l-.53-.52a5.44,5.44,0,0,1-.91-1.12c-.11-.21-.18-.43-.27-.65s-.14-.28-.22-.42c-1.74-1.69-3.41-2.49-4.27-1.9a1.11,1.11,0,0,0-.29.32l0,.21a2.82,2.82,0,0,0,.07,1,3.88,3.88,0,0,0,.33.88,5.4,5.4,0,0,1,.48,1,3.42,3.42,0,0,1,.12,1,5.69,5.69,0,0,0,.09,1,1.44,1.44,0,0,0,.43.79,2.49,2.49,0,0,0,.59.29,2.86,2.86,0,0,1,.65.44.71.71,0,0,1,.29.5c0,.22-.05.43-.05.64a1.72,1.72,0,0,0,.65,1.3,6.66,6.66,0,0,0,1.33.81c.24.13.49.27.72.42l.35.24c.13.1.24.21.37.32a6.28,6.28,0,0,0,1.73.93c.3.13.61.26.89.41a1.88,1.88,0,0,0,.52-1.79A4.39,4.39,0,0,1,1089.36,343.3Z"
              fill="#396039"
            />
            <path
              d="M1080.07,333.57a68.92,68.92,0,0,1,7.49,9.19,58.11,58.11,0,0,1,3,5.1,35.37,35.37,0,0,1,2.25,5.49,39.75,39.75,0,0,0-2.34-5.45,55.29,55.29,0,0,0-3.06-5.06q-1.67-2.46-3.51-4.78C1082.7,336.52,1081.42,335,1080.07,333.57Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1093.58,343.44a.33.33,0,0,1-.14-.23.39.39,0,0,1,.15-.28,2.27,2.27,0,0,1,.42-.33v0a2.13,2.13,0,0,1-.26-.26.45.45,0,0,1-.11-.23c0-.17.17-.24.3-.3l.28-.1c.06-.29.12-.59.17-.9l-.16,0a2.83,2.83,0,0,1-.41-.14.64.64,0,0,1-.28-.18.06.06,0,0,1,0-.1,2.46,2.46,0,0,1,.4-.19,1,1,0,0,0,.35-.23c.1-.12,0-.28,0-.42a.43.43,0,0,1,.16-.29l.14-.11c0-.37.07-.76.1-1.15l-.23-.07a1.18,1.18,0,0,1-.52-.27.43.43,0,0,1-.08-.52,1,1,0,0,1,.53-.39,1.73,1.73,0,0,1,.32-.11c0-.13,0-.27.08-.4,0-.38,0-.77,0-1.17l0-.05a.67.67,0,0,0-.22-.13,1.11,1.11,0,0,1-.32-.25.06.06,0,0,1,0-.09c.15-.14.53-.33.42-.59,0-.07-.15-.08-.21-.12a.2.2,0,0,1-.12-.23c.05-.18.27-.24.36-.38s-.16-.21-.27-.22a2.7,2.7,0,0,1-.57,0c-.06,0-.06-.09,0-.12.3-.21.59-.42.89-.61,0-.82-.13-1.6-.23-2.33l-.13,0a.08.08,0,0,1-.09-.06,2.85,2.85,0,0,0-.55.28l-.3.23c-.07.06-.17,0-.1-.1a2.43,2.43,0,0,1,.32-.24,5.9,5.9,0,0,1,.8-.49c-.1-.64-.21-1.23-.34-1.78a2.46,2.46,0,0,0-.68.36l-.25.22a.07.07,0,0,1-.1-.1l.26-.23.49-.45.2-.15a12,12,0,0,0-.49-1.53,9.29,9.29,0,0,1-.92.37.07.07,0,0,1-.09-.07,1.51,1.51,0,0,1,.34-.75,3.11,3.11,0,0,1,.29-.33c-.34-.57-.71-.89-1.1-.89-.79,0-1.51,1.3-2,3.37l.6.58a.07.07,0,0,1-.08.11,4.86,4.86,0,0,1-.59-.42c-.12.55-.23,1.15-.33,1.79a9.81,9.81,0,0,1,.62,1.26.07.07,0,0,1,0,.09c-.26.14-.53.25-.8.37-.08.9-.13,1.86-.15,2.86a5.48,5.48,0,0,1,.56,1.29,3,3,0,0,1,0,1c0,.18,0,.35,0,.52s0,.34,0,.51-.17.62-.23.94a.78.78,0,0,0,.22.78,1.65,1.65,0,0,0,.57.22.27.27,0,0,1,.18.15.35.35,0,0,1,0,.26,1.36,1.36,0,0,1-.6.51l-.22.12c.49,3.06,1.36,5.11,2.36,5.11.61,0,1.18-.78,1.64-2.1Z"
              fill="#659965"
            />
            <path
              d="M1092.08,327.8l-.07,13.27,0,6.64V351c0,1.11,0,2.21.1,3.32-.21-2.21-.17-4.43-.2-6.64v-6.64C1091.93,336.65,1092,332.22,1092.08,327.8Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1096.41,332.64a.92.92,0,0,0-.52,0c-.09.13-.19.26-.29.38s-.31.37-.48.54a5.59,5.59,0,0,0-.45.52,4.91,4.91,0,0,0-.53.95,4.33,4.33,0,0,1-.54,1.1c-.21.26-.49.46-.72.7h0c-.06.16-.12.32-.17.49a13.36,13.36,0,0,0-.65,3.13,2.42,2.42,0,0,0,0,.25,19.41,19.41,0,0,1,.39,2.26.94.94,0,0,0,.44.33c1.08.36,2.74-1.74,3.71-4.68S1097.5,333,1096.41,332.64Z"
              fill="#3b6818"
            />
            <path
              d="M1096.62,338.61s-4.65,2.38-4.82,14.63"
              fill="none"
              stroke="#78bf3a"
              strokeMiterlimit="10"
              strokeWidth="0.14"
            />
            <path
              d="M1095.68,333.75A2.61,2.61,0,0,0,1095,335a5.7,5.7,0,0,1-.27,1.29,1.77,1.77,0,0,1-.42.58c-.17.16-.35.29-.51.45a1.45,1.45,0,0,0-.37.62,1.17,1.17,0,0,0,0,.56,2.12,2.12,0,0,1,.09.57,2,2,0,0,1-.24.77,2.23,2.23,0,0,0-.23.8,1.48,1.48,0,0,0,.09.51,1.65,1.65,0,0,1,0,.55,1.48,1.48,0,0,1-.17.5,1.17,1.17,0,0,0-.16.44,1.34,1.34,0,0,0,.2.64l0,.07a.76.76,0,0,0,.19.12c.85.28,2.33-1.88,3.3-4.82s1.06-5.56.21-5.84a.56.56,0,0,0-.36,0A5.32,5.32,0,0,1,1095.68,333.75Z"
              fill="#659965"
            />
          </g>
        </g> */}
        <g>
          <polygon
            points="942.15 313.77 942.15 318.44 936.63 310.58 942.15 307.39 942.15 311.32 947.67 314.45 947.67 316.95 942.15 313.77"
            fill="none"
            stroke="#4ff219"
            strokeLinejoin="round"
            strokeWidth="1.11"
          />
          <image
            width="85"
            height="85"
            transform="translate(899.67 270)"
            xlinkHref="data:image/png;base64,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"
          />
          <line
            x1="943.89"
            y1="315.14"
            x2="943.89"
            y2="326.29"
            fill="none"
            stroke="#4ff219"
            strokeLinejoin="round"
            strokeWidth="1.11"
          />
          <line
            x1="943.89"
            y1="315.67"
            x2="943.89"
            y2="326.14"
            fill="none"
            stroke="#f7e4f4"
            strokeLinejoin="round"
            strokeWidth="0.15"
          />
          <polygon
            points="942.15 313.77 942.15 318.44 936.63 310.58 942.15 307.39 942.15 311.32 947.67 314.45 947.67 316.95 942.15 313.77"
            fill="none"
            stroke="#f7e4f4"
            strokeLinejoin="round"
            strokeWidth="0.16"
          />
        </g>
        <g>
          <g>
            <rect
              x="1280.11"
              y="346.8"
              width="3.91"
              height="69.2"
              rx="0.64"
              fill="#a39bb2"
            />
            <g>
              <ellipse
                cx="1282.07"
                cy="328.47"
                rx="8.03"
                ry="1.58"
                fill="url(#f2947948-b5c2-41a6-b964-a1fac0d45965)"
              />
              <ellipse
                cx="1282.07"
                cy="331.22"
                rx="11.07"
                ry="2.07"
                fill="url(#b73c1d82-195a-499a-bd55-640349d8d781)"
              />
              <ellipse
                cx="1282.07"
                cy="333.96"
                rx="14.12"
                ry="2.56"
                fill="url(#f63dd7d1-5f2d-4424-b7cb-980d00b1cb2a)"
              />
              <ellipse
                cx="1282.07"
                cy="336.7"
                rx="17.16"
                ry="3.05"
                fill="url(#b3a97687-d507-4dcf-8073-376a9c2b4b2a)"
              />
              <ellipse
                cx="1282.07"
                cy="339.44"
                rx="20.2"
                ry="3.54"
                fill="url(#bc239816-8614-484d-a446-e27d38f1f249)"
              />
              <ellipse
                cx="1282.07"
                cy="342.18"
                rx="23.25"
                ry="4.03"
                fill="url(#bcf7eec9-a311-449b-8549-f1ebfc805dd5)"
              />
              <ellipse
                cx="1282.07"
                cy="346.22"
                rx="20.96"
                ry="3.69"
                fill="url(#e103a088-567f-4c6f-8f45-ba5a0f150745)"
              />
              <ellipse
                cx="1282.07"
                cy="350.26"
                rx="18.68"
                ry="3.35"
                fill="url(#aa887489-ef79-4504-bedb-4e3d82a6b296)"
              />
              <ellipse
                cx="1282.07"
                cy="354.29"
                rx="16.39"
                ry="3"
                fill="url(#af6c3ec6-82db-47f8-a352-267d20394c42)"
              />
              <ellipse
                cx="1282.07"
                cy="358.33"
                rx="14.11"
                ry="2.66"
                fill="url(#aa2343be-7655-4c7d-b7b6-e32323a2968f)"
              />
              <ellipse
                cx="1282.07"
                cy="362.37"
                rx="11.82"
                ry="2.32"
                fill="url(#f055da16-953f-43e3-bb88-4b4fd943bc99)"
              />
            </g>
          </g>
          <circle
            cx="1281.67"
            cy="344.16"
            r="39"
            fill="url(#ec05867d-2463-4df3-8eb8-16ede8436748)"
          />
        </g>
        <g>
          <path
            d="M893.88,494.22s12.71,26.37-3.36,40.78h24.93s-9.13-4.48-10.25-7.37-1.25-21.51-9.08-32.56Z"
            fill="#6d3b2f"
          />
          <path
            d="M897.08,495.51s1.34-15.22,10-17.2c0,0-3.62,3.09-1.81,5.6,0,0,3.31-7.47,13.39-5.6,0,0-11.62,1.42-13.39,8.45a8.13,8.13,0,0,1,8.91,2.71S897.07,489.76,897.08,495.51Z"
            fill="#43771c"
          />
          <path
            d="M893.88,495.51s-1.34-15.22-10-17.2c0,0,3.62,3.09,1.81,5.6,0,0-3.3-7.47-13.39-5.6,0,0,11.62,1.42,13.39,8.45a8.13,8.13,0,0,0-8.91,2.71S893.89,489.76,893.88,495.51Z"
            fill="#43771c"
          />
          <path
            d="M898.14,498.2s-16.82-21.91-35.59-13.48c0,0,10.62-.4,11.51.85,0,0-3.48-.55-3.31,2.88,0,0,7.22-3.46,9.25-1.75,0,0-4,.8-3.76,2.49,0,0,6.43-1.53,8.09,0,0,0-4.15,1-2.5,3,0,0,5.69-2.47,8.42,1.22,0,0-2.38-.81-3.11.07C887.14,493.41,897.72,496,898.14,498.2Z"
            fill="#529022"
          />
          <path
            d="M895,497.91s14.41-20.73,33.82-10.2c0,0-10.54-1.48-11.29-.29a3.31,3.31,0,0,1,3.56,3.28s-7.49-4.27-9.32-2.73c0,0,4,1.23,4,2.93,0,0-6.51-2.22-8-.86,0,0,4.2,1.42,2.77,3.29,0,0-5.87-3.1-8.2.4,0,0,2.27-.59,3.08.38C905.42,494.11,895.22,495.65,895,497.91Z"
            fill="#529022"
          />
          <path
            d="M898.52,497s-16-12.71-28.92,4.58c0,0,8-5.6,8.83-4.84a3.86,3.86,0,0,0-2.07,4.38s4.95-6.86,6.74-6.22c0,0-2.92,2.73-2.48,4.24,0,0,4.64-4.63,6.11-4,0,0-3,3-1.45,4.07,0,0,3.94-5.15,6.55-3,0,0-1.92.39-2.34,1.58C889.49,497.82,897.87,495.07,898.52,497Z"
            fill="#426642"
          />
          <path
            d="M893.88,497.44s19-14.62,33.87,4.57c0,0-9.25-6.13-10.27-5.27a4.16,4.16,0,0,1,2.35,4.89s-5.68-7.61-7.8-6.86c0,0,3.37,3,2.83,4.72,0,0-5.36-5.12-7.1-4.4,0,0,3.46,3.29,1.62,4.55,0,0-4.52-5.72-7.63-3.2,0,0,2.25.4,2.72,1.74C904.47,498.18,894.68,495.25,893.88,497.44Z"
            fill="#426642"
          />
          <path
            d="M896.66,497.9c-.69-8.8,8.59-19,15.27-18.41,0,0-13.19-2.56-15.32,5.34,0,0,2.67-10.47,6.56-10.47,0,0-8.59-2.35-10.14,4.91,0,0-4.64-9.07,0-10.3,0,0-10.62,2.83-6.08,9.88,0,0-4.86-4.06-10.63,1.28,0,0,11.32.21,13.24,4.7,0,0-5-3.21-7.9,0,0,0,10-1.66,12.49,5.71Z"
            fill="#529022"
          />
          <path
            d="M896.12,497.9c-.54-6.79,6.63-14.69,11.77-14.2,0,0-10.17-2-11.81,4.12,0,0,2-8.07,5.06-8.07,0,0-6.63-1.81-7.82,3.79,0,0-3.58-7,0-8,0,0-8.19,2.18-4.69,7.62,0,0-3.75-3.13-8.2,1,0,0,8.73.17,10.21,3.63,0,0-3.83-2.47-6.09,0,0,0,7.7-1.28,9.63,4.4Z"
            fill="#396039"
          />
          <path
            d="M895.26,500.58s.78-8.8,5.81-9.94c0,0-2.09,1.79-1.05,3.24,0,0,1.91-4.32,7.74-3.24,0,0-6.72.82-7.74,4.89a4.69,4.69,0,0,1,5.15,1.56S895.26,497.26,895.26,500.58Z"
            fill="#659965"
          />
          <path
            d="M896.77,499.3s-.78-8.8-5.81-9.94c0,0,2.09,1.79,1,3.24,0,0-1.91-4.32-7.74-3.24,0,0,6.72.82,7.74,4.89a4.69,4.69,0,0,0-5.15,1.56S896.77,496,896.77,499.3Z"
            fill="#659965"
          />
          <path
            d="M905.2,527.63c-1-2.59-1.21-17.95-7-29.05.78,3.06,6,24,3.28,30-1.07,2.39,2.39,4.61,7.17,6.46h6.76S906.32,530.52,905.2,527.63Z"
            fill="#17216b"
            opacity="0.24"
          />
        </g>
        {/* <g>
          <g>
            <path
              d="M1454.87,493.91c-.07-.53-.11-1.07-.14-1.59a12.94,12.94,0,0,1,.07-2.33c.1-.69.3-1.36.46-2a6.6,6.6,0,0,0,.2-1.82c0-.67-.22-1.31-.27-2a4.79,4.79,0,0,1,.14-1.51c.13-.34.27-.68.42-1a8.35,8.35,0,0,1,.58-.88.14.14,0,0,0,0-.18,7.07,7.07,0,0,1,7.88-3.4,2,2,0,0,0,.54.55,4.71,4.71,0,0,0,1.63.6,3.15,3.15,0,0,1,1.69.88,15.57,15.57,0,0,1,1.14,1.83,3.39,3.39,0,0,0,.76.8,3.6,3.6,0,0,0,.93.44,2.55,2.55,0,0,1,1,.6,8.19,8.19,0,0,1,.66.89,7.55,7.55,0,0,0,.79.81,6,6,0,0,1,.57.66c.84,1.1.9,2.57,1.21,3.87a5.62,5.62,0,0,0,.91,2.15,10.28,10.28,0,0,0,1.36,1.36,4.51,4.51,0,0,1,1,1.19,5,5,0,0,1,.46,2.16c.09,1.78-.06,3.56.15,5.33a10.85,10.85,0,0,0,.22,1.29c.1.4.24.8.32,1.21a2.72,2.72,0,0,1-.12,1.57,13.18,13.18,0,0,1-.73,1.33,4,4,0,0,0-.67,2.12,3.34,3.34,0,0,1,0,1.18,2.54,2.54,0,0,1-.51.85,10.36,10.36,0,0,0-1.31,1.5.16.16,0,0,0,0,.08,6.91,6.91,0,0,1-1.82,1.1,7.06,7.06,0,0,1-3.06.48,10.56,10.56,0,0,0-2-1.08,23.83,23.83,0,0,1-2.44-1,6.87,6.87,0,0,1-1.08-.7c-.33-.27-.62-.58-1-.84-.66-.49-1.41-.85-2-1.38a3.59,3.59,0,0,1-.87-1.07c-.2-.39-.35-.81-.53-1.22a3.86,3.86,0,0,0-.67-1.1,10.31,10.31,0,0,0-.94-.93c-.43-.39-.88-.76-1.31-1.14a34.21,34.21,0,0,1-1.6-3.27,6.78,6.78,0,0,1,.58-1.35c.35-.65.75-1.26,1.11-1.91a.18.18,0,0,0-.09-.25,17.26,17.26,0,0,1-1.76-.4,2.35,2.35,0,0,1-1.13-.63,2.22,2.22,0,0,1-.44-.78C1455,494.59,1454.94,494.25,1454.87,493.91Z"
              fill="#396039"
            />
            <path
              d="M1460.39,478.82a123,123,0,0,1,8,17.36c2.31,5.95,4.3,12,6.14,18.13s3.36,12.32,4.83,18.53c.72,3.11,1.36,6.23,2,9.35l1.76,9.41-1.91-9.38c-.71-3.11-1.36-6.23-2.1-9.33-1.5-6.2-3.06-12.39-4.93-18.49s-3.75-12.18-6-18.15l-1.76-4.44c-.62-1.47-1.21-2.95-1.87-4.4A91,91,0,0,0,1460.39,478.82Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1490.36,521.17c0-.77,0-1.53-.09-2.29a50.74,50.74,0,0,1,3.5-11.25c.38-.37.75-.74,1.09-1.14s.78-1,1.16-1.55l1.33-1.82a15.68,15.68,0,0,0,2.14-3.75c.24-.67.33-1.37.51-2.06.12-.46.28-.92.44-1.37,4.36-5.84,8.93-9,11.76-7.68a3.26,3.26,0,0,1,1,.79c.06.2.12.41.17.62a8.8,8.8,0,0,1,.27,2.89,12.63,12.63,0,0,1-.57,2.77,18.92,18.92,0,0,0-.94,3.2,11.91,11.91,0,0,0,.12,3,14.38,14.38,0,0,1,.22,3.07,4.11,4.11,0,0,1-.88,2.53,7.47,7.47,0,0,1-1.62,1.16,8,8,0,0,0-1.72,1.62,2.13,2.13,0,0,0-.6,1.63c.07.63.34,1.23.45,1.86a5.25,5.25,0,0,1-1.31,4.17,20.34,20.34,0,0,1-3.55,3.06c-.67.51-1.33,1-2,1.59-.31.28-.62.58-.91.89s-.62.74-.94,1.11a19,19,0,0,1-4.69,3.61c-.85.52-1.68,1-2.47,1.64-1.43-.72-2.22-2.53-2.4-5.08A12.34,12.34,0,0,0,1490.36,521.17Z"
              fill="#2f4f2f"
            />
            <path
              d="M1513.27,487.81q-2.51,3.69-4.82,7.5t-4.54,7.68q-4.4,7.77-8.14,15.87a172.28,172.28,0,0,0-6.65,16.53c-.86,2.85-1.81,5.67-2.46,8.57-.82,2.86-1.26,5.81-1.82,8.73a104.58,104.58,0,0,1,4.07-17.37,170.32,170.32,0,0,1,6.56-16.6q3.81-8.08,8.25-15.84C1506.68,497.72,1509.83,492.66,1513.27,487.81Z"
              fill="#87f139"
            />
          </g>
          <g>
            <path
              d="M1490.65,525.49c.1-.6.16-1.21.22-1.81a39.67,39.67,0,0,1,4.17-8.37c.34-.24.68-.49,1-.75s.75-.71,1.11-1.08l1.27-1.25a12.34,12.34,0,0,0,2.16-2.67c.27-.5.43-1,.66-1.55a10.88,10.88,0,0,1,.52-1c4.16-4,8.15-5.95,10.19-4.52a2.51,2.51,0,0,1,.7.75c0,.17,0,.33.07.5a7.11,7.11,0,0,1-.16,2.3,10.45,10.45,0,0,1-.8,2.1,14.53,14.53,0,0,0-1.14,2.39,8.82,8.82,0,0,0-.29,2.4,12.34,12.34,0,0,1-.22,2.43,3.33,3.33,0,0,1-1,1.88,6,6,0,0,1-1.41.7,6.11,6.11,0,0,0-1.56,1.05,1.72,1.72,0,0,0-.68,1.2c0,.51.12,1,.12,1.52a4.2,4.2,0,0,1-1.55,3.1,16.4,16.4,0,0,1-3.18,1.94c-.58.32-1.17.64-1.73,1-.28.19-.56.38-.83.59s-.58.5-.88.75a15.28,15.28,0,0,1-4.13,2.23c-.73.3-1.45.61-2.14,1-1-.75-1.42-2.27-1.24-4.28A10.37,10.37,0,0,0,1490.65,525.49Z"
              fill="#396039"
            />
            <path
              d="M1512.84,502.25q-2.43,2.58-4.72,5.28c-1.55,1.78-3.06,3.6-4.53,5.44q-4.42,5.53-8.39,11.41a137.6,137.6,0,0,0-7.32,12.11c-1,2.11-2.14,4.2-3,6.39s-1.73,4.39-2.55,6.61a83,83,0,0,1,5.38-13.11,136.21,136.21,0,0,1,7.24-12.19q4-5.85,8.49-11.35A141.06,141.06,0,0,1,1512.84,502.25Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1480.55,525.82a.79.79,0,0,0,.34-.56.9.9,0,0,0-.35-.65,6.46,6.46,0,0,0-1-.8v0a5.26,5.26,0,0,0,.62-.63,1,1,0,0,0,.27-.55c0-.4-.41-.59-.72-.71s-.44-.17-.67-.24c-.14-.69-.28-1.41-.4-2.16l.4-.1a6.76,6.76,0,0,0,1-.32,1.73,1.73,0,0,0,.67-.42.18.18,0,0,0,0-.27c-.31-.17-.64-.29-1-.44a2.13,2.13,0,0,1-.84-.54c-.24-.31-.06-.67,0-1a.94.94,0,0,0-.39-.68l-.32-.27c-.1-.89-.18-1.8-.25-2.74l.55-.16a2.94,2.94,0,0,0,1.25-.65,1.06,1.06,0,0,0,.19-1.26,2.45,2.45,0,0,0-1.26-.93,6.61,6.61,0,0,0-.79-.25c0-.32-.11-.64-.16-1,0-.91,0-1.85,0-2.79a.44.44,0,0,1,.08-.11,1.46,1.46,0,0,1,.52-.32,3,3,0,0,0,.78-.59.17.17,0,0,0,0-.24c-.37-.31-1.27-.77-1-1.39.07-.18.36-.2.51-.28a.5.5,0,0,0,.27-.56c-.12-.42-.63-.58-.86-.91s.4-.5.65-.52a7.7,7.7,0,0,0,1.36,0,.17.17,0,0,0,0-.3c-.69-.5-1.39-1-2.12-1.44.13-2,.32-3.83.56-5.58l.31.09a.17.17,0,0,0,.2-.15,6.71,6.71,0,0,1,1.33.69q.36.25.72.54c.16.13.39-.09.23-.23a6.94,6.94,0,0,0-.76-.58,13.9,13.9,0,0,0-1.91-1.16c.22-1.53.49-3,.8-4.27a6.93,6.93,0,0,1,1.64.86l.59.54a.17.17,0,0,0,.24-.24,4.68,4.68,0,0,0-.62-.56c-.39-.36-.77-.72-1.18-1.06l-.47-.38a27.15,27.15,0,0,1,1.17-3.65,21.07,21.07,0,0,0,2.2.89.18.18,0,0,0,.21-.16,3.6,3.6,0,0,0-.81-1.81,7.34,7.34,0,0,0-.7-.79c.81-1.36,1.7-2.12,2.63-2.12,1.9,0,3.61,3.1,4.81,8.06-.49.44-1,.91-1.44,1.38a.17.17,0,0,0,.2.26,11.3,11.3,0,0,0,1.39-1c.3,1.31.56,2.73.79,4.26a23.93,23.93,0,0,0-1.47,3,.17.17,0,0,0,0,.23c.62.32,1.27.58,1.9.87.2,2.16.32,4.45.36,6.83a12.79,12.79,0,0,0-1.32,3.09,6.85,6.85,0,0,0-.11,2.47c0,.41.09.82.11,1.23s0,.81.07,1.21c.11.76.4,1.49.53,2.25a1.84,1.84,0,0,1-.5,1.86,4.35,4.35,0,0,1-1.39.53.63.63,0,0,0-.41.35.79.79,0,0,0,.11.63,3.37,3.37,0,0,0,1.43,1.21l.52.29c-1.16,7.32-3.25,12.21-5.63,12.21-1.46,0-2.82-1.86-3.92-5A2.16,2.16,0,0,0,1480.55,525.82Z"
              fill="#659965"
            />
            <path
              d="M1484.14,488.46c.29,10.57.37,21.14.49,31.71V536c-.06,5.29,0,10.59-.48,15.85.26-2.63.2-5.28.24-7.92l0-7.93-.1-15.85Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1473.79,500a2.05,2.05,0,0,1,1.25,0c.23.3.46.6.71.89s.73.88,1.13,1.29a11.66,11.66,0,0,1,1.08,1.25,10.47,10.47,0,0,1,1.25,2.27,10.34,10.34,0,0,0,1.3,2.62c.51.63,1.16,1.1,1.72,1.67l0,0c.14.38.27.77.4,1.16a30.82,30.82,0,0,1,1.55,7.48q0,.3-.06.6a47.47,47.47,0,0,0-1,5.41,2.16,2.16,0,0,1-1,.78c-2.59.85-6.56-4.16-8.87-11.19S1471.2,500.89,1473.79,500Z"
              fill="#3b6818"
            />
            <path
              d="M1473.29,514.3s11.13,5.67,11.51,34.93"
              fill="none"
              stroke="#78bf3a"
              strokeMiterlimit="10"
              strokeWidth="0.33"
            />
            <path
              d="M1475.54,502.69a6.31,6.31,0,0,1,1.54,2.91,13.59,13.59,0,0,0,.63,3.08,4.25,4.25,0,0,0,1,1.38c.4.37.83.69,1.22,1.08a3.24,3.24,0,0,1,.89,1.48,2.79,2.79,0,0,1,0,1.32,6.21,6.21,0,0,0-.2,1.37,4.52,4.52,0,0,0,.56,1.85,5.14,5.14,0,0,1,.56,1.9,4,4,0,0,1-.21,1.21,3.62,3.62,0,0,0-.08,1.32,3.47,3.47,0,0,0,.41,1.21,2.56,2.56,0,0,1,.37,1,3.33,3.33,0,0,1-.48,1.55l-.08.16a1.18,1.18,0,0,1-.45.27c-2,.67-5.58-4.48-7.89-11.51s-2.54-13.27-.5-13.94a1.49,1.49,0,0,1,.86,0A13.26,13.26,0,0,0,1475.54,502.69Z"
              fill="#659965"
            />
          </g>
        </g> */}
        {/* <g>
          <g>
            <rect
              x="1301.11"
              y="495.8"
              width="3.91"
              height="69.2"
              rx="0.64"
              fill="#a39bb2"
            />
            <g>
              <ellipse
                cx="1303.07"
                cy="477.47"
                rx="8.03"
                ry="1.58"
                fill="url(#b8580682-6b84-40ef-a816-addbb2c78d9a)"
              />
              <ellipse
                cx="1303.07"
                cy="480.22"
                rx="11.07"
                ry="2.07"
                fill="url(#a91146ca-867d-40cd-83a3-64884ff3213e)"
              />
              <ellipse
                cx="1303.07"
                cy="482.96"
                rx="14.12"
                ry="2.56"
                fill="url(#ede75fb9-28de-4db1-9167-0d039d0d3856)"
              />
              <ellipse
                cx="1303.07"
                cy="485.7"
                rx="17.16"
                ry="3.05"
                fill="url(#e67dbd60-aedf-40cb-9c80-fd876c627070)"
              />
              <ellipse
                cx="1303.07"
                cy="488.44"
                rx="20.2"
                ry="3.54"
                fill="url(#b9e5a795-68d2-48db-9265-aa16acdb0960)"
              />
              <ellipse
                cx="1303.07"
                cy="491.18"
                rx="23.25"
                ry="4.03"
                fill="url(#b43e5881-efd0-44f5-b77b-772f0515daf6)"
              />
              <ellipse
                cx="1303.07"
                cy="495.22"
                rx="20.96"
                ry="3.69"
                fill="url(#ad0b7413-ada2-45ef-ae93-836dbc21acfd)"
              />
              <ellipse
                cx="1303.07"
                cy="499.26"
                rx="18.68"
                ry="3.35"
                fill="url(#b96144d9-6141-4ff6-8aca-783e8dde018f)"
              />
              <ellipse
                cx="1303.07"
                cy="503.29"
                rx="16.39"
                ry="3"
                fill="url(#f53b0898-5b99-443c-bd81-7a293f2986db)"
              />
              <ellipse
                cx="1303.07"
                cy="507.33"
                rx="14.11"
                ry="2.66"
                fill="url(#e6845bf2-9d4a-4443-a1e7-3efc01fd199c)"
              />
              <ellipse
                cx="1303.07"
                cy="511.37"
                rx="11.82"
                ry="2.32"
                fill="url(#a0a0d3ef-26d9-47c6-838b-68e36d75b29e)"
              />
            </g>
          </g>
          <circle
            cx="1302.67"
            cy="493.16"
            r="39"
            fill="url(#b487387a-e7bd-428a-9e49-f8bb91e24037)"
          />
        </g> */}
        {/* <g>
          <path
            d="M1076.53,616.6s-20.69,24.45-54.48,14.07c0,0-8.49.66-1.26-14.11s15.16-5.75,15.16-5.75-.93-12.15,10.51-11.25,4.32,11.21,8.62,12.49,5.24-10,10-11.95,13.47,3,12.48,9.73Z"
            fill="#396039"
          />
          <path
            d="M1049.21,623.82c-4.62,0,.21-6.22-1.7-7.76s-5.13,4-7.75,7.08-5.41,0-8.81-4-4.78-7.13-10.16-2.58-13.3,10.88-6.37,14,17.83,6,22,2.6,10.89,3.3,12.65.94S1053.21,623.84,1049.21,623.82Z"
            fill="#426642"
          />
          <path
            d="M1045.7,610.05c3.15-3.09.4-8.17-3.1-6.6s-.78,7.09-4,8.79-8.81,3.67-2.55,5.61S1045.7,610.05,1045.7,610.05Z"
            fill="#2f4f2f"
          />
          <path
            d="M1067.37,619.89c4.61-2.87,5.5-7.88,4.08-9s-5.3-4.44-6.45,0-8.71,5.75-7.09,9.87S1067.37,619.89,1067.37,619.89Z"
            fill="#2f4f2f"
          />
          <path
            d="M1063.65,630.38c5.76-5.21,10.14-3.52,9.74-6.86s.52-6.53-3.28-7.35-4.15,3.75-7.45,4.51-3.87-4.91-7-.7S1056.85,636.54,1063.65,630.38Z"
            fill="#426642"
          />
          <path
            d="M1054.55,633.92c6.49-2,4.37-5,2.31-6.62s-6,2.9-8.62,1.72-7.89,3.19-10.44,1.13-7.74-6-10.27-1.95-6.52,12.83,1.19,8.88,15.77-1,19.49-1.08A12.22,12.22,0,0,0,1054.55,633.92Z"
            fill="#659965"
          />
        </g> */}
        {/* <g>
          <path
            d="M951.77,618.6s20.69,24.45,54.48,14.07c0,0,8.49.66,1.26-14.11s-15.16-5.75-15.16-5.75.93-12.15-10.51-11.25-4.31,11.21-8.61,12.49-5.25-10-10-11.95-13.47,3-12.48,9.73Z"
            fill="#396039"
          />
          <path
            d="M979.1,625.82c4.61,0-.22-6.22,1.7-7.76s5.12,4,7.74,7.08,5.42,0,8.82-4,4.77-7.13,10.15-2.58,13.3,10.88,6.37,14-17.82,6-22,2.6-10.89,3.3-12.65.94S975.09,625.84,979.1,625.82Z"
            fill="#426642"
          />
          <path
            d="M982.6,612.05c-3.14-3.09-.4-8.17,3.1-6.6s.78,7.09,4,8.79,8.81,3.67,2.55,5.61S982.6,612.05,982.6,612.05Z"
            fill="#2f4f2f"
          />
          <path
            d="M960.93,621.89c-4.61-2.87-5.49-7.88-4.08-9s5.31-4.44,6.45,0,8.71,5.75,7.1,9.87S960.93,621.89,960.93,621.89Z"
            fill="#2f4f2f"
          />
          <path
            d="M964.65,632.38c-5.76-5.21-10.13-3.52-9.73-6.86s-.53-6.53,3.28-7.35,4.14,3.75,7.45,4.51,3.86-4.91,7-.7S971.46,638.54,964.65,632.38Z"
            fill="#426642"
          />
          <path
            d="M973.75,635.92c-6.49-2-4.37-5-2.31-6.62s6,2.9,8.62,1.72,7.9,3.19,10.45,1.13,7.73-6,10.26-1.95,6.52,12.83-1.19,8.88-15.77-1-19.48-1.08A12.23,12.23,0,0,1,973.75,635.92Z"
            fill="#659965"
          />
        </g> */}
        <g>
          <path
            d="M1037.88,675.22s12.71,26.37-3.36,40.78h24.93s-9.13-4.48-10.25-7.37-1.25-21.51-9.08-32.56Z"
            fill="#6d3b2f"
          />
          <path
            d="M1041.08,676.51s1.34-15.22,10-17.2c0,0-3.62,3.09-1.81,5.6,0,0,3.31-7.47,13.39-5.6,0,0-11.62,1.42-13.39,8.45a8.13,8.13,0,0,1,8.91,2.71S1041.07,670.76,1041.08,676.51Z"
            fill="#43771c"
          />
          <path
            d="M1037.88,676.51s-1.34-15.22-10-17.2c0,0,3.62,3.09,1.81,5.6,0,0-3.3-7.47-13.39-5.6,0,0,11.62,1.42,13.39,8.45a8.13,8.13,0,0,0-8.91,2.71S1037.89,670.76,1037.88,676.51Z"
            fill="#43771c"
          />
          <path
            d="M1042.14,679.2s-16.82-21.91-35.59-13.48c0,0,10.62-.4,11.51.85,0,0-3.48-.55-3.31,2.88,0,0,7.22-3.46,9.25-1.75,0,0-4,.8-3.76,2.49,0,0,6.43-1.53,8.09,0,0,0-4.15,1-2.5,3,0,0,5.69-2.47,8.42,1.22,0,0-2.38-.81-3.11.07C1031.14,674.41,1041.72,677,1042.14,679.2Z"
            fill="#529022"
          />
          <path
            d="M1039,678.91s14.41-20.73,33.82-10.2c0,0-10.54-1.48-11.29-.29a3.31,3.31,0,0,1,3.56,3.28s-7.49-4.27-9.32-2.73c0,0,4,1.23,4,2.93,0,0-6.51-2.22-8-.86,0,0,4.2,1.42,2.77,3.29,0,0-5.87-3.1-8.2.4,0,0,2.27-.59,3.08.38C1049.42,675.11,1039.22,676.65,1039,678.91Z"
            fill="#529022"
          />
          <path
            d="M1042.52,678s-16-12.71-28.92,4.58c0,0,8-5.6,8.83-4.84a3.86,3.86,0,0,0-2.07,4.38s4.95-6.86,6.74-6.22c0,0-2.92,2.73-2.48,4.24,0,0,4.64-4.63,6.11-4,0,0-3,3-1.45,4.07,0,0,3.94-5.15,6.55-3,0,0-1.92.39-2.34,1.58C1033.49,678.82,1041.87,676.07,1042.52,678Z"
            fill="#426642"
          />
          <path
            d="M1037.88,678.44s19-14.62,33.87,4.57c0,0-9.25-6.13-10.27-5.27a4.16,4.16,0,0,1,2.35,4.89s-5.68-7.61-7.8-6.86c0,0,3.37,3,2.83,4.72,0,0-5.36-5.12-7.1-4.4,0,0,3.46,3.29,1.62,4.55,0,0-4.52-5.72-7.63-3.2,0,0,2.25.4,2.72,1.74C1048.47,679.18,1038.68,676.25,1037.88,678.44Z"
            fill="#426642"
          />
          <path
            d="M1040.66,678.9c-.69-8.8,8.59-19,15.27-18.41,0,0-13.19-2.56-15.32,5.34,0,0,2.67-10.47,6.56-10.47,0,0-8.59-2.35-10.14,4.91,0,0-4.64-9.07,0-10.3,0,0-10.62,2.83-6.08,9.88,0,0-4.86-4.06-10.63,1.28,0,0,11.32.21,13.24,4.7,0,0-5-3.21-7.9,0,0,0,10-1.66,12.49,5.71Z"
            fill="#529022"
          />
          <path
            d="M1040.12,678.9c-.54-6.79,6.63-14.69,11.77-14.2,0,0-10.17-2-11.81,4.12,0,0,2.05-8.07,5.06-8.07,0,0-6.63-1.81-7.82,3.79,0,0-3.58-7,0-7.95,0,0-8.19,2.18-4.69,7.62,0,0-3.75-3.13-8.2,1,0,0,8.73.17,10.21,3.63,0,0-3.83-2.47-6.09,0,0,0,7.7-1.28,9.63,4.4Z"
            fill="#396039"
          />
          <path
            d="M1039.26,681.58s.78-8.8,5.81-9.94c0,0-2.09,1.79-1,3.24,0,0,1.91-4.32,7.74-3.24,0,0-6.72.82-7.74,4.89a4.69,4.69,0,0,1,5.15,1.56S1039.26,678.26,1039.26,681.58Z"
            fill="#659965"
          />
          <path
            d="M1040.77,680.3s-.78-8.8-5.81-9.94c0,0,2.09,1.79,1,3.24,0,0-1.91-4.32-7.74-3.24,0,0,6.72.82,7.74,4.89a4.69,4.69,0,0,0-5.15,1.56S1040.77,677,1040.77,680.3Z"
            fill="#659965"
          />
          <path
            d="M1049.2,708.63c-1-2.59-1.21-18-7-29,.78,3.06,6,24,3.28,30-1.07,2.39,2.39,4.61,7.17,6.46h6.76S1050.32,711.52,1049.2,708.63Z"
            fill="#17216b"
            opacity="0.24"
          />
        </g>
        <g>
          <path
            d="M1086.51,663.22s-12.7,26.37,3.37,40.78H1065s9.13-4.48,10.25-7.37,1.24-21.51,9.08-32.56Z"
            fill="#6d3b2f"
          />
          <path
            d="M1083.32,664.51s-1.34-15.22-10-17.2c0,0,3.61,3.09,1.8,5.6,0,0-3.3-7.47-13.39-5.6,0,0,11.63,1.42,13.39,8.45a8.11,8.11,0,0,0-8.9,2.71S1083.33,658.76,1083.32,664.51Z"
            fill="#43771c"
          />
          <path
            d="M1086.51,664.51s1.35-15.22,10-17.2c0,0-3.62,3.09-1.81,5.6,0,0,3.3-7.47,13.39-5.6,0,0-11.62,1.42-13.39,8.45a8.13,8.13,0,0,1,8.91,2.71S1086.5,658.76,1086.51,664.51Z"
            fill="#43771c"
          />
          <path
            d="M1082.25,667.2s16.83-21.91,35.6-13.48c0,0-10.62-.4-11.51.85,0,0,3.48-.55,3.3,2.88,0,0-7.21-3.46-9.25-1.75,0,0,4,.8,3.77,2.49,0,0-6.43-1.53-8.09,0,0,0,4.15,1,2.49,3,0,0-5.68-2.47-8.41,1.22,0,0,2.38-.81,3.11.07C1093.26,662.41,1082.68,665,1082.25,667.2Z"
            fill="#529022"
          />
          <path
            d="M1085.37,666.91s-14.41-20.73-33.82-10.2c0,0,10.53-1.48,11.29-.29a3.31,3.31,0,0,0-3.56,3.28s7.49-4.27,9.32-2.73c0,0-4,1.23-4,2.93,0,0,6.51-2.22,8-.86,0,0-4.2,1.42-2.77,3.29,0,0,5.87-3.1,8.19.4,0,0-2.26-.59-3.08.38C1075,663.11,1085.17,664.65,1085.37,666.91Z"
            fill="#529022"
          />
          <path
            d="M1081.88,666s16-12.71,28.92,4.58c0,0-8-5.6-8.83-4.84a3.86,3.86,0,0,1,2.07,4.38s-5-6.86-6.74-6.22c0,0,2.91,2.73,2.48,4.24,0,0-4.64-4.63-6.12-4,0,0,3,3,1.46,4.07,0,0-3.94-5.15-6.55-3,0,0,1.92.39,2.34,1.58C1090.91,666.82,1082.53,664.07,1081.88,666Z"
            fill="#426642"
          />
          <path
            d="M1086.52,666.44s-19-14.62-33.88,4.57c0,0,9.26-6.13,10.28-5.27a4.16,4.16,0,0,0-2.35,4.89s5.68-7.61,7.79-6.86c0,0-3.36,3-2.83,4.72,0,0,5.36-5.12,7.11-4.4,0,0-3.47,3.29-1.63,4.55,0,0,4.53-5.72,7.63-3.2,0,0-2.24.4-2.72,1.74C1075.92,667.18,1085.71,664.25,1086.52,666.44Z"
            fill="#426642"
          />
          <path
            d="M1083.74,666.9c.69-8.8-8.6-19-15.27-18.41,0,0,13.19-2.56,15.32,5.34,0,0-2.67-10.47-6.56-10.47,0,0,8.59-2.35,10.14,4.91,0,0,4.64-9.07,0-10.3,0,0,10.62,2.83,6.08,9.88,0,0,4.86-4.06,10.62,1.28,0,0-11.31.21-13.23,4.7,0,0,5-3.21,7.9,0,0,0-10-1.66-12.49,5.71Z"
            fill="#529022"
          />
          <path
            d="M1084.28,666.9c.54-6.79-6.63-14.69-11.77-14.2,0,0,10.16-2,11.81,4.12,0,0-2.06-8.07-5.06-8.07,0,0,6.63-1.81,7.82,3.79,0,0,3.58-7,0-7.95,0,0,8.19,2.18,4.69,7.62,0,0,3.75-3.13,8.19,1,0,0-8.72.17-10.2,3.63,0,0,3.82-2.47,6.09,0,0,0-7.7-1.28-9.64,4.4Z"
            fill="#396039"
          />
          <path
            d="M1085.13,669.58s-.77-8.8-5.8-9.94c0,0,2.09,1.79,1.05,3.24,0,0-1.91-4.32-7.75-3.24,0,0,6.72.82,7.75,4.89a4.69,4.69,0,0,0-5.15,1.56S1085.14,666.26,1085.13,669.58Z"
            fill="#659965"
          />
          <path
            d="M1083.63,668.3s.78-8.8,5.81-9.94c0,0-2.1,1.79-1,3.24,0,0,1.91-4.32,7.74-3.24,0,0-6.72.82-7.74,4.89a4.69,4.69,0,0,1,5.15,1.56S1083.63,665,1083.63,668.3Z"
            fill="#659965"
          />
          <path
            d="M1075.2,696.63c1-2.59,1.21-18,7-29-.78,3.06-6,24-3.28,30,1.07,2.39-2.39,4.61-7.18,6.46H1065S1074.08,699.52,1075.2,696.63Z"
            fill="#17216b"
            opacity="0.24"
          />
        </g>
        <ellipse
          cx="1305.17"
          cy="624.5"
          rx="11.5"
          ry="4.5"
          fill="#141c66"
          opacity="0.28"
        />
        <g>
          <path d="M1288.16,610.3v0h0Z" fill="#ef6291" />
          <path
            d="M1315.28,604.78v0c0,1.53-6.42,2.75-13.79,2.75s-13.33-1.24-13.33-2.77Z"
            fill="#ef6291"
          />
          <path
            d="M1309.85,621.8h0a.22.22,0,0,1,0,.08c0,.9-3.51,1.63-7.85,1.63s-7.84-.73-7.84-1.63a.22.22,0,0,1,0-.08h-.08l-5.9-11.58h27.12Z"
            fill="#c1567f"
          />
          <path
            d="M1315.28,604.8c0,1.53-6.42,2.75-13.79,2.75s-13.33-1.24-13.33-2.77,6-2.77,13.33-2.77,13.73,1.25,13.79,2.77Z"
            fill="#c16f86"
          />
          <path
            d="M1313.75,604.8c0,1.35-5.69,2.44-12.23,2.44s-11.83-1.1-11.83-2.46,5.29-2.46,11.83-2.46S1313.75,603.44,1313.75,604.8Z"
            fill="#513126"
          />
          <path
            d="M1309.66,622.22c-9.42.46-9.11-11.1-9.11-11.1l-12.15-.43,5.66,11.11h.08a.22.22,0,0,0,0,.08c0,.9,3.51,1.63,7.84,1.63C1305.76,623.51,1308.91,623,1309.66,622.22Z"
            fill="#602b8e"
            opacity="0.35"
          />
          <path
            d="M1315.28,604.8v5.52c0,1.52-6.21,2.77-13.54,2.77s-13.53-1.25-13.58-2.77v-5.54c0,1.53,6,2.77,13.33,2.77S1315.28,606.33,1315.28,604.8Z"
            fill="#ef6291"
          />
          <path
            d="M1295.34,607.24h0c-4.27-.46-7.18-1.38-7.18-2.45v5.54c0,1.3,4.58,2.4,10.5,2.69C1294.26,612,1295.34,607.24,1295.34,607.24Z"
            fill="#602b8e"
            opacity="0.35"
          />
          <g>
            <path
              d="M1292.3,602.18c-2.16.42-4.16-4.58-5.59-6.84,0,0,3.77.23,5.63,1.43S1295.22,601.6,1292.3,602.18Z"
              fill="#1c7f19"
            />
            <path
              d="M1286.71,595.34a35.75,35.75,0,0,1,3.88,2.69,17.55,17.55,0,0,1,1.74,1.6,3.56,3.56,0,0,1,1.14,2,2.16,2.16,0,0,0-.46-1.06,7.15,7.15,0,0,0-.76-.89,19.9,19.9,0,0,0-1.76-1.55C1289.28,597.15,1288,596.26,1286.71,595.34Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1305.09,600c-2.16.42-4.16-4.58-5.59-6.83,0,0,3.78.23,5.64,1.43S1308,599.39,1305.09,600Z"
              fill="#1c7f19"
            />
            <path
              d="M1299.5,593.13a35.35,35.35,0,0,1,3.89,2.68,20.35,20.35,0,0,1,1.74,1.61,3.49,3.49,0,0,1,1.13,2,2,2,0,0,0-.46-1.06,7.07,7.07,0,0,0-.75-.89,20,20,0,0,0-1.77-1.55C1302.08,594.93,1300.78,594,1299.5,593.13Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1299.86,606.77c-2.16.42-4.16-4.57-5.59-6.83,0,0,3.78.23,5.63,1.43S1302.78,606.2,1299.86,606.77Z"
              fill="#1b6817"
            />
            <path
              d="M1294.27,599.94a36.79,36.79,0,0,1,3.89,2.68,18.84,18.84,0,0,1,1.73,1.61,3.48,3.48,0,0,1,1.14,2,2,2,0,0,0-.46-1,5.86,5.86,0,0,0-.76-.89,17.36,17.36,0,0,0-1.76-1.56C1296.85,601.74,1295.55,600.85,1294.27,599.94Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1294.21,606.77c-1.55.3-3-3.29-4-4.91a10.7,10.7,0,0,1,4,1C1295.58,603.74,1296.31,606.36,1294.21,606.77Z"
              fill="#1b6817"
            />
            <path
              d="M1290.19,601.86a26.67,26.67,0,0,1,2.8,1.92,13.61,13.61,0,0,1,1.24,1.16,2.51,2.51,0,0,1,.82,1.45,2.73,2.73,0,0,0-.87-1.4,13.45,13.45,0,0,0-1.27-1.11C1292.05,603.15,1291.11,602.51,1290.19,601.86Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1294,596.5c-1.57.31-3-3.33-4.06-5a10.89,10.89,0,0,1,4.09,1C1295.35,593.44,1296.09,596.08,1294,596.5Z"
              fill="#1c7f19"
            />
            <path
              d="M1289.91,591.53a26.17,26.17,0,0,1,2.82,2,14,14,0,0,1,1.26,1.17,2.55,2.55,0,0,1,.83,1.47,2.85,2.85,0,0,0-.88-1.41,12.57,12.57,0,0,0-1.29-1.13C1291.78,592.85,1290.84,592.2,1289.91,591.53Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1295.75,604.06c2.15.43,4.16-4.57,5.59-6.83,0,0-3.78.23-5.64,1.43S1292.83,603.49,1295.75,604.06Z"
              fill="#1c7f19"
            />
            <path
              d="M1301.34,597.23c-1.28.91-2.58,1.81-3.78,2.81a17.48,17.48,0,0,0-1.77,1.56,5.8,5.8,0,0,0-.75.89,2,2,0,0,0-.46,1.06,3.46,3.46,0,0,1,1.13-2,20.35,20.35,0,0,1,1.74-1.61A36.79,36.79,0,0,1,1301.34,597.23Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1306.93,597.42c2.16.42,4.16-4.58,5.59-6.84,0,0-3.77.23-5.63,1.43S1304,596.84,1306.93,597.42Z"
              fill="#1c7f19"
            />
            <path
              d="M1312.52,590.58c-1.28.92-2.57,1.81-3.78,2.82A19.9,19.9,0,0,0,1307,595a7.15,7.15,0,0,0-.76.89,2.16,2.16,0,0,0-.46,1.06,3.56,3.56,0,0,1,1.14-2,17.55,17.55,0,0,1,1.74-1.6A35.75,35.75,0,0,1,1312.52,590.58Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1295.76,598.39c1.57.3,3-3.33,4.07-5a10.92,10.92,0,0,0-4.1,1C1294.38,595.33,1293.64,598,1295.76,598.39Z"
              fill="#1b6817"
            />
            <path
              d="M1299.83,593.42c-.94.67-1.88,1.31-2.75,2.05a11.49,11.49,0,0,0-1.28,1.13,2.8,2.8,0,0,0-.89,1.41,2.57,2.57,0,0,1,.83-1.47,14,14,0,0,1,1.26-1.17A27.33,27.33,0,0,1,1299.83,593.42Z"
              fill="#30562e"
            />
          </g>
          <path
            d="M1295.6,606.15a9,9,0,0,1-1.64-3,5.23,5.23,0,0,1-.24-1.77,4.13,4.13,0,0,1,.16-.92l.3-.81a13.39,13.39,0,0,0,.54-3.26c.06-1.13.09-2.26.08-3.41a16.34,16.34,0,0,1,.43,3.42,10.35,10.35,0,0,1-.44,3.47,4.58,4.58,0,0,0-.45,1.55,5.19,5.19,0,0,0,.11,1.61A13.8,13.8,0,0,0,1295.6,606.15Z"
            fill="#30562e"
          />
          <path
            d="M1301.72,596.14c-.1.41-.35.84-.46,1.19a3.88,3.88,0,0,0,.37,1.11,9.39,9.39,0,0,1,.72,2.54,11.59,11.59,0,0,1-.63,5.17c0-.86.08-1.72.1-2.57a21,21,0,0,0-.11-2.52,13.82,13.82,0,0,0-.56-2.46c-.05-.21-.12-.41-.17-.63a1.3,1.3,0,0,1,0-.74C1301.22,596.8,1301.47,596.52,1301.72,596.14Z"
            fill="#30562e"
          />
          <path
            d="M1307,591.63a6.61,6.61,0,0,1-1,1.49c-.38.45-.74.92-.59,1.4a3.64,3.64,0,0,0,.86,1.39,5.4,5.4,0,0,1,.93,1.65,9.92,9.92,0,0,1,.44,3.65,13.84,13.84,0,0,1-.61,3.57,32.91,32.91,0,0,0,.11-3.57,12.13,12.13,0,0,0-.55-3.43,4.8,4.8,0,0,0-.79-1.48,3.75,3.75,0,0,1-.89-1.7,1.38,1.38,0,0,1,.23-1,3.85,3.85,0,0,1,.64-.69A9.38,9.38,0,0,0,1307,591.63Z"
            fill="#30562e"
          />
          <g>
            <path
              d="M1308.14,603.64c1.57.31,3-3.33,4.06-5a10.89,10.89,0,0,0-4.09,1C1306.76,600.58,1306,603.23,1308.14,603.64Z"
              fill="#1b6817"
            />
            <path
              d="M1306.69,606c1.57.31,3-3.33,4.06-5a10.8,10.8,0,0,0-4.09,1C1305.31,603,1304.57,605.61,1306.69,606Z"
              fill="#1b6817"
            />
            <path
              d="M1312.2,598.67c-.93.67-1.87,1.32-2.74,2.05a12.57,12.57,0,0,0-1.29,1.13,2.85,2.85,0,0,0-.88,1.41,2.55,2.55,0,0,1,.83-1.47,14,14,0,0,1,1.26-1.17A26.17,26.17,0,0,1,1312.2,598.67Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1303.23,605.7c2.16.43,4.16-4.57,5.59-6.83,0,0-3.78.23-5.63,1.43S1300.31,605.13,1303.23,605.7Z"
              fill="#1c7f19"
            />
            <path
              d="M1308.82,598.87c-1.28.92-2.58,1.81-3.78,2.82a17.27,17.27,0,0,0-1.76,1.55,5.86,5.86,0,0,0-.76.89,2.07,2.07,0,0,0-.46,1.06,3.47,3.47,0,0,1,1.14-2,16.5,16.5,0,0,1,1.74-1.6A35.75,35.75,0,0,1,1308.82,598.87Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1300.41,599c-1.57.31-3-3.32-4.06-5a10.89,10.89,0,0,1,4.09,1C1301.79,596,1302.53,598.63,1300.41,599Z"
              fill="#1c7f19"
            />
            <path
              d="M1296.35,594.08a28.31,28.31,0,0,1,2.82,1.95,12.65,12.65,0,0,1,1.26,1.17,2.49,2.49,0,0,1,.83,1.47,2.78,2.78,0,0,0-.89-1.42,12.6,12.6,0,0,0-1.28-1.13C1298.22,595.39,1297.28,594.74,1296.35,594.08Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M1307.12,594c-1.72-.65-.26-3.4-.46-4.55s1.52-1.9,2.89-1.23.57,1.85,1.69,2.55S1308.51,594.54,1307.12,594Z"
              fill="#bc784a"
            />
            <path
              d="M1306.37,594.16c-1.82-.2-1.08-3.23-1.55-4.29s1-2.23,2.49-1.92,1,1.64,2.26,2S1307.84,594.31,1306.37,594.16Z"
              fill="#ed863a"
            />
            <path
              d="M1306.29,594.4c-1.83-.2-.24-2.73-.71-3.79s.08-2,1.57-1.73.94.87,2.19,1.27S1307.76,594.55,1306.29,594.4Z"
              fill="#bc784a"
            />
            <path
              d="M1306.53,594.91c-1.62-.48-.44-2.81-.69-3.76s1.29-1.62,2.58-1.1.64,1.51,1.71,2.05S1307.84,595.3,1306.53,594.91Z"
              fill="#ed863a"
            />
          </g>
          <g>
            <path
              d="M1301.36,594.93c-1.8-.33-.83-3.3-1.22-4.4s1.17-2.13,2.63-1.71.88,1.71,2.1,2.21S1302.82,595.21,1301.36,594.93Z"
              fill="#bc784a"
            />
            <path
              d="M1300.64,595.2c-1.82.13-1.61-3-2.25-4s.61-2.37,2.13-2.33,1.27,1.44,2.57,1.61S1302.12,595.1,1300.64,595.2Z"
              fill="#ed863a"
            />
            <path
              d="M1300.6,595.45c-1.82.13-.69-2.64-1.34-3.6s-.26-2,1.26-2,1.07.69,2.37.86S1302.09,595.35,1300.6,595.45Z"
              fill="#bc784a"
            />
            <path
              d="M1300.93,595.92c-1.68-.19-.91-2.7-1.31-3.58s1-1.83,2.35-1.55.88,1.38,2,1.73S1302.29,596.07,1300.93,595.92Z"
              fill="#ed863a"
            />
          </g>
          <g>
            <path
              d="M1295.88,593.21c1.8-.34.82-3.31,1.21-4.4s-1.17-2.14-2.63-1.71-.88,1.71-2.09,2.21S1294.41,593.48,1295.88,593.21Z"
              fill="#bc784a"
            />
            <path
              d="M1296.59,593.48c1.83.13,1.61-3,2.25-4s-.61-2.37-2.13-2.33-1.26,1.44-2.57,1.61S1295.11,593.37,1296.59,593.48Z"
              fill="#ed863a"
            />
            <path
              d="M1296.63,593.73c1.83.13.7-2.64,1.34-3.6s.26-2-1.26-2-1.07.7-2.37.87S1295.15,593.62,1296.63,593.73Z"
              fill="#bc784a"
            />
            <path
              d="M1296.31,594.19c1.67-.19.9-2.69,1.31-3.58s-1-1.82-2.36-1.54-.88,1.37-2,1.72S1295,594.35,1296.31,594.19Z"
              fill="#ed863a"
            />
          </g>
          <ellipse
            cx="1309"
            cy="602.3"
            rx="1.15"
            ry="0.35"
            transform="translate(7.05 1219.71) rotate(-50.08)"
            fill="#b2eff9"
            opacity="0.25"
          />
        </g>
        <g>
          <path
            d="M1011.53,776.6s-20.69,24.45-54.48,14.07c0,0-8.49.66-1.26-14.11S971,770.81,971,770.81s-.93-12.15,10.51-11.25,4.32,11.21,8.62,12.49,5.24-10,9.95-11.95,13.47,3,12.48,9.73Z"
            fill="#396039"
          />
          <path
            d="M984.21,783.82c-4.62,0,.21-6.22-1.7-7.76s-5.13,4-7.75,7.08-5.41,0-8.81-4-4.78-7.13-10.16-2.58-13.3,10.88-6.37,14,17.83,6,22,2.6,10.89,3.3,12.65.94S988.21,783.84,984.21,783.82Z"
            fill="#426642"
          />
          <path
            d="M980.7,770.05c3.15-3.09.4-8.17-3.1-6.6s-.78,7.09-4,8.79-8.81,3.67-2.55,5.61S980.7,770.05,980.7,770.05Z"
            fill="#2f4f2f"
          />
          <path
            d="M1002.37,779.89c4.61-2.87,5.5-7.88,4.08-9s-5.3-4.44-6.45,0-8.71,5.75-7.09,9.87S1002.37,779.89,1002.37,779.89Z"
            fill="#2f4f2f"
          />
          <path
            d="M998.65,790.38c5.76-5.21,10.14-3.52,9.74-6.86s.52-6.53-3.28-7.35-4.15,3.75-7.45,4.51-3.87-4.91-7-.7S991.85,796.54,998.65,790.38Z"
            fill="#426642"
          />
          <path
            d="M989.55,793.92c6.49-2,4.37-5,2.31-6.62s-6,2.9-8.62,1.72-7.89,3.19-10.44,1.13-7.74-6-10.27-1.95S956,801,963.72,797.08s15.77-1,19.49-1.08A12.22,12.22,0,0,0,989.55,793.92Z"
            fill="#659965"
          />
        </g>
        <g>
          <path
            d="M1388.12,793.07l-2.24-.85a55.91,55.91,0,0,1,4.44,15.78h3.94C1393,802.79,1391.16,797.36,1388.12,793.07Z"
            fill="#6d3b2f"
          />
          <path
            d="M1389.08,793.51s1.34-15.22,10-17.2c0,0-3.62,3.09-1.81,5.6,0,0,3.31-7.47,13.39-5.6,0,0-11.62,1.42-13.39,8.45a8.13,8.13,0,0,1,8.91,2.71S1389.07,787.76,1389.08,793.51Z"
            fill="#43771c"
          />
          <path
            d="M1385.88,793.51s-1.34-15.22-10-17.2c0,0,3.62,3.09,1.81,5.6,0,0-3.3-7.47-13.39-5.6,0,0,11.62,1.42,13.39,8.45a8.13,8.13,0,0,0-8.91,2.71S1385.89,787.76,1385.88,793.51Z"
            fill="#43771c"
          />
          <path
            d="M1390.14,796.2s-16.82-21.91-35.59-13.48c0,0,10.62-.4,11.51.85,0,0-3.48-.55-3.31,2.88,0,0,7.22-3.46,9.25-1.75,0,0-4,.8-3.76,2.49,0,0,6.43-1.53,8.09,0,0,0-4.15,1-2.5,3,0,0,5.69-2.47,8.42,1.22,0,0-2.38-.81-3.11.07C1379.14,791.41,1389.72,794,1390.14,796.2Z"
            fill="#529022"
          />
          <path
            d="M1387,795.91s14.41-20.73,33.82-10.2c0,0-10.54-1.48-11.29-.29a3.31,3.31,0,0,1,3.56,3.28s-7.49-4.27-9.32-2.73c0,0,4,1.23,4,2.93,0,0-6.51-2.22-8-.86,0,0,4.2,1.42,2.77,3.29,0,0-5.87-3.1-8.2.4,0,0,2.27-.59,3.08.38C1397.42,792.11,1387.22,793.65,1387,795.91Z"
            fill="#529022"
          />
          <path
            d="M1390.52,795s-16-12.71-28.92,4.58c0,0,8-5.6,8.83-4.84a3.86,3.86,0,0,0-2.07,4.38s5-6.86,6.74-6.22c0,0-2.92,2.73-2.48,4.24,0,0,4.64-4.63,6.11-4,0,0-3,3-1.45,4.07,0,0,3.94-5.15,6.55-3,0,0-1.92.39-2.34,1.58C1381.49,795.82,1389.87,793.07,1390.52,795Z"
            fill="#426642"
          />
          <path
            d="M1385.88,795.44s19-14.62,33.87,4.57c0,0-9.25-6.13-10.27-5.27a4.16,4.16,0,0,1,2.35,4.89s-5.68-7.61-7.8-6.86c0,0,3.37,3,2.83,4.72,0,0-5.36-5.12-7.1-4.4,0,0,3.46,3.29,1.62,4.55,0,0-4.52-5.72-7.63-3.2,0,0,2.25.4,2.72,1.74C1396.47,796.18,1386.68,793.25,1385.88,795.44Z"
            fill="#426642"
          />
          <path
            d="M1388.66,795.9c-.69-8.8,8.59-19,15.27-18.41,0,0-13.19-2.56-15.32,5.34,0,0,2.67-10.47,6.56-10.47,0,0-8.59-2.35-10.14,4.91,0,0-4.64-9.07,0-10.3,0,0-10.62,2.83-6.08,9.88,0,0-4.86-4.06-10.63,1.28,0,0,11.32.21,13.24,4.7,0,0-5-3.21-7.9,0,0,0,10-1.66,12.49,5.71Z"
            fill="#529022"
          />
          <path
            d="M1388.12,795.9c-.54-6.79,6.63-14.69,11.77-14.2,0,0-10.17-2-11.81,4.12,0,0,2.05-8.07,5.06-8.07,0,0-6.63-1.81-7.82,3.79,0,0-3.58-7,0-7.95,0,0-8.19,2.18-4.69,7.62,0,0-3.75-3.13-8.2,1,0,0,8.73.17,10.21,3.63,0,0-3.83-2.47-6.09,0,0,0,7.7-1.28,9.63,4.4Z"
            fill="#396039"
          />
          <path
            d="M1387.26,798.58s.78-8.8,5.81-9.94c0,0-2.09,1.79-1,3.24,0,0,1.91-4.32,7.74-3.24,0,0-6.72.82-7.74,4.89a4.69,4.69,0,0,1,5.15,1.56S1387.26,795.26,1387.26,798.58Z"
            fill="#659965"
          />
          <path
            d="M1388.77,797.3s-.78-8.8-5.81-9.94c0,0,2.09,1.79,1,3.24,0,0-1.91-4.32-7.74-3.24,0,0,6.72.82,7.74,4.89a4.69,4.69,0,0,0-5.15,1.56S1388.77,794,1388.77,797.3Z"
            fill="#659965"
          />
          <path
            d="M1390.24,796.58c.34,1.33,1.51,6,2.5,11.42h1.52A50,50,0,0,0,1390.24,796.58Z"
            fill="#17216b"
            opacity="0.24"
          />
        </g>
        <g>
          <g>
            <path
              d="M1443.87,730.91c-.07-.53-.11-1.07-.14-1.59a12.94,12.94,0,0,1,.07-2.33c.1-.69.3-1.36.46-2a6.6,6.6,0,0,0,.2-1.82c0-.67-.22-1.31-.27-2a4.79,4.79,0,0,1,.14-1.51c.13-.34.27-.68.42-1a8.35,8.35,0,0,1,.58-.88.14.14,0,0,0,0-.18,7.07,7.07,0,0,1,7.88-3.4,2,2,0,0,0,.54.55,4.71,4.71,0,0,0,1.63.6,3.15,3.15,0,0,1,1.69.88,15.57,15.57,0,0,1,1.14,1.83,3.39,3.39,0,0,0,.76.8,3.6,3.6,0,0,0,.93.44,2.55,2.55,0,0,1,1,.6,8.19,8.19,0,0,1,.66.89,7.55,7.55,0,0,0,.79.81,6,6,0,0,1,.57.66c.84,1.1.9,2.57,1.21,3.87a5.62,5.62,0,0,0,.91,2.15,10.28,10.28,0,0,0,1.36,1.36,4.51,4.51,0,0,1,1,1.19,5,5,0,0,1,.46,2.16c.09,1.78-.06,3.56.15,5.33a10.85,10.85,0,0,0,.22,1.29c.1.4.24.8.32,1.21a2.72,2.72,0,0,1-.12,1.57,13.18,13.18,0,0,1-.73,1.33,4,4,0,0,0-.67,2.12,3.34,3.34,0,0,1,0,1.18,2.54,2.54,0,0,1-.51.85,10.36,10.36,0,0,0-1.31,1.5.16.16,0,0,0,0,.08,6.91,6.91,0,0,1-1.82,1.1,7.06,7.06,0,0,1-3.06.48,10.56,10.56,0,0,0-2-1.08,23.83,23.83,0,0,1-2.44-1,6.87,6.87,0,0,1-1.08-.7c-.33-.27-.62-.58-1-.84-.66-.49-1.41-.85-2-1.38a3.59,3.59,0,0,1-.87-1.07c-.2-.39-.35-.81-.53-1.22a3.86,3.86,0,0,0-.67-1.1,10.31,10.31,0,0,0-.94-.93c-.43-.39-.88-.76-1.31-1.14a34.21,34.21,0,0,1-1.6-3.27,6.78,6.78,0,0,1,.58-1.35c.35-.65.75-1.26,1.11-1.91a.18.18,0,0,0-.09-.25,17.26,17.26,0,0,1-1.76-.4,2.35,2.35,0,0,1-1.13-.63,2.22,2.22,0,0,1-.44-.78C1444,731.59,1443.94,731.25,1443.87,730.91Z"
              fill="#396039"
            />
            <path
              d="M1449.39,715.82a123,123,0,0,1,8,17.36c2.31,6,4.3,12,6.14,18.13s3.36,12.32,4.83,18.53c.72,3.11,1.36,6.23,2,9.35l1.76,9.41-1.91-9.38c-.71-3.11-1.36-6.23-2.1-9.33-1.5-6.2-3.06-12.39-4.93-18.49s-3.75-12.18-6-18.15l-1.76-4.44c-.62-1.47-1.21-2.95-1.87-4.4A91,91,0,0,0,1449.39,715.82Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1479.36,758.17c0-.77,0-1.53-.09-2.29a50.74,50.74,0,0,1,3.5-11.25c.38-.37.75-.74,1.09-1.14s.78-1,1.16-1.55l1.33-1.82a15.68,15.68,0,0,0,2.14-3.75c.24-.67.33-1.37.51-2.06.12-.46.28-.92.44-1.37,4.36-5.84,8.93-9,11.76-7.68a3.26,3.26,0,0,1,1,.79c.06.2.12.41.17.62a8.8,8.8,0,0,1,.27,2.89,12.63,12.63,0,0,1-.57,2.77,18.92,18.92,0,0,0-.94,3.2,11.91,11.91,0,0,0,.12,3,14.38,14.38,0,0,1,.22,3.07,4.11,4.11,0,0,1-.88,2.53,7.47,7.47,0,0,1-1.62,1.16,8,8,0,0,0-1.72,1.62,2.13,2.13,0,0,0-.6,1.63c.07.63.34,1.23.45,1.86a5.25,5.25,0,0,1-1.31,4.17,20.34,20.34,0,0,1-3.55,3.06c-.67.51-1.33,1-2,1.59-.31.28-.62.58-.91.89s-.62.74-.94,1.11a19,19,0,0,1-4.69,3.61c-.85.52-1.68,1-2.47,1.64-1.43-.72-2.22-2.53-2.4-5.08A12.34,12.34,0,0,0,1479.36,758.17Z"
              fill="#2f4f2f"
            />
            <path
              d="M1502.27,724.81q-2.51,3.69-4.82,7.5t-4.54,7.68q-4.4,7.77-8.14,15.87a172.28,172.28,0,0,0-6.65,16.53c-.86,2.85-1.81,5.67-2.46,8.57-.82,2.86-1.26,5.81-1.82,8.73a104.58,104.58,0,0,1,4.07-17.37,170.32,170.32,0,0,1,6.56-16.6q3.81-8.09,8.25-15.84C1495.68,734.72,1498.83,729.66,1502.27,724.81Z"
              fill="#87f139"
            />
          </g>
          <g>
            <path
              d="M1479.65,762.49c.1-.6.16-1.21.22-1.81a39.67,39.67,0,0,1,4.17-8.37c.34-.24.68-.49,1-.75s.75-.71,1.11-1.08l1.27-1.25a12.34,12.34,0,0,0,2.16-2.67c.27-.5.43-1,.66-1.55a10.88,10.88,0,0,1,.52-1c4.16-4,8.15-6,10.19-4.52a2.51,2.51,0,0,1,.7.75c0,.17,0,.33.07.5a7.11,7.11,0,0,1-.16,2.3,10.45,10.45,0,0,1-.8,2.1,14.53,14.53,0,0,0-1.14,2.39,8.82,8.82,0,0,0-.29,2.4,12.34,12.34,0,0,1-.22,2.43,3.33,3.33,0,0,1-1,1.88,6,6,0,0,1-1.41.7,6.11,6.11,0,0,0-1.56,1.05,1.72,1.72,0,0,0-.68,1.2c0,.51.12,1,.12,1.52a4.2,4.2,0,0,1-1.55,3.1,16.4,16.4,0,0,1-3.18,1.94c-.58.32-1.17.64-1.73,1-.28.19-.56.38-.83.59s-.58.5-.88.75a15.28,15.28,0,0,1-4.13,2.23c-.73.3-1.45.61-2.14,1-1-.75-1.42-2.27-1.24-4.28A10.37,10.37,0,0,0,1479.65,762.49Z"
              fill="#396039"
            />
            <path
              d="M1501.84,739.25q-2.43,2.58-4.72,5.28c-1.55,1.78-3.06,3.6-4.53,5.44q-4.42,5.53-8.39,11.41a137.6,137.6,0,0,0-7.32,12.11c-1,2.11-2.14,4.2-3,6.39s-1.73,4.39-2.55,6.61a83,83,0,0,1,5.38-13.11,136.21,136.21,0,0,1,7.24-12.19q4-5.85,8.49-11.35A141.06,141.06,0,0,1,1501.84,739.25Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1469.55,762.82a.79.79,0,0,0,.34-.56.9.9,0,0,0-.35-.65,6.46,6.46,0,0,0-1-.8v0a5.26,5.26,0,0,0,.62-.63,1,1,0,0,0,.27-.55c0-.4-.41-.59-.72-.71s-.44-.17-.67-.24c-.14-.69-.28-1.41-.4-2.16l.4-.1a6.76,6.76,0,0,0,1-.32,1.73,1.73,0,0,0,.67-.42.18.18,0,0,0,0-.27c-.31-.17-.64-.29-1-.44a2.13,2.13,0,0,1-.84-.54c-.24-.31-.06-.67,0-1a.94.94,0,0,0-.39-.68l-.32-.27c-.1-.89-.18-1.8-.25-2.74l.55-.16a2.94,2.94,0,0,0,1.25-.65,1.06,1.06,0,0,0,.19-1.26,2.45,2.45,0,0,0-1.26-.93,6.61,6.61,0,0,0-.79-.25c0-.32-.11-.64-.16-1,0-.91,0-1.85,0-2.79a.44.44,0,0,1,.08-.11,1.46,1.46,0,0,1,.52-.32,3,3,0,0,0,.78-.59.17.17,0,0,0,0-.24c-.37-.31-1.27-.77-1-1.39.07-.18.36-.2.51-.28a.5.5,0,0,0,.27-.56c-.12-.42-.63-.58-.86-.91s.4-.5.65-.52a7.7,7.7,0,0,0,1.36,0,.17.17,0,0,0,0-.3c-.69-.5-1.39-1-2.12-1.44.13-2,.32-3.83.56-5.58l.31.09a.17.17,0,0,0,.2-.15,6.71,6.71,0,0,1,1.33.69l.72.54c.16.13.39-.09.23-.23a6.94,6.94,0,0,0-.76-.58,13.9,13.9,0,0,0-1.91-1.16c.22-1.53.49-3,.8-4.27a6.93,6.93,0,0,1,1.64.86l.59.54a.17.17,0,0,0,.24-.24,4.68,4.68,0,0,0-.62-.56c-.39-.36-.77-.72-1.18-1.06l-.47-.38a27.15,27.15,0,0,1,1.17-3.65,21.07,21.07,0,0,0,2.2.89.18.18,0,0,0,.21-.16,3.6,3.6,0,0,0-.81-1.81,7.34,7.34,0,0,0-.7-.79c.81-1.36,1.7-2.12,2.63-2.12,1.9,0,3.61,3.1,4.81,8.06-.49.44-1,.91-1.44,1.38a.17.17,0,0,0,.2.26,11.3,11.3,0,0,0,1.39-1c.3,1.31.56,2.73.79,4.26a23.93,23.93,0,0,0-1.47,3,.17.17,0,0,0,0,.23c.62.32,1.27.58,1.9.87.2,2.16.32,4.45.36,6.83a12.79,12.79,0,0,0-1.32,3.09,6.85,6.85,0,0,0-.11,2.47c0,.41.09.82.11,1.23s0,.81.07,1.21c.11.76.4,1.49.53,2.25a1.84,1.84,0,0,1-.5,1.86,4.35,4.35,0,0,1-1.39.53.63.63,0,0,0-.41.35.79.79,0,0,0,.11.63,3.37,3.37,0,0,0,1.43,1.21l.52.29c-1.16,7.32-3.25,12.21-5.63,12.21-1.46,0-2.82-1.86-3.92-5A2.16,2.16,0,0,0,1469.55,762.82Z"
              fill="#659965"
            />
            <path
              d="M1473.14,725.46c.29,10.57.37,21.14.49,31.71V773c-.06,5.29,0,10.59-.48,15.85.26-2.63.2-5.28.24-7.92l0-7.93-.1-15.85Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1462.79,737a2.05,2.05,0,0,1,1.25,0c.23.3.46.6.71.89.36.44.73.88,1.13,1.29a11.66,11.66,0,0,1,1.08,1.25,10.47,10.47,0,0,1,1.25,2.27,10.34,10.34,0,0,0,1.3,2.62c.51.63,1.16,1.1,1.72,1.67l0,0c.14.38.27.77.4,1.16a30.82,30.82,0,0,1,1.55,7.48q0,.3-.06.6a47.47,47.47,0,0,0-1,5.41,2.16,2.16,0,0,1-1,.78c-2.59.85-6.56-4.16-8.87-11.19S1460.2,737.89,1462.79,737Z"
              fill="#3b6818"
            />
            <path
              d="M1462.29,751.3s11.13,5.67,11.51,34.93"
              fill="none"
              stroke="#78bf3a"
              strokeMiterlimit="10"
              strokeWidth="0.33"
            />
            <path
              d="M1464.54,739.69a6.31,6.31,0,0,1,1.54,2.91,13.59,13.59,0,0,0,.63,3.08,4.25,4.25,0,0,0,1,1.38c.4.37.83.69,1.22,1.08a3.24,3.24,0,0,1,.89,1.48,2.79,2.79,0,0,1,0,1.32,6.21,6.21,0,0,0-.2,1.37,4.52,4.52,0,0,0,.56,1.85,5.14,5.14,0,0,1,.56,1.9,4,4,0,0,1-.21,1.21,3.62,3.62,0,0,0-.08,1.32,3.47,3.47,0,0,0,.41,1.21,2.56,2.56,0,0,1,.37,1,3.33,3.33,0,0,1-.48,1.55l-.08.16a1.18,1.18,0,0,1-.45.27c-2,.67-5.58-4.48-7.89-11.51s-2.54-13.27-.5-13.94a1.49,1.49,0,0,1,.86,0A13.26,13.26,0,0,0,1464.54,739.69Z"
              fill="#659965"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1464.56,756.86a9,9,0,0,0,.09-1,7.41,7.41,0,0,0,0-1.49c-.06-.45-.19-.88-.29-1.31a4.25,4.25,0,0,1-.13-1.17c0-.43.14-.85.17-1.27a2.94,2.94,0,0,0-.09-1c-.08-.22-.17-.43-.27-.64s-.24-.38-.37-.57a.08.08,0,0,1,0-.12,4.82,4.82,0,0,0-2.28-2,4.71,4.71,0,0,0-2.79-.19,1.5,1.5,0,0,1-.35.36,3.23,3.23,0,0,1-1,.38,2,2,0,0,0-1.09.56,11,11,0,0,0-.73,1.18,2.21,2.21,0,0,1-.49.52,2.53,2.53,0,0,1-.6.28,1.59,1.59,0,0,0-.63.39,6.07,6.07,0,0,0-.43.57,6.14,6.14,0,0,1-.5.52,4.83,4.83,0,0,0-.37.42,6.36,6.36,0,0,0-.78,2.5,3.68,3.68,0,0,1-.59,1.38,6.57,6.57,0,0,1-.87.88,2.83,2.83,0,0,0-.66.76,3.19,3.19,0,0,0-.3,1.39c-.06,1.15,0,2.29-.1,3.43a7.56,7.56,0,0,1-.14.83c-.06.26-.15.51-.2.78a1.74,1.74,0,0,0,.07,1c.13.3.32.57.47.86a2.58,2.58,0,0,1,.44,1.36,2.16,2.16,0,0,0,0,.76,1.79,1.79,0,0,0,.33.55,7,7,0,0,1,.85,1,.13.13,0,0,1,0,.06,4.47,4.47,0,0,0,3.15,1,6.9,6.9,0,0,1,1.32-.69c.52-.22,1.07-.4,1.57-.67a5.1,5.1,0,0,0,.69-.45c.21-.18.4-.38.62-.54.43-.32.91-.55,1.31-.89a2.33,2.33,0,0,0,.56-.69c.13-.25.23-.52.34-.79a2.64,2.64,0,0,1,.43-.7,6.9,6.9,0,0,1,.61-.6l.84-.74a21.54,21.54,0,0,0,1-2.1,4.84,4.84,0,0,0-.37-.87c-.23-.42-.49-.81-.71-1.23a.11.11,0,0,1,0-.16c.38-.08.77-.14,1.14-.25a1.62,1.62,0,0,0,.72-.41,1.46,1.46,0,0,0,.28-.5C1464.47,757.3,1464.52,757.08,1464.56,756.86Z"
              fill="#396039"
            />
            <path
              d="M1461,747.15a58.69,58.69,0,0,0-2.7,5.52c-.84,1.88-1.6,3.78-2.34,5.7-1.46,3.83-2.72,7.74-3.88,11.68s-2.2,7.91-3.17,11.89c-.47,2-.9,4-1.35,6l-1.23,6,1.13-6.06c.44-2,.85-4,1.31-6,1-4,1.93-8,3.11-11.92s2.46-7.84,3.95-11.67A78.54,78.54,0,0,1,1461,747.15Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1441.72,774.4c0-.49,0-1,.06-1.47a32.38,32.38,0,0,0-2.25-7.24c-.24-.24-.48-.48-.7-.73s-.5-.67-.75-1-.57-.78-.85-1.17a10,10,0,0,1-1.38-2.42c-.15-.43-.21-.88-.33-1.32s-.18-.59-.28-.88c-2.81-3.76-5.75-5.82-7.57-4.94a2.14,2.14,0,0,0-.66.5l-.12.4a6.09,6.09,0,0,0-.17,1.86,8.41,8.41,0,0,0,.37,1.78,11.79,11.79,0,0,1,.6,2.06,7.56,7.56,0,0,1-.07,2,8.68,8.68,0,0,0-.14,2,2.69,2.69,0,0,0,.56,1.64,5.45,5.45,0,0,0,1,.74,5.27,5.27,0,0,1,1.12,1,1.43,1.43,0,0,1,.38,1.05c0,.41-.22.79-.29,1.2a3.39,3.39,0,0,0,.84,2.68,13.46,13.46,0,0,0,2.29,2c.43.33.85.66,1.26,1,.2.19.4.38.59.58s.4.48.6.71a12.26,12.26,0,0,0,3,2.33c.54.33,1.08.67,1.59,1,.92-.46,1.43-1.63,1.54-3.27A8.19,8.19,0,0,1,1441.72,774.4Z"
              fill="#2f4f2f"
            />
            <path
              d="M1427,752.93a135,135,0,0,1,11.46,19.89,111.38,111.38,0,0,1,4.22,10.69,68,68,0,0,1,2.62,11.18,77.34,77.34,0,0,0-2.76-11.13,110.07,110.07,0,0,0-4.28-10.65q-2.4-5.2-5.23-10.21C1431.11,759.38,1429.13,756.1,1427,752.93Z"
              fill="#87f139"
            />
          </g>
          <g>
            <path
              d="M1441.54,777.18c-.06-.38-.11-.77-.14-1.16a26.15,26.15,0,0,0-2.68-5.39c-.23-.16-.44-.31-.65-.48s-.47-.46-.71-.69-.55-.54-.82-.81a7.62,7.62,0,0,1-1.38-1.72c-.18-.32-.28-.66-.43-1s-.21-.44-.33-.65c-2.68-2.59-5.25-3.83-6.57-2.91a1.89,1.89,0,0,0-.45.48c0,.11,0,.22,0,.32a4.59,4.59,0,0,0,.11,1.48A6.47,6.47,0,0,0,1428,766a8.78,8.78,0,0,1,.73,1.55,5.7,5.7,0,0,1,.19,1.54,7.42,7.42,0,0,0,.14,1.56,2.17,2.17,0,0,0,.66,1.21,3.79,3.79,0,0,0,.9.45,4.07,4.07,0,0,1,1,.68,1.08,1.08,0,0,1,.43.77c0,.33-.07.65-.07,1a2.66,2.66,0,0,0,1,2,10.15,10.15,0,0,0,2,1.25c.38.21.76.41,1.12.65a6.3,6.3,0,0,1,.53.37c.2.15.38.33.57.49a9.75,9.75,0,0,0,2.66,1.43c.47.19.93.39,1.38.62.66-.47.91-1.45.79-2.75A6.84,6.84,0,0,1,1441.54,777.18Z"
              fill="#396039"
            />
            <path
              d="M1427.26,762.23a104.73,104.73,0,0,1,11.52,14.12,86.05,86.05,0,0,1,4.66,7.84,52.93,52.93,0,0,1,3.47,8.44,61.83,61.83,0,0,0-3.59-8.37,89,89,0,0,0-4.71-7.79q-2.55-3.78-5.4-7.34C1431.3,766.76,1429.34,764.44,1427.26,762.23Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1448,777.4a.55.55,0,0,1-.22-.36.62.62,0,0,1,.22-.43,5.52,5.52,0,0,1,.66-.51v0a3,3,0,0,1-.4-.4.67.67,0,0,1-.17-.36c0-.26.26-.37.46-.45l.43-.16c.1-.44.18-.91.26-1.39l-.25-.06a5.17,5.17,0,0,1-.63-.21,1.16,1.16,0,0,1-.43-.27.11.11,0,0,1,0-.17c.19-.11.41-.19.61-.29a1.38,1.38,0,0,0,.54-.34c.16-.2,0-.43,0-.66a.62.62,0,0,1,.25-.44l.2-.17c.07-.57.12-1.16.16-1.77l-.35-.1a1.87,1.87,0,0,1-.8-.42.67.67,0,0,1-.13-.8,1.57,1.57,0,0,1,.81-.6,5.08,5.08,0,0,1,.51-.17c0-.2.07-.41.11-.61l0-1.8,0-.07a1.08,1.08,0,0,0-.34-.21,1.7,1.7,0,0,1-.5-.38.1.1,0,0,1,0-.15c.24-.2.81-.5.65-.9,0-.11-.23-.12-.33-.18a.32.32,0,0,1-.17-.36c.07-.27.4-.37.55-.58s-.26-.33-.42-.33a6.47,6.47,0,0,1-.88,0c-.09,0-.09-.15,0-.2.45-.32.9-.64,1.37-.92-.09-1.27-.21-2.47-.37-3.59l-.19.05a.1.1,0,0,1-.13-.09,4.65,4.65,0,0,0-.86.44c-.16.11-.31.23-.46.35s-.26-.06-.15-.15a4.49,4.49,0,0,1,.49-.37,9.61,9.61,0,0,1,1.23-.75c-.15-1-.32-1.9-.52-2.74a4,4,0,0,0-1.05.55l-.38.34c-.11.09-.25,0-.16-.15a4.48,4.48,0,0,1,.4-.36c.25-.23.5-.46.76-.68l.3-.25a16.57,16.57,0,0,0-.75-2.34,14.26,14.26,0,0,1-1.41.56.11.11,0,0,1-.14-.1,2.31,2.31,0,0,1,.52-1.16c.14-.17.29-.35.45-.51-.52-.87-1.09-1.36-1.69-1.36-1.22,0-2.32,2-3.1,5.18.32.29.63.59.93.89a.11.11,0,0,1-.13.17,8.14,8.14,0,0,1-.9-.64c-.19.84-.36,1.76-.5,2.74a18.31,18.31,0,0,1,1,1.94.12.12,0,0,1,0,.15c-.4.21-.81.37-1.22.56-.13,1.39-.21,2.86-.23,4.39a8.53,8.53,0,0,1,.85,2,4.73,4.73,0,0,1,.07,1.59c0,.27-.06.53-.07.8s0,.51,0,.77c-.07.49-.25,1-.34,1.45a1.21,1.21,0,0,0,.33,1.2,2.74,2.74,0,0,0,.89.34.38.38,0,0,1,.26.22.54.54,0,0,1-.07.41,2.12,2.12,0,0,1-.92.78l-.34.19c.75,4.71,2.09,7.85,3.63,7.85.94,0,1.81-1.19,2.52-3.22Z"
              fill="#659965"
            />
            <path
              d="M1445.73,753.35l-.1,20.41-.07,10.2,0,5.1c0,1.7,0,3.41.15,5.1-.32-3.39-.27-6.8-.31-10.2v-10.2C1445.49,767,1445.54,760.15,1445.73,753.35Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1452.39,760.8a1.36,1.36,0,0,0-.8,0c-.15.2-.3.39-.46.58s-.47.56-.73.82a10.69,10.69,0,0,0-.7.81,7.4,7.4,0,0,0-.8,1.46,6.84,6.84,0,0,1-.84,1.69c-.32.4-.74.7-1.1,1.07l0,0c-.09.25-.18.5-.26.75a20.14,20.14,0,0,0-1,4.82c0,.12,0,.25,0,.38a29.83,29.83,0,0,1,.61,3.48,1.34,1.34,0,0,0,.67.5c1.66.55,4.22-2.67,5.71-7.2S1454.05,761.35,1452.39,760.8Z"
              fill="#3b6818"
            />
            <path
              d="M1452.71,770s-7.16,3.65-7.41,22.49"
              fill="none"
              stroke="#78bf3a"
              strokeMiterlimit="10"
              strokeWidth="0.21"
            />
            <path
              d="M1451.26,762.51a4.13,4.13,0,0,0-1,1.87,8.92,8.92,0,0,1-.4,2,2.81,2.81,0,0,1-.65.89c-.26.24-.54.45-.79.7a2.09,2.09,0,0,0-.57.95,1.62,1.62,0,0,0,0,.85,3.66,3.66,0,0,1,.12.88,2.94,2.94,0,0,1-.36,1.19,3.36,3.36,0,0,0-.36,1.22,2.45,2.45,0,0,0,.14.78,2.45,2.45,0,0,1,0,.86,2.13,2.13,0,0,1-.26.77,1.59,1.59,0,0,0-.24.67,2,2,0,0,0,.31,1,.31.31,0,0,0,0,.1.64.64,0,0,0,.29.18c1.31.43,3.59-2.88,5.08-7.41s1.63-8.54.31-9a.87.87,0,0,0-.55,0A8.68,8.68,0,0,1,1451.26,762.51Z"
              fill="#659965"
            />
          </g>
        </g>
        <g transform="translate(-20 0)">
          <path
            d="M195,448.35c3.58-5.92,4.81-7.26,3.28-11.25s-3-.58-1.46-8.08-4.28-9.72-6.91-10-15.11,7-13,11,3,15.28.74,16.22S190.82,455.32,195,448.35Z"
            fill="#396039"
          />
          <path
            d="M192.63,434.59c-.11-3.23,4.75-4.51,3.17-6s-3.46-5.27-5-3.28-2.7,4.92-3.87,3.28-2.46-1.7-3.22,0-.12,3.81-1.93,3.28-2.64.29-2.4,2.05,1.58,1.06,2.75,3.16,6.44,1.82,5.56.65S192.63,434.59,192.63,434.59Z"
            fill="#447244"
          />
          <path
            d="M201.71,429c2.63-4.16,6.32-8,10-4.39s-2.46,10,0,12.47,1.94,8.9,0,9.14-11.12.23-13.52,1.35-5.51-3-5.57-7S201.71,429,201.71,429Z"
            fill="#6b996b"
          />
          <path
            d="M187.83,453.68c6.17,4.7,6.62-11.66,0-10.25s-8.78,1-10.89-1.93-7.38,2.22-7.55,3.68,1.52,6.39,5.15,7.79S184.14,450.86,187.83,453.68Z"
            fill="#447244"
          />
          <path
            d="M200.58,457c-6.17,4.71-6.62-11.65,0-10.24s8.78,1,10.89-1.94,7.38,2.23,7.56,3.69-1.53,6.39-5.16,7.79S204.27,454.14,200.58,457Z"
            fill="#447244"
          />
          <path
            d="M208.27,451.33c.88-1.75,3.45,1.64,3.45,1.64s-.17-2.28,1.23-3.1,2.05,1.29,2.05,1.29c.12-1.64,3.46-.12,2.52,1.83h0a7.78,7.78,0,0,1-3.65,3.26,6.49,6.49,0,0,1-2.61.34l-3.15-.8S207.39,453.09,208.27,451.33Z"
            fill="#396039"
          />
          <path
            d="M195.56,454.32c-1.23,2.17-1.93,21.67,0,30.63,0,0-5.62-1-7.38-.06-.17.58-.17.06-.17.06s7.79-27.12,1-35.08-14.17,0-14.17,0,2-4.69,6.38-5,10.43,5.33,10.72,6.44c0,0,.23-8.55-2.52-11.53s.76-5.15.76-5.15-3.63,1.11,2.23,8.72c3,3.95.88,11.3.88,11.3s1.87-5.74,6.56-4.51,7.49,6.68,11.88,6.33a23.19,23.19,0,0,1-9.25-2.75A5.42,5.42,0,0,0,195.56,454.32Z"
            fill="#704d3c"
          />
          <path
            d="M202,453.4a5.38,5.38,0,0,0-6.41.92c-.42.75-.78,3.55-1,7.27-1.4-4.85,1.12-10.61,1.92-11.12a4.4,4.4,0,0,1,3.36-.37,10.46,10.46,0,0,1,3.09,1.47Z"
            fill="#634b42"
          />
          <path
            d="M191.2,451.6c.64,1.46,1.35,5.75.55,8h0c-.15-4-.92-7.56-2.75-9.7a14.69,14.69,0,0,0-1.21-1.26l-.28-.82A10.57,10.57,0,0,1,191.2,451.6Z"
            fill="#44322c"
          />
          <path
            d="M200.67,452.49c1.69-.55,1.8-2.93,3.81-2.79s2.25,3,3.92,4.9,3,1.47,4.36,2.12-3.65,7.8-8.28,5.21-4.19-2.15-5.79-3.2S196.89,453.72,200.67,452.49Z"
            fill="#6b996b"
          />
          <g>
            <path d="M191.88,448.82c0,.1,0,.12,0,.05v-.05Z" fill="#7f2c03" />
            <path
              d="M191.81,447.78c-.21-2.72-.8-6.31-2.4-8a3.46,3.46,0,0,1-1-2.12l.8-.16a16,16,0,0,0,3.23,5.85l.13.18C192.39,445,191.91,446.62,191.81,447.78Z"
              fill="#634b42"
            />
          </g>
          <path
            d="M185.47,447.57c-1.11-1.39.11-3.44-1.64-4.43s-3.55,1.28-6,1.92-3.34-.45-4.8-.64-1.27,8.51,4,8.91,4.68.53,6.6.53S188,450.68,185.47,447.57Z"
            fill="#6b996b"
          />
          <path
            d="M187.7,431.13c1.16-1.82,2.77-3.48,4.39-1.92s-1.08,4.36,0,5.46.84,3.9,0,4-4.87.1-5.92.59-2.41-1.31-2.44-3.05S187.7,431.13,187.7,431.13Z"
            fill="#6b996b"
          />
          <path
            d="M176.17,451.39c.34.5,1.31.41,1.88.18s.89-2,1.8-1.66,1.35,1.2,2.36.91.58-1.38,1.87-1.4,2.41.47,2.45,1.14a1,1,0,0,1,0,.17h0s0,.1,0,.15a3.29,3.29,0,0,1-2.82,3c-1.92,0-1.31-.13-6.6-.53a4.2,4.2,0,0,1-1.94-.62C174.55,452.33,175.84,450.88,176.17,451.39Z"
            fill="#447244"
          />
          <path
            d="M200,458.71c1.29,0,3.87,1.41,4.22.12s2.93-1.58,3.22-1a2.55,2.55,0,0,0,2.75.88c.88-.47,1.76.7,1.36,1.16-1.63,1.85-4.38,3.53-7,2.06-3.21-1.8-4-2.14-4.69-2.53C199.49,459.18,199,458.71,200,458.71Z"
            fill="#396039"
          />
          <path
            d="M195.15,443.9c.82-1.82,2.81-1.47,4.22-1.23s1,2.1,2.11,1.23,3.57,1.23,2.64,2.75h0a21.56,21.56,0,0,0-5.92.94c-1.49.68-3.25-.63-4.38-2.67l-.5-1h0S194.33,445.71,195.15,443.9Z"
            fill="#447244"
          />
          <path
            d="M210,442.78c-.53-1.64,1.81-3,0-3s-4.81,1.81-4.51-.82-.53-4-2.52-3.87-3.51-4.09-2.4-5.06-6.21,1.84-3,4.6,4.39,1.87,4.28,3.16,0,4,2.45,4.39-.69,3.75,1.15,4.51S211.43,447.18,210,442.78Z"
            fill="#447244"
          />
          <path
            d="M188,485s.48-1.69,1.1-4.33c4.89-2.51,5.24-10.68,5.25-10.92a82.7,82.7,0,0,0,1.2,15.25s-5.62-1-7.38-.06C188,485.47,188,485,188,485Z"
            fill="#44322c"
          />
          <path
            d="M193.84,484.7a29.74,29.74,0,0,0-.72-4.65,30.87,30.87,0,0,1-.07-4.71c.18-3.14.48-6.26.62-9.4,0-.78.09-1.56.1-2.34a8.66,8.66,0,0,0,0-1.15c-.06-.36-.19-.75-.27-1.13a13.29,13.29,0,0,1-.39-2.34,4.81,4.81,0,0,1,.31-2.37c.72-1.37,1.31-2.93,2.65-3.88a3.88,3.88,0,0,1,2.29-.55,10.23,10.23,0,0,1,2.34.32,10.81,10.81,0,0,0-2.34-.24,3.8,3.8,0,0,0-2.19.61c-1.26.92-1.85,2.46-2.54,3.84a4.74,4.74,0,0,0-.26,2.25,13.74,13.74,0,0,0,.41,2.29c.09.39.22.74.3,1.15a8.2,8.2,0,0,1,.05,1.2c0,.79,0,1.58-.07,2.36-.18,3.14-.52,6.27-.74,9.39a33.22,33.22,0,0,0,0,4.68A30.52,30.52,0,0,1,193.84,484.7Z"
            fill="#44322c"
          />
          <path
            d="M192.6,469.69a14,14,0,0,0,0,1.94,2.83,2.83,0,0,1-.12,1,2.93,2.93,0,0,1-.51.87,5.23,5.23,0,0,0-1.45,3.4,7.47,7.47,0,0,0,0,1.89,15,15,0,0,0,.5,1.85,15.82,15.82,0,0,1,.41,3.87,21,21,0,0,0-.67-3.8,11,11,0,0,1-.56-1.87,8.21,8.21,0,0,1-.05-2,5.45,5.45,0,0,1,1.59-3.54,2.49,2.49,0,0,0,.52-.77,2.71,2.71,0,0,0,.15-.91A14,14,0,0,1,192.6,469.69Z"
            fill="#44322c"
          />
          <path
            d="M192.6,444.8c.07.75.36,1.44.4,2.21a8.2,8.2,0,0,1-.15,1.09,4.42,4.42,0,0,0,.21,1.06,10.54,10.54,0,0,1,.63,4.43c-.09.78-.4,1.46-.47,2.18a14.55,14.55,0,0,0-.12,2.19,27.32,27.32,0,0,0,.5,4.41,20.4,20.4,0,0,1-.77-4.39,13,13,0,0,1,.07-2.25c.07-.77.38-1.48.45-2.18a11,11,0,0,0-.55-4.32,4.29,4.29,0,0,1-.17-1.13c0-.43.21-.72.2-1.1C192.85,446.29,192.61,445.55,192.6,444.8Z"
            fill="#44322c"
          />
        </g>
        <g>
          <rect
            x="215.56"
            y="312.77"
            width="0.92"
            height="16.23"
            fill="#6c6575"
          />
          <ellipse
            cx="216.17"
            cy="312.45"
            rx="6.5"
            ry="5.99"
            fill="url(#e419dd99-7238-40ae-bd03-4aeb143be87f)"
            style={{ mixBlendMode: 'overlay' }}
          />
          <g>
            <ellipse
              cx="216.02"
              cy="308.47"
              rx="1.88"
              ry="0.37"
              fill="url(#b4b035fe-8d53-4b54-a630-f1a89c0e4291)"
            />
            <ellipse
              cx="216.02"
              cy="309.11"
              rx="2.6"
              ry="0.48"
              fill="url(#f18aa09f-03f8-4703-9671-4a72634480af)"
            />
            <ellipse
              cx="216.02"
              cy="309.76"
              rx="3.31"
              ry="0.6"
              fill="url(#b7d74724-baf7-4d29-b9fd-432755d8c985)"
            />
            <ellipse
              cx="216.02"
              cy="310.4"
              rx="4.03"
              ry="0.72"
              fill="url(#f3227212-5716-46df-b375-d253278d85c6)"
            />
            <ellipse
              cx="216.02"
              cy="311.04"
              rx="4.74"
              ry="0.83"
              fill="url(#a52441bb-4c21-4c7c-b368-806446ee3d70)"
            />
            <ellipse
              cx="216.02"
              cy="311.69"
              rx="5.45"
              ry="0.95"
              fill="url(#eff01fcc-9bdf-41f4-b121-31efba8abfbb)"
            />
            <ellipse
              cx="216.02"
              cy="312.63"
              rx="4.92"
              ry="0.87"
              fill="url(#ae15538c-f9e5-414f-a332-e5163a867b1c)"
            />
            <ellipse
              cx="216.02"
              cy="313.58"
              rx="4.38"
              ry="0.78"
              fill="url(#fad8facb-cd10-4065-8f4f-b15be47b4f04)"
            />
            <ellipse
              cx="216.02"
              cy="314.53"
              rx="3.84"
              ry="0.7"
              fill="url(#a1c10317-8150-4156-b4f4-53d97ed694af)"
            />
            <ellipse
              cx="216.02"
              cy="315.47"
              rx="3.31"
              ry="0.62"
              fill="url(#fd8a780d-94f9-4ab9-8878-4168d3e6b90c)"
            />
            <ellipse
              cx="216.02"
              cy="316.42"
              rx="2.77"
              ry="0.54"
              fill="url(#bd258222-dbd0-4a2b-bce5-f998336bbd6b)"
            />
          </g>
        </g>
        {/* <g>
          <g>
            <path
              d="M1237.83,444.88c0-.39-.08-.79-.1-1.19a8.35,8.35,0,0,1,0-1.73c.07-.51.22-1,.34-1.52a5.09,5.09,0,0,0,.15-1.35c0-.5-.16-1-.2-1.48a3.28,3.28,0,0,1,.1-1.12c.1-.26.2-.51.31-.74a5.82,5.82,0,0,1,.44-.66.1.1,0,0,0,0-.14,5.28,5.28,0,0,1,5.88-2.53,1.56,1.56,0,0,0,.4.41,3.33,3.33,0,0,0,1.22.45,2.3,2.3,0,0,1,1.25.65,11.28,11.28,0,0,1,.86,1.37,2.41,2.41,0,0,0,.56.59,2.64,2.64,0,0,0,.7.33,1.87,1.87,0,0,1,.72.45,5.21,5.21,0,0,1,.5.66,5.67,5.67,0,0,0,.59.61,4.81,4.81,0,0,1,.42.48,7.45,7.45,0,0,1,.9,2.89,4.22,4.22,0,0,0,.68,1.6,8.11,8.11,0,0,0,1,1,3.07,3.07,0,0,1,.77.88,3.78,3.78,0,0,1,.35,1.62c.06,1.32,0,2.65.11,4,0,.32.09.64.16,1s.18.59.24.9a2,2,0,0,1-.09,1.17,9.49,9.49,0,0,1-.54,1,2.92,2.92,0,0,0-.5,1.58,2.6,2.6,0,0,1,0,.88,1.86,1.86,0,0,1-.39.63,8.56,8.56,0,0,0-1,1.12.14.14,0,0,0,0,.06,4.84,4.84,0,0,1-1.36.82,5.19,5.19,0,0,1-2.28.36,7.71,7.71,0,0,0-1.53-.81,17.11,17.11,0,0,1-1.82-.77,5.22,5.22,0,0,1-.8-.52c-.25-.2-.46-.44-.72-.63-.49-.36-1-.63-1.52-1a2.71,2.71,0,0,1-.64-.79c-.16-.3-.26-.61-.4-.92a2.78,2.78,0,0,0-.5-.82,9.13,9.13,0,0,0-.7-.69c-.32-.29-.65-.56-1-.85a24,24,0,0,1-1.18-2.44,4.44,4.44,0,0,1,.43-1c.25-.49.55-.94.82-1.42,0-.06,0-.17-.06-.19-.44-.09-.89-.16-1.32-.29a1.82,1.82,0,0,1-.84-.48,1.65,1.65,0,0,1-.32-.58C1237.94,445.39,1237.88,445.13,1237.83,444.88Z"
              fill="#396039"
            />
            <path
              d="M1241.94,433.64a90.85,90.85,0,0,1,6,12.93c1.71,4.44,3.2,9,4.57,13.51s2.5,9.18,3.6,13.81c.53,2.32,1,4.65,1.52,7l1.3,7-1.42-7c-.52-2.32-1-4.65-1.56-7-1.12-4.62-2.29-9.23-3.67-13.78s-2.81-9.08-4.5-13.52c-.85-2.22-1.73-4.43-2.7-6.6A66.33,66.33,0,0,0,1241.94,433.64Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1264.28,465.2q0-.85-.06-1.71a37.63,37.63,0,0,1,2.6-8.39c.28-.27.56-.55.81-.84s.59-.77.87-1.16.66-.9,1-1.36a11.7,11.7,0,0,0,1.59-2.79c.18-.5.25-1,.38-1.53.1-.35.21-.69.33-1,3.25-4.35,6.66-6.73,8.77-5.72a2.4,2.4,0,0,1,.76.59c0,.15.09.3.13.46a6.24,6.24,0,0,1,.2,2.15,9.3,9.3,0,0,1-.43,2.07,13.93,13.93,0,0,0-.69,2.39,8.57,8.57,0,0,0,.09,2.26,10.94,10.94,0,0,1,.16,2.28,3,3,0,0,1-.66,1.9,5.71,5.71,0,0,1-1.2.86,5.7,5.7,0,0,0-1.29,1.21,1.58,1.58,0,0,0-.44,1.21c0,.47.25.92.33,1.39a4,4,0,0,1-1,3.11,16,16,0,0,1-2.65,2.27c-.5.38-1,.77-1.46,1.19-.23.21-.46.43-.68.66s-.46.56-.7.83a14.28,14.28,0,0,1-3.49,2.69c-.63.39-1.26.78-1.84,1.22-1.07-.53-1.66-1.88-1.79-3.78A9.5,9.5,0,0,0,1264.28,465.2Z"
              fill="#2f4f2f"
            />
            <path
              d="M1281.36,440.33c-2.49,3.67-4.79,7.47-7,11.32s-4.21,7.8-6.07,11.82a127.35,127.35,0,0,0-5,12.33,88.93,88.93,0,0,0-3.2,12.89,78.72,78.72,0,0,1,3-12.94,125.3,125.3,0,0,1,4.89-12.38A155.88,155.88,0,0,1,1281.36,440.33Z"
              fill="#87f139"
            />
          </g>
          <g>
            <path
              d="M1264.49,468.41c.08-.44.13-.89.17-1.34a29.81,29.81,0,0,1,3.1-6.24c.26-.18.51-.37.75-.56s.55-.53.82-.8.64-.62,1-.94a9.37,9.37,0,0,0,1.61-2c.2-.37.32-.77.49-1.15s.25-.51.39-.76c3.1-3,6.07-4.43,7.6-3.37a2,2,0,0,1,.52.56c0,.12,0,.25,0,.37a5.22,5.22,0,0,1-.11,1.72,8,8,0,0,1-.6,1.56,10.86,10.86,0,0,0-.85,1.79,7.11,7.11,0,0,0-.22,1.78,8.41,8.41,0,0,1-.16,1.81,2.43,2.43,0,0,1-.76,1.4,4.11,4.11,0,0,1-1,.52,4.85,4.85,0,0,0-1.16.79,1.3,1.3,0,0,0-.51.89c0,.38.09.75.09,1.13a3.07,3.07,0,0,1-1.16,2.31,12.16,12.16,0,0,1-2.36,1.45c-.44.24-.88.48-1.29.75a6.82,6.82,0,0,0-.62.43c-.23.18-.44.38-.66.56a11.07,11.07,0,0,1-3.08,1.67c-.54.22-1.08.45-1.59.72-.77-.56-1.06-1.69-.93-3.19A7.65,7.65,0,0,0,1264.49,468.41Z"
              fill="#396039"
            />
            <path
              d="M1281,451.1c-2.41,2.56-4.68,5.25-6.89,8s-4.28,5.58-6.25,8.5a104.44,104.44,0,0,0-5.46,9,72.61,72.61,0,0,0-4.15,9.69,61.8,61.8,0,0,1,4-9.76,100.2,100.2,0,0,1,5.4-9.09A122.38,122.38,0,0,1,1281,451.1Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1257,468.66a.58.58,0,0,0,.25-.41.68.68,0,0,0-.26-.49,4.81,4.81,0,0,0-.75-.6v0a2.92,2.92,0,0,0,.46-.47.64.64,0,0,0,.2-.41c0-.3-.3-.43-.53-.52l-.5-.19c-.11-.51-.21-1.05-.3-1.6l.29-.08a6.23,6.23,0,0,0,.73-.24,1.28,1.28,0,0,0,.49-.31.13.13,0,0,0,0-.2c-.23-.13-.48-.22-.72-.33a1.7,1.7,0,0,1-.62-.4c-.18-.23,0-.5,0-.76a.71.71,0,0,0-.29-.51l-.24-.2c-.07-.66-.13-1.35-.19-2l.41-.12a2.35,2.35,0,0,0,.94-.49.79.79,0,0,0,.14-.93,1.84,1.84,0,0,0-.94-.7,4,4,0,0,0-.59-.18c0-.24-.08-.48-.12-.72,0-.68,0-1.38,0-2.08a.22.22,0,0,1,0-.08,1.06,1.06,0,0,1,.39-.24,2.28,2.28,0,0,0,.58-.44.12.12,0,0,0,0-.18c-.27-.23-.94-.58-.75-1,0-.13.27-.15.38-.21a.36.36,0,0,0,.2-.41c-.09-.32-.47-.43-.64-.68s.3-.38.49-.38a5.69,5.69,0,0,0,1,0c.11,0,.11-.16,0-.22-.52-.37-1-.74-1.58-1.08.09-1.46.24-2.85.42-4.15l.22.06a.13.13,0,0,0,.16-.1,5.41,5.41,0,0,1,1,.5l.53.41c.12.1.3-.07.18-.17s-.37-.3-.57-.44a11.53,11.53,0,0,0-1.43-.86q.25-1.71.6-3.18a5.32,5.32,0,0,1,1.23.64c.14.14.29.27.44.4s.28-.06.17-.17a3,3,0,0,0-.46-.42c-.29-.27-.58-.54-.88-.8l-.35-.28a20.35,20.35,0,0,1,.87-2.72,14.4,14.4,0,0,0,1.64.66.13.13,0,0,0,.16-.12,2.65,2.65,0,0,0-.61-1.34,4.78,4.78,0,0,0-.52-.59c.61-1,1.27-1.58,2-1.58,1.41,0,2.68,2.31,3.58,6-.37.33-.72.68-1.07,1a.12.12,0,0,0,.15.19,8.4,8.4,0,0,0,1-.74c.23,1,.42,2,.59,3.17a19.49,19.49,0,0,0-1.1,2.25.13.13,0,0,0,0,.17c.46.24,1,.43,1.42.65.15,1.61.24,3.31.27,5.09a9.19,9.19,0,0,0-1,2.3,5,5,0,0,0-.08,1.84c0,.31.06.61.08.92s0,.6,0,.9c.09.57.3,1.11.4,1.68a1.38,1.38,0,0,1-.38,1.39,3.38,3.38,0,0,1-1,.39.48.48,0,0,0-.31.26.65.65,0,0,0,.09.47,2.52,2.52,0,0,0,1.06.9l.39.22c-.86,5.46-2.42,9.1-4.19,9.1-1.1,0-2.11-1.39-2.93-3.73A2.52,2.52,0,0,0,1257,468.66Z"
              fill="#659965"
            />
            <path
              d="M1259.65,440.82c.21,7.87.27,15.75.36,23.63v11.82c0,3.94,0,7.88-.35,11.81.18-2,.14-3.94.17-5.9l0-5.91-.08-11.82Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1251.93,449.45a1.55,1.55,0,0,1,.93,0l.53.66c.27.33.55.66.84,1a9,9,0,0,1,.81.93,8,8,0,0,1,.93,1.7,8.26,8.26,0,0,0,1,1.95c.38.47.87.82,1.28,1.24l0,0c.11.28.21.57.3.86a23.57,23.57,0,0,1,1.16,5.58c0,.15,0,.29,0,.44a34.66,34.66,0,0,0-.7,4,1.53,1.53,0,0,1-.77.58c-1.93.64-4.89-3.09-6.62-8.33S1250,450.08,1251.93,449.45Z"
              fill="#3b6818"
            />
            <path
              d="M1251.56,460.07s8.29,4.23,8.58,26"
              fill="none"
              stroke="#78bf3a"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <path
              d="M1253.24,451.42a4.73,4.73,0,0,1,1.14,2.17,10.68,10.68,0,0,0,.47,2.3,3.38,3.38,0,0,0,.75,1c.3.28.62.51.91.8a2.45,2.45,0,0,1,.67,1.1,2.06,2.06,0,0,1,0,1,4.33,4.33,0,0,0-.15,1,3.41,3.41,0,0,0,.42,1.38,3.88,3.88,0,0,1,.41,1.41,3.4,3.4,0,0,1-.15.91,2.66,2.66,0,0,0-.06,1,2.4,2.4,0,0,0,.3.9,2,2,0,0,1,.28.77,2.33,2.33,0,0,1-.36,1.15l-.06.12a.81.81,0,0,1-.34.21c-1.52.5-4.15-3.34-5.88-8.58s-1.89-9.89-.37-10.39a.94.94,0,0,1,.64,0A10.19,10.19,0,0,0,1253.24,451.42Z"
              fill="#659965"
            />
          </g>
        </g> */}
        <g>
          <g>
            <rect
              x="630.91"
              y="324.29"
              width="1.91"
              height="33.71"
              rx="0.95"
              fill="#a39bb2"
            />
            <g>
              <ellipse
                cx="631.87"
                cy="315.36"
                rx="3.91"
                ry="0.77"
                fill="url(#a47cfe28-edc2-439d-99f7-950f3e8e50a5)"
              />
              <ellipse
                cx="631.87"
                cy="316.7"
                rx="5.39"
                ry="1.01"
                fill="url(#b18b728d-e990-4b2f-aa41-bb25a4cd355d)"
              />
              <ellipse
                cx="631.87"
                cy="318.03"
                rx="6.88"
                ry="1.25"
                fill="url(#b9330299-fd9b-4e36-8005-d40c7e90168c)"
              />
              <ellipse
                cx="631.87"
                cy="319.37"
                rx="8.36"
                ry="1.49"
                fill="url(#a6890239-d7c9-4b73-a565-3e46c2435f24)"
              />
              <ellipse
                cx="631.87"
                cy="320.7"
                rx="9.84"
                ry="1.72"
                fill="url(#e5417d92-da41-4f5d-af6e-d5fdbc0053f5)"
              />
              <ellipse
                cx="631.87"
                cy="322.04"
                rx="11.33"
                ry="1.96"
                fill="url(#aed27ad7-28fa-4e87-90a4-78cf0da1cd78)"
              />
              <ellipse
                cx="631.87"
                cy="324"
                rx="10.21"
                ry="1.8"
                fill="url(#a63149d5-971d-450e-b1e7-0cdaf6cf3110)"
              />
              <ellipse
                cx="631.87"
                cy="325.97"
                rx="9.1"
                ry="1.63"
                fill="url(#e9e03a91-3800-41ba-b797-5918b0d1b98e)"
              />
              <ellipse
                cx="631.87"
                cy="327.94"
                rx="7.99"
                ry="1.46"
                fill="url(#f5273b89-2da0-4638-b0f3-b936845d12f9)"
              />
              <ellipse
                cx="631.87"
                cy="329.91"
                rx="6.87"
                ry="1.3"
                fill="url(#b16f21d2-d6c2-4504-919a-5b12422f896c)"
              />
              <ellipse
                cx="631.87"
                cy="331.87"
                rx="5.76"
                ry="1.13"
                fill="url(#b0a538b1-c6a2-44d9-8334-e0850719b6a5)"
              />
            </g>
          </g>
          <circle
            cx="631.67"
            cy="323"
            r="19"
            fill="url(#f019a494-9601-4989-adca-79d2715021e5)"
          />
        </g>
        <g transform="translate(-70 -10)">
          <g>
            <rect
              x="192.91"
              y="492.29"
              width="1.91"
              height="33.71"
              rx="0.95"
              fill="#a39bb2"
            />
            <g>
              <ellipse
                cx="193.87"
                cy="483.36"
                rx="3.91"
                ry="0.77"
                fill="url(#a3b39100-32dd-4d46-9482-d9cc113836ef)"
              />
              <ellipse
                cx="193.87"
                cy="484.7"
                rx="5.39"
                ry="1.01"
                fill="url(#b527b5f1-f9f2-4d72-8569-4f8b866afd9f)"
              />
              <ellipse
                cx="193.87"
                cy="486.03"
                rx="6.88"
                ry="1.25"
                fill="url(#a82ac099-985c-4b9b-bda8-97f43260215e)"
              />
              <ellipse
                cx="193.87"
                cy="487.37"
                rx="8.36"
                ry="1.49"
                fill="url(#a003f0a7-43bf-4f0e-bcc9-dd6e792e963c)"
              />
              <ellipse
                cx="193.87"
                cy="488.7"
                rx="9.84"
                ry="1.72"
                fill="url(#eabe069d-3792-49c6-89d4-931b379dd5f7)"
              />
              <ellipse
                cx="193.87"
                cy="490.04"
                rx="11.33"
                ry="1.96"
                fill="url(#b947bc29-6398-4e62-902b-0102d1fc1cf6)"
              />
              <ellipse
                cx="193.87"
                cy="492"
                rx="10.21"
                ry="1.8"
                fill="url(#e58a81fc-7a18-43cd-babf-f9f7b6b52ac0)"
              />
              <ellipse
                cx="193.87"
                cy="493.97"
                rx="9.1"
                ry="1.63"
                fill="url(#b5ceecec-c8d1-4eca-827f-438a3abaf636)"
              />
              <ellipse
                cx="193.87"
                cy="495.94"
                rx="7.99"
                ry="1.46"
                fill="url(#a4d6b615-1227-40af-a037-65669ab8cac9)"
              />
              <ellipse
                cx="193.87"
                cy="497.91"
                rx="6.87"
                ry="1.3"
                fill="url(#b20a5d33-45c5-49f1-a539-21b488d16d09)"
              />
              <ellipse
                cx="193.87"
                cy="499.87"
                rx="5.76"
                ry="1.13"
                fill="url(#bc7b3891-aa23-49b3-b4ca-16b3503db929)"
              />
            </g>
          </g>
          <circle
            cx="193.67"
            cy="491"
            r="19"
            fill="url(#ed828bcd-c270-40ae-a351-12025fe77116)"
          />
        </g>
        <g>
          <g>
            <rect
              x="846.09"
              y="877.53"
              width="3.91"
              height="69.2"
              rx="0.64"
              fill="#a39bb2"
            />
            <g>
              <ellipse
                cx="848.04"
                cy="859.2"
                rx="8.03"
                ry="1.58"
                fill="url(#bffd6cf8-a6be-4452-9d35-df238200afff)"
              />
              <ellipse
                cx="848.04"
                cy="861.94"
                rx="11.07"
                ry="2.07"
                fill="url(#b4588049-c0fe-4605-80a5-b78c51f56c8c)"
              />
              <ellipse
                cx="848.04"
                cy="864.69"
                rx="14.12"
                ry="2.56"
                fill="url(#bd531b56-1959-46ab-bfcb-1d6076168161)"
              />
              <ellipse
                cx="848.04"
                cy="867.43"
                rx="17.16"
                ry="3.05"
                fill="url(#b0802ffa-c7db-47e2-b579-84645b638a0b)"
              />
              <ellipse
                cx="848.04"
                cy="870.17"
                rx="20.2"
                ry="3.54"
                fill="url(#ebd74319-1a86-431c-a060-3583f9d304f3)"
              />
              <ellipse
                cx="848.04"
                cy="872.91"
                rx="23.25"
                ry="4.03"
                fill="url(#e8888fe9-6aba-40e1-9a8a-e2d0c7ce10fd)"
              />
              <ellipse
                cx="848.04"
                cy="876.95"
                rx="20.96"
                ry="3.69"
                fill="url(#fbc7c430-c476-40f6-9583-ec454f3c3817)"
              />
              <ellipse
                cx="848.04"
                cy="880.99"
                rx="18.68"
                ry="3.35"
                fill="url(#e7d03105-e4b6-4c51-b70f-fa55a97292b9)"
              />
              <ellipse
                cx="848.04"
                cy="885.02"
                rx="16.39"
                ry="3"
                fill="url(#a6aec762-96e9-4f6d-8993-a2c4f7839e07)"
              />
              <ellipse
                cx="848.04"
                cy="889.06"
                rx="14.11"
                ry="2.66"
                fill="url(#a5363db2-4d8c-440a-95ef-7cbba758ec67)"
              />
              <ellipse
                cx="848.04"
                cy="893.1"
                rx="11.82"
                ry="2.32"
                fill="url(#ee31f54a-7a88-43f4-bcf9-9e1bd62be08a)"
              />
            </g>
          </g>
          <circle
            cx="847.64"
            cy="874.89"
            r="39"
            fill="url(#ae341de5-b83b-4046-9ea0-330db9d7bbbc)"
          />
        </g>
        <g>
          <path d="M764.81,936.51v0h0Z" fill="#ef6291" />
          <path
            d="M791.93,931v0c0,1.53-6.42,2.75-13.78,2.75s-13.34-1.24-13.34-2.77Z"
            fill="#ef6291"
          />
          <path
            d="M786.5,948h0a.28.28,0,0,1,0,.09c0,.9-3.51,1.63-7.84,1.63s-7.85-.73-7.85-1.63a.28.28,0,0,1,0-.09h-.08l-5.9-11.58h27.12Z"
            fill="#c1567f"
          />
          <path
            d="M791.93,931c0,1.53-6.42,2.75-13.78,2.75s-13.34-1.24-13.34-2.77,6-2.77,13.34-2.77,13.72,1.25,13.78,2.77Z"
            fill="#c16f86"
          />
          <path
            d="M790.4,931c0,1.36-5.69,2.44-12.23,2.44s-11.83-1.1-11.83-2.46,5.3-2.46,11.83-2.46S790.4,929.65,790.4,931Z"
            fill="#513126"
          />
          <path
            d="M786.31,948.43c-9.42.46-9.11-11.1-9.11-11.1l-12.15-.43L770.71,948h.08a.28.28,0,0,0,0,.09c0,.9,3.51,1.63,7.85,1.63C782.41,949.73,785.57,949.17,786.31,948.43Z"
            fill="#602b8e"
            opacity="0.35"
          />
          <path
            d="M791.93,931v5.52c0,1.52-6.2,2.77-13.54,2.77s-13.53-1.25-13.58-2.77V931c0,1.53,6,2.77,13.34,2.77S791.93,932.54,791.93,931Z"
            fill="#ef6291"
          />
          <path
            d="M772,933.45h0c-4.27-.46-7.18-1.39-7.18-2.46v5.54c0,1.3,4.59,2.4,10.5,2.7C770.91,938.21,772,933.45,772,933.45Z"
            fill="#602b8e"
            opacity="0.35"
          />
          <g>
            <path
              d="M769,928.39c-2.16.42-4.16-4.58-5.59-6.83,0,0,3.78.23,5.63,1.43S771.87,927.82,769,928.39Z"
              fill="#1c7f19"
            />
            <path
              d="M763.36,921.56a34.31,34.31,0,0,1,3.88,2.68,17.65,17.65,0,0,1,1.74,1.61,3.45,3.45,0,0,1,1.14,2,2.11,2.11,0,0,0-.46-1.06,7.15,7.15,0,0,0-.76-.89,18.58,18.58,0,0,0-1.76-1.55C765.93,923.36,764.64,922.47,763.36,921.56Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M781.75,926.17c-2.16.43-4.16-4.57-5.6-6.83,0,0,3.78.23,5.64,1.43S784.67,925.6,781.75,926.17Z"
              fill="#1c7f19"
            />
            <path
              d="M776.15,919.34A35.79,35.79,0,0,1,780,922a20.35,20.35,0,0,1,1.74,1.61,3.53,3.53,0,0,1,1.14,2,2,2,0,0,0-.47-1.06,5.8,5.8,0,0,0-.75-.89,17.48,17.48,0,0,0-1.77-1.56C778.73,921.15,777.44,920.25,776.15,919.34Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M776.52,933c-2.16.42-4.17-4.58-5.6-6.84,0,0,3.78.23,5.64,1.43S779.43,932.41,776.52,933Z"
              fill="#1b6817"
            />
            <path
              d="M770.92,926.15a36.88,36.88,0,0,1,3.89,2.69,18.74,18.74,0,0,1,1.74,1.6,3.56,3.56,0,0,1,1.14,2,2.08,2.08,0,0,0-.47-1.06,6.31,6.31,0,0,0-.75-.89A18.7,18.7,0,0,0,774.7,929C773.5,928,772.2,927.07,770.92,926.15Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M770.86,933c-1.55.3-3-3.29-4-4.91a10.75,10.75,0,0,1,4,1C772.23,930,773,932.57,770.86,933Z"
              fill="#1b6817"
            />
            <path
              d="M766.85,928.07a26.17,26.17,0,0,1,2.79,1.93,13.51,13.51,0,0,1,1.25,1.15,2.46,2.46,0,0,1,.81,1.46,2.69,2.69,0,0,0-.87-1.4,12.26,12.26,0,0,0-1.27-1.12C768.7,929.37,767.77,928.73,766.85,928.07Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M770.62,922.71c-1.57.31-3-3.32-4.06-5a10.89,10.89,0,0,1,4.09,1C772,919.66,772.74,922.3,770.62,922.71Z"
              fill="#1c7f19"
            />
            <path
              d="M766.56,917.75a24.81,24.81,0,0,1,2.82,2,12.76,12.76,0,0,1,1.27,1.17,2.53,2.53,0,0,1,.82,1.47,2.76,2.76,0,0,0-.88-1.42,15.21,15.21,0,0,0-1.28-1.13C768.43,919.06,767.49,918.41,766.56,917.75Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M772.4,930.28c2.16.42,4.16-4.58,5.59-6.84,0,0-3.78.24-5.63,1.43S769.48,929.71,772.4,930.28Z"
              fill="#1c7f19"
            />
            <path
              d="M778,923.44c-1.28.92-2.58,1.81-3.78,2.82a18.58,18.58,0,0,0-1.76,1.55,6.39,6.39,0,0,0-.76.89,2,2,0,0,0-.46,1.06,3.5,3.5,0,0,1,1.14-2,17.44,17.44,0,0,1,1.73-1.6A36.88,36.88,0,0,1,778,923.44Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M783.58,923.63c2.16.42,4.16-4.58,5.6-6.83,0,0-3.78.23-5.64,1.43S780.67,923.06,783.58,923.63Z"
              fill="#1c7f19"
            />
            <path
              d="M789.18,916.8c-1.28.91-2.58,1.8-3.78,2.81a18.7,18.7,0,0,0-1.77,1.55,6.31,6.31,0,0,0-.75.89,2.12,2.12,0,0,0-.47,1.06,3.5,3.5,0,0,1,1.14-2,18.85,18.85,0,0,1,1.74-1.61A35.35,35.35,0,0,1,789.18,916.8Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M772.41,924.6c1.57.31,3-3.32,4.07-5a10.84,10.84,0,0,0-4.1,1C771,921.54,770.29,924.19,772.41,924.6Z"
              fill="#1b6817"
            />
            <path
              d="M776.48,919.64c-.93.66-1.87,1.31-2.75,2a15.21,15.21,0,0,0-1.28,1.13,2.85,2.85,0,0,0-.89,1.42,2.6,2.6,0,0,1,.83-1.48,12.55,12.55,0,0,1,1.26-1.16A24.53,24.53,0,0,1,776.48,919.64Z"
              fill="#30562e"
            />
          </g>
          <path
            d="M772.25,932.37a9,9,0,0,1-1.64-3,5,5,0,0,1-.23-1.77,3.53,3.53,0,0,1,.15-.91l.3-.81a12.64,12.64,0,0,0,.54-3.27c.06-1.12.09-2.26.08-3.41a16.42,16.42,0,0,1,.43,3.42,10.57,10.57,0,0,1-.43,3.47,4.68,4.68,0,0,0-.46,1.55,5.49,5.49,0,0,0,.11,1.61A14,14,0,0,0,772.25,932.37Z"
            fill="#30562e"
          />
          <path
            d="M778.37,922.35c-.1.42-.35.84-.45,1.19s.23.73.36,1.11a9.14,9.14,0,0,1,.72,2.54,11.64,11.64,0,0,1-.63,5.18c0-.87.08-1.73.1-2.58a21.06,21.06,0,0,0-.11-2.52,14.6,14.6,0,0,0-.55-2.45c-.06-.21-.12-.42-.17-.63a1.25,1.25,0,0,1,0-.75C777.87,923,778.13,922.74,778.37,922.35Z"
            fill="#30562e"
          />
          <path
            d="M783.68,917.84a6.67,6.67,0,0,1-1,1.49c-.39.45-.75.92-.6,1.4a3.57,3.57,0,0,0,.86,1.39,5.16,5.16,0,0,1,.94,1.66,10.09,10.09,0,0,1,.44,3.65,14.29,14.29,0,0,1-.62,3.56,30.48,30.48,0,0,0,.11-3.57,11.89,11.89,0,0,0-.55-3.43,4.75,4.75,0,0,0-.79-1.47,3.85,3.85,0,0,1-.89-1.7,1.37,1.37,0,0,1,.23-1,4.33,4.33,0,0,1,.64-.7A8.83,8.83,0,0,0,783.68,917.84Z"
            fill="#30562e"
          />
          <g>
            <path
              d="M784.79,929.85c1.57.31,3-3.32,4.06-5a10.89,10.89,0,0,0-4.09,1C783.41,926.8,782.67,929.44,784.79,929.85Z"
              fill="#1b6817"
            />
            <path
              d="M783.34,932.23c1.57.31,3-3.32,4.07-5a10.92,10.92,0,0,0-4.1,1C782,929.18,781.22,931.82,783.34,932.23Z"
              fill="#1b6817"
            />
            <path
              d="M788.85,924.89c-.93.66-1.87,1.31-2.74,2a12.6,12.6,0,0,0-1.28,1.13,2.78,2.78,0,0,0-.89,1.42,2.49,2.49,0,0,1,.83-1.47,12.65,12.65,0,0,1,1.26-1.17A28.31,28.31,0,0,1,788.85,924.89Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M779.88,931.92c2.16.42,4.16-4.58,5.59-6.83,0,0-3.77.23-5.63,1.42S777,931.35,779.88,931.92Z"
              fill="#1c7f19"
            />
            <path
              d="M785.47,925.09c-1.28.91-2.57,1.8-3.78,2.81a19.9,19.9,0,0,0-1.76,1.55,7.15,7.15,0,0,0-.76.89,2.2,2.2,0,0,0-.46,1.06,3.56,3.56,0,0,1,1.14-2,18.85,18.85,0,0,1,1.74-1.6A34.31,34.31,0,0,1,785.47,925.09Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M777.06,925.26c-1.57.3-3-3.33-4.06-5a10.89,10.89,0,0,1,4.09,1C778.44,922.2,779.18,924.84,777.06,925.26Z"
              fill="#1c7f19"
            />
            <path
              d="M773,920.29a26.17,26.17,0,0,1,2.82,2,14,14,0,0,1,1.26,1.17,2.52,2.52,0,0,1,.83,1.47,2.78,2.78,0,0,0-.88-1.41,13.61,13.61,0,0,0-1.28-1.13C774.87,921.6,773.93,921,773,920.29Z"
              fill="#30562e"
            />
          </g>
          <g>
            <path
              d="M783.77,920.23c-1.72-.65-.26-3.4-.45-4.55s1.51-1.9,2.88-1.22.57,1.84,1.69,2.55S785.16,920.76,783.77,920.23Z"
              fill="#bc784a"
            />
            <path
              d="M783,920.37c-1.82-.19-1.08-3.23-1.55-4.29s1-2.22,2.49-1.92,1,1.64,2.26,2S784.5,920.53,783,920.37Z"
              fill="#ed863a"
            />
            <path
              d="M782.94,920.61c-1.82-.19-.24-2.72-.71-3.78s.08-2,1.57-1.74.94.88,2.19,1.27S784.42,920.77,782.94,920.61Z"
              fill="#bc784a"
            />
            <path
              d="M783.18,921.12c-1.62-.48-.43-2.81-.68-3.75s1.28-1.62,2.58-1.11.63,1.51,1.7,2.06S784.49,921.52,783.18,921.12Z"
              fill="#ed863a"
            />
          </g>
          <g>
            <path
              d="M778,921.15c-1.8-.34-.83-3.31-1.22-4.4s1.17-2.14,2.63-1.72.88,1.72,2.1,2.21S779.47,921.42,778,921.15Z"
              fill="#bc784a"
            />
            <path
              d="M777.29,921.42c-1.82.13-1.6-3-2.25-4s.61-2.36,2.13-2.32,1.27,1.43,2.57,1.61S778.78,921.31,777.29,921.42Z"
              fill="#ed863a"
            />
            <path
              d="M777.26,921.67c-1.83.13-.7-2.64-1.35-3.61s-.26-2,1.26-2,1.07.69,2.38.87S778.74,921.56,777.26,921.67Z"
              fill="#bc784a"
            />
            <path
              d="M777.58,922.13c-1.68-.19-.9-2.69-1.31-3.58s1-1.82,2.35-1.54.88,1.37,2,1.72S778.94,922.29,777.58,922.13Z"
              fill="#ed863a"
            />
          </g>
          <g>
            <path
              d="M772.53,919.42c1.8-.33.83-3.3,1.22-4.4s-1.17-2.13-2.64-1.71-.87,1.71-2.09,2.21S771.07,919.7,772.53,919.42Z"
              fill="#bc784a"
            />
            <path
              d="M773.24,919.69c1.83.13,1.61-3,2.26-4s-.62-2.37-2.13-2.33-1.27,1.44-2.57,1.61S771.76,919.59,773.24,919.69Z"
              fill="#ed863a"
            />
            <path
              d="M773.28,919.94c1.83.13.7-2.64,1.34-3.6s.26-2-1.25-2-1.08.69-2.38.86S771.8,919.84,773.28,919.94Z"
              fill="#bc784a"
            />
            <path
              d="M773,920.41c1.67-.19.9-2.7,1.31-3.58s-1-1.83-2.36-1.55-.88,1.38-2,1.73S771.6,920.56,773,920.41Z"
              fill="#ed863a"
            />
          </g>
          <ellipse
            cx="785.65"
            cy="928.52"
            rx="1.15"
            ry="0.35"
            transform="translate(-430.63 935.21) rotate(-50.08)"
            fill="#b2eff9"
            opacity="0.25"
          />
        </g>
        <g>
          <path
            d="M975.83,843.54s12.7,26.37-3.36,40.78h24.92s-9.12-4.48-10.24-7.37-1.25-21.51-9.09-32.56Z"
            fill="#6d3b2f"
          />
          <path
            d="M979,844.83s1.35-15.22,10.05-17.2c0,0-3.62,3.09-1.81,5.6,0,0,3.3-7.46,13.39-5.6,0,0-11.62,1.42-13.39,8.45a8.13,8.13,0,0,1,8.91,2.71S979,839.08,979,844.83Z"
            fill="#43771c"
          />
          <path
            d="M975.83,844.83s-1.34-15.22-10-17.2c0,0,3.61,3.09,1.8,5.6,0,0-3.3-7.46-13.39-5.6,0,0,11.63,1.42,13.39,8.45a8.11,8.11,0,0,0-8.9,2.71S975.84,839.08,975.83,844.83Z"
            fill="#43771c"
          />
          <path
            d="M980.09,847.52S963.27,825.61,944.5,834c0,0,10.61-.4,11.5.85,0,0-3.47-.54-3.3,2.88,0,0,7.22-3.46,9.25-1.75,0,0-4,.8-3.77,2.49,0,0,6.44-1.53,8.09,0,0,0-4.15,1-2.49,3,0,0,5.68-2.47,8.41,1.22,0,0-2.37-.81-3.11.07C969.08,842.73,979.66,845.28,980.09,847.52Z"
            fill="#529022"
          />
          <path
            d="M977,847.23s14.4-20.73,33.81-10.2c0,0-10.53-1.48-11.29-.29a3.31,3.31,0,0,1,3.56,3.28s-7.48-4.27-9.32-2.73c0,0,4,1.23,4,2.93,0,0-6.52-2.22-8-.86,0,0,4.21,1.42,2.77,3.29,0,0-5.87-3.1-8.19.4,0,0,2.27-.59,3.08.38C987.37,843.43,977.17,845,977,847.23Z"
            fill="#529022"
          />
          <path
            d="M980.47,846.33s-16-12.71-28.93,4.58c0,0,8-5.6,8.84-4.84a3.87,3.87,0,0,0-2.08,4.38s5-6.86,6.74-6.22c0,0-2.91,2.73-2.48,4.24,0,0,4.64-4.63,6.12-4,0,0-3,3-1.45,4.07,0,0,3.94-5.15,6.54-3,0,0-1.91.39-2.34,1.59C971.43,847.15,979.82,844.39,980.47,846.33Z"
            fill="#426642"
          />
          <path
            d="M975.82,846.77s19-14.63,33.88,4.56c0,0-9.25-6.13-10.28-5.27a4.17,4.17,0,0,1,2.35,4.89s-5.68-7.61-7.79-6.86c0,0,3.37,3,2.83,4.72,0,0-5.36-5.12-7.1-4.4,0,0,3.46,3.29,1.62,4.55,0,0-4.52-5.72-7.63-3.2,0,0,2.24.4,2.72,1.74C986.42,847.5,976.63,844.57,975.82,846.77Z"
            fill="#426642"
          />
          <path
            d="M978.61,847.22c-.7-8.8,8.59-19.05,15.26-18.41,0,0-13.18-2.56-15.32,5.34,0,0,2.67-10.47,6.57-10.47,0,0-8.6-2.35-10.14,4.91,0,0-4.65-9.07,0-10.3,0,0-10.63,2.83-6.09,9.88,0,0-4.86-4.06-10.62,1.28,0,0,11.31.21,13.24,4.7,0,0-5-3.21-7.9,0,0,0,10-1.66,12.49,5.71Z"
            fill="#529022"
          />
          <path
            d="M978.06,847.22c-.53-6.79,6.63-14.69,11.78-14.2,0,0-10.17-2-11.82,4.12,0,0,2.06-8.07,5.07-8.07,0,0-6.63-1.81-7.83,3.79,0,0-3.58-7,0-8,0,0-8.19,2.18-4.69,7.62,0,0-3.75-3.13-8.19,1,0,0,8.73.17,10.21,3.63,0,0-3.83-2.47-6.09,0,0,0,7.69-1.28,9.63,4.4Z"
            fill="#396039"
          />
          <path
            d="M977.21,849.9s.78-8.8,5.8-9.94c0,0-2.09,1.79-1,3.24,0,0,1.91-4.32,7.74-3.24,0,0-6.72.82-7.74,4.89a4.69,4.69,0,0,1,5.15,1.56S977.2,846.58,977.21,849.9Z"
            fill="#659965"
          />
          <path
            d="M978.71,848.62s-.77-8.8-5.8-9.94c0,0,2.09,1.79,1,3.24,0,0-1.91-4.32-7.74-3.24,0,0,6.72.82,7.74,4.89a4.69,4.69,0,0,0-5.15,1.56S978.72,845.3,978.71,848.62Z"
            fill="#659965"
          />
          <path
            d="M987.15,877c-1-2.59-1.21-18-7-29.05.78,3.06,6,24,3.28,30-1.06,2.39,2.4,4.61,7.18,6.46h6.75S988.27,879.84,987.15,877Z"
            fill="#17216b"
            opacity="0.24"
          />
        </g>
        <g>
          <path
            d="M1025.83,833.54s12.7,26.37-3.36,40.78h24.92s-9.12-4.48-10.24-7.37-1.25-21.51-9.09-32.56Z"
            fill="#6d3b2f"
          />
          <path
            d="M1029,834.83s1.35-15.22,10-17.2c0,0-3.62,3.09-1.81,5.6,0,0,3.3-7.46,13.39-5.6,0,0-11.62,1.42-13.39,8.45a8.13,8.13,0,0,1,8.91,2.71S1029,829.08,1029,834.83Z"
            fill="#43771c"
          />
          <path
            d="M1025.83,834.83s-1.34-15.22-10-17.2c0,0,3.61,3.09,1.8,5.6,0,0-3.3-7.46-13.39-5.6,0,0,11.63,1.42,13.39,8.45a8.11,8.11,0,0,0-8.9,2.71S1025.84,829.08,1025.83,834.83Z"
            fill="#43771c"
          />
          <path
            d="M1030.09,837.52S1013.27,815.61,994.5,824c0,0,10.61-.4,11.5.85,0,0-3.47-.54-3.3,2.88,0,0,7.22-3.46,9.25-1.75,0,0-4,.8-3.77,2.49,0,0,6.44-1.53,8.09,0,0,0-4.15,1-2.49,3,0,0,5.68-2.47,8.41,1.22,0,0-2.37-.81-3.11.07C1019.08,832.73,1029.66,835.28,1030.09,837.52Z"
            fill="#529022"
          />
          <path
            d="M1027,837.23s14.4-20.73,33.81-10.2c0,0-10.53-1.48-11.29-.29a3.31,3.31,0,0,1,3.56,3.28s-7.48-4.27-9.32-2.73c0,0,4,1.23,4,2.93,0,0-6.52-2.22-8-.86,0,0,4.21,1.42,2.77,3.29,0,0-5.87-3.1-8.19.4,0,0,2.27-.59,3.08.38C1037.37,833.43,1027.17,835,1027,837.23Z"
            fill="#529022"
          />
          <path
            d="M1030.47,836.33s-16-12.71-28.93,4.58c0,0,8-5.6,8.84-4.84a3.87,3.87,0,0,0-2.08,4.38s5-6.86,6.74-6.22c0,0-2.91,2.73-2.48,4.24,0,0,4.64-4.63,6.12-4,0,0-3,3-1.45,4.07,0,0,3.94-5.15,6.54-3,0,0-1.91.39-2.34,1.59C1021.43,837.15,1029.82,834.39,1030.47,836.33Z"
            fill="#426642"
          />
          <path
            d="M1025.82,836.77s19-14.63,33.88,4.56c0,0-9.25-6.13-10.28-5.27a4.17,4.17,0,0,1,2.35,4.89s-5.68-7.61-7.79-6.86c0,0,3.37,3,2.83,4.72,0,0-5.36-5.12-7.1-4.4,0,0,3.46,3.29,1.62,4.55,0,0-4.52-5.72-7.63-3.2,0,0,2.24.4,2.72,1.74C1036.42,837.5,1026.63,834.57,1025.82,836.77Z"
            fill="#426642"
          />
          <path
            d="M1028.61,837.22c-.7-8.8,8.59-19.05,15.26-18.41,0,0-13.18-2.56-15.32,5.34,0,0,2.67-10.47,6.57-10.47,0,0-8.6-2.35-10.14,4.91,0,0-4.65-9.07,0-10.3,0,0-10.63,2.83-6.09,9.88,0,0-4.86-4.06-10.62,1.28,0,0,11.31.21,13.24,4.7,0,0-5-3.21-7.9,0,0,0,10-1.66,12.49,5.71Z"
            fill="#529022"
          />
          <path
            d="M1028.06,837.22c-.53-6.79,6.63-14.69,11.78-14.2,0,0-10.17-2-11.82,4.12,0,0,2.06-8.07,5.07-8.07,0,0-6.63-1.81-7.83,3.79,0,0-3.58-7,0-8,0,0-8.19,2.18-4.69,7.62,0,0-3.75-3.13-8.19,1,0,0,8.73.17,10.21,3.63,0,0-3.83-2.47-6.09,0,0,0,7.69-1.28,9.63,4.4Z"
            fill="#396039"
          />
          <path
            d="M1027.21,839.9s.78-8.8,5.8-9.94c0,0-2.09,1.79-1,3.24,0,0,1.91-4.32,7.74-3.24,0,0-6.72.82-7.74,4.89a4.69,4.69,0,0,1,5.15,1.56S1027.2,836.58,1027.21,839.9Z"
            fill="#659965"
          />
          <path
            d="M1028.71,838.62s-.77-8.8-5.8-9.94c0,0,2.09,1.79,1,3.24,0,0-1.91-4.32-7.74-3.24,0,0,6.72.82,7.74,4.89a4.69,4.69,0,0,0-5.15,1.56S1028.72,835.3,1028.71,838.62Z"
            fill="#659965"
          />
          <path
            d="M1037.15,867c-1-2.59-1.21-18-7-29.05.78,3.06,6,24,3.28,30-1.06,2.39,2.4,4.61,7.18,6.46h6.75S1038.27,869.84,1037.15,867Z"
            fill="#17216b"
            opacity="0.24"
          />
        </g>
        <g>
          <path
            d="M971.18,978.29s-20.69,24.45-54.48,14.07c0,0-8.48.66-1.26-14.11s15.16-5.75,15.16-5.75-.93-12.15,10.51-11.24,4.32,11.21,8.62,12.48,5.25-10,9.95-12,13.47,3,12.48,9.73Z"
            fill="#396039"
          />
          <path
            d="M943.86,985.52c-4.62,0,.21-6.23-1.7-7.77s-5.13,4-7.75,7.09-5.41,0-8.81-4-4.78-7.13-10.16-2.58-13.3,10.89-6.37,14,17.83,6,22,2.61,10.89,3.29,12.66.94S947.86,985.53,943.86,985.52Z"
            fill="#426642"
          />
          <path
            d="M940.35,971.74c3.15-3.08.4-8.16-3.1-6.6s-.78,7.1-4,8.8-8.81,3.67-2.55,5.61S940.35,971.74,940.35,971.74Z"
            fill="#2f4f2f"
          />
          <path
            d="M962,981.58c4.61-2.87,5.5-7.88,4.08-9s-5.3-4.44-6.45,0-8.71,5.74-7.09,9.86S962,981.58,962,981.58Z"
            fill="#2f4f2f"
          />
          <path
            d="M958.3,992.08c5.76-5.22,10.14-3.52,9.74-6.86s.52-6.53-3.28-7.36-4.15,3.76-7.45,4.51-3.87-4.91-7-.69S951.5,998.24,958.3,992.08Z"
            fill="#426642"
          />
          <path
            d="M949.2,995.61c6.49-2,4.37-5,2.31-6.62s-6,2.91-8.62,1.73-7.89,3.18-10.44,1.12-7.74-6-10.27-2-6.52,12.83,1.19,8.89,15.77-1,19.49-1.08A12.18,12.18,0,0,0,949.2,995.61Z"
            fill="#659965"
          />
        </g>
        <g>
          <path
            d="M1035.18,970.29s-20.69,24.45-54.48,14.07c0,0-8.48.66-1.26-14.11s15.16-5.75,15.16-5.75-.93-12.15,10.51-11.24,4.32,11.21,8.62,12.48,5.25-10,9.95-12,13.47,3,12.48,9.73Z"
            fill="#396039"
          />
          <path
            d="M1007.86,977.52c-4.62,0,.21-6.23-1.7-7.77s-5.13,4-7.75,7.09-5.41,0-8.81-4-4.78-7.13-10.16-2.58-13.3,10.89-6.37,14,17.83,6,22,2.61,10.89,3.29,12.66.94S1011.86,977.53,1007.86,977.52Z"
            fill="#426642"
          />
          <path
            d="M1004.35,963.74c3.15-3.08.4-8.16-3.1-6.6s-.78,7.1-4,8.8-8.81,3.67-2.55,5.61S1004.35,963.74,1004.35,963.74Z"
            fill="#2f4f2f"
          />
          <path
            d="M1026,973.58c4.61-2.87,5.5-7.88,4.08-9s-5.3-4.44-6.45,0-8.71,5.74-7.09,9.86S1026,973.58,1026,973.58Z"
            fill="#2f4f2f"
          />
          <path
            d="M1022.3,984.08c5.76-5.22,10.14-3.52,9.74-6.86s.52-6.53-3.28-7.36-4.15,3.76-7.45,4.51-3.87-4.91-7-.69S1015.5,990.24,1022.3,984.08Z"
            fill="#426642"
          />
          <path
            d="M1013.2,987.61c6.49-2,4.37-5,2.31-6.62s-6,2.91-8.62,1.73-7.89,3.18-10.44,1.12-7.74-6-10.27-2-6.52,12.83,1.19,8.89,15.77-1,19.49-1.08A12.18,12.18,0,0,0,1013.2,987.61Z"
            fill="#659965"
          />
        </g>
        <g>
          <g>
            <path
              d="M1448.3,880.44c-.07-.53-.11-1.07-.14-1.59a12.08,12.08,0,0,1,.07-2.33c.1-.69.3-1.36.46-2a7,7,0,0,0,.2-1.82c0-.67-.22-1.31-.27-2a4.27,4.27,0,0,1,.14-1.51c.12-.34.26-.68.41-1a7.11,7.11,0,0,1,.59-.88.14.14,0,0,0,0-.19,7.11,7.11,0,0,1,7.89-3.39,1.89,1.89,0,0,0,.54.55,4.64,4.64,0,0,0,1.63.6,3.09,3.09,0,0,1,1.68.88,14.85,14.85,0,0,1,1.15,1.83,3.2,3.2,0,0,0,.76.8,3.32,3.32,0,0,0,.93.44,2.4,2.4,0,0,1,1,.6,8.28,8.28,0,0,1,.67.89,8.62,8.62,0,0,0,.79.81,7.3,7.3,0,0,1,.57.66c.83,1.1.9,2.57,1.21,3.87a5.62,5.62,0,0,0,.91,2.15,9.64,9.64,0,0,0,1.35,1.36,4.37,4.37,0,0,1,1,1.19,5.14,5.14,0,0,1,.46,2.16c.09,1.78-.06,3.56.15,5.33a10.85,10.85,0,0,0,.22,1.29c.1.4.24.8.32,1.21a2.72,2.72,0,0,1-.12,1.57,13.18,13.18,0,0,1-.73,1.33,3.88,3.88,0,0,0-.67,2.12,3.59,3.59,0,0,1,0,1.18,2.41,2.41,0,0,1-.52.85,10.29,10.29,0,0,0-1.3,1.5.16.16,0,0,0,0,.08,6.81,6.81,0,0,1-1.83,1.1,7,7,0,0,1-3,.48,10.56,10.56,0,0,0-2-1.08,24,24,0,0,1-2.45-1,7.28,7.28,0,0,1-1.07-.7c-.34-.27-.63-.58-1-.84-.66-.49-1.41-.85-2-1.38a3.72,3.72,0,0,1-.86-1.07c-.21-.39-.35-.81-.53-1.22a3.86,3.86,0,0,0-.67-1.1,11.78,11.78,0,0,0-.94-.93c-.43-.39-.88-.76-1.31-1.14a31.18,31.18,0,0,1-1.6-3.28,6.39,6.39,0,0,1,.58-1.34c.34-.65.75-1.26,1.1-1.91a.17.17,0,0,0-.08-.25,18.09,18.09,0,0,1-1.77-.4,2.32,2.32,0,0,1-1.12-.63,2.08,2.08,0,0,1-.44-.78C1448.44,881.12,1448.37,880.78,1448.3,880.44Z"
              fill="#396039"
            />
            <path
              d="M1453.82,865.35a123,123,0,0,1,8,17.36c2.3,5.95,4.3,12,6.14,18.13s3.36,12.32,4.83,18.53c.71,3.1,1.35,6.23,2,9.35l1.75,9.41-1.91-9.38c-.7-3.11-1.35-6.23-2.09-9.33-1.5-6.2-3.07-12.39-4.93-18.49s-3.76-12.19-6-18.15l-1.75-4.45c-.63-1.46-1.21-2.94-1.88-4.39A88.56,88.56,0,0,0,1453.82,865.35Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1483.79,907.7c0-.77,0-1.53-.09-2.29a50.58,50.58,0,0,1,3.5-11.25,14.45,14.45,0,0,0,1.08-1.14c.43-.49.79-1,1.17-1.55l1.33-1.82a15.65,15.65,0,0,0,2.13-3.75c.24-.67.33-1.37.52-2.06.12-.46.27-.92.43-1.37,4.37-5.84,8.94-9,11.77-7.68a3.12,3.12,0,0,1,1,.79,6.32,6.32,0,0,1,.18.62,9,9,0,0,1,.27,2.89,13.26,13.26,0,0,1-.58,2.77,18.88,18.88,0,0,0-.93,3.2,11.47,11.47,0,0,0,.12,3,15.06,15.06,0,0,1,.22,3.07,4.06,4.06,0,0,1-.89,2.53,7.41,7.41,0,0,1-1.61,1.16,8.06,8.06,0,0,0-1.73,1.62,2.16,2.16,0,0,0-.59,1.63c.07.63.34,1.23.45,1.86a5.28,5.28,0,0,1-1.31,4.17,20.78,20.78,0,0,1-3.56,3.06c-.66.51-1.32,1-2,1.59-.32.28-.62.58-.92.89s-.62.74-.93,1.11a19,19,0,0,1-4.69,3.61c-.85.52-1.68,1.05-2.47,1.64-1.44-.72-2.22-2.53-2.4-5.08A12.76,12.76,0,0,0,1483.79,907.7Z"
              fill="#2f4f2f"
            />
            <path
              d="M1506.7,874.34q-2.52,3.69-4.82,7.5t-4.54,7.68q-4.39,7.77-8.14,15.86a170.92,170.92,0,0,0-6.65,16.54c-.86,2.85-1.81,5.67-2.46,8.57-.82,2.86-1.26,5.81-1.83,8.73a105.61,105.61,0,0,1,4.08-17.37,170.25,170.25,0,0,1,6.55-16.6q3.81-8.09,8.26-15.84C1500.1,884.25,1503.26,879.19,1506.7,874.34Z"
              fill="#87f139"
            />
          </g>
          <g>
            <path
              d="M1484.07,912c.1-.6.17-1.21.22-1.81a40.16,40.16,0,0,1,4.17-8.37c.35-.24.68-.49,1-.75s.74-.71,1.11-1.08l1.27-1.25a12,12,0,0,0,2.15-2.67c.28-.5.43-1,.67-1.55.15-.35.33-.68.51-1,4.17-4,8.15-5.95,10.2-4.52a2.64,2.64,0,0,1,.7.75,4,4,0,0,1,.06.5,6.84,6.84,0,0,1-.16,2.3,9.37,9.37,0,0,1-.8,2.1A16.35,16.35,0,0,0,1504,897a9.67,9.67,0,0,0-.29,2.4,11,11,0,0,1-.22,2.43,3.32,3.32,0,0,1-1,1.88,6.18,6.18,0,0,1-1.41.7,6.11,6.11,0,0,0-1.56,1,1.69,1.69,0,0,0-.68,1.2c0,.51.11,1,.12,1.51a4.18,4.18,0,0,1-1.56,3.11,16.83,16.83,0,0,1-3.17,1.94c-.59.32-1.17.64-1.73,1-.29.19-.57.38-.84.59s-.58.5-.87.75a15.33,15.33,0,0,1-4.14,2.23c-.72.3-1.44.61-2.14,1-1-.75-1.42-2.27-1.23-4.28A9.92,9.92,0,0,0,1484.07,912Z"
              fill="#396039"
            />
            <path
              d="M1506.27,888.78c-1.63,1.72-3.2,3.48-4.73,5.28s-3,3.6-4.52,5.44q-4.43,5.54-8.39,11.41a135.22,135.22,0,0,0-7.32,12.11c-1,2.11-2.14,4.2-3,6.39s-1.73,4.39-2.55,6.61a82.09,82.09,0,0,1,5.38-13.11,136.21,136.21,0,0,1,7.24-12.19c2.67-3.9,5.51-7.68,8.48-11.35S1502.94,892.14,1506.27,888.78Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1474,912.35a.85.85,0,0,0,.34-.56,1,1,0,0,0-.35-.66,7.89,7.89,0,0,0-1-.8v0a5.26,5.26,0,0,0,.62-.63,1,1,0,0,0,.27-.55c0-.4-.41-.59-.72-.71s-.45-.17-.67-.24c-.15-.69-.28-1.41-.41-2.16l.4-.1a7.87,7.87,0,0,0,1-.32,1.64,1.64,0,0,0,.67-.43.17.17,0,0,0,0-.26c-.3-.17-.64-.29-1-.44a2.1,2.1,0,0,1-.83-.54c-.25-.31-.06-.67-.06-1a.91.91,0,0,0-.39-.68c-.1-.1-.21-.18-.31-.27-.1-.89-.19-1.8-.26-2.74l.55-.16a2.94,2.94,0,0,0,1.25-.65,1,1,0,0,0,.19-1.26,2.39,2.39,0,0,0-1.25-.93,7.24,7.24,0,0,0-.79-.25c0-.32-.11-.64-.17-1,0-.91,0-1.85,0-2.79l.07-.11a1.66,1.66,0,0,1,.52-.32,2.86,2.86,0,0,0,.79-.59.18.18,0,0,0,0-.24c-.37-.31-1.27-.77-1-1.39.08-.18.36-.2.52-.28a.5.5,0,0,0,.27-.56c-.12-.42-.63-.58-.86-.91s.4-.5.65-.52a7.73,7.73,0,0,0,1.36,0,.17.17,0,0,0,0-.3c-.7-.5-1.4-1-2.13-1.44.14-2,.33-3.83.57-5.58l.3.09a.18.18,0,0,0,.21-.15,6.64,6.64,0,0,1,1.32.69q.38.25.72.54c.17.13.4-.09.24-.23a8.05,8.05,0,0,0-.76-.58,14.47,14.47,0,0,0-1.92-1.17c.23-1.52.5-3,.8-4.26a7,7,0,0,1,1.65.86l.59.54a.17.17,0,0,0,.23-.24,4.6,4.6,0,0,0-.61-.56c-.39-.36-.78-.72-1.18-1.06l-.47-.38a28.74,28.74,0,0,1,1.16-3.65,23,23,0,0,0,2.2.89.17.17,0,0,0,.21-.16,3.51,3.51,0,0,0-.81-1.81,8.48,8.48,0,0,0-.69-.79c.8-1.36,1.7-2.12,2.63-2.12,1.9,0,3.61,3.1,4.81,8.06-.5.44-1,.91-1.44,1.38a.17.17,0,0,0,.2.26,11.3,11.3,0,0,0,1.39-1c.3,1.31.56,2.73.79,4.26a24,24,0,0,0-1.48,3,.19.19,0,0,0,.06.23c.62.32,1.27.58,1.9.87.2,2.16.32,4.45.36,6.83a12.44,12.44,0,0,0-1.33,3.09,7.33,7.33,0,0,0-.11,2.47q.08.61.12,1.23a9.82,9.82,0,0,0,.07,1.21c.11.76.39,1.49.53,2.25a1.87,1.87,0,0,1-.51,1.86,4.21,4.21,0,0,1-1.38.53.62.62,0,0,0-.42.35.83.83,0,0,0,.12.63,3.32,3.32,0,0,0,1.43,1.21l.52.29c-1.16,7.32-3.25,12.21-5.63,12.21-1.47,0-2.82-1.86-3.92-5Z"
              fill="#659965"
            />
            <path
              d="M1477.57,875c.29,10.57.36,21.14.49,31.71v15.85c-.07,5.29,0,10.58-.48,15.85.25-2.63.2-5.28.23-7.92l0-7.93-.1-15.85Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1467.22,886.57a2,2,0,0,1,1.24,0c.24.3.47.6.71.89s.74.88,1.14,1.29a11.82,11.82,0,0,1,1.08,1.25,10.91,10.91,0,0,1,1.25,2.27,10.34,10.34,0,0,0,1.3,2.62c.51.63,1.16,1.1,1.72,1.67l0,0c.14.38.27.77.4,1.16a31.31,31.31,0,0,1,1.55,7.48q0,.3-.06.6a47.47,47.47,0,0,0-.95,5.41,2.2,2.2,0,0,1-1,.78c-2.59.85-6.56-4.16-8.88-11.19S1464.63,887.42,1467.22,886.57Z"
              fill="#3b6818"
            />
            <path
              d="M1466.72,900.83s11.12,5.66,11.51,34.93"
              fill="none"
              stroke="#78bf3a"
              strokeMiterlimit="10"
              strokeWidth="0.33"
            />
            <path
              d="M1469,889.22a6.31,6.31,0,0,1,1.54,2.91,13.07,13.07,0,0,0,.63,3.08,4.25,4.25,0,0,0,1,1.38c.39.37.82.69,1.21,1.08a3.26,3.26,0,0,1,.9,1.48,2.79,2.79,0,0,1,0,1.32,5.67,5.67,0,0,0-.2,1.37,4.52,4.52,0,0,0,.56,1.85,5.09,5.09,0,0,1,.56,1.9,4.32,4.32,0,0,1-.21,1.21,3.62,3.62,0,0,0-.08,1.32,3.47,3.47,0,0,0,.41,1.21,2.4,2.4,0,0,1,.36,1,3.21,3.21,0,0,1-.47,1.55.8.8,0,0,0-.08.16,1.27,1.27,0,0,1-.46.27c-2,.67-5.57-4.48-7.89-11.51s-2.53-13.27-.49-13.94a1.41,1.41,0,0,1,.86,0A12.82,12.82,0,0,0,1469,889.22Z"
              fill="#659965"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1135.53,929.88c0-.34.07-.69.09-1a7.53,7.53,0,0,0,0-1.5c-.06-.44-.19-.87-.29-1.3a4.27,4.27,0,0,1-.13-1.18c0-.42.14-.84.17-1.27a2.9,2.9,0,0,0-.08-1c-.09-.22-.17-.43-.27-.64a4.35,4.35,0,0,0-.38-.57.09.09,0,0,1,0-.12,4.86,4.86,0,0,0-2.28-2,4.74,4.74,0,0,0-2.8-.19,1.17,1.17,0,0,1-.35.35,3,3,0,0,1-1.05.39,2,2,0,0,0-1.08.56,9.7,9.7,0,0,0-.74,1.18,2.2,2.2,0,0,1-.49.52,2.46,2.46,0,0,1-.59.28,1.43,1.43,0,0,0-.63.39,4.73,4.73,0,0,0-.43.57,5,5,0,0,1-.51.52,5,5,0,0,0-.37.42,6.35,6.35,0,0,0-.77,2.49,3.66,3.66,0,0,1-.59,1.39,7.15,7.15,0,0,1-.87.87,2.74,2.74,0,0,0-.67.77,3.31,3.31,0,0,0-.3,1.39c0,1.14,0,2.29-.09,3.43a7.56,7.56,0,0,1-.14.83c-.07.26-.16.51-.21.78a1.75,1.75,0,0,0,.08,1,7,7,0,0,0,.47.85,2.52,2.52,0,0,1,.43,1.37,2.16,2.16,0,0,0,0,.76,1.51,1.51,0,0,0,.33.54,7,7,0,0,1,.84,1l0,0a4.12,4.12,0,0,0,1.17.71,4.56,4.56,0,0,0,2,.31,7.25,7.25,0,0,1,1.32-.7,14.46,14.46,0,0,0,1.57-.66,3.61,3.61,0,0,0,.69-.46c.22-.17.41-.37.63-.54.42-.31.91-.54,1.31-.88a2.3,2.3,0,0,0,.55-.69,7.83,7.83,0,0,0,.34-.79,2.73,2.73,0,0,1,.44-.71q.29-.32.6-.6l.85-.73a20.62,20.62,0,0,0,1-2.11,3.85,3.85,0,0,0-.37-.86c-.22-.42-.48-.82-.71-1.23a.11.11,0,0,1,.06-.16,10.88,10.88,0,0,0,1.13-.26,1.48,1.48,0,0,0,.73-.41,1.33,1.33,0,0,0,.28-.49C1135.44,930.31,1135.49,930.09,1135.53,929.88Z"
              fill="#396039"
            />
            <path
              d="M1132,920.17a56.41,56.41,0,0,0-2.71,5.52c-.84,1.88-1.6,3.78-2.33,5.7-1.46,3.83-2.72,7.74-3.88,11.68s-2.21,7.9-3.18,11.89c-.47,2-.89,4-1.34,6l-1.23,6,1.13-6c.43-2,.84-4,1.31-6,.94-4,1.92-8,3.1-11.92s2.47-7.84,4-11.67A79.71,79.71,0,0,1,1132,920.17Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1112.69,947.42q0-.74.06-1.47a32.91,32.91,0,0,0-2.25-7.24,9.53,9.53,0,0,1-.7-.73,12,12,0,0,1-.75-1l-.86-1.17a9.75,9.75,0,0,1-1.37-2.41c-.16-.43-.21-.88-.33-1.32s-.18-.6-.28-.89c-2.81-3.76-5.75-5.81-7.58-4.94a1.89,1.89,0,0,0-.65.51,2.64,2.64,0,0,0-.12.4,5.53,5.53,0,0,0-.17,1.86,8.41,8.41,0,0,0,.37,1.78,12.16,12.16,0,0,1,.6,2.06,7.57,7.57,0,0,1-.08,2,10,10,0,0,0-.14,2,2.65,2.65,0,0,0,.57,1.63,4.83,4.83,0,0,0,1,.75,5,5,0,0,1,1.11,1,1.42,1.42,0,0,1,.39,1c0,.41-.22.79-.29,1.2a3.35,3.35,0,0,0,.84,2.68,13.39,13.39,0,0,0,2.28,2c.43.33.86.66,1.26,1,.2.19.4.38.59.58s.4.47.61.71a12.11,12.11,0,0,0,3,2.32c.55.34,1.08.68,1.59,1.06.92-.47,1.43-1.63,1.55-3.27A7.78,7.78,0,0,1,1112.69,947.42Z"
              fill="#2f4f2f"
            />
            <path
              d="M1098,926a134.41,134.41,0,0,1,11.45,19.89,108.82,108.82,0,0,1,4.22,10.69,68.14,68.14,0,0,1,2.63,11.17,77.34,77.34,0,0,0-2.76-11.13,109.89,109.89,0,0,0-4.28-10.64q-2.42-5.2-5.24-10.21C1102.08,932.4,1100.09,929.12,1098,926Z"
              fill="#87f139"
            />
          </g>
          <g>
            <path
              d="M1112.51,950.2a11.47,11.47,0,0,1-.14-1.16,25.73,25.73,0,0,0-2.69-5.39c-.22-.16-.44-.32-.64-.49a9.22,9.22,0,0,1-.71-.69c-.27-.27-.55-.53-.82-.81a7.66,7.66,0,0,1-1.39-1.71c-.17-.32-.28-.67-.42-1s-.22-.44-.34-.65c-2.68-2.59-5.24-3.83-6.56-2.91a1.48,1.48,0,0,0-.45.48c0,.11,0,.21,0,.32a4.32,4.32,0,0,0,.1,1.48,6.5,6.5,0,0,0,.52,1.35,9.85,9.85,0,0,1,.73,1.54,5.83,5.83,0,0,1,.19,1.55,7.42,7.42,0,0,0,.14,1.56,2.09,2.09,0,0,0,.65,1.21,4.28,4.28,0,0,0,.91.45,4,4,0,0,1,1,.68,1.08,1.08,0,0,1,.43.77c0,.32-.07.65-.08,1a2.73,2.73,0,0,0,1,2,10.51,10.51,0,0,0,2,1.25c.38.2.75.41,1.11.64.19.12.37.25.54.38s.37.32.56.48a9.81,9.81,0,0,0,2.66,1.44c.47.19.94.39,1.38.62.67-.48.92-1.45.8-2.75A6.14,6.14,0,0,1,1112.51,950.2Z"
              fill="#396039"
            />
            <path
              d="M1098.22,935.24a105.67,105.67,0,0,1,11.53,14.13,88.4,88.4,0,0,1,4.66,7.84,53.72,53.72,0,0,1,3.46,8.43,61.71,61.71,0,0,0-3.59-8.36,84.39,84.39,0,0,0-4.71-7.79q-2.55-3.78-5.39-7.34C1102.27,939.78,1100.3,937.46,1098.22,935.24Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1119,950.42a.63.63,0,0,1-.22-.36.66.66,0,0,1,.23-.43,4.06,4.06,0,0,1,.65-.51v0a3,3,0,0,1-.4-.4.77.77,0,0,1-.18-.36c0-.26.27-.38.47-.45l.43-.16c.09-.45.18-.91.26-1.39l-.26-.07a3.45,3.45,0,0,1-.62-.2,1.08,1.08,0,0,1-.43-.27.12.12,0,0,1,0-.17c.2-.12.41-.19.62-.29a1.38,1.38,0,0,0,.54-.34c.16-.2,0-.44,0-.66a.61.61,0,0,1,.25-.44l.21-.17c.06-.57.11-1.16.16-1.77l-.35-.1a1.85,1.85,0,0,1-.81-.42.68.68,0,0,1-.12-.81,1.54,1.54,0,0,1,.81-.6,4.16,4.16,0,0,1,.5-.16c0-.2.08-.41.11-.61q0-.88,0-1.8a.18.18,0,0,0,0-.07,1,1,0,0,0-.33-.21,1.89,1.89,0,0,1-.51-.38.12.12,0,0,1,0-.15c.24-.2.82-.5.66-.9,0-.11-.24-.13-.33-.18a.32.32,0,0,1-.18-.36c.08-.27.41-.37.56-.59s-.26-.32-.42-.33a5.15,5.15,0,0,1-.88,0,.11.11,0,0,1,0-.2c.45-.32.9-.64,1.37-.93-.08-1.26-.2-2.46-.36-3.59l-.2.06a.1.1,0,0,1-.13-.09,4,4,0,0,0-.85.44c-.16.11-.31.23-.46.35s-.26-.06-.16-.15a4.2,4.2,0,0,1,.49-.37,10.48,10.48,0,0,1,1.24-.75c-.15-1-.32-1.9-.52-2.74a4.11,4.11,0,0,0-1.06.55l-.38.34a.11.11,0,0,1-.15-.15,3.42,3.42,0,0,1,.4-.36c.25-.23.5-.47.76-.69l.3-.24a19.27,19.27,0,0,0-.75-2.35,12.37,12.37,0,0,1-1.42.57.1.1,0,0,1-.13-.1,2.19,2.19,0,0,1,.52-1.16,3.57,3.57,0,0,1,.45-.51c-.52-.88-1.1-1.36-1.7-1.36-1.22,0-2.32,2-3.09,5.18.32.29.62.59.92.89a.11.11,0,0,1-.13.17,8,8,0,0,1-.89-.64c-.19.84-.36,1.76-.51,2.74a15.82,15.82,0,0,1,1,1.94.1.1,0,0,1,0,.15c-.39.21-.81.37-1.22.56-.12,1.39-.2,2.86-.23,4.39a8,8,0,0,1,.85,2,4.48,4.48,0,0,1,.08,1.59c0,.26-.06.53-.08.79a6.79,6.79,0,0,1,0,.78c-.08.49-.26,1-.34,1.45a1.18,1.18,0,0,0,.32,1.2,2.83,2.83,0,0,0,.89.34.4.4,0,0,1,.27.22.51.51,0,0,1-.08.41,2.23,2.23,0,0,1-.91.78l-.34.18c.75,4.72,2.09,7.86,3.62,7.86,1,0,1.82-1.2,2.53-3.22Z"
              fill="#659965"
            />
            <path
              d="M1116.69,926.37l-.1,20.41-.06,10.2v5.1c0,1.7,0,3.41.15,5.1-.32-3.39-.26-6.8-.3-10.2v-10.2C1116.46,940,1116.51,933.17,1116.69,926.37Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1123.36,933.82a1.4,1.4,0,0,0-.81,0l-.45.58c-.24.28-.48.56-.73.82a7.67,7.67,0,0,0-.7.81,7,7,0,0,0-.81,1.46,6.48,6.48,0,0,1-.83,1.69c-.33.4-.75.7-1.11,1.07l0,0-.26.75a20.51,20.51,0,0,0-1,4.81,2.58,2.58,0,0,0,0,.39,31.26,31.26,0,0,1,.61,3.48,1.39,1.39,0,0,0,.66.5c1.67.55,4.22-2.67,5.71-7.2S1125,934.37,1123.36,933.82Z"
              fill="#3b6818"
            />
            <path
              d="M1123.67,943s-7.15,3.65-7.4,22.48"
              fill="none"
              stroke="#78bf3a"
              strokeMiterlimit="10"
              strokeWidth="0.21"
            />
            <path
              d="M1122.23,935.53a4,4,0,0,0-1,1.87,8.94,8.94,0,0,1-.41,2,2.77,2.77,0,0,1-.65.89c-.25.24-.53.45-.78.7a2.06,2.06,0,0,0-.58.95,1.86,1.86,0,0,0,0,.85,3.67,3.67,0,0,1,.13.88,3,3,0,0,1-.36,1.19,3.3,3.3,0,0,0-.36,1.22,2.83,2.83,0,0,0,.13.78,2.21,2.21,0,0,1-.21,1.63,1.58,1.58,0,0,0-.23.66,2.06,2.06,0,0,0,.3,1l0,.1a.92.92,0,0,0,.3.18c1.31.43,3.58-2.88,5.07-7.41s1.63-8.54.32-9a.87.87,0,0,0-.55,0A8.76,8.76,0,0,1,1122.23,935.53Z"
              fill="#659965"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1120.3,904.44c-.07-.53-.11-1.07-.14-1.59a12.08,12.08,0,0,1,.07-2.33c.1-.69.3-1.36.46-2a7,7,0,0,0,.2-1.82c0-.67-.22-1.31-.27-2a4.27,4.27,0,0,1,.14-1.51c.12-.34.26-.68.41-1a7.11,7.11,0,0,1,.59-.88.14.14,0,0,0,0-.19,7.11,7.11,0,0,1,7.89-3.39,1.89,1.89,0,0,0,.54.55,4.64,4.64,0,0,0,1.63.6,3.09,3.09,0,0,1,1.68.88,14.85,14.85,0,0,1,1.15,1.83,3.2,3.2,0,0,0,.76.8,3.32,3.32,0,0,0,.93.44,2.4,2.4,0,0,1,1,.6,8.28,8.28,0,0,1,.67.89,8.62,8.62,0,0,0,.79.81,7.3,7.3,0,0,1,.57.66c.83,1.1.9,2.57,1.21,3.87a5.62,5.62,0,0,0,.91,2.15,9.64,9.64,0,0,0,1.35,1.36,4.37,4.37,0,0,1,1,1.19,5.14,5.14,0,0,1,.46,2.16c.09,1.78-.06,3.56.15,5.33a10.85,10.85,0,0,0,.22,1.29c.1.4.24.8.32,1.21a2.72,2.72,0,0,1-.12,1.57,13.18,13.18,0,0,1-.73,1.33,3.88,3.88,0,0,0-.67,2.12,3.59,3.59,0,0,1,0,1.18,2.41,2.41,0,0,1-.52.85,10.29,10.29,0,0,0-1.3,1.5.16.16,0,0,0,0,.08,6.81,6.81,0,0,1-1.83,1.1,7,7,0,0,1-3,.48,10.56,10.56,0,0,0-2-1.08,24,24,0,0,1-2.45-1,7.28,7.28,0,0,1-1.07-.7c-.34-.27-.63-.58-1-.84-.66-.49-1.41-.85-2-1.38a3.72,3.72,0,0,1-.86-1.07c-.21-.39-.35-.81-.53-1.22a3.86,3.86,0,0,0-.67-1.1,11.78,11.78,0,0,0-.94-.93c-.43-.39-.88-.76-1.31-1.14a31.18,31.18,0,0,1-1.6-3.28,6.39,6.39,0,0,1,.58-1.34c.34-.65.75-1.26,1.1-1.91a.17.17,0,0,0-.08-.25,18.09,18.09,0,0,1-1.77-.4,2.32,2.32,0,0,1-1.12-.63,2.08,2.08,0,0,1-.44-.78C1120.44,905.12,1120.37,904.78,1120.3,904.44Z"
              fill="#396039"
            />
            <path
              d="M1125.82,889.35a123,123,0,0,1,8,17.36c2.3,5.95,4.3,12,6.14,18.13s3.36,12.32,4.83,18.53c.71,3.1,1.35,6.23,2,9.35l1.75,9.41-1.91-9.38c-.7-3.11-1.35-6.23-2.09-9.33-1.5-6.2-3.07-12.39-4.93-18.49s-3.76-12.19-6-18.15l-1.75-4.45c-.63-1.46-1.21-2.94-1.88-4.39A88.56,88.56,0,0,0,1125.82,889.35Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1155.79,931.7c0-.77,0-1.53-.09-2.29a50.58,50.58,0,0,1,3.5-11.25,14.45,14.45,0,0,0,1.08-1.14c.43-.49.79-1,1.17-1.55l1.33-1.82a15.65,15.65,0,0,0,2.13-3.75c.24-.67.33-1.37.52-2.06.12-.46.27-.92.43-1.37,4.37-5.84,8.94-9,11.77-7.68a3.12,3.12,0,0,1,1,.79,6.32,6.32,0,0,1,.18.62,9,9,0,0,1,.27,2.89,13.26,13.26,0,0,1-.58,2.77,18.88,18.88,0,0,0-.93,3.2,11.47,11.47,0,0,0,.12,3,15.06,15.06,0,0,1,.22,3.07,4.06,4.06,0,0,1-.89,2.53,7.41,7.41,0,0,1-1.61,1.16,8.06,8.06,0,0,0-1.73,1.62,2.16,2.16,0,0,0-.59,1.63c.07.63.34,1.23.45,1.86a5.28,5.28,0,0,1-1.31,4.17,20.78,20.78,0,0,1-3.56,3.06c-.66.51-1.32,1-2,1.59-.32.28-.62.58-.92.89s-.62.74-.93,1.11a19,19,0,0,1-4.69,3.61c-.85.52-1.68,1.05-2.47,1.64-1.44-.72-2.22-2.53-2.4-5.08A12.76,12.76,0,0,0,1155.79,931.7Z"
              fill="#2f4f2f"
            />
            <path
              d="M1178.7,898.34q-2.52,3.69-4.82,7.5t-4.54,7.68q-4.39,7.77-8.14,15.86a170.92,170.92,0,0,0-6.65,16.54c-.86,2.85-1.81,5.67-2.46,8.57-.82,2.86-1.26,5.81-1.83,8.73a105.61,105.61,0,0,1,4.08-17.37,170.25,170.25,0,0,1,6.55-16.6q3.81-8.09,8.26-15.84C1172.1,908.25,1175.26,903.19,1178.7,898.34Z"
              fill="#87f139"
            />
          </g>
          <g>
            <path
              d="M1156.07,936c.1-.6.17-1.21.22-1.81a40.16,40.16,0,0,1,4.17-8.37c.35-.24.68-.49,1-.75s.74-.71,1.11-1.08l1.27-1.25a12,12,0,0,0,2.15-2.67c.28-.5.43-1,.67-1.55.15-.35.33-.68.51-1,4.17-4,8.15-5.95,10.2-4.52a2.64,2.64,0,0,1,.7.75,4,4,0,0,1,.06.5,6.84,6.84,0,0,1-.16,2.3,9.37,9.37,0,0,1-.8,2.1A16.35,16.35,0,0,0,1176,921a9.67,9.67,0,0,0-.29,2.4,11,11,0,0,1-.22,2.43,3.32,3.32,0,0,1-1,1.88,6.18,6.18,0,0,1-1.41.7,6.11,6.11,0,0,0-1.56,1,1.69,1.69,0,0,0-.68,1.2c0,.51.11,1,.12,1.51a4.18,4.18,0,0,1-1.56,3.11,16.83,16.83,0,0,1-3.17,1.94c-.59.32-1.17.64-1.73,1-.29.19-.57.38-.84.59s-.58.5-.87.75a15.33,15.33,0,0,1-4.14,2.23c-.72.3-1.44.61-2.14,1-1-.75-1.42-2.27-1.23-4.28A9.92,9.92,0,0,0,1156.07,936Z"
              fill="#396039"
            />
            <path
              d="M1178.27,912.78c-1.63,1.72-3.2,3.48-4.73,5.28s-3,3.6-4.52,5.44q-4.43,5.54-8.39,11.41a135.22,135.22,0,0,0-7.32,12.11c-1,2.11-2.14,4.2-3,6.39s-1.73,4.39-2.55,6.61a82.09,82.09,0,0,1,5.38-13.11,136.21,136.21,0,0,1,7.24-12.19c2.67-3.9,5.51-7.68,8.48-11.35S1174.94,916.14,1178.27,912.78Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1146,936.35a.85.85,0,0,0,.34-.56,1,1,0,0,0-.35-.66,7.89,7.89,0,0,0-1-.8v0a5.26,5.26,0,0,0,.62-.63,1,1,0,0,0,.27-.55c0-.4-.41-.59-.72-.71s-.45-.17-.67-.24c-.15-.69-.28-1.41-.41-2.16l.4-.1a7.87,7.87,0,0,0,1-.32,1.64,1.64,0,0,0,.67-.43.17.17,0,0,0,0-.26c-.3-.17-.64-.29-1-.44a2.1,2.1,0,0,1-.83-.54c-.25-.31-.06-.67-.06-1a.91.91,0,0,0-.39-.68c-.1-.1-.21-.18-.31-.27-.1-.89-.19-1.8-.26-2.74l.55-.16a2.94,2.94,0,0,0,1.25-.65,1,1,0,0,0,.19-1.26,2.39,2.39,0,0,0-1.25-.93,7.24,7.24,0,0,0-.79-.25c0-.32-.11-.64-.17-1,0-.91,0-1.85,0-2.79l.07-.11a1.66,1.66,0,0,1,.52-.32,2.86,2.86,0,0,0,.79-.59.18.18,0,0,0,0-.24c-.37-.31-1.27-.77-1-1.39.08-.18.36-.2.52-.28a.5.5,0,0,0,.27-.56c-.12-.42-.63-.58-.86-.91s.4-.5.65-.52a7.73,7.73,0,0,0,1.36,0,.17.17,0,0,0,0-.3c-.7-.5-1.4-1-2.13-1.44.14-2,.33-3.83.57-5.58l.3.09a.18.18,0,0,0,.21-.15,6.64,6.64,0,0,1,1.32.69q.38.25.72.54c.17.13.4-.09.24-.23a8.05,8.05,0,0,0-.76-.58,14.47,14.47,0,0,0-1.92-1.17c.23-1.52.5-3,.8-4.26a7,7,0,0,1,1.65.86l.59.54a.17.17,0,0,0,.23-.24,4.6,4.6,0,0,0-.61-.56c-.39-.36-.78-.72-1.18-1.06l-.47-.38a28.74,28.74,0,0,1,1.16-3.65,23,23,0,0,0,2.2.89.17.17,0,0,0,.21-.16,3.51,3.51,0,0,0-.81-1.81,8.48,8.48,0,0,0-.69-.79c.8-1.36,1.7-2.12,2.63-2.12,1.9,0,3.61,3.1,4.81,8.06-.5.44-1,.91-1.44,1.38a.17.17,0,0,0,.2.26,11.3,11.3,0,0,0,1.39-1c.3,1.31.56,2.73.79,4.26a24,24,0,0,0-1.48,3,.19.19,0,0,0,.06.23c.62.32,1.27.58,1.9.87.2,2.16.32,4.45.36,6.83a12.44,12.44,0,0,0-1.33,3.09,7.33,7.33,0,0,0-.11,2.47q.08.61.12,1.23a9.82,9.82,0,0,0,.07,1.21c.11.76.39,1.49.53,2.25a1.87,1.87,0,0,1-.51,1.86,4.21,4.21,0,0,1-1.38.53.62.62,0,0,0-.42.35.83.83,0,0,0,.12.63,3.32,3.32,0,0,0,1.43,1.21l.52.29c-1.16,7.32-3.25,12.21-5.63,12.21-1.47,0-2.82-1.86-3.92-5Z"
              fill="#659965"
            />
            <path
              d="M1149.57,899c.29,10.57.36,21.14.49,31.71v15.85c-.07,5.29,0,10.58-.48,15.85.25-2.63.2-5.28.23-7.92l0-7.93-.1-15.85Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1139.22,910.57a2,2,0,0,1,1.24,0c.24.3.47.6.71.89s.74.88,1.14,1.29a11.82,11.82,0,0,1,1.08,1.25,10.91,10.91,0,0,1,1.25,2.27,10.34,10.34,0,0,0,1.3,2.62c.51.63,1.16,1.1,1.72,1.67l0,0c.14.38.27.77.4,1.16a31.31,31.31,0,0,1,1.55,7.48q0,.3-.06.6a47.47,47.47,0,0,0-.95,5.41,2.2,2.2,0,0,1-1,.78c-2.59.85-6.56-4.16-8.88-11.19S1136.63,911.42,1139.22,910.57Z"
              fill="#3b6818"
            />
            <path
              d="M1138.72,924.83s11.12,5.66,11.51,34.93"
              fill="none"
              stroke="#78bf3a"
              strokeMiterlimit="10"
              strokeWidth="0.33"
            />
            <path
              d="M1141,913.22a6.31,6.31,0,0,1,1.54,2.91,13.07,13.07,0,0,0,.63,3.08,4.25,4.25,0,0,0,1,1.38c.39.37.82.69,1.21,1.08a3.26,3.26,0,0,1,.9,1.48,2.79,2.79,0,0,1,0,1.32,5.67,5.67,0,0,0-.2,1.37,4.52,4.52,0,0,0,.56,1.85,5.09,5.09,0,0,1,.56,1.9,4.32,4.32,0,0,1-.21,1.21,3.62,3.62,0,0,0-.08,1.32,3.47,3.47,0,0,0,.41,1.21,2.4,2.4,0,0,1,.36,1,3.21,3.21,0,0,1-.47,1.55.8.8,0,0,0-.08.16,1.27,1.27,0,0,1-.46.27c-2,.67-5.57-4.48-7.89-11.51s-2.53-13.27-.49-13.94a1.41,1.41,0,0,1,.86,0A12.82,12.82,0,0,0,1141,913.22Z"
              fill="#659965"
            />
          </g>
        </g>
        <g>
          <path
            d="M1327.46,869.22s-12.71,26.37,3.36,40.78h-24.93s9.13-4.48,10.25-7.37,1.25-21.51,9.09-32.56Z"
            fill="#6d3b2f"
          />
          <path
            d="M1324.27,870.51s-1.35-15.22-10-17.2c0,0,3.62,3.09,1.81,5.6,0,0-3.3-7.47-13.39-5.6,0,0,11.62,1.42,13.39,8.45a8.13,8.13,0,0,0-8.91,2.71S1324.28,864.76,1324.27,870.51Z"
            fill="#43771c"
          />
          <path
            d="M1327.46,870.51s1.34-15.22,10-17.2c0,0-3.62,3.09-1.81,5.6,0,0,3.31-7.47,13.4-5.6,0,0-11.63,1.42-13.4,8.45a8.13,8.13,0,0,1,8.91,2.71S1327.45,864.76,1327.46,870.51Z"
            fill="#43771c"
          />
          <path
            d="M1323.2,873.2s16.82-21.91,35.59-13.48c0,0-10.61-.4-11.51.85,0,0,3.48-.55,3.31,2.88,0,0-7.22-3.46-9.25-1.75,0,0,4,.8,3.76,2.49,0,0-6.43-1.53-8.09,0,0,0,4.16,1,2.5,3,0,0-5.69-2.47-8.41,1.22,0,0,2.37-.81,3.11.07C1334.21,868.41,1323.62,871,1323.2,873.2Z"
            fill="#529022"
          />
          <path
            d="M1326.31,872.91s-14.4-20.73-33.81-10.2c0,0,10.53-1.48,11.29-.29a3.31,3.31,0,0,0-3.56,3.28s7.48-4.27,9.32-2.73c0,0-4,1.23-4,2.93,0,0,6.52-2.22,8-.86,0,0-4.2,1.42-2.76,3.29,0,0,5.87-3.1,8.19.4,0,0-2.27-.59-3.08.38C1315.92,869.11,1326.12,870.65,1326.31,872.91Z"
            fill="#529022"
          />
          <path
            d="M1322.82,872s16-12.71,28.93,4.58c0,0-8-5.6-8.84-4.84a3.87,3.87,0,0,1,2.08,4.38s-5-6.86-6.74-6.22c0,0,2.91,2.73,2.48,4.24,0,0-4.64-4.63-6.12-4,0,0,3,3,1.45,4.07,0,0-3.94-5.15-6.55-3,0,0,1.92.39,2.35,1.58C1331.86,872.82,1323.47,870.07,1322.82,872Z"
            fill="#426642"
          />
          <path
            d="M1327.47,872.44s-19-14.62-33.88,4.57c0,0,9.25-6.13,10.28-5.27a4.16,4.16,0,0,0-2.35,4.89s5.68-7.61,7.79-6.86c0,0-3.37,3-2.83,4.72,0,0,5.36-5.12,7.1-4.4,0,0-3.46,3.29-1.62,4.55,0,0,4.52-5.72,7.63-3.2,0,0-2.24.4-2.72,1.74C1316.87,873.18,1326.66,870.25,1327.47,872.44Z"
            fill="#426642"
          />
          <path
            d="M1324.68,872.9c.7-8.8-8.59-19-15.26-18.41,0,0,13.18-2.56,15.32,5.34,0,0-2.67-10.47-6.57-10.47,0,0,8.59-2.35,10.14,4.91,0,0,4.65-9.07,0-10.3,0,0,10.62,2.83,6.09,9.88,0,0,4.86-4.06,10.62,1.28,0,0-11.32.21-13.24,4.7,0,0,5-3.21,7.9,0,0,0-10-1.66-12.49,5.71Z"
            fill="#529022"
          />
          <path
            d="M1325.23,872.9c.53-6.79-6.63-14.69-11.78-14.2,0,0,10.17-2,11.82,4.12,0,0-2.06-8.07-5.07-8.07,0,0,6.63-1.81,7.83,3.79,0,0,3.58-7,0-7.95,0,0,8.19,2.18,4.69,7.62,0,0,3.74-3.13,8.19,1,0,0-8.73.17-10.21,3.63,0,0,3.83-2.47,6.09,0,0,0-7.69-1.28-9.63,4.4Z"
            fill="#396039"
          />
          <path
            d="M1326.08,875.58s-.78-8.8-5.8-9.94c0,0,2.09,1.79,1,3.24,0,0-1.91-4.32-7.74-3.24,0,0,6.72.82,7.74,4.89a4.69,4.69,0,0,0-5.15,1.56S1326.09,872.26,1326.08,875.58Z"
            fill="#659965"
          />
          <path
            d="M1324.58,874.3s.77-8.8,5.8-9.94c0,0-2.09,1.79-1,3.24,0,0,1.91-4.32,7.74-3.24,0,0-6.72.82-7.74,4.89a4.68,4.68,0,0,1,5.14,1.56S1324.57,871,1324.58,874.3Z"
            fill="#659965"
          />
          <path
            d="M1316.14,902.63c1-2.59,1.21-18,7-29-.77,3.06-5.94,24-3.27,30,1.06,2.39-2.4,4.61-7.18,6.46h-6.76S1315,905.52,1316.14,902.63Z"
            fill="#17216b"
            opacity="0.24"
          />
        </g>
        <g>
          <g>
            <path
              d="M1456.53,920.88c0-.34.07-.69.09-1a7.53,7.53,0,0,0,0-1.5c-.06-.44-.19-.87-.29-1.3a4.27,4.27,0,0,1-.13-1.18c0-.42.14-.84.17-1.27a2.9,2.9,0,0,0-.08-1c-.09-.22-.17-.43-.27-.64a4.35,4.35,0,0,0-.38-.57.09.09,0,0,1,0-.12,4.86,4.86,0,0,0-2.28-2,4.74,4.74,0,0,0-2.8-.19,1.17,1.17,0,0,1-.35.35,3,3,0,0,1-1.05.39,2,2,0,0,0-1.08.56,9.7,9.7,0,0,0-.74,1.18,2.2,2.2,0,0,1-.49.52,2.46,2.46,0,0,1-.59.28,1.43,1.43,0,0,0-.63.39,4.73,4.73,0,0,0-.43.57,5,5,0,0,1-.51.52,5,5,0,0,0-.37.42,6.35,6.35,0,0,0-.77,2.49,3.66,3.66,0,0,1-.59,1.39,7.15,7.15,0,0,1-.87.87,2.74,2.74,0,0,0-.67.77,3.31,3.31,0,0,0-.3,1.39c0,1.14,0,2.29-.09,3.43a7.56,7.56,0,0,1-.14.83c-.07.26-.16.51-.21.78a1.75,1.75,0,0,0,.08,1,7,7,0,0,0,.47.85,2.52,2.52,0,0,1,.43,1.37,2.16,2.16,0,0,0,0,.76,1.51,1.51,0,0,0,.33.54,7,7,0,0,1,.84,1l0,0a4.12,4.12,0,0,0,1.17.71,4.56,4.56,0,0,0,2,.31,7.25,7.25,0,0,1,1.32-.7,14.46,14.46,0,0,0,1.57-.66,3.61,3.61,0,0,0,.69-.46c.22-.17.41-.37.63-.54.42-.31.91-.54,1.31-.88a2.3,2.3,0,0,0,.55-.69,7.83,7.83,0,0,0,.34-.79,2.73,2.73,0,0,1,.44-.71q.29-.32.6-.6l.85-.73a20.62,20.62,0,0,0,1-2.11,3.85,3.85,0,0,0-.37-.86c-.22-.42-.48-.82-.71-1.23a.11.11,0,0,1,.06-.16,10.88,10.88,0,0,0,1.13-.26,1.48,1.48,0,0,0,.73-.41,1.33,1.33,0,0,0,.28-.49C1456.44,921.31,1456.49,921.09,1456.53,920.88Z"
              fill="#396039"
            />
            <path
              d="M1453,911.17a56.41,56.41,0,0,0-2.71,5.52c-.84,1.88-1.6,3.78-2.33,5.7-1.46,3.83-2.72,7.74-3.88,11.68s-2.21,7.9-3.18,11.89c-.47,2-.89,4-1.34,6l-1.23,6,1.13-6c.43-2,.84-4,1.31-6,.94-4,1.92-8,3.1-11.92s2.47-7.84,4-11.67A79.71,79.71,0,0,1,1453,911.17Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1433.69,938.42q0-.74.06-1.47a32.91,32.91,0,0,0-2.25-7.24,9.53,9.53,0,0,1-.7-.73,12,12,0,0,1-.75-1l-.86-1.17a9.75,9.75,0,0,1-1.37-2.41c-.16-.43-.21-.88-.33-1.32s-.18-.6-.28-.89c-2.81-3.76-5.75-5.81-7.58-4.94a1.89,1.89,0,0,0-.65.51,2.64,2.64,0,0,0-.12.4,5.53,5.53,0,0,0-.17,1.86,8.41,8.41,0,0,0,.37,1.78,12.16,12.16,0,0,1,.6,2.06,7.57,7.57,0,0,1-.08,2,10,10,0,0,0-.14,2,2.65,2.65,0,0,0,.57,1.63,4.83,4.83,0,0,0,1,.75,5,5,0,0,1,1.11,1,1.42,1.42,0,0,1,.39,1c0,.41-.22.79-.29,1.2a3.35,3.35,0,0,0,.84,2.68,13.39,13.39,0,0,0,2.28,2c.43.33.86.66,1.26,1,.2.19.4.38.59.58s.4.47.61.71a12.11,12.11,0,0,0,3,2.32c.55.34,1.08.68,1.59,1.06.92-.47,1.43-1.63,1.55-3.27A7.78,7.78,0,0,1,1433.69,938.42Z"
              fill="#2f4f2f"
            />
            <path
              d="M1419,917a134.41,134.41,0,0,1,11.45,19.89,108.82,108.82,0,0,1,4.22,10.69,68.14,68.14,0,0,1,2.63,11.17,77.34,77.34,0,0,0-2.76-11.13,109.89,109.89,0,0,0-4.28-10.64q-2.42-5.2-5.24-10.21C1423.08,923.4,1421.09,920.12,1419,917Z"
              fill="#87f139"
            />
          </g>
          <g>
            <path
              d="M1433.51,941.2a11.47,11.47,0,0,1-.14-1.16,25.73,25.73,0,0,0-2.69-5.39c-.22-.16-.44-.32-.64-.49a9.22,9.22,0,0,1-.71-.69c-.27-.27-.55-.53-.82-.81a7.66,7.66,0,0,1-1.39-1.71c-.17-.32-.28-.67-.42-1s-.22-.44-.34-.65c-2.68-2.59-5.24-3.83-6.56-2.91a1.48,1.48,0,0,0-.45.48c0,.11,0,.21,0,.32a4.32,4.32,0,0,0,.1,1.48,6.5,6.5,0,0,0,.52,1.35,9.85,9.85,0,0,1,.73,1.54,5.83,5.83,0,0,1,.19,1.55,7.42,7.42,0,0,0,.14,1.56,2.09,2.09,0,0,0,.65,1.21,4.28,4.28,0,0,0,.91.45,4,4,0,0,1,1,.68,1.08,1.08,0,0,1,.43.77c0,.32-.07.65-.08,1a2.73,2.73,0,0,0,1,2,10.51,10.51,0,0,0,2,1.25c.38.2.75.41,1.11.64.19.12.37.25.54.38s.37.32.56.48a9.81,9.81,0,0,0,2.66,1.44c.47.19.94.39,1.38.62.67-.48.92-1.45.8-2.75A6.14,6.14,0,0,1,1433.51,941.2Z"
              fill="#396039"
            />
            <path
              d="M1419.22,926.24a105.67,105.67,0,0,1,11.53,14.13,88.4,88.4,0,0,1,4.66,7.84,53.72,53.72,0,0,1,3.46,8.43,61.71,61.71,0,0,0-3.59-8.36,84.39,84.39,0,0,0-4.71-7.79q-2.55-3.78-5.39-7.34C1423.27,930.78,1421.3,928.46,1419.22,926.24Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1440,941.42a.63.63,0,0,1-.22-.36.66.66,0,0,1,.23-.43,4.06,4.06,0,0,1,.65-.51v0a3,3,0,0,1-.4-.4.77.77,0,0,1-.18-.36c0-.26.27-.38.47-.45l.43-.16c.09-.45.18-.91.26-1.39l-.26-.07a3.45,3.45,0,0,1-.62-.2,1.08,1.08,0,0,1-.43-.27.12.12,0,0,1,0-.17c.2-.12.41-.19.62-.29a1.38,1.38,0,0,0,.54-.34c.16-.2,0-.44,0-.66a.61.61,0,0,1,.25-.44l.21-.17c.06-.57.11-1.16.16-1.77l-.35-.1a1.85,1.85,0,0,1-.81-.42.68.68,0,0,1-.12-.81,1.54,1.54,0,0,1,.81-.6,4.16,4.16,0,0,1,.5-.16c0-.2.08-.41.11-.61q0-.88,0-1.8a.18.18,0,0,0,0-.07,1,1,0,0,0-.33-.21,1.89,1.89,0,0,1-.51-.38.12.12,0,0,1,0-.15c.24-.2.82-.5.66-.9,0-.11-.24-.13-.33-.18a.32.32,0,0,1-.18-.36c.08-.27.41-.37.56-.59s-.26-.32-.42-.33a5.15,5.15,0,0,1-.88,0,.11.11,0,0,1,0-.2c.45-.32.9-.64,1.37-.93-.08-1.26-.2-2.46-.36-3.59l-.2.06a.1.1,0,0,1-.13-.09,4,4,0,0,0-.85.44c-.16.11-.31.23-.46.35s-.26-.06-.16-.15a4.2,4.2,0,0,1,.49-.37,10.48,10.48,0,0,1,1.24-.75c-.15-1-.32-1.9-.52-2.74a4.11,4.11,0,0,0-1.06.55l-.38.34a.11.11,0,0,1-.15-.15,3.42,3.42,0,0,1,.4-.36c.25-.23.5-.47.76-.69l.3-.24a19.27,19.27,0,0,0-.75-2.35,12.37,12.37,0,0,1-1.42.57.1.1,0,0,1-.13-.1,2.19,2.19,0,0,1,.52-1.16,3.57,3.57,0,0,1,.45-.51c-.52-.88-1.1-1.36-1.7-1.36-1.22,0-2.32,2-3.09,5.18.32.29.62.59.92.89a.11.11,0,0,1-.13.17,8,8,0,0,1-.89-.64c-.19.84-.36,1.76-.51,2.74a15.82,15.82,0,0,1,1,1.94.1.1,0,0,1,0,.15c-.39.21-.81.37-1.22.56-.12,1.39-.2,2.86-.23,4.39a8,8,0,0,1,.85,2,4.48,4.48,0,0,1,.08,1.59c0,.26-.06.53-.08.79a6.79,6.79,0,0,1,0,.78c-.08.49-.26,1-.34,1.45a1.18,1.18,0,0,0,.32,1.2,2.83,2.83,0,0,0,.89.34.4.4,0,0,1,.27.22.51.51,0,0,1-.08.41,2.23,2.23,0,0,1-.91.78l-.34.18c.75,4.72,2.09,7.86,3.62,7.86,1,0,1.82-1.2,2.53-3.22Z"
              fill="#659965"
            />
            <path
              d="M1437.69,917.37l-.1,20.41-.06,10.2v5.1c0,1.7,0,3.41.15,5.1-.32-3.39-.26-6.8-.3-10.2v-10.2C1437.46,931,1437.51,924.17,1437.69,917.37Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1444.36,924.82a1.4,1.4,0,0,0-.81,0l-.45.58c-.24.28-.48.56-.73.82a7.67,7.67,0,0,0-.7.81,7,7,0,0,0-.81,1.46,6.48,6.48,0,0,1-.83,1.69c-.33.4-.75.7-1.11,1.07l0,0-.26.75a20.51,20.51,0,0,0-1,4.81,2.58,2.58,0,0,0,0,.39,31.26,31.26,0,0,1,.61,3.48,1.39,1.39,0,0,0,.66.5c1.67.55,4.22-2.67,5.71-7.2S1446,925.37,1444.36,924.82Z"
              fill="#3b6818"
            />
            <path
              d="M1444.67,934s-7.15,3.65-7.4,22.48"
              fill="none"
              stroke="#78bf3a"
              strokeMiterlimit="10"
              strokeWidth="0.21"
            />
            <path
              d="M1443.23,926.53a4,4,0,0,0-1,1.87,8.94,8.94,0,0,1-.41,2,2.77,2.77,0,0,1-.65.89c-.25.24-.53.45-.78.7a2.06,2.06,0,0,0-.58.95,1.86,1.86,0,0,0,0,.85,3.67,3.67,0,0,1,.13.88,3,3,0,0,1-.36,1.19,3.3,3.3,0,0,0-.36,1.22,2.83,2.83,0,0,0,.13.78,2.21,2.21,0,0,1-.21,1.63,1.58,1.58,0,0,0-.23.66,2.06,2.06,0,0,0,.3,1l0,.1a.92.92,0,0,0,.3.18c1.31.43,3.58-2.88,5.07-7.41s1.63-8.54.32-9a.87.87,0,0,0-.55,0A8.76,8.76,0,0,1,1443.23,926.53Z"
              fill="#659965"
            />
          </g>
        </g>
      </g>
    </g>
  );
};

export default FutureCityStaticElements;
